// Generated by Avo VERSION 183.8.0. You should never have to make changes to this file.
// If you find yourself in the situation where you have to edit the file please contact us at hi@avo.app.
// If you encounter a git conflict in this file run `avo pull` and it will be resolved automatically.
/* eslint-disable */

// fetch() polyfill
(function () {
  if (typeof window === 'undefined') {
    return;
  }
  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob:
      'FileReader' in self &&
      'Blob' in self &&
      (function() {
        try {
          new Blob();
          return true
        } catch (e) {
          return false
        }
      })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  };

  function isDataView(obj) {
    return obj && DataView.prototype.isPrototypeOf(obj)
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ];

    var isArrayBufferView =
      ArrayBuffer.isView ||
      function(obj) {
        return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
      };
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name);
    }
    if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value);
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift();
        return {done: value === undefined, value: value}
      }
    };

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      };
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {};

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value);
      }, this);
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1]);
      }, this);
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name]);
      }, this);
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name);
    value = normalizeValue(value);
    var oldValue = this.map[name];
    this.map[name] = oldValue ? oldValue + ', ' + value : value;
  };

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)];
  };

  Headers.prototype.get = function(name) {
    name = normalizeName(name);
    return this.has(name) ? this.map[name] : null
  };

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  };

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value);
  };

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this);
      }
    }
  };

  Headers.prototype.keys = function() {
    var items = [];
    this.forEach(function(value, name) {
      items.push(name);
    });
    return iteratorFor(items)
  };

  Headers.prototype.values = function() {
    var items = [];
    this.forEach(function(value) {
      items.push(value);
    });
    return iteratorFor(items)
  };

  Headers.prototype.entries = function() {
    var items = [];
    this.forEach(function(value, name) {
      items.push([name, value]);
    });
    return iteratorFor(items)
  };

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true;
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result);
      };
      reader.onerror = function() {
        reject(reader.error);
      };
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsArrayBuffer(blob);
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsText(blob);
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf);
    var chars = new Array(view.length);

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i]);
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength);
      view.set(new Uint8Array(buf));
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false;

    this._initBody = function(body) {
      this._bodyInit = body;
      if (!body) {
        this._bodyText = '';
      } else if (typeof body === 'string') {
        this._bodyText = body;
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body;
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body;
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString();
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer);
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer]);
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body);
      } else {
        this._bodyText = body = Object.prototype.toString.call(body);
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8');
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type);
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
        }
      }
    };

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this);
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      };

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      };
    }

    this.text = function() {
      var rejected = consumed(this);
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    };

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      };
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    };

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT'];

  function normalizeMethod(method) {
    var upcased = method.toUpperCase();
    return methods.indexOf(upcased) > -1 ? upcased : method
  }

  function Request(input, options) {
    options = options || {};
    var body = options.body;

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url;
      this.credentials = input.credentials;
      if (!options.headers) {
        this.headers = new Headers(input.headers);
      }
      this.method = input.method;
      this.mode = input.mode;
      this.signal = input.signal;
      if (!body && input._bodyInit != null) {
        body = input._bodyInit;
        input.bodyUsed = true;
      }
    } else {
      this.url = String(input);
    }

    this.credentials = options.credentials || this.credentials || 'same-origin';
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers);
    }
    this.method = normalizeMethod(options.method || this.method || 'GET');
    this.mode = options.mode || this.mode || null;
    this.signal = options.signal || this.signal;
    this.referrer = null;

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body);
  }

  Request.prototype.clone = function() {
    return new Request(this, {body: this._bodyInit})
  };

  function decode(body) {
    var form = new FormData();
    body
      .trim()
      .split('&')
      .forEach(function(bytes) {
        if (bytes) {
          var split = bytes.split('=');
          var name = split.shift().replace(/\+/g, ' ');
          var value = split.join('=').replace(/\+/g, ' ');
          form.append(decodeURIComponent(name), decodeURIComponent(value));
        }
      });
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers();
    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
    // https://tools.ietf.org/html/rfc7230#section-3.2
    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
    preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':');
      var key = parts.shift().trim();
      if (key) {
        var value = parts.join(':').trim();
        headers.append(key, value);
      }
    });
    return headers
  }

  Body.call(Request.prototype);

  function Response(bodyInit, options) {
    if (!options) {
      options = {};
    }

    this.type = 'default';
    this.status = options.status === undefined ? 200 : options.status;
    this.ok = this.status >= 200 && this.status < 300;
    this.statusText = 'statusText' in options ? options.statusText : 'OK';
    this.headers = new Headers(options.headers);
    this.url = options.url || '';
    this._initBody(bodyInit);
  }

  Body.call(Response.prototype);

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  };

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''});
    response.type = 'error';
    return response
  };

  var redirectStatuses = [301, 302, 303, 307, 308];

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  };

  self.DOMException = self.DOMException;
  try {
    new self.DOMException();
  } catch (err) {
    self.DOMException = function(message, name) {
      this.message = message;
      this.name = name;
      var error = Error(message);
      this.stack = error.stack;
    };
    self.DOMException.prototype = Object.create(Error.prototype);
    self.DOMException.prototype.constructor = self.DOMException;
  }

  function fetch(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init);

      if (request.signal && request.signal.aborted) {
        return reject(new self.DOMException('Aborted', 'AbortError'))
      }

      var xhr = new XMLHttpRequest();

      function abortXhr() {
        xhr.abort();
      }

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        };
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
        var body = 'response' in xhr ? xhr.response : xhr.responseText;
        resolve(new Response(body, options));
      };

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'));
      };

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'));
      };

      xhr.onabort = function() {
        reject(new self.DOMException('Aborted', 'AbortError'));
      };

      xhr.open(request.method, request.url, true);

      if (request.credentials === 'include') {
        xhr.withCredentials = true;
      } else if (request.credentials === 'omit') {
        xhr.withCredentials = false;
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob';
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value);
      });

      if (request.signal) {
        request.signal.addEventListener('abort', abortXhr);

        xhr.onreadystatechange = function() {
          // DONE (success or failure)
          if (xhr.readyState === 4) {
            request.signal.removeEventListener('abort', abortXhr);
          }
        };
      }

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
    })
  }

  fetch.polyfill = true;

  if (!self.fetch) {
    self.fetch = fetch;
    self.Headers = Headers;
    self.Request = Request;
    self.Response = Response;
  }
})();

(function(exports) {
  var __AVO_DEV__ = false;
  var __AVO_NOOP__ = false;
  var __AVO_LOGGER__ = null;
  var __AVO_ENV__ = null;
  var __REPORT_FAILURE_AS__ = null;
  var __STRICT__ = null;
  
  var __WEB_DEBUGGER__ = true;
  const avoInspectorApiKey = "D7U8qXZqpeuBzuZTJr4l";
  var __INSPECTOR__ = null;
  
  // polyfill Array.isArray
  if (!Array.isArray) {
    Array.isArray = function(arg) {
      return Object.prototype.toString.call(arg) === '[object Array]';
    };
  }

  // polyfill Object.assign
  if (typeof Object.assign !== 'function') {
    // Must be writable: true, enumerable: false, configurable: true
    Object.defineProperty(Object, "assign", {
      value: function assign(target, varArgs) { // .length of function is 2
        if (target == null) { // TypeError if undefined or null
          throw new TypeError('Cannot convert undefined or null to object');
        }

        var to = Object(target);

        for (var index = 1; index < arguments.length; index++) {
          var nextSource = arguments[index];

          if (nextSource != null) { // Skip over if undefined or null
            for (var nextKey in nextSource) {
              // Avoid bugs when hasOwnProperty is shadowed
              if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
                to[nextKey] = nextSource[nextKey];
              }
            }
          }
        }
        return to;
      },
      writable: true,
      configurable: true
    });
  }

  // From https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/keys
  if (!Object.keys) {
    Object.keys = (function() {
      'use strict';
      var hasOwnProperty = Object.prototype.hasOwnProperty,
          hasDontEnumBug = !({ toString: null }).propertyIsEnumerable('toString'),
          dontEnums = [
            'toString',
            'toLocaleString',
            'valueOf',
            'hasOwnProperty',
            'isPrototypeOf',
            'propertyIsEnumerable',
            'constructor'
          ],
          dontEnumsLength = dontEnums.length;

      return function(obj) {
        if (typeof obj !== 'function' && (typeof obj !== 'object' || obj === null)) {
          throw new TypeError('Object.keys called on non-object');
        }

        var result = [], prop, i;

        for (prop in obj) {
          if (hasOwnProperty.call(obj, prop)) {
            result.push(prop);
          }
        }

        if (hasDontEnumBug) {
          for (i = 0; i < dontEnumsLength; i++) {
            if (hasOwnProperty.call(obj, dontEnums[i])) {
              result.push(dontEnums[i]);
            }
          }
        }
        return result;
      };
    }());
  }

  // polyfill Array.indexOf
  if (!Array.prototype.indexOf)  Array.prototype.indexOf = (function(Object, max, min){
    "use strict";
    return function indexOf(member, fromIndex) {
      if(this===null||this===undefined)throw TypeError("Array.prototype.indexOf called on null or undefined");

      var that = Object(this), Len = that.length >>> 0, i = min(fromIndex | 0, Len);
      if (i < 0) i = max(0, Len+i); else if (i >= Len) return -1;

      if(member===void 0){ for(; i !== Len; ++i) if(that[i]===void 0 && i in that) return i; // undefined
      }else if(member !== member){   for(; i !== Len; ++i) if(that[i] !== that[i]) return i; // NaN
      }else                           for(; i !== Len; ++i) if(that[i] === member) return i; // all else

      return -1; // if the value was not found, then return -1
    };
  })(Object, Math.max, Math.min);
  
  var array_difference, AvoAssert, InternalAvoLogger;
  array_difference = function array_difference(a1, a2) {
    var result = [];
    for (var i = 0; i < a1.length; i++) {
      if (a2.indexOf(a1[i]) === -1) {
        result.push(a1[i]);
      }
    }
    return result;
  }
  
  AvoAssert = {
    assertObject: function assertObject(propertyId, propName, obj) {
      if (typeof obj !== 'object') {
        var message = propName +
          ' should be of type object but you provided type ' +
          typeof obj +
          ' with value ' +
          JSON.stringify(obj);
        return [{tag: 'expectedObjectType', propertyId: propertyId, message: message, actualType: typeof obj}];
      } else {
        return [];
      }
    },

    assertString: function assertString(propertyId, propName, str) {
      if (typeof str !== 'string') {
        var message = propName +
          ' should be of type string but you provided type ' +
          typeof str +
          ' with value ' +
          JSON.stringify(str);
        return [{tag: 'expectedStringType', propertyId: propertyId, message: message, actualType: typeof str}];
      } else {
        return [];
      }
    },

    assertInt: function assertInt(propertyId, propName, int) {
      if (typeof int === 'number' && int !== Math.round(int)) {
        var message = propName +
          ' should be of type int but you provided type float with value ' +
          JSON.stringify(int);
        return [{tag: 'expectedIntType', propertyId: propertyId, actualType: 'float'}];
      } else if (typeof int !== 'number') {
        var message = propName +
          ' should be of type int but you provided type ' +
          typeof int +
          ' with value ' +
          JSON.stringify(int);
        return [{tag: 'expectedIntType', propertyId: propertyId, message: message, actualType: typeof int}];
      } else {
        return [];
      }
    },

    assertLong: function assertLong(propertyId, propName, long) {
      if (typeof long === 'number' && long !== Math.round(long)) {
        var message = propName +
          ' should be of type long but you provided type float with value ' +
          JSON.stringify(long);
        return [{tag: 'expectedLongType', propertyId: propertyId, actualType: 'float'}];
      } else if (typeof long !== 'number') {
        var message = propName +
          ' should be of type long but you provided type ' +
          typeof long +
          ' with value ' +
          JSON.stringify(long);
        return [{tag: 'expectedLongType', propertyId: propertyId, message: message, actualType: typeof long}];
      } else {
        return [];
      }
    },

    assertFloat: function assertFloat(propertyId, propName, float) {
      if (typeof float !== 'number') {
        var message = propName +
          ' should be of type float but you provided type ' +
          typeof float +
          ' with value ' +
          JSON.stringify(float);
        return [{tag: 'expectedFloatType', propertyId: propertyId, message: message, actualType: typeof float}];
      } else {
        return [];
      }
    },

    assertBool: function assertBool(propertyId, propName, bool) {
      if (typeof bool !== 'boolean') {
        var message = propName +
          ' should be of type boolean but you provided type ' +
          typeof bool +
          ' with value ' +
          JSON.stringify(bool);
        return [{tag: 'expectedBoolType', propertyId: propertyId, message: message, actualType: typeof bool}];
      } else {
        return [];
      }
    },

    assertMax: function assertMax(propertyId, propName, max, value) {
      if (value > max) {
        var message = propName +
          ' has a maximum value of ' +
          max +
          ' but you provided the value ' +
          JSON.stringify(value);
        return [{tag: 'expectedMax', propertyId: propertyId, message: message}];
      } else {
        return [];
      }
    },

    assertMin: function assertMin(propertyId, propName, min, value) {
      if (value < min) {
        var message = propName +
          ' has a minimum value of ' +
          min +
          ' but you provided the value ' +
          JSON.stringify(value);
        return [{tag: 'expectedMin', propertyId: propertyId, message: message}];
      } else {
        return [];
      }
    },

    assertList: function assertList(propertyId, propName, value) {
      if (!Array.isArray(value)) {
        var message = propName + ' should be of type list but you provided type ' + typeof value;
        return [{tag: 'expectedList', propertyId: propertyId, message: message, actualType: typeof value}];
      } else {
        return [];
      }
    },

    assertNoAdditionalProperties: function assertNoAdditionalProperties(eventName, input, spec) {
      var additionalKeys = array_difference(input, spec);
      if (additionalKeys.length) {
        var message = "Additional properties when sending event " + eventName + ": " + JSON.stringify(additionalKeys);
        return [{tag: 'expectedNoAdditionalProperties', additionalProperties: additionalKeys, message: message}];
      } else {
        return [];
      }
    },

    assertNoAdditionalUserProperties: function assertNoAdditionalProperties(eventName, input, spec) {
      var additionalKeys = array_difference(input, spec);
      if (additionalKeys.length) {
        var message = "Additional user properties when sending event " + eventName + ": " + JSON.stringify(additionalKeys);
        return [{tag: 'expectedNoAdditionalUserProperties', additionalProperties: additionalKeys, message: message}];
      } else {
        return [];
      }
    }
  };
  
    const WebDebuggerAssertions = {
      hasKey(obj, key) {
        return obj && obj[key] != null;
      },
      assertKey(obj, key, assert) {
        if (this.hasKey(obj, key) && assert(obj[key])) {
          return true;
        } else {
          throw new Error('WebDebugger: Object key: "' + key + '" failed assertion.')
        }
      },
      assertKeys(obj, arrayOfAssertions) {
        return arrayOfAssertions.every(assertionForKey => {
          if (this.hasKey(assertionForKey, "key") && this.hasKey(assertionForKey, "assert")) {
            return this.assertKey(obj, assertionForKey.key, assertionForKey.assert);
          } else {
            throw new Error('WebDebugger: Object form for assertion invalid.');
          }
        });
      },
      assertInt(int) {
        return Number.isInteger(int);
      },
    };

    var WebDebuggerPosition = {
      position: {
        BOTTOM_RIGHT: 'BottomRight',
        BOTTOM_LEFT: 'BottomLeft',
        TOP_RIGHT: 'TopRight',
        TOP_LEFT: 'TopLeft',
      },
      BottomRight(parameters) {
        return WebDebuggerAssertions.assertKeys(
          parameters,
          [
            { key: "bottom", assert: WebDebuggerAssertions.assertInt },
            { key: "right", assert: WebDebuggerAssertions.assertInt },
          ],
        ) && {
          position: this.position.BOTTOM_RIGHT,
          bottom: parameters.bottom,
          right: parameters.right,
        };
      },
      BottomLeft(parameters) {
        return WebDebuggerAssertions.assertKeys(
          parameters,
          [
            { key: "bottom", assert: WebDebuggerAssertions.assertInt },
            { key: "left", assert: WebDebuggerAssertions.assertInt },
          ],
        ) && {
          position: this.position.BOTTOM_LEFT,
          bottom: parameters.bottom,
          left: parameters.left,
        };
      },
      TopRight(parameters) {
        return WebDebuggerAssertions.assertKeys(
          parameters,
          [
            { key: "top", assert: WebDebuggerAssertions.assertInt },
            { key: "right", assert: WebDebuggerAssertions.assertInt },
          ],
        ) && {
          position: this.position.TOP_RIGHT,
          top: parameters.top,
          right: parameters.right,
        };
      },
      TopLeft(parameters) {
        return WebDebuggerAssertions.assertKeys(
          parameters,
          [
            { key: "top", assert: WebDebuggerAssertions.assertInt },
            { key: "left", assert: WebDebuggerAssertions.assertInt },
          ],
        ) && {
          position: this.position.TOP_LEFT,
          top: parameters.top,
          left: parameters.left,
        };
      },
    }
    
  
  InternalAvoLogger = {
    logEventSent: function logEventSent(eventName, eventProperties, userProperties, groupProperties) {
      const message = "Event Sent:" + eventName + "Event Props:" + JSON.stringify(eventProperties) + "User Props:" + JSON.stringify(userProperties) + "Group Props:" + JSON.stringify(groupProperties);

      if (__AVO_LOGGER__ && __AVO_LOGGER__.logDebug && __AVO_LOGGER__.logDebug(__AVO_ENV__, message)) {
        return
      }
      typeof console !== 'undefined' && console.log("[avo] Event Sent:", eventName, "Event Props:", eventProperties, "User Props:", userProperties, "Group Props:", groupProperties);
    },

    log: function log(message) {
      if (__AVO_LOGGER__ && __AVO_LOGGER__.logDebug && __AVO_LOGGER__.logDebug(__AVO_ENV__, message)) {
        return
      }
      typeof console !== 'undefined' && console.log("[avo] " + message);
    },

    warn: function warn(message) {
      if (__AVO_LOGGER__ && __AVO_LOGGER__.logWarn && __AVO_LOGGER__.logWarn(__AVO_ENV__, message)) {
        return
      }
      typeof console !== 'undefined' && console.warn("[avo] " + message);
    },

    error: function error(message, error) {
      if (__AVO_LOGGER__ && __AVO_LOGGER__.logError && __AVO_LOGGER__.logError(__AVO_ENV__, message + error)) {
        return
      }
      typeof console !== 'undefined' && console.error("[avo] " + message, error);
    }
  };
  
  var _avo_invoke, _avo_invoke_meta;
var _avo_sampling_rate = 1.0;
function _avo_invoke_payload(body) {
  if (typeof window === 'undefined') { return; }
  if (_avo_sampling_rate > 0) {
    if (Math.random() < _avo_sampling_rate) {
      fetch("https://api.avo.app/i", {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify(body)
      }).then(function(res) { return res.json(); }).then(function(data) { _avo_sampling_rate = data.sa; }).catch(function() {});
    }
  }
}

_avo_invoke = function _avo_invoke(env, eventId, hash, messages, origin) {
  _avo_invoke_payload({
    "ac": "aoY3ZdBiC2y6WKahyZHk",
    "br": "master",
    "en": env,
    "ev": eventId,
    "ha": hash,
    "sc": "YlokXVpIQVXO68TO4Rm5",
    "se": (new Date()).toISOString(),
    "so": "xFLbWhqhHE",
    "va": messages.length === 0,
    "me": messages,
    "or": origin
  });
}

_avo_invoke_meta = function _avo_invoke_meta(env, type, messages, origin) {
  _avo_invoke_payload({
    "ac": "aoY3ZdBiC2y6WKahyZHk",
    "br": "master",
    "en": env,
    "ty": type,
    "sc": "YlokXVpIQVXO68TO4Rm5",
    "se": (new Date()).toISOString(),
    "so": "xFLbWhqhHE",
    "va": messages.length === 0,
    "me": messages,
    "or": origin
  });
}
  
  
  var _avo_debugger_log;
var _avo_debugger_events_during_boot = [];
var _avo_debugger_ready = false;

if (typeof window !== 'undefined') {
  window.addEventListener("message", function(event) {
    if (event.origin !== "https://www.avo.app") {
      return;
    }
    var iframe = document.getElementById("avo-debugger");
    if (iframe && event && event.data && event.data.type_ === "avo-debugger-update-style") {
      iframe.style = event.data.style;
    } else if (iframe && event && event.data && event.data.type_ === "avo-debugger-ready") {
      var message = {
        type_: "avo-debugger-boot-events",
        schemaId: "YlokXVpIQVXO68TO4Rm5",
        href: window.location.href,
        events: _avo_debugger_events_during_boot
      };
      _avo_debugger_events_during_boot = [];
      _avo_debugger_ready = true;
      iframe.contentWindow.postMessage(message, "https://www.avo.app/_debugger")
    }
  });
}

_avo_debugger_log = function _avo_debugger_log(eventId, eventName, messages, eventProperties, userProperties, groupProperties) {
  if (typeof window === 'undefined') { return; }
  var event = {
    eventId: eventId,
    eventName: eventName,
    messages: messages,
    timestamp: Date.now(),
    eventProperties: eventProperties,
    userProperties: userProperties,
    groupProperties: groupProperties
  };

  if (_avo_debugger_ready) {
    var message = {type_: "avo-debugger-events", events: [event]};
    document.getElementById("avo-debugger").contentWindow.postMessage(message, "https://www.avo.app/_debugger")
  } else {
    _avo_debugger_events_during_boot.push(event);
  }
}

function _avo_debugger_send_position(position) {
  if (typeof window === 'undefined') { return; }
  window.addEventListener("message", function(event) {
    if (event.origin !== "https://www.avo.app") {
      return;
    }
    if (event.data.type_ === "avo-debugger-ready" && position !== null) {
      var message = {type_: "avo-debugger-position", position: position};
      document.getElementById("avo-debugger").contentWindow.postMessage(message, "https://www.avo.app/_debugger")
    }
  })
}
  
  
  var Platform = {
    WEB: "web",
    I_O_S: "iOS",
    ANDROID: "android",
    MFEP: "MFEP",
  };
  
  var PaymentType = {
    IDEAL: "Ideal",
    CREDIT_CARD: "Credit Card",
  };
  
  var Schema = {
    IGLU_NL_NS_LOGIN_START_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/login_start/jsonschema/1-0-0",
    IGLU_NL_NS_LOGIN_ERROR_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/login_error/jsonschema/1-0-0",
    IGLU_NL_NS_VIEW_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/view/jsonschema/1-0-0",
    IGLU_NL_NS_CART_REMOVE_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/cart_remove/jsonschema/1-0-0",
    IGLU_NL_NS_CHAT_START_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/chat_start/jsonschema/1-0-0",
    IGLU_NL_NS_CHECKOUT_PROGRESS_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/checkout_progress/jsonschema/1-0-0",
    IGLU_NL_NS_CHECKOUT_START_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/checkout_start/jsonschema/1-0-0",
    IGLU_NL_NS_CONTENT_SHARE_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/content_share/jsonschema/1-0-0",
    IGLU_NL_NS_COOKIE_CHANGE_PERMISSION_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/cookie_change_permission/jsonschema/1-0-0",
    IGLU_NL_NS_EXPERIMENT_SUCCESS_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/experiment_success/jsonschema/1-0-0",
    IGLU_NL_NS_FILE_DOWNLOAD_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/file_download/jsonschema/1-0-0",
    IGLU_NL_NS_FORM_ERROR_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/form_error/jsonschema/1-0-0",
    IGLU_NL_NS_FORM_START_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/form_start/jsonschema/1-0-0",
    IGLU_NL_NS_ITEM_SELECT_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/item_select/jsonschema/1-0-0",
    IGLU_NL_NS_ITEM_VIEW_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/item_view/jsonschema/1-0-0",
    IGLU_NL_NS_KEUZEHULP_CLICK_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/keuzehulp_click/jsonschema/1-0-0",
    IGLU_NL_NS_LEAD_GENERATE_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/lead_generate/jsonschema/1-0-0",
    IGLU_NL_NS_NBA_SUCCESS_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/nba_success/jsonschema/1-0-0",
    IGLU_NL_NS_PAGE_ERROR_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/page_error/jsonschema/1-0-0",
    IGLU_NL_NS_PUSH_CONSENT_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/push_consent/jsonschema/1-0-0",
    IGLU_NL_NS_REGISTRATION_START_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/registration_start/jsonschema/1-0-0",
    IGLU_NL_NS_REGISTRATION_SUCCESS_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/registration_success/jsonschema/1-0-0",
    IGLU_NL_NS_REISPLANNER_ERROR_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/reisplanner_error/jsonschema/1-0-0",
    IGLU_NL_NS_REISPLANNER_SUCCESS_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/reisplanner_success/jsonschema/1-0-0",
    IGLU_NL_NS_REISREGISSEUR_CHANGE_PERMISSION_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/reisregisseur_change_permission/jsonschema/1-0-0",
    IGLU_NL_NS_REISVERGELIJKER_START_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/reisvergelijker_start/jsonschema/1-0-0",
    IGLU_NL_NS_REISVERGELIJKER_SUCCESS_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/reisvergelijker_success/jsonschema/1-0-0",
    IGLU_NL_NS_SCROLL_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/scroll/jsonschema/1-0-0",
    IGLU_NL_NS_SEARCH_START_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/search_start/jsonschema/1-0-0",
    IGLU_NL_NS_VIDEO_COMPLETE_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/video_complete/jsonschema/1-0-0",
    IGLU_NL_NS_VIDEO_PROGRESS_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/video_progress/jsonschema/1-0-0",
    IGLU_NL_NS_VIDEO_START_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/video_start/jsonschema/1-0-0",
    IGLU_NL_NS_VISIT_QUALIFIED_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/visit_qualified/jsonschema/1-0-0",
    IGLU_NL_NS_APP_CLEAR_DATA_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/app_clear_data/jsonschema/1-0-0",
    IGLU_NL_NS_PURCHASE_INTENTION_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/purchase_intention/jsonschema/1-0-0",
    IGLU_NL_NS_SESSION_COUNT_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/session_count/jsonschema/1-0-0",
    IGLU_NL_NS_SESSION_START_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/session_start/jsonschema/1-0-0",
    IGLU_NL_NS_FORM_SUBMIT_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/form_submit/jsonschema/1-0-0",
    IGLU_NL_NS_KEUZEHULP_SUCCESS_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/keuzehulp_success/jsonschema/1-0-0",
    IGLU_NL_NS_WIDGET_ADD_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/widget_add/jsonschema/1-0-0",
    IGLU_NL_NS_WIDGET_REMOVE_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/widget_remove/jsonschema/1-0-0",
    IGLU_NL_NS_STATION_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/station/jsonschema/1-0-0",
    IGLU_NL_NS_DETAIL_CLICK_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/detail_click/jsonschema/1-0-0",
    IGLU_NL_NS_VOORZIENINGEN_CLICK_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/voorzieningen_click/jsonschema/1-0-0",
    IGLU_NL_NS_KAART_CLICK_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/kaart_click/jsonschema/1-0-0",
    IGLU_NL_NS_MODALITIES_FILTER_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/modalities_filter/jsonschema/1-0-0",
    IGLU_NL_NS_PLAN_VANAF_HIER_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/plan_vanaf_hier/jsonschema/1-0-0",
    IGLU_NL_NS_TRAJECT_ADD_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/traject_add/jsonschema/1-0-0",
    IGLU_NL_NS_TRAJECT_REMOVE_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/traject_remove/jsonschema/1-0-0",
    IGLU_NL_NS_TRAJECT_SEINTJES_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/traject_seintjes/jsonschema/1-0-0",
    IGLU_NL_NS_NOTIFICATION_RECEIVE_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/notification_receive/jsonschema/1-0-0",
    IGLU_NL_NS_NOTIFICATION_OPEN_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/notification_open/jsonschema/1-0-0",
    IGLU_NL_NS_NOTIFICATION_FOREGROUND_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/notification_foreground/jsonschema/1-0-0",
    IGLU_NL_NS_NOTIFICATION_DISMISS_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/notification_dismiss/jsonschema/1-0-0",
    IGLU_NL_NS_APP_EXCEPTION_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/app_exception/jsonschema/1-0-0",
    IGLU_NL_NS_APP_REMOVE_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/app_remove/jsonschema/1-0-0",
    IGLU_NL_NS_APP_UPDATE_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/app_update/jsonschema/1-0-0",
    IGLU_NL_NS_OS_UPDATE_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/os_update/jsonschema/1-0-0",
    IGLU_NL_NS_SERVER_PURCHASE_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/server_purchase/jsonschema/1-0-0",
    IGLU_NL_NS_REMOVE_FROM_CART_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/remove_from_cart/jsonschema/1-0-0",
    IGLU_NL_NS_LOGIN_SUCCESS_JSONSCHEMA_2MINUS0MINUS3: "iglu:nl.ns/login_success/jsonschema/2-0-3",
    IGLU_NL_NS_PAGE_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/page/jsonschema/1-0-0",
    IGLU_NL_NS_COOKIE_CONSENT_SUBMIT_JSONSCHEMA_2MINUS0MINUS2: "iglu:nl.ns/cookie_consent_submit/jsonschema/2-0-2",
    IGLU_NL_NS_COOKIE_CONSENT_VIEW_JSONSCHEMA_2MINUS0MINUS2: "iglu:nl.ns/cookie_consent_view/jsonschema/2-0-2",
    IGLU_NL_NS_LOGIN_STATUS_UPDATE_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/login_status_update/jsonschema/1-0-0",
    IGLU_NL_NS_CLASS_CHANGE_CONFIRM_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/class_change_confirm/jsonschema/1-0-0",
    IGLU_NL_NS_CLASS_CHANGE_SET_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/class_change_set/jsonschema/1-0-0",
    IGLU_NL_NS_NBA_CONTEXT_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/nba_context/jsonschema/1-0-0",
    IGLU_NL_NS_SCREEN_CONTEXT_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/screen_context/jsonschema/1-0-0",
    IGLU_NL_NS_TEST_EVENT_VARIANT_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/test_event_variant/jsonschema/1-0-0",
    IGLU_NL_NS_FEEDBACK_GIVE_JSONSCHEMA_1MINUS0MINUS2: "iglu:nl.ns/feedback_give/jsonschema/1-0-2",
    IGLU_NL_NS_CONSENT_CONTEXT_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/consent_context/jsonschema/1-0-0",
    IGLU_NL_NS_PURCHASE_INTENTION_CONTEXT_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/purchase_intention_context/jsonschema/1-0-0",
    IGLU_NL_NS_GLOBAL_CONTEXTS_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/global_contexts/jsonschema/1-0-0",
    IGLU_NL_NS_LOST_AND_FOUND_SEARCH_CATEGORY_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/lost_and_found_search_category/jsonschema/1-0-0",
    IGLU_NL_NS_LOST_AND_FOUND_SEARCH_TERM_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/lost_and_found_search_term/jsonschema/1-0-0",
    IGLU_NL_NS_SCREEN_VIEW_JSONSCHEMA_1MINUS0MINUS7: "iglu:nl.ns/screen_view/jsonschema/1-0-7",
    IGLU_NL_NS_ADD_TO_CART_JSONSCHEMA_1MINUS0MINUS5: "iglu:nl.ns/add_to_cart/jsonschema/1-0-5",
    IGLU_NL_NS_TRAVEL_PLANNER_PLAN_JOURNEY_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/travel_planner_plan_journey/jsonschema/1-0-0",
    IGLU_NL_NS_AUTHENTICATION_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/authentication/jsonschema/1-0-0",
    IGLU_NL_NS_BANNER_CLICK_JSONSCHEMA_1MINUS0MINUS3: "iglu:nl.ns/banner_click/jsonschema/1-0-3",
    IGLU_NL_NS_CART_ADD_JSONSCHEMA_1MINUS0MINUS3: "iglu:nl.ns/cart_add/jsonschema/1-0-3",
    IGLU_NL_NS_CHECKBOX_CLICK_JSONSCHEMA_1MINUS0MINUS3: "iglu:nl.ns/checkbox_click/jsonschema/1-0-3",
    IGLU_NL_NS_CHIP_FILTER_CLICK_JSONSCHEMA_1MINUS0MINUS3: "iglu:nl.ns/chip_filter_click/jsonschema/1-0-3",
    IGLU_NL_NS_CLICK_JSONSCHEMA_1MINUS0MINUS2: "iglu:nl.ns/click/jsonschema/1-0-2",
    IGLU_NL_NS_CLICKED_OPTION_JSONSCHEMA_1MINUS0MINUS1: "iglu:nl.ns/clicked_option/jsonschema/1-0-1",
    IGLU_NL_NS_COOKIE_CONSENT_CHANGE_JSONSCHEMA_1MINUS0MINUS2: "iglu:nl.ns/cookie_consent_change/jsonschema/1-0-2",
    IGLU_NL_NS_DATEPICKER_CLICK_JSONSCHEMA_1MINUS0MINUS3: "iglu:nl.ns/datepicker_click/jsonschema/1-0-3",
    IGLU_NL_NS_ELEMENT_CLICK_JSONSCHEMA_1MINUS0MINUS2: "iglu:nl.ns/element_click/jsonschema/1-0-2",
    IGLU_NL_NS_ELEMENT_VIEW_JSONSCHEMA_4MINUS0MINUS2: "iglu:nl.ns/element_view/jsonschema/4-0-2",
    IGLU_NL_NS_ERROR_JSONSCHEMA_1MINUS0MINUS1: "iglu:nl.ns/error/jsonschema/1-0-1",
    IGLU_NL_NS_EXPANDABLE_CLICK_JSONSCHEMA_1MINUS0MINUS3: "iglu:nl.ns/expandable_click/jsonschema/1-0-3",
    IGLU_NL_NS_EXPERIMENT_VIEW_JSONSCHEMA_1MINUS0MINUS5: "iglu:nl.ns/experiment_view/jsonschema/1-0-5",
    IGLU_NL_NS_LINK_CLICK_JSONSCHEMA_1MINUS0MINUS1: "iglu:nl.ns/link_click/jsonschema/1-0-1",
    IGLU_NL_NS_LOGOUT_SUCCESS_JSONSCHEMA_1MINUS0MINUS1: "iglu:nl.ns/logout_success/jsonschema/1-0-1",
    IGLU_NL_NS_NBA_AUDIENCE_ADD_JSONSCHEMA_1MINUS0MINUS1: "iglu:nl.ns/nba_audience_add/jsonschema/1-0-1",
    IGLU_NL_NS_NBA_VIEW_JSONSCHEMA_1MINUS0MINUS3: "iglu:nl.ns/nba_view/jsonschema/1-0-3",
    IGLU_NL_NS_PAGE_VIEW_JSONSCHEMA_4MINUS0MINUS3: "iglu:nl.ns/page_view/jsonschema/4-0-3",
    IGLU_NL_NS_REISPLANNER_PLAN_TRIP_JSONSCHEMA_1MINUS0MINUS3: "iglu:nl.ns/reisplanner_plan_trip/jsonschema/1-0-3",
    IGLU_NL_NS_SEARCH_VIEW_RESULTS_JSONSCHEMA_2MINUS0MINUS3: "iglu:nl.ns/search_view_results/jsonschema/2-0-3",
    IGLU_NL_NS_SELECT_CLICK_JSONSCHEMA_1MINUS0MINUS2: "iglu:nl.ns/select_click/jsonschema/1-0-2",
    IGLU_NL_NS_SELECTABLE_CLICK_JSONSCHEMA_1MINUS0MINUS3: "iglu:nl.ns/selectable_click/jsonschema/1-0-3",
    IGLU_NL_NS_SERVER_EXPERIMENTS_JSONSCHEMA_1MINUS0MINUS1: "iglu:nl.ns/server_experiments/jsonschema/1-0-1",
    IGLU_NL_NS_SUBSCRIPTION_CANCEL_SELECT_JSONSCHEMA_1MINUS0MINUS1: "iglu:nl.ns/subscription_cancel_select/jsonschema/1-0-1",
    IGLU_NL_NS_SUBSCRIPTION_CHANGE_JSONSCHEMA_1MINUS0MINUS1: "iglu:nl.ns/subscription_change/jsonschema/1-0-1",
    IGLU_NL_NS_SUBSCRIPTION_CHANGE_SELECT_JSONSCHEMA_1MINUS0MINUS2: "iglu:nl.ns/subscription_change_select/jsonschema/1-0-2",
    IGLU_NL_NS_TOGGLE_CLICK_JSONSCHEMA_1MINUS0MINUS3: "iglu:nl.ns/toggle_click/jsonschema/1-0-3",
    IGLU_NL_NS_TOOLTIP_CLICK_JSONSCHEMA_1MINUS0MINUS4: "iglu:nl.ns/tooltip_click/jsonschema/1-0-4",
    IGLU_NL_NS_BUTTON_CLICK_JSONSCHEMA_2MINUS0MINUS6: "iglu:nl.ns/button_click/jsonschema/2-0-6",
    IGLU_NL_NS_APP_OS_UNSUPPORTED_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/app_os_unsupported/jsonschema/1-0-0",
    IGLU_NL_NS_UNSUPPORTED_APP_VERSION_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/unsupported_app_version/jsonschema/1-0-0",
    IGLU_NL_NS_UNSUPPORTED_OS_VERSION_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/unsupported_os_version/jsonschema/1-0-0",
    IGLU_NL_NS_DEPRECATED_APP_VERSION_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/deprecated_app_version/jsonschema/1-0-0",
    IGLU_NL_NS_ADD_PAYMENT_INFO_JSONSCHEMA_1MINUS0MINUS2: "iglu:nl.ns/add_payment_info/jsonschema/1-0-2",
    IGLU_NL_NS_ADD_SHIPPING_INFO_JSONSCHEMA_1MINUS0MINUS2: "iglu:nl.ns/add_shipping_info/jsonschema/1-0-2",
    IGLU_NL_NS_ADD_TO_CART_JSONSCHEMA_1MINUS0MINUS6: "iglu:nl.ns/add_to_cart/jsonschema/1-0-6",
    IGLU_NL_NS_BEGIN_CHECKOUT_JSONSCHEMA_1MINUS0MINUS2: "iglu:nl.ns/begin_checkout/jsonschema/1-0-2",
    IGLU_NL_NS_PURCHASE_JSONSCHEMA_2MINUS0MINUS7: "iglu:nl.ns/purchase/jsonschema/2-0-7",
    IGLU_NL_NS_PURCHASE_UNCONFIRMED_JSONSCHEMA_1MINUS0MINUS4: "iglu:nl.ns/purchase_unconfirmed/jsonschema/1-0-4",
    IGLU_NL_NS_VIEW_ITEM_JSONSCHEMA_1MINUS0MINUS2: "iglu:nl.ns/view_item/jsonschema/1-0-2",
    IGLU_NL_NS_VIEW_ITEM_LIST_JSONSCHEMA_1MINUS0MINUS2: "iglu:nl.ns/view_item_list/jsonschema/1-0-2",
    IGLU_NL_NS_PURCHASE_INTENTION_CONTEXT_JSONSCHEMA_1MINUS0MINUS1: "iglu:nl.ns/purchase_intention_context/jsonschema/1-0-1",
    IGLU_NL_NS_JOURNEY_DETAIL_SAVE_TRIP_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/journey_detail_save_trip/jsonschema/1-0-0",
    IGLU_NL_NS_JOURNEY_DETAIL_SET_NOTIFICATIONS_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/journey_detail_set_notifications/jsonschema/1-0-0",
    IGLU_NL_NS_SAVED_TRIPS_DELETE_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/saved_trips_delete/jsonschema/1-0-0",
    IGLU_NL_NS_SAVED_TRIPS_EXTRA_OPTIONS_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/saved_trips_extra_options/jsonschema/1-0-0",
    IGLU_NL_NS_SAVED_TRIPS_MODAL_CANCEL_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/saved_trips_modal_cancel/jsonschema/1-0-0",
    IGLU_NL_NS_SAVED_TRIPS_MODAL_EXTRA_OPTIONS_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/saved_trips_modal_extra_options/jsonschema/1-0-0",
    IGLU_NL_NS_SAVED_TRIPS_MODAL_SAVE_NOTIFICATIONS_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/saved_trips_modal_save_notifications/jsonschema/1-0-0",
    IGLU_NL_NS_SAVED_TRIPS_SAVE_CHANGES_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/saved_trips_save_changes/jsonschema/1-0-0",
    IGLU_NL_NS_BOTTOM_BAR_SAVED_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/bottom_bar_saved/jsonschema/1-0-0",
    IGLU_NL_NS_HOMEPAGE_SAVED_TRIPS_WIDGET_CLICK_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/homepage_saved_trips_widget_click/jsonschema/1-0-0",
    IGLU_NL_NS_HOMEPAGE_SAVED_TRIPS_WIDGET_TO_SAVED_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/homepage_saved_trips_widget_to_saved/jsonschema/1-0-0",
    IGLU_NL_NS_SELECT_ITEM_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/select_item/jsonschema/1-0-0",
    IGLU_NL_NS_VIEW_ITEM_LIST_JSONSCHEMA_1MINUS0MINUS3: "iglu:nl.ns/view_item_list/jsonschema/1-0-3",
    IGLU_NL_NS_PAGE_CONTEXT_JSONSCHEMA_1MINUS0MINUS2: "iglu:nl.ns/page_context/jsonschema/1-0-2",
    IGLU_NL_NS_PAGE_VIEW_JSONSCHEMA_4MINUS0MINUS4: "iglu:nl.ns/page_view/jsonschema/4-0-4",
    IGLU_NL_NS_EXPERIMENTS_CONTEXT_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/experiments_context/jsonschema/1-0-0",
    IGLU_NL_NS_LOGIN_STATUS_CONTEXT_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/login_status_context/jsonschema/1-0-0",
    IGLU_NL_NS_PERSONALIZATION_CONTEXT_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/personalization_context/jsonschema/1-0-0",
    IGLU_NL_NS_PAGE_CONTEXT_JSONSCHEMA_1MINUS0MINUS3: "iglu:nl.ns/page_context/jsonschema/1-0-3",
    IGLU_NL_NS_BANNER_CLICK_JSONSCHEMA_1MINUS0MINUS4: "iglu:nl.ns/banner_click/jsonschema/1-0-4",
    IGLU_NL_NS_NBA_VIEW_JSONSCHEMA_1MINUS0MINUS4: "iglu:nl.ns/nba_view/jsonschema/1-0-4",
    IGLU_NL_NS_PURCHASE_JSONSCHEMA_2MINUS0MINUS8: "iglu:nl.ns/purchase/jsonschema/2-0-8",
    IGLU_NL_NS_CONSENT_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/consent/jsonschema/1-0-0",
    IGLU_NL_NS_SCROLL_CONTEXT_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/scroll_context/jsonschema/1-0-0",
    IGLU_NL_NS_SCREEN_VIEW_JSONSCHEMA_1MINUS0MINUS8: "iglu:nl.ns/screen_view/jsonschema/1-0-8",
    IGLU_NL_NS_SCREEN_VIEW_JSONSCHEMA_1MINUS0MINUS9: "iglu:nl.ns/screen_view/jsonschema/1-0-9",
    IGLU_NL_NS_PURCHASE_NON_USABLE_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/purchase_non_usable/jsonschema/1-0-0",
    IGLU_NL_NS_EXPERIMENTS_INITIALIZED_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/experiments_initialized/jsonschema/1-0-0",
    IGLU_NL_NS_EXPERIMENTS_JSONSCHEMA_1MINUS0MINUS1: "iglu:nl.ns/experiments/jsonschema/1-0-1",
    IGLU_NL_NS_EXPERIMENTS_JSONSCHEMA_1MINUS0MINUS2: "iglu:nl.ns/experiments/jsonschema/1-0-2",
    IGLU_NL_NS_GLOBAL_CONTEXTS_JSONSCHEMA_1MINUS0MINUS1: "iglu:nl.ns/global_contexts/jsonschema/1-0-1",
    IGLU_NL_NS_SCREEN_VIEW_JSONSCHEMA_1MINUS1MINUS0: "iglu:nl.ns/screen_view/jsonschema/1-1-0",
    IGLU_NL_NS_SCREEN_VIEW_JSONSCHEMA_1MINUS0MINUS10: "iglu:nl.ns/screen_view/jsonschema/1-0-10",
    IGLU_NL_NS_ADD_PAYMENT_INFO_JSONSCHEMA_1MINUS0MINUS3: "iglu:nl.ns/add_payment_info/jsonschema/1-0-3",
    IGLU_NL_NS_ADD_SHIPPING_INFO_JSONSCHEMA_1MINUS0MINUS3: "iglu:nl.ns/add_shipping_info/jsonschema/1-0-3",
    IGLU_NL_NS_ADD_TO_CART_JSONSCHEMA_1MINUS0MINUS7: "iglu:nl.ns/add_to_cart/jsonschema/1-0-7",
    IGLU_NL_NS_BEGIN_CHECKOUT_JSONSCHEMA_1MINUS0MINUS3: "iglu:nl.ns/begin_checkout/jsonschema/1-0-3",
    IGLU_NL_NS_KEUZEHULP_SUCCESS_JSONSCHEMA_1MINUS0MINUS2: "iglu:nl.ns/keuzehulp_success/jsonschema/1-0-2",
    IGLU_NL_NS_PURCHASE_JSONSCHEMA_2MINUS0MINUS9: "iglu:nl.ns/purchase/jsonschema/2-0-9",
    IGLU_NL_NS_PURCHASE_UNCONFIRMED_JSONSCHEMA_1MINUS0MINUS5: "iglu:nl.ns/purchase_unconfirmed/jsonschema/1-0-5",
    IGLU_NL_NS_VIEW_ITEM_JSONSCHEMA_1MINUS0MINUS3: "iglu:nl.ns/view_item/jsonschema/1-0-3",
    IGLU_NL_NS_VIEW_ITEM_LIST_JSONSCHEMA_1MINUS0MINUS4: "iglu:nl.ns/view_item_list/jsonschema/1-0-4",
    IGLU_NL_NS_REMOVE_FROM_CART_JSONSCHEMA_1MINUS0MINUS1: "iglu:nl.ns/remove_from_cart/jsonschema/1-0-1",
    IGLU_NL_NS_SELECT_ITEM_JSONSCHEMA_1MINUS0MINUS1: "iglu:nl.ns/select_item/jsonschema/1-0-1",
    IGLU_NL_NS_FORM_ERROR_JSONSCHEMA_1MINUS0MINUS1: "iglu:nl.ns/form_error/jsonschema/1-0-1",
    IGLU_NL_NS_FORM_START_JSONSCHEMA_1MINUS0MINUS1: "iglu:nl.ns/form_start/jsonschema/1-0-1",
    IGLU_NL_NS_FORM_SUBMIT_JSONSCHEMA_1MINUS0MINUS1: "iglu:nl.ns/form_submit/jsonschema/1-0-1",
    IGLU_NL_NS_PERSONALIZATION_CONTEXT_JSONSCHEMA_1MINUS0MINUS1: "iglu:nl.ns/personalization_context/jsonschema/1-0-1",
    IGLU_NL_NS_BEGIN_CHECKOUT_JSONSCHEMA_1MINUS0MINUS4: "iglu:nl.ns/begin_checkout/jsonschema/1-0-4",
    IGLU_NL_NS_FILE_DOWNLOAD_JSONSCHEMA_1MINUS0MINUS1: "iglu:nl.ns/file_download/jsonschema/1-0-1",
    IGLU_NL_NS_REISPLANNER_ERROR_JSONSCHEMA_1MINUS0MINUS1: "iglu:nl.ns/reisplanner_error/jsonschema/1-0-1",
    IGLU_NL_NS_CONSENT_JSONSCHEMA_1MINUS0MINUS2: "iglu:nl.ns/consent/jsonschema/1-0-2",
    IGLU_NL_NS_EXPERIMENTS_JSONSCHEMA_1MINUS0MINUS3: "iglu:nl.ns/experiments/jsonschema/1-0-3",
    IGLU_NL_NS_LOGIN_STATUS_CONTEXT_JSONSCHEMA_1MINUS0MINUS1: "iglu:nl.ns/login_status_context/jsonschema/1-0-1",
    IGLU_NL_NS_PAGE_CONTEXT_JSONSCHEMA_1MINUS0MINUS4: "iglu:nl.ns/page_context/jsonschema/1-0-4",
    IGLU_NL_NS_PURCHASE_INTENTION_CONTEXT_JSONSCHEMA_1MINUS0MINUS2: "iglu:nl.ns/purchase_intention_context/jsonschema/1-0-2",
    IGLU_NL_NS_SCREEN_CONTEXT_JSONSCHEMA_1MINUS0MINUS1: "iglu:nl.ns/screen_context/jsonschema/1-0-1",
    IGLU_NL_NS_SCREEN_VIEW_JSONSCHEMA_1MINUS0MINUS11: "iglu:nl.ns/screen_view/jsonschema/1-0-11",
    IGLU_NL_NS_EXPERIMENTS_SESSION_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/experiments_session/jsonschema/1-0-0",
    IGLU_NL_NS_PURCHASE_JSONSCHEMA_2MINUS0MINUS10: "iglu:nl.ns/purchase/jsonschema/2-0-10",
    IGLU_NL_NS_PURCHASE_SERVER_SIDE_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/purchase_server_side/jsonschema/1-0-0",
    IGLU_NL_NS_ADD_PAYMENT_INFO_JSONSCHEMA_1MINUS0MINUS4: "iglu:nl.ns/add_payment_info/jsonschema/1-0-4",
    IGLU_NL_NS_ADD_SHIPPING_INFO_JSONSCHEMA_1MINUS0MINUS4: "iglu:nl.ns/add_shipping_info/jsonschema/1-0-4",
    IGLU_NL_NS_ADD_TO_CART_JSONSCHEMA_1MINUS0MINUS8: "iglu:nl.ns/add_to_cart/jsonschema/1-0-8",
    IGLU_NL_NS_ADD_TO_CART_JSONSCHEMA_2MINUS0MINUS0: "iglu:nl.ns/add_to_cart/jsonschema/2-0-0",
    IGLU_NL_NS_BEGIN_CHECKOUT_JSONSCHEMA_1MINUS0MINUS5: "iglu:nl.ns/begin_checkout/jsonschema/1-0-5",
    IGLU_NL_NS_KEUZEHULP_SUCCESS_JSONSCHEMA_1MINUS0MINUS1: "iglu:nl.ns/keuzehulp_success/jsonschema/1-0-1",
    IGLU_NL_NS_PURCHASE_JSONSCHEMA_2MINUS0MINUS11: "iglu:nl.ns/purchase/jsonschema/2-0-11",
    IGLU_NL_NS_PURCHASE_JSONSCHEMA_2MINUS0MINUS12: "iglu:nl.ns/purchase/jsonschema/2-0-12",
    IGLU_NL_NS_PURCHASE_UNCONFIRMED_JSONSCHEMA_1MINUS0MINUS6: "iglu:nl.ns/purchase_unconfirmed/jsonschema/1-0-6",
    IGLU_NL_NS_REMOVE_FROM_CART_JSONSCHEMA_1MINUS0MINUS2: "iglu:nl.ns/remove_from_cart/jsonschema/1-0-2",
    IGLU_NL_NS_SELECT_ITEM_JSONSCHEMA_1MINUS0MINUS3: "iglu:nl.ns/select_item/jsonschema/1-0-3",
    IGLU_NL_NS_VIEW_ITEM_JSONSCHEMA_1MINUS0MINUS4: "iglu:nl.ns/view_item/jsonschema/1-0-4",
    IGLU_NL_NS_VIEW_ITEM_LIST_JSONSCHEMA_1MINUS0MINUS5: "iglu:nl.ns/view_item_list/jsonschema/1-0-5",
    IGLU_NL_NS_ORDER_CHANGE_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/order_change/jsonschema/1-0-0",
    IGLU_NL_NS_PURCHASE_UNCONFIRMED_JSONSCHEMA_1MINUS0MINUS7: "iglu:nl.ns/purchase_unconfirmed/jsonschema/1-0-7",
    IGLU_NL_NS_REMOVE_FROM_CART_JSONSCHEMA_1MINUS0MINUS3: "iglu:nl.ns/remove_from_cart/jsonschema/1-0-3",
    IGLU_NL_NS_ELEMENT_VIEW_JSONSCHEMA_4MINUS0MINUS3: "iglu:nl.ns/element_view/jsonschema/4-0-3",
    IGLU_NL_NS_EXTERNAL_REFERRER_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/external_referrer/jsonschema/1-0-0",
    IGLU_COM_SNOWPLOWANALYTICS_MOBILE_DEEP_LINK_RECEIVED_JSONSCHEMA_1MINUS0MINUS0: "iglu:com.snowplowanalytics.mobile/deep_link_received/jsonschema/1-0-0",
    IGLU_NL_NS_CANCELLATION_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/cancellation/jsonschema/1-0-0",
    IGLU_NL_NS_ADD_PAYMENT_INFO_JSONSCHEMA_1MINUS0MINUS5: "iglu:nl.ns/add_payment_info/jsonschema/1-0-5",
    IGLU_NL_NS_ADD_SHIPPING_INFO_JSONSCHEMA_1MINUS0MINUS5: "iglu:nl.ns/add_shipping_info/jsonschema/1-0-5",
    IGLU_NL_NS_ADD_TO_CART_JSONSCHEMA_2MINUS0MINUS1: "iglu:nl.ns/add_to_cart/jsonschema/2-0-1",
    IGLU_NL_NS_ADD_TO_CART_JSONSCHEMA_2MINUS0MINUS2: "iglu:nl.ns/add_to_cart/jsonschema/2-0-2",
    IGLU_NL_NS_BEGIN_CHECKOUT_JSONSCHEMA_1MINUS0MINUS6: "iglu:nl.ns/begin_checkout/jsonschema/1-0-6",
    IGLU_NL_NS_KEUZEHULP_SUCCESS_JSONSCHEMA_1MINUS0MINUS3: "iglu:nl.ns/keuzehulp_success/jsonschema/1-0-3",
    IGLU_NL_NS_PAGE_CONTEXT_JSONSCHEMA_1MINUS0MINUS5: "iglu:nl.ns/page_context/jsonschema/1-0-5",
    IGLU_NL_NS_PURCHASE_JSONSCHEMA_2MINUS0MINUS13: "iglu:nl.ns/purchase/jsonschema/2-0-13",
    IGLU_NL_NS_PURCHASE_UNCONFIRMED_JSONSCHEMA_1MINUS0MINUS8: "iglu:nl.ns/purchase_unconfirmed/jsonschema/1-0-8",
    IGLU_NL_NS_REMOVE_FROM_CART_JSONSCHEMA_1MINUS0MINUS4: "iglu:nl.ns/remove_from_cart/jsonschema/1-0-4",
    IGLU_NL_NS_SELECT_ITEM_JSONSCHEMA_1MINUS0MINUS4: "iglu:nl.ns/select_item/jsonschema/1-0-4",
    IGLU_NL_NS_VIEW_ITEM_JSONSCHEMA_1MINUS0MINUS5: "iglu:nl.ns/view_item/jsonschema/1-0-5",
    IGLU_NL_NS_VIEW_ITEM_LIST_JSONSCHEMA_1MINUS0MINUS6: "iglu:nl.ns/view_item_list/jsonschema/1-0-6",
    IGLU_NL_NS_BANNER_CLICK_JSONSCHEMA_1MINUS0MINUS5: "iglu:nl.ns/banner_click/jsonschema/1-0-5",
    IGLU_NL_NS_NBA_VIEW_JSONSCHEMA_1MINUS0MINUS5: "iglu:nl.ns/nba_view/jsonschema/1-0-5",
    IGLU_NL_NS_ELEMENT_CLICK_JSONSCHEMA_1MINUS0MINUS3: "iglu:nl.ns/element_click/jsonschema/1-0-3",
    IGLU_NL_NS_LINK_CLICK_JSONSCHEMA_1MINUS0MINUS2: "iglu:nl.ns/link_click/jsonschema/1-0-2",
    IGLU_NL_NS_ELEMENT_CLICK_JSONSCHEMA_1MINUS0MINUS4: "iglu:nl.ns/element_click/jsonschema/1-0-4",
    IGLU_NL_NS_MODALITY_CARD_CLICK_JSONSCHEMA_1MINUS0MINUS1: "iglu:nl.ns/modality_card_click/jsonschema/1-0-1",
    IGLU_NL_NS_CHAT_START_JSONSCHEMA_1MINUS0MINUS1: "iglu:nl.ns/chat_start/jsonschema/1-0-1",
    IGLU_NL_NS_ELEMENT_CLOSE_JSONSCHEMA_1MINUS0MINUS0: "iglu:nl.ns/element_close/jsonschema/1-0-0",
  };
  
  var ChatInitiator = {
    CLICK: "click",
    HOVER: "hover",
    PREVIOUS_CHAT_SESSION: "previous_chat_session",
    TIME_DELAY: "time_delay",
  };
  
  var Language = {
    NL: "nl",
    EN: "en",
  };
  
  var NsShop = {
    NS_BUSINESSCARD: "ns_businesscard",
    SPOORDEELWINKEL: "spoordeelwinkel",
    ABONNEMENTEN: "abonnementen",
    LOSSE_VERVOERSBEWIJZEN: "losse_vervoersbewijzen",
    LVB_KAARTJES: "lvb_kaartjes",
    LVB_APP: "lvb_app",
    NS_MINUSFLEX: "ns-flex",
    KLANTENSERVICE: "klantenservice",
    MIJN_NS_CONSUMENT: "mijn_ns_consument",
    MIJN_NS_ZAKELIJK: "mijn_ns_zakelijk",
  };
  
  var FeedbackPlatform = {
    USABILLA: "usabilla",
    GETFEEDBACK: "getfeedback",
    QUALTRICS: "qualtrics",
  };
  
  var Currency = {
    EUR: "EUR",
  };
  
  var OriginType = {
    STATION: "station",
    ADDRESS: "address",
    STOP: "stop",
    POI: "poi",
    UNKNOWN: "unknown",
  };
  
  var CustomerEntity = {
    KAARTHOUDER: "kaarthouder",
    CONTACTPERSOON: "contactpersoon",
  };
  
  var Cluster = {
    ABO: "abo",
    LVB: "lvb",
    NSI: "nsi",
    OVK: "ovk",
    RCR: "rcr",
  };
  
  var CampaignStatus = {
    ACTIVE: "active",
    INACTIVE: "inactive",
  };
  
  var ChatClickSource = {
    BUTTON: "button",
    CANCELLATION_LINK: "cancellation_link",
    CHAT_LINK: "chat_link",
    LIVE_CHAT: "live_chat",
  };
  
  var PageType = {
    SERVICE_PAGE: "service_page",
    HOME_PAGE: "home_page",
    CHECK_OUT_PAGE: "check_out_page",
    THANK_YOU_PAGE: "thank_you_page",
    PRODUCT_OVERVIEW_PAGE: "product_overview_page",
    PRODUCT_CATEGORY_PAGE: "product_category_page",
    PRODUCT_DETAIL_PAGE: "product_detail_page",
    PRODUCT_CONFIGURATION_PAGE: "product_configuration_page",
    CAMPAIGN_PAGE: "campaign_page",
    NOT_SET: "not_set",
    CONTENT_OVERVIEW_PAGE: "content_overview_page",
    CONTENT_ARTICLE_PAGE: "content_article_page",
  };
  
  var WebsiteVersion = {
    CONSUMENT: "consument",
    ZAKELIJK: "zakelijk",
  };
  
  var MijnnsVersion = {
    MIJNNS: "mijnns",
    MIJNNS_ZAKELIJK: "mijnns_zakelijk",
  };
  
  var DestinationType = {
    STATION: "station",
    ADDRESS: "address",
    STOP: "stop",
    POI: "poi",
    UNKNOWN: "unknown",
  };
  
  var NsEnvironment = {
    ACC: "acc",
    TEST: "test",
    PROD: "prod",
    TEST2: "test2",
    TEST3: "test3",
    TESTAUT: "testaut",
    TESTAUT2: "testaut2",
    TESTAUT3: "testaut3",
    DEV_MINUSLOCALHOST: "dev-localhost",
    UNITTEST: "unittest",
  };
  
  var Method = {
    FACEBOOK: "facebook",
    TWITTER: "twitter",
    INSTAGRAM: "instagram",
    YOUTUBE: "youtube",
    LINKEDIN: "linkedin",
  };
  
  function assertOptionalCookieConsentStatus(cookieConsentStatus, label_) {
    var messages = [];
    if (cookieConsentStatus !== undefined && cookieConsentStatus !== null) {
      messages = messages.concat(AvoAssert.assertString("-DxiaheG2mil", label_ ? "cookie_consent_status" + ": " + label_ : "cookie_consent_status", cookieConsentStatus));
    }
    return messages;
  }
  
  function assertPlatform(platform, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("-PddLxwT_", label_ ? "platform" + ": " + label_ : "platform", platform));
    if ("web" !== platform &&
        "iOS" !== platform &&
        "android" !== platform &&
        "MFEP" !== platform) {
      var message = (label_ ? "platform" + ": " + label_ : "platform") + " should match one of the following values [ web | iOS | android | MFEP ] but you provided the value " + platform
      messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "-PddLxwT_", message: message}]);
    }
    return messages;
  }
  
  function assertExperiments(experiments, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertObject("-aHNB2FOOK", label_ ? "experiments" + ": " + label_ : "experiments", experiments));
    if (experiments !== null && experiments !== undefined) {
      messages = messages.concat(assertTestId(experiments.testId, label_));
      messages = messages.concat(assertOptionalTestDescription(experiments.testDescription, label_));
      messages = messages.concat(assertTestVariant(experiments.testVariant, label_));
      messages = messages.concat(assertOptionalTestLocation(experiments.testLocation, label_));
      messages = messages.concat(assertOptionalTestTeam(experiments.testTeam, label_));
      messages = messages.concat(assertOptionalTestAudienceId(experiments.testAudienceId, label_));
      messages = messages.concat(assertTestTool(experiments.testTool, label_));
    }
    return messages;
  }
  
  function assertOptionalPaymentType(paymentType, label_) {
    var messages = [];
    if (paymentType !== undefined && paymentType !== null) {
      messages = messages.concat(AvoAssert.assertString("06ak1UmwgYlK", label_ ? "payment_type" + ": " + label_ : "payment_type", paymentType));
      if ("Ideal" !== paymentType &&
          "Credit Card" !== paymentType) {
        var message = (label_ ? "payment_type" + ": " + label_ : "payment_type") + " should match one of the following values [ Ideal | Credit Card ] but you provided the value " + paymentType
        messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "06ak1UmwgYlK", message: message}]);
      }
    }
    return messages;
  }
  
  function assertIntercityDirect(intercityDirect, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertBool("17s21jQ4G", label_ ? "intercity_direct" + ": " + label_ : "intercity_direct", intercityDirect));
    return messages;
  }
  
  function assertOptionalIntercityDirect(intercityDirect, label_) {
    var messages = [];
    if (intercityDirect !== undefined && intercityDirect !== null) {
      messages = messages.concat(AvoAssert.assertBool("17s21jQ4G", label_ ? "intercity_direct" + ": " + label_ : "intercity_direct", intercityDirect));
    }
    return messages;
  }
  
  function assertValue(value, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertFloat("1WkP-6sA8x_5", label_ ? "value" + ": " + label_ : "value", value));
    return messages;
  }
  
  function assertSelectedOption(selectedOption, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("2_Kyx49Pj", label_ ? "selected_option" + ": " + label_ : "selected_option", selectedOption));
    return messages;
  }
  
  function assertVisible(visible, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertBool("2b5JV7Hc-MhF", label_ ? "visible" + ": " + label_ : "visible", visible));
    return messages;
  }
  
  function assertOptionalUtmCampaign(utmCampaign, label_) {
    var messages = [];
    if (utmCampaign !== undefined && utmCampaign !== null) {
      messages = messages.concat(AvoAssert.assertString("3k9em70_j0Ac", label_ ? "utm_campaign" + ": " + label_ : "utm_campaign", utmCampaign));
    }
    return messages;
  }
  
  function assertSchema(schema, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("4-eTlbcITN", label_ ? "schema" + ": " + label_ : "schema", schema));
    if ("iglu:nl.ns/login_start/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/login_error/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/view/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/cart_remove/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/chat_start/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/checkout_progress/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/checkout_start/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/content_share/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/cookie_change_permission/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/experiment_success/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/file_download/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/form_error/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/form_start/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/item_select/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/item_view/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/keuzehulp_click/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/lead_generate/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/nba_success/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/page_error/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/push_consent/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/registration_start/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/registration_success/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/reisplanner_error/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/reisplanner_success/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/reisregisseur_change_permission/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/reisvergelijker_start/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/reisvergelijker_success/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/scroll/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/search_start/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/video_complete/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/video_progress/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/video_start/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/visit_qualified/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/app_clear_data/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/purchase_intention/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/session_count/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/session_start/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/form_submit/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/keuzehulp_success/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/widget_add/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/widget_remove/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/station/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/detail_click/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/voorzieningen_click/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/kaart_click/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/modalities_filter/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/plan_vanaf_hier/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/traject_add/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/traject_remove/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/traject_seintjes/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/notification_receive/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/notification_open/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/notification_foreground/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/notification_dismiss/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/app_exception/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/app_remove/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/app_update/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/os_update/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/server_purchase/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/remove_from_cart/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/login_success/jsonschema/2-0-3" !== schema &&
        "iglu:nl.ns/page/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/cookie_consent_submit/jsonschema/2-0-2" !== schema &&
        "iglu:nl.ns/cookie_consent_view/jsonschema/2-0-2" !== schema &&
        "iglu:nl.ns/login_status_update/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/class_change_confirm/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/class_change_set/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/nba_context/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/screen_context/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/test_event_variant/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/feedback_give/jsonschema/1-0-2" !== schema &&
        "iglu:nl.ns/consent_context/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/purchase_intention_context/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/global_contexts/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/lost_and_found_search_category/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/lost_and_found_search_term/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/screen_view/jsonschema/1-0-7" !== schema &&
        "iglu:nl.ns/add_to_cart/jsonschema/1-0-5" !== schema &&
        "iglu:nl.ns/travel_planner_plan_journey/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/authentication/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/banner_click/jsonschema/1-0-3" !== schema &&
        "iglu:nl.ns/cart_add/jsonschema/1-0-3" !== schema &&
        "iglu:nl.ns/checkbox_click/jsonschema/1-0-3" !== schema &&
        "iglu:nl.ns/chip_filter_click/jsonschema/1-0-3" !== schema &&
        "iglu:nl.ns/click/jsonschema/1-0-2" !== schema &&
        "iglu:nl.ns/clicked_option/jsonschema/1-0-1" !== schema &&
        "iglu:nl.ns/cookie_consent_change/jsonschema/1-0-2" !== schema &&
        "iglu:nl.ns/datepicker_click/jsonschema/1-0-3" !== schema &&
        "iglu:nl.ns/element_click/jsonschema/1-0-2" !== schema &&
        "iglu:nl.ns/element_view/jsonschema/4-0-2" !== schema &&
        "iglu:nl.ns/error/jsonschema/1-0-1" !== schema &&
        "iglu:nl.ns/expandable_click/jsonschema/1-0-3" !== schema &&
        "iglu:nl.ns/experiment_view/jsonschema/1-0-5" !== schema &&
        "iglu:nl.ns/link_click/jsonschema/1-0-1" !== schema &&
        "iglu:nl.ns/logout_success/jsonschema/1-0-1" !== schema &&
        "iglu:nl.ns/nba_audience_add/jsonschema/1-0-1" !== schema &&
        "iglu:nl.ns/nba_view/jsonschema/1-0-3" !== schema &&
        "iglu:nl.ns/page_view/jsonschema/4-0-3" !== schema &&
        "iglu:nl.ns/reisplanner_plan_trip/jsonschema/1-0-3" !== schema &&
        "iglu:nl.ns/search_view_results/jsonschema/2-0-3" !== schema &&
        "iglu:nl.ns/select_click/jsonschema/1-0-2" !== schema &&
        "iglu:nl.ns/selectable_click/jsonschema/1-0-3" !== schema &&
        "iglu:nl.ns/server_experiments/jsonschema/1-0-1" !== schema &&
        "iglu:nl.ns/subscription_cancel_select/jsonschema/1-0-1" !== schema &&
        "iglu:nl.ns/subscription_change/jsonschema/1-0-1" !== schema &&
        "iglu:nl.ns/subscription_change_select/jsonschema/1-0-2" !== schema &&
        "iglu:nl.ns/toggle_click/jsonschema/1-0-3" !== schema &&
        "iglu:nl.ns/tooltip_click/jsonschema/1-0-4" !== schema &&
        "iglu:nl.ns/button_click/jsonschema/2-0-6" !== schema &&
        "iglu:nl.ns/app_os_unsupported/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/unsupported_app_version/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/unsupported_os_version/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/deprecated_app_version/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/add_payment_info/jsonschema/1-0-2" !== schema &&
        "iglu:nl.ns/add_shipping_info/jsonschema/1-0-2" !== schema &&
        "iglu:nl.ns/add_to_cart/jsonschema/1-0-6" !== schema &&
        "iglu:nl.ns/begin_checkout/jsonschema/1-0-2" !== schema &&
        "iglu:nl.ns/purchase/jsonschema/2-0-7" !== schema &&
        "iglu:nl.ns/purchase_unconfirmed/jsonschema/1-0-4" !== schema &&
        "iglu:nl.ns/view_item/jsonschema/1-0-2" !== schema &&
        "iglu:nl.ns/view_item_list/jsonschema/1-0-2" !== schema &&
        "iglu:nl.ns/purchase_intention_context/jsonschema/1-0-1" !== schema &&
        "iglu:nl.ns/journey_detail_save_trip/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/journey_detail_set_notifications/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/saved_trips_delete/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/saved_trips_extra_options/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/saved_trips_modal_cancel/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/saved_trips_modal_extra_options/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/saved_trips_modal_save_notifications/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/saved_trips_save_changes/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/bottom_bar_saved/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/homepage_saved_trips_widget_click/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/homepage_saved_trips_widget_to_saved/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/select_item/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/view_item_list/jsonschema/1-0-3" !== schema &&
        "iglu:nl.ns/page_context/jsonschema/1-0-2" !== schema &&
        "iglu:nl.ns/page_view/jsonschema/4-0-4" !== schema &&
        "iglu:nl.ns/experiments_context/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/login_status_context/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/personalization_context/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/page_context/jsonschema/1-0-3" !== schema &&
        "iglu:nl.ns/banner_click/jsonschema/1-0-4" !== schema &&
        "iglu:nl.ns/nba_view/jsonschema/1-0-4" !== schema &&
        "iglu:nl.ns/purchase/jsonschema/2-0-8" !== schema &&
        "iglu:nl.ns/consent/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/scroll_context/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/screen_view/jsonschema/1-0-8" !== schema &&
        "iglu:nl.ns/screen_view/jsonschema/1-0-9" !== schema &&
        "iglu:nl.ns/purchase_non_usable/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/experiments_initialized/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/experiments/jsonschema/1-0-1" !== schema &&
        "iglu:nl.ns/experiments/jsonschema/1-0-2" !== schema &&
        "iglu:nl.ns/global_contexts/jsonschema/1-0-1" !== schema &&
        "iglu:nl.ns/screen_view/jsonschema/1-1-0" !== schema &&
        "iglu:nl.ns/screen_view/jsonschema/1-0-10" !== schema &&
        "iglu:nl.ns/add_payment_info/jsonschema/1-0-3" !== schema &&
        "iglu:nl.ns/add_shipping_info/jsonschema/1-0-3" !== schema &&
        "iglu:nl.ns/add_to_cart/jsonschema/1-0-7" !== schema &&
        "iglu:nl.ns/begin_checkout/jsonschema/1-0-3" !== schema &&
        "iglu:nl.ns/keuzehulp_success/jsonschema/1-0-2" !== schema &&
        "iglu:nl.ns/purchase/jsonschema/2-0-9" !== schema &&
        "iglu:nl.ns/purchase_unconfirmed/jsonschema/1-0-5" !== schema &&
        "iglu:nl.ns/view_item/jsonschema/1-0-3" !== schema &&
        "iglu:nl.ns/view_item_list/jsonschema/1-0-4" !== schema &&
        "iglu:nl.ns/remove_from_cart/jsonschema/1-0-1" !== schema &&
        "iglu:nl.ns/select_item/jsonschema/1-0-1" !== schema &&
        "iglu:nl.ns/form_error/jsonschema/1-0-1" !== schema &&
        "iglu:nl.ns/form_start/jsonschema/1-0-1" !== schema &&
        "iglu:nl.ns/form_submit/jsonschema/1-0-1" !== schema &&
        "iglu:nl.ns/personalization_context/jsonschema/1-0-1" !== schema &&
        "iglu:nl.ns/begin_checkout/jsonschema/1-0-4" !== schema &&
        "iglu:nl.ns/file_download/jsonschema/1-0-1" !== schema &&
        "iglu:nl.ns/reisplanner_error/jsonschema/1-0-1" !== schema &&
        "iglu:nl.ns/consent/jsonschema/1-0-2" !== schema &&
        "iglu:nl.ns/experiments/jsonschema/1-0-3" !== schema &&
        "iglu:nl.ns/login_status_context/jsonschema/1-0-1" !== schema &&
        "iglu:nl.ns/page_context/jsonschema/1-0-4" !== schema &&
        "iglu:nl.ns/purchase_intention_context/jsonschema/1-0-2" !== schema &&
        "iglu:nl.ns/screen_context/jsonschema/1-0-1" !== schema &&
        "iglu:nl.ns/screen_view/jsonschema/1-0-11" !== schema &&
        "iglu:nl.ns/experiments_session/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/purchase/jsonschema/2-0-10" !== schema &&
        "iglu:nl.ns/purchase_server_side/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/add_payment_info/jsonschema/1-0-4" !== schema &&
        "iglu:nl.ns/add_shipping_info/jsonschema/1-0-4" !== schema &&
        "iglu:nl.ns/add_to_cart/jsonschema/1-0-8" !== schema &&
        "iglu:nl.ns/add_to_cart/jsonschema/2-0-0" !== schema &&
        "iglu:nl.ns/begin_checkout/jsonschema/1-0-5" !== schema &&
        "iglu:nl.ns/keuzehulp_success/jsonschema/1-0-1" !== schema &&
        "iglu:nl.ns/purchase/jsonschema/2-0-11" !== schema &&
        "iglu:nl.ns/purchase/jsonschema/2-0-12" !== schema &&
        "iglu:nl.ns/purchase_unconfirmed/jsonschema/1-0-6" !== schema &&
        "iglu:nl.ns/remove_from_cart/jsonschema/1-0-2" !== schema &&
        "iglu:nl.ns/select_item/jsonschema/1-0-3" !== schema &&
        "iglu:nl.ns/view_item/jsonschema/1-0-4" !== schema &&
        "iglu:nl.ns/view_item_list/jsonschema/1-0-5" !== schema &&
        "iglu:nl.ns/order_change/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/purchase_unconfirmed/jsonschema/1-0-7" !== schema &&
        "iglu:nl.ns/remove_from_cart/jsonschema/1-0-3" !== schema &&
        "iglu:nl.ns/element_view/jsonschema/4-0-3" !== schema &&
        "iglu:nl.ns/external_referrer/jsonschema/1-0-0" !== schema &&
        "iglu:com.snowplowanalytics.mobile/deep_link_received/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/cancellation/jsonschema/1-0-0" !== schema &&
        "iglu:nl.ns/add_payment_info/jsonschema/1-0-5" !== schema &&
        "iglu:nl.ns/add_shipping_info/jsonschema/1-0-5" !== schema &&
        "iglu:nl.ns/add_to_cart/jsonschema/2-0-1" !== schema &&
        "iglu:nl.ns/add_to_cart/jsonschema/2-0-2" !== schema &&
        "iglu:nl.ns/begin_checkout/jsonschema/1-0-6" !== schema &&
        "iglu:nl.ns/keuzehulp_success/jsonschema/1-0-3" !== schema &&
        "iglu:nl.ns/page_context/jsonschema/1-0-5" !== schema &&
        "iglu:nl.ns/purchase/jsonschema/2-0-13" !== schema &&
        "iglu:nl.ns/purchase_unconfirmed/jsonschema/1-0-8" !== schema &&
        "iglu:nl.ns/remove_from_cart/jsonschema/1-0-4" !== schema &&
        "iglu:nl.ns/select_item/jsonschema/1-0-4" !== schema &&
        "iglu:nl.ns/view_item/jsonschema/1-0-5" !== schema &&
        "iglu:nl.ns/view_item_list/jsonschema/1-0-6" !== schema &&
        "iglu:nl.ns/banner_click/jsonschema/1-0-5" !== schema &&
        "iglu:nl.ns/nba_view/jsonschema/1-0-5" !== schema &&
        "iglu:nl.ns/element_click/jsonschema/1-0-3" !== schema &&
        "iglu:nl.ns/link_click/jsonschema/1-0-2" !== schema &&
        "iglu:nl.ns/element_click/jsonschema/1-0-4" !== schema &&
        "iglu:nl.ns/modality_card_click/jsonschema/1-0-1" !== schema &&
        "iglu:nl.ns/chat_start/jsonschema/1-0-1" !== schema &&
        "iglu:nl.ns/element_close/jsonschema/1-0-0" !== schema) {
      var message = (label_ ? "schema" + ": " + label_ : "schema") + " should match one of the following values [ iglu:nl.ns/login_start/jsonschema/1-0-0 | iglu:nl.ns/login_error/jsonschema/1-0-0 | iglu:nl.ns/view/jsonschema/1-0-0 | iglu:nl.ns/cart_remove/jsonschema/1-0-0 | iglu:nl.ns/chat_start/jsonschema/1-0-0 | iglu:nl.ns/checkout_progress/jsonschema/1-0-0 | iglu:nl.ns/checkout_start/jsonschema/1-0-0 | iglu:nl.ns/content_share/jsonschema/1-0-0 | iglu:nl.ns/cookie_change_permission/jsonschema/1-0-0 | iglu:nl.ns/experiment_success/jsonschema/1-0-0 | iglu:nl.ns/file_download/jsonschema/1-0-0 | iglu:nl.ns/form_error/jsonschema/1-0-0 | iglu:nl.ns/form_start/jsonschema/1-0-0 | iglu:nl.ns/item_select/jsonschema/1-0-0 | iglu:nl.ns/item_view/jsonschema/1-0-0 | iglu:nl.ns/keuzehulp_click/jsonschema/1-0-0 | iglu:nl.ns/lead_generate/jsonschema/1-0-0 | iglu:nl.ns/nba_success/jsonschema/1-0-0 | iglu:nl.ns/page_error/jsonschema/1-0-0 | iglu:nl.ns/push_consent/jsonschema/1-0-0 | iglu:nl.ns/registration_start/jsonschema/1-0-0 | iglu:nl.ns/registration_success/jsonschema/1-0-0 | iglu:nl.ns/reisplanner_error/jsonschema/1-0-0 | iglu:nl.ns/reisplanner_success/jsonschema/1-0-0 | iglu:nl.ns/reisregisseur_change_permission/jsonschema/1-0-0 | iglu:nl.ns/reisvergelijker_start/jsonschema/1-0-0 | iglu:nl.ns/reisvergelijker_success/jsonschema/1-0-0 | iglu:nl.ns/scroll/jsonschema/1-0-0 | iglu:nl.ns/search_start/jsonschema/1-0-0 | iglu:nl.ns/video_complete/jsonschema/1-0-0 | iglu:nl.ns/video_progress/jsonschema/1-0-0 | iglu:nl.ns/video_start/jsonschema/1-0-0 | iglu:nl.ns/visit_qualified/jsonschema/1-0-0 | iglu:nl.ns/app_clear_data/jsonschema/1-0-0 | iglu:nl.ns/purchase_intention/jsonschema/1-0-0 | iglu:nl.ns/session_count/jsonschema/1-0-0 | iglu:nl.ns/session_start/jsonschema/1-0-0 | iglu:nl.ns/form_submit/jsonschema/1-0-0 | iglu:nl.ns/keuzehulp_success/jsonschema/1-0-0 | iglu:nl.ns/widget_add/jsonschema/1-0-0 | iglu:nl.ns/widget_remove/jsonschema/1-0-0 | iglu:nl.ns/station/jsonschema/1-0-0 | iglu:nl.ns/detail_click/jsonschema/1-0-0 | iglu:nl.ns/voorzieningen_click/jsonschema/1-0-0 | iglu:nl.ns/kaart_click/jsonschema/1-0-0 | iglu:nl.ns/modalities_filter/jsonschema/1-0-0 | iglu:nl.ns/plan_vanaf_hier/jsonschema/1-0-0 | iglu:nl.ns/traject_add/jsonschema/1-0-0 | iglu:nl.ns/traject_remove/jsonschema/1-0-0 | iglu:nl.ns/traject_seintjes/jsonschema/1-0-0 | iglu:nl.ns/notification_receive/jsonschema/1-0-0 | iglu:nl.ns/notification_open/jsonschema/1-0-0 | iglu:nl.ns/notification_foreground/jsonschema/1-0-0 | iglu:nl.ns/notification_dismiss/jsonschema/1-0-0 | iglu:nl.ns/app_exception/jsonschema/1-0-0 | iglu:nl.ns/app_remove/jsonschema/1-0-0 | iglu:nl.ns/app_update/jsonschema/1-0-0 | iglu:nl.ns/os_update/jsonschema/1-0-0 | iglu:nl.ns/server_purchase/jsonschema/1-0-0 | iglu:nl.ns/remove_from_cart/jsonschema/1-0-0 | iglu:nl.ns/login_success/jsonschema/2-0-3 | iglu:nl.ns/page/jsonschema/1-0-0 | iglu:nl.ns/cookie_consent_submit/jsonschema/2-0-2 | iglu:nl.ns/cookie_consent_view/jsonschema/2-0-2 | iglu:nl.ns/login_status_update/jsonschema/1-0-0 | iglu:nl.ns/class_change_confirm/jsonschema/1-0-0 | iglu:nl.ns/class_change_set/jsonschema/1-0-0 | iglu:nl.ns/nba_context/jsonschema/1-0-0 | iglu:nl.ns/screen_context/jsonschema/1-0-0 | iglu:nl.ns/test_event_variant/jsonschema/1-0-0 | iglu:nl.ns/feedback_give/jsonschema/1-0-2 | iglu:nl.ns/consent_context/jsonschema/1-0-0 | iglu:nl.ns/purchase_intention_context/jsonschema/1-0-0 | iglu:nl.ns/global_contexts/jsonschema/1-0-0 | iglu:nl.ns/lost_and_found_search_category/jsonschema/1-0-0 | iglu:nl.ns/lost_and_found_search_term/jsonschema/1-0-0 | iglu:nl.ns/screen_view/jsonschema/1-0-7 | iglu:nl.ns/add_to_cart/jsonschema/1-0-5 | iglu:nl.ns/travel_planner_plan_journey/jsonschema/1-0-0 | iglu:nl.ns/authentication/jsonschema/1-0-0 | iglu:nl.ns/banner_click/jsonschema/1-0-3 | iglu:nl.ns/cart_add/jsonschema/1-0-3 | iglu:nl.ns/checkbox_click/jsonschema/1-0-3 | iglu:nl.ns/chip_filter_click/jsonschema/1-0-3 | iglu:nl.ns/click/jsonschema/1-0-2 | iglu:nl.ns/clicked_option/jsonschema/1-0-1 | iglu:nl.ns/cookie_consent_change/jsonschema/1-0-2 | iglu:nl.ns/datepicker_click/jsonschema/1-0-3 | iglu:nl.ns/element_click/jsonschema/1-0-2 | iglu:nl.ns/element_view/jsonschema/4-0-2 | iglu:nl.ns/error/jsonschema/1-0-1 | iglu:nl.ns/expandable_click/jsonschema/1-0-3 | iglu:nl.ns/experiment_view/jsonschema/1-0-5 | iglu:nl.ns/link_click/jsonschema/1-0-1 | iglu:nl.ns/logout_success/jsonschema/1-0-1 | iglu:nl.ns/nba_audience_add/jsonschema/1-0-1 | iglu:nl.ns/nba_view/jsonschema/1-0-3 | iglu:nl.ns/page_view/jsonschema/4-0-3 | iglu:nl.ns/reisplanner_plan_trip/jsonschema/1-0-3 | iglu:nl.ns/search_view_results/jsonschema/2-0-3 | iglu:nl.ns/select_click/jsonschema/1-0-2 | iglu:nl.ns/selectable_click/jsonschema/1-0-3 | iglu:nl.ns/server_experiments/jsonschema/1-0-1 | iglu:nl.ns/subscription_cancel_select/jsonschema/1-0-1 | iglu:nl.ns/subscription_change/jsonschema/1-0-1 | iglu:nl.ns/subscription_change_select/jsonschema/1-0-2 | iglu:nl.ns/toggle_click/jsonschema/1-0-3 | iglu:nl.ns/tooltip_click/jsonschema/1-0-4 | iglu:nl.ns/button_click/jsonschema/2-0-6 | iglu:nl.ns/app_os_unsupported/jsonschema/1-0-0 | iglu:nl.ns/unsupported_app_version/jsonschema/1-0-0 | iglu:nl.ns/unsupported_os_version/jsonschema/1-0-0 | iglu:nl.ns/deprecated_app_version/jsonschema/1-0-0 | iglu:nl.ns/add_payment_info/jsonschema/1-0-2 | iglu:nl.ns/add_shipping_info/jsonschema/1-0-2 | iglu:nl.ns/add_to_cart/jsonschema/1-0-6 | iglu:nl.ns/begin_checkout/jsonschema/1-0-2 | iglu:nl.ns/purchase/jsonschema/2-0-7 | iglu:nl.ns/purchase_unconfirmed/jsonschema/1-0-4 | iglu:nl.ns/view_item/jsonschema/1-0-2 | iglu:nl.ns/view_item_list/jsonschema/1-0-2 | iglu:nl.ns/purchase_intention_context/jsonschema/1-0-1 | iglu:nl.ns/journey_detail_save_trip/jsonschema/1-0-0 | iglu:nl.ns/journey_detail_set_notifications/jsonschema/1-0-0 | iglu:nl.ns/saved_trips_delete/jsonschema/1-0-0 | iglu:nl.ns/saved_trips_extra_options/jsonschema/1-0-0 | iglu:nl.ns/saved_trips_modal_cancel/jsonschema/1-0-0 | iglu:nl.ns/saved_trips_modal_extra_options/jsonschema/1-0-0 | iglu:nl.ns/saved_trips_modal_save_notifications/jsonschema/1-0-0 | iglu:nl.ns/saved_trips_save_changes/jsonschema/1-0-0 | iglu:nl.ns/bottom_bar_saved/jsonschema/1-0-0 | iglu:nl.ns/homepage_saved_trips_widget_click/jsonschema/1-0-0 | iglu:nl.ns/homepage_saved_trips_widget_to_saved/jsonschema/1-0-0 | iglu:nl.ns/select_item/jsonschema/1-0-0 | iglu:nl.ns/view_item_list/jsonschema/1-0-3 | iglu:nl.ns/page_context/jsonschema/1-0-2 | iglu:nl.ns/page_view/jsonschema/4-0-4 | iglu:nl.ns/experiments_context/jsonschema/1-0-0 | iglu:nl.ns/login_status_context/jsonschema/1-0-0 | iglu:nl.ns/personalization_context/jsonschema/1-0-0 | iglu:nl.ns/page_context/jsonschema/1-0-3 | iglu:nl.ns/banner_click/jsonschema/1-0-4 | iglu:nl.ns/nba_view/jsonschema/1-0-4 | iglu:nl.ns/purchase/jsonschema/2-0-8 | iglu:nl.ns/consent/jsonschema/1-0-0 | iglu:nl.ns/scroll_context/jsonschema/1-0-0 | iglu:nl.ns/screen_view/jsonschema/1-0-8 | iglu:nl.ns/screen_view/jsonschema/1-0-9 | iglu:nl.ns/purchase_non_usable/jsonschema/1-0-0 | iglu:nl.ns/experiments_initialized/jsonschema/1-0-0 | iglu:nl.ns/experiments/jsonschema/1-0-1 | iglu:nl.ns/experiments/jsonschema/1-0-2 | iglu:nl.ns/global_contexts/jsonschema/1-0-1 | iglu:nl.ns/screen_view/jsonschema/1-1-0 | iglu:nl.ns/screen_view/jsonschema/1-0-10 | iglu:nl.ns/add_payment_info/jsonschema/1-0-3 | iglu:nl.ns/add_shipping_info/jsonschema/1-0-3 | iglu:nl.ns/add_to_cart/jsonschema/1-0-7 | iglu:nl.ns/begin_checkout/jsonschema/1-0-3 | iglu:nl.ns/keuzehulp_success/jsonschema/1-0-2 | iglu:nl.ns/purchase/jsonschema/2-0-9 | iglu:nl.ns/purchase_unconfirmed/jsonschema/1-0-5 | iglu:nl.ns/view_item/jsonschema/1-0-3 | iglu:nl.ns/view_item_list/jsonschema/1-0-4 | iglu:nl.ns/remove_from_cart/jsonschema/1-0-1 | iglu:nl.ns/select_item/jsonschema/1-0-1 | iglu:nl.ns/form_error/jsonschema/1-0-1 | iglu:nl.ns/form_start/jsonschema/1-0-1 | iglu:nl.ns/form_submit/jsonschema/1-0-1 | iglu:nl.ns/personalization_context/jsonschema/1-0-1 | iglu:nl.ns/begin_checkout/jsonschema/1-0-4 | iglu:nl.ns/file_download/jsonschema/1-0-1 | iglu:nl.ns/reisplanner_error/jsonschema/1-0-1 | iglu:nl.ns/consent/jsonschema/1-0-2 | iglu:nl.ns/experiments/jsonschema/1-0-3 | iglu:nl.ns/login_status_context/jsonschema/1-0-1 | iglu:nl.ns/page_context/jsonschema/1-0-4 | iglu:nl.ns/purchase_intention_context/jsonschema/1-0-2 | iglu:nl.ns/screen_context/jsonschema/1-0-1 | iglu:nl.ns/screen_view/jsonschema/1-0-11 | iglu:nl.ns/experiments_session/jsonschema/1-0-0 | iglu:nl.ns/purchase/jsonschema/2-0-10 | iglu:nl.ns/purchase_server_side/jsonschema/1-0-0 | iglu:nl.ns/add_payment_info/jsonschema/1-0-4 | iglu:nl.ns/add_shipping_info/jsonschema/1-0-4 | iglu:nl.ns/add_to_cart/jsonschema/1-0-8 | iglu:nl.ns/add_to_cart/jsonschema/2-0-0 | iglu:nl.ns/begin_checkout/jsonschema/1-0-5 | iglu:nl.ns/keuzehulp_success/jsonschema/1-0-1 | iglu:nl.ns/purchase/jsonschema/2-0-11 | iglu:nl.ns/purchase/jsonschema/2-0-12 | iglu:nl.ns/purchase_unconfirmed/jsonschema/1-0-6 | iglu:nl.ns/remove_from_cart/jsonschema/1-0-2 | iglu:nl.ns/select_item/jsonschema/1-0-3 | iglu:nl.ns/view_item/jsonschema/1-0-4 | iglu:nl.ns/view_item_list/jsonschema/1-0-5 | iglu:nl.ns/order_change/jsonschema/1-0-0 | iglu:nl.ns/purchase_unconfirmed/jsonschema/1-0-7 | iglu:nl.ns/remove_from_cart/jsonschema/1-0-3 | iglu:nl.ns/element_view/jsonschema/4-0-3 | iglu:nl.ns/external_referrer/jsonschema/1-0-0 | iglu:com.snowplowanalytics.mobile/deep_link_received/jsonschema/1-0-0 | iglu:nl.ns/cancellation/jsonschema/1-0-0 | iglu:nl.ns/add_payment_info/jsonschema/1-0-5 | iglu:nl.ns/add_shipping_info/jsonschema/1-0-5 | iglu:nl.ns/add_to_cart/jsonschema/2-0-1 | iglu:nl.ns/add_to_cart/jsonschema/2-0-2 | iglu:nl.ns/begin_checkout/jsonschema/1-0-6 | iglu:nl.ns/keuzehulp_success/jsonschema/1-0-3 | iglu:nl.ns/page_context/jsonschema/1-0-5 | iglu:nl.ns/purchase/jsonschema/2-0-13 | iglu:nl.ns/purchase_unconfirmed/jsonschema/1-0-8 | iglu:nl.ns/remove_from_cart/jsonschema/1-0-4 | iglu:nl.ns/select_item/jsonschema/1-0-4 | iglu:nl.ns/view_item/jsonschema/1-0-5 | iglu:nl.ns/view_item_list/jsonschema/1-0-6 | iglu:nl.ns/banner_click/jsonschema/1-0-5 | iglu:nl.ns/nba_view/jsonschema/1-0-5 | iglu:nl.ns/element_click/jsonschema/1-0-3 | iglu:nl.ns/link_click/jsonschema/1-0-2 | iglu:nl.ns/element_click/jsonschema/1-0-4 | iglu:nl.ns/modality_card_click/jsonschema/1-0-1 | iglu:nl.ns/chat_start/jsonschema/1-0-1 | iglu:nl.ns/element_close/jsonschema/1-0-0 ] but you provided the value " + schema
      messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "4-eTlbcITN", message: message}]);
    }
    return messages;
  }
  
  function assertOptionalUtmSource(utmSource, label_) {
    var messages = [];
    if (utmSource !== undefined && utmSource !== null) {
      messages = messages.concat(AvoAssert.assertString("4X73rTMNgTkZ", label_ ? "utm_source" + ": " + label_ : "utm_source", utmSource));
    }
    return messages;
  }
  
  function assertOptionalFeedbackType(feedbackType, label_) {
    var messages = [];
    if (feedbackType !== undefined && feedbackType !== null) {
      messages = messages.concat(AvoAssert.assertString("5EE-BUb_w", label_ ? "feedback_type" + ": " + label_ : "feedback_type", feedbackType));
    }
    return messages;
  }
  
  function assertVideoUrl(videoUrl, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("5W6xoSKVWDn2", label_ ? "video_url" + ": " + label_ : "video_url", videoUrl));
    return messages;
  }
  
  function assertChatInitiator(chatInitiator, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("5pRtByAXn", label_ ? "chat_initiator" + ": " + label_ : "chat_initiator", chatInitiator));
    if ("click" !== chatInitiator &&
        "hover" !== chatInitiator &&
        "previous_chat_session" !== chatInitiator &&
        "time_delay" !== chatInitiator) {
      var message = (label_ ? "chat_initiator" + ": " + label_ : "chat_initiator") + " should match one of the following values [ click | hover | previous_chat_session | time_delay ] but you provided the value " + chatInitiator
      messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "5pRtByAXn", message: message}]);
    }
    return messages;
  }
  
  function assertOpened(opened, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertBool("5r8JteLxZ", label_ ? "opened" + ": " + label_ : "opened", opened));
    return messages;
  }
  
  function assertItemBrand(itemBrand, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("6-GUnFHLFL", label_ ? "item_brand" + ": " + label_ : "item_brand", itemBrand));
    return messages;
  }
  
  function assertOptionalItemBrand(itemBrand, label_) {
    var messages = [];
    if (itemBrand !== undefined && itemBrand !== null) {
      messages = messages.concat(AvoAssert.assertString("6-GUnFHLFL", label_ ? "item_brand" + ": " + label_ : "item_brand", itemBrand));
    }
    return messages;
  }
  
  function assertOptionalData(data, label_) {
    var messages = [];
    if (data !== undefined && data !== null) {
      messages = messages.concat(AvoAssert.assertString("7HGUvDZb-Fax", label_ ? "data" + ": " + label_ : "data", data));
    }
    return messages;
  }
  
  function assertErrorCategory(errorCategory, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("7Nf2EeEBl", label_ ? "error_category" + ": " + label_ : "error_category", errorCategory));
    return messages;
  }
  
  function assertUcVariant(ucVariant, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("7OXAcO_7A", label_ ? "uc_variant" + ": " + label_ : "uc_variant", ucVariant));
    return messages;
  }
  
  function assertQuestion(question, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("7f5ty_nULaWo", label_ ? "question" + ": " + label_ : "question", question));
    return messages;
  }
  
  function assertOptionalItemCategory(itemCategory, label_) {
    var messages = [];
    if (itemCategory !== undefined && itemCategory !== null) {
      messages = messages.concat(AvoAssert.assertString("7h-TV9MOq2", label_ ? "item_category" + ": " + label_ : "item_category", itemCategory));
    }
    return messages;
  }
  
  function assertFormDestination(formDestination, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("83KZlBXgHnFi", label_ ? "form_destination" + ": " + label_ : "form_destination", formDestination));
    return messages;
  }
  
  function assertOptionOnlyLocalTrains(optionOnlyLocalTrains, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertBool("8jofQf9ETeBe", label_ ? "option_only_local_trains" + ": " + label_ : "option_only_local_trains", optionOnlyLocalTrains));
    return messages;
  }
  
  function assertCoupon(coupon, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("9Tv-BxH6jSI", label_ ? "coupon" + ": " + label_ : "coupon", coupon));
    return messages;
  }
  
  function assertOptionalCoupon(coupon, label_) {
    var messages = [];
    if (coupon !== undefined && coupon !== null) {
      messages = messages.concat(AvoAssert.assertString("9Tv-BxH6jSI", label_ ? "coupon" + ": " + label_ : "coupon", coupon));
    }
    return messages;
  }
  
  function assertHashedEmail(hashedEmail, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("ALoQI7FpkV", label_ ? "hashed_email" + ": " + label_ : "hashed_email", hashedEmail));
    return messages;
  }
  
  function assertLanguage(language, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("Af3-RL1nz2", label_ ? "language" + ": " + label_ : "language", language));
    if ("nl" !== language &&
        "en" !== language) {
      var message = (label_ ? "language" + ": " + label_ : "language") + " should match one of the following values [ nl | en ] but you provided the value " + language
      messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "Af3-RL1nz2", message: message}]);
    }
    return messages;
  }
  
  function assertUcLocation(ucLocation, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("Am6PkQ_Uo", label_ ? "uc_location" + ": " + label_ : "uc_location", ucLocation));
    return messages;
  }
  
  function assertChatTool(chatTool, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("B7jES2_im", label_ ? "chat_tool" + ": " + label_ : "chat_tool", chatTool));
    return messages;
  }
  
  function assertOptionalNsShop(nsShop, label_) {
    var messages = [];
    if (nsShop !== undefined && nsShop !== null) {
      messages = messages.concat(AvoAssert.assertString("BImlhIesBPhx", label_ ? "ns_shop" + ": " + label_ : "ns_shop", nsShop));
      if ("ns_businesscard" !== nsShop &&
          "spoordeelwinkel" !== nsShop &&
          "abonnementen" !== nsShop &&
          "losse_vervoersbewijzen" !== nsShop &&
          "lvb_kaartjes" !== nsShop &&
          "lvb_app" !== nsShop &&
          "ns-flex" !== nsShop &&
          "klantenservice" !== nsShop &&
          "mijn_ns_consument" !== nsShop &&
          "mijn_ns_zakelijk" !== nsShop) {
        var message = (label_ ? "ns_shop" + ": " + label_ : "ns_shop") + " should match one of the following values [ ns_businesscard | spoordeelwinkel | abonnementen | losse_vervoersbewijzen | lvb_kaartjes | lvb_app | ns-flex | klantenservice | mijn_ns_consument | mijn_ns_zakelijk ] but you provided the value " + nsShop
        messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "BImlhIesBPhx", message: message}]);
      }
    }
    return messages;
  }
  
  function assertNsShop(nsShop, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("BImlhIesBPhx", label_ ? "ns_shop" + ": " + label_ : "ns_shop", nsShop));
    if ("ns_businesscard" !== nsShop &&
        "spoordeelwinkel" !== nsShop &&
        "abonnementen" !== nsShop &&
        "losse_vervoersbewijzen" !== nsShop &&
        "lvb_kaartjes" !== nsShop &&
        "lvb_app" !== nsShop &&
        "ns-flex" !== nsShop &&
        "klantenservice" !== nsShop &&
        "mijn_ns_consument" !== nsShop &&
        "mijn_ns_zakelijk" !== nsShop) {
      var message = (label_ ? "ns_shop" + ": " + label_ : "ns_shop") + " should match one of the following values [ ns_businesscard | spoordeelwinkel | abonnementen | losse_vervoersbewijzen | lvb_kaartjes | lvb_app | ns-flex | klantenservice | mijn_ns_consument | mijn_ns_zakelijk ] but you provided the value " + nsShop
      messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "BImlhIesBPhx", message: message}]);
    }
    return messages;
  }
  
  function assertFeedbackPlatform(feedbackPlatform, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("BRMFCaolHInZ", label_ ? "feedback_platform" + ": " + label_ : "feedback_platform", feedbackPlatform));
    if ("usabilla" !== feedbackPlatform &&
        "getfeedback" !== feedbackPlatform &&
        "qualtrics" !== feedbackPlatform) {
      var message = (label_ ? "feedback_platform" + ": " + label_ : "feedback_platform") + " should match one of the following values [ usabilla | getfeedback | qualtrics ] but you provided the value " + feedbackPlatform
      messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "BRMFCaolHInZ", message: message}]);
    }
    return messages;
  }
  
  function assertOptionalUtmId(utmId, label_) {
    var messages = [];
    if (utmId !== undefined && utmId !== null) {
      messages = messages.concat(AvoAssert.assertString("BXSsSA9Tphqq", label_ ? "utm_id" + ": " + label_ : "utm_id", utmId));
    }
    return messages;
  }
  
  function assertClickType(clickType, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("BxxFgWL7KfAD", label_ ? "click_type" + ": " + label_ : "click_type", clickType));
    return messages;
  }
  
  function assertVideoCurrentTime(videoCurrentTime, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertFloat("C3vfalxpU8Ib", label_ ? "video_current_time" + ": " + label_ : "video_current_time", videoCurrentTime));
    return messages;
  }
  
  function assertOptionalOptionTransportOptions(optionTransportOptions, label_) {
    var messages = [];
    if (optionTransportOptions !== undefined && optionTransportOptions !== null) {
      messages = messages.concat(AvoAssert.assertString("CaMQ0XJCJbKL", label_ ? "option_transport_options" + ": " + label_ : "option_transport_options", optionTransportOptions));
    }
    return messages;
  }
  
  function assertAffiliation(affiliation, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("D-6RH3lvH", label_ ? "affiliation" + ": " + label_ : "affiliation", affiliation));
    return messages;
  }
  
  function assertOptionalAffiliation(affiliation, label_) {
    var messages = [];
    if (affiliation !== undefined && affiliation !== null) {
      messages = messages.concat(AvoAssert.assertString("D-6RH3lvH", label_ ? "affiliation" + ": " + label_ : "affiliation", affiliation));
    }
    return messages;
  }
  
  function assertExternalLink(externalLink, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertBool("DzZMn4cZBxR", label_ ? "external_link" + ": " + label_ : "external_link", externalLink));
    return messages;
  }
  
  function assertVideoTitle(videoTitle, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("E29-6P-mJPC9", label_ ? "video_title" + ": " + label_ : "video_title", videoTitle));
    return messages;
  }
  
  function assertOptionalOptionExtraTransferTime(optionExtraTransferTime, label_) {
    var messages = [];
    if (optionExtraTransferTime !== undefined && optionExtraTransferTime !== null) {
      messages = messages.concat(AvoAssert.assertInt("EhTR7EnR_4-n", label_ ? "option_extra_transfer_time" + ": " + label_ : "option_extra_transfer_time", optionExtraTransferTime));
    }
    return messages;
  }
  
  function assertAnswer(answer, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("F4RDcFwudL0_", label_ ? "answer" + ": " + label_ : "answer", answer));
    return messages;
  }
  
  function assertElementStructure(elementStructure, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("FPhLne42GAA", label_ ? "element_structure" + ": " + label_ : "element_structure", elementStructure));
    return messages;
  }
  
  function assertTestTool(testTool, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("GL_TSnWYyKgW", label_ ? "test_tool" + ": " + label_ : "test_tool", testTool));
    return messages;
  }
  
  function assertOptionalExistingProduct(existingProduct, label_) {
    var messages = [];
    if (existingProduct !== undefined && existingProduct !== null) {
      messages = messages.concat(AvoAssert.assertList("GsMr_TucEDqV", "existing_product", existingProduct));
      existingProduct.forEach(function (value, index) {
        messages = messages.concat(AvoAssert.assertObject("GsMr_TucEDqV", "item at index " + index + " in existing_product", value));
        messages = messages.concat(assertItemId(value.itemId, "item at index " + index + " in existing_product"));
        messages = messages.concat(assertItemName(value.itemName, "item at index " + index + " in existing_product"));
        messages = messages.concat(assertQuantity(value.quantity, "item at index " + index + " in existing_product"));
        messages = messages.concat(assertOptionalItemCategory(value.itemCategory, "item at index " + index + " in existing_product"));
        messages = messages.concat(assertOptionalItemCategory2(value.itemCategory2, "item at index " + index + " in existing_product"));
        messages = messages.concat(assertPrice(value.price, "item at index " + index + " in existing_product"));
        messages = messages.concat(assertOptionalItemBrand(value.itemBrand, "item at index " + index + " in existing_product"));
        messages = messages.concat(assertOptionalItemVariant(value.itemVariant, "item at index " + index + " in existing_product"));
      });
    }
    return messages;
  }
  
  function assertCurrency(currency, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("GuYrcDncVS5", label_ ? "currency" + ": " + label_ : "currency", currency));
    if ("EUR" !== currency) {
      var message = (label_ ? "currency" + ": " + label_ : "currency") + " should match one of the following values [ EUR ] but you provided the value " + currency
      messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "GuYrcDncVS5", message: message}]);
    }
    return messages;
  }
  
  function assertOptionalClickId1(clickId1, label_) {
    var messages = [];
    if (clickId1 !== undefined && clickId1 !== null) {
      messages = messages.concat(AvoAssert.assertString("HolZTTkkioUB", label_ ? "click_id" + ": " + label_ : "click_id", clickId1));
    }
    return messages;
  }
  
  function assertTestId(testId, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("HpghA4STUpM1", label_ ? "test_id" + ": " + label_ : "test_id", testId));
    return messages;
  }
  
  function assertPageTitle(pageTitle, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("HrAYDiO719kk", label_ ? "page_title" + ": " + label_ : "page_title", pageTitle));
    return messages;
  }
  
  function assertVideoProvider1(videoProvider1, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("Hx_El_YtO-Wk", label_ ? "video_provider" + ": " + label_ : "video_provider", videoProvider1));
    return messages;
  }
  
  function assertTestVariant(testVariant, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("I44jVDyqBZic", label_ ? "test_variant" + ": " + label_ : "test_variant", testVariant));
    return messages;
  }
  
  function assertOptionalTax(tax, label_) {
    var messages = [];
    if (tax !== undefined && tax !== null) {
      messages = messages.concat(AvoAssert.assertFloat("IBS3IO629xIC", label_ ? "tax" + ": " + label_ : "tax", tax));
    }
    return messages;
  }
  
  function assertOriginType(originType, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("JhQcIHY4C9pI", label_ ? "origin_type" + ": " + label_ : "origin_type", originType));
    if ("station" !== originType &&
        "address" !== originType &&
        "stop" !== originType &&
        "poi" !== originType &&
        "unknown" !== originType) {
      var message = (label_ ? "origin_type" + ": " + label_ : "origin_type") + " should match one of the following values [ station | address | stop | poi | unknown ] but you provided the value " + originType
      messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "JhQcIHY4C9pI", message: message}]);
    }
    return messages;
  }
  
  function assertDeurTotDeur(deurTotDeur, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertList("JzW147FWP", "deur_tot_deur", deurTotDeur));
    if (deurTotDeur !== null && deurTotDeur !== undefined && deurTotDeur.forEach) {
      deurTotDeur.forEach(function (value, index) {
      });
    }
    return messages;
  }
  
  function assertOptionalDeurTotDeur(deurTotDeur, label_) {
    var messages = [];
    if (deurTotDeur !== undefined && deurTotDeur !== null) {
      messages = messages.concat(AvoAssert.assertList("JzW147FWP", "deur_tot_deur", deurTotDeur));
      deurTotDeur.forEach(function (value, index) {
      });
    }
    return messages;
  }
  
  function assertClickClasses(clickClasses, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("K5J4L8efdGgl", label_ ? "click_classes" + ": " + label_ : "click_classes", clickClasses));
    return messages;
  }
  
  function assertDestination(destination, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("K5UKR3Wbe9xC", label_ ? "destination" + ": " + label_ : "destination", destination));
    return messages;
  }
  
  function assertVideoPercent(videoPercent, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertInt("KtXvxPrGGhXA", label_ ? "video_percent" + ": " + label_ : "video_percent", videoPercent));
    return messages;
  }
  
  function assertDatalayerSource(datalayerSource, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("L-rHlXDQJd", label_ ? "datalayer_source" + ": " + label_ : "datalayer_source", datalayerSource));
    return messages;
  }
  
  function assertOptionalItemListName(itemListName, label_) {
    var messages = [];
    if (itemListName !== undefined && itemListName !== null) {
      messages = messages.concat(AvoAssert.assertString("LydSjYynFBlR", label_ ? "item_list_name" + ": " + label_ : "item_list_name", itemListName));
    }
    return messages;
  }
  
  function assertOptionList(optionList, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertList("MJqw4kh96", "option_list", optionList));
    if (optionList !== null && optionList !== undefined && optionList.forEach) {
      optionList.forEach(function (value, index) {
      });
    }
    return messages;
  }
  
  function assertOptionalOptionList(optionList, label_) {
    var messages = [];
    if (optionList !== undefined && optionList !== null) {
      messages = messages.concat(AvoAssert.assertList("MJqw4kh96", "option_list", optionList));
      optionList.forEach(function (value, index) {
      });
    }
    return messages;
  }
  
  function assertOptionalOriginModalities(originModalities, label_) {
    var messages = [];
    if (originModalities !== undefined && originModalities !== null) {
      messages = messages.concat(AvoAssert.assertString("MgmcZ65PSEiQ", label_ ? "origin_modalities" + ": " + label_ : "origin_modalities", originModalities));
    }
    return messages;
  }
  
  function assertGlobalContext(globalContext, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertBool("NL2dr-pMqXumklSBDwovA", label_ ? "global_context" + ": " + label_ : "global_context", globalContext));
    return messages;
  }
  
  function assertOptionalGlobalContext(globalContext, label_) {
    var messages = [];
    if (globalContext !== undefined && globalContext !== null) {
      messages = messages.concat(AvoAssert.assertBool("NL2dr-pMqXumklSBDwovA", label_ ? "global_context" + ": " + label_ : "global_context", globalContext));
    }
    return messages;
  }
  
  function assertOptionalDescription(description, label_) {
    var messages = [];
    if (description !== undefined && description !== null) {
      messages = messages.concat(AvoAssert.assertString("OCfm56R0fQu", label_ ? "description" + ": " + label_ : "description", description));
    }
    return messages;
  }
  
  function assertDescription(description, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("OCfm56R0fQu", label_ ? "description" + ": " + label_ : "description", description));
    return messages;
  }
  
  function assertOptionalTicketClass(ticketClass, label_) {
    var messages = [];
    if (ticketClass !== undefined && ticketClass !== null) {
      messages = messages.concat(AvoAssert.assertString("OPP6AeYDy", label_ ? "ticket_class" + ": " + label_ : "ticket_class", ticketClass));
    }
    return messages;
  }
  
  function assertItems(items, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertList("Oavl4KfPHF3", "items", items));
    if (items !== null && items !== undefined && items.forEach) {
      items.forEach(function (value, index) {
        messages = messages.concat(AvoAssert.assertObject("Oavl4KfPHF3", "item at index " + index + " in items", value));
        messages = messages.concat(assertItemId(value.itemId, "item at index " + index + " in items"));
        messages = messages.concat(assertItemName(value.itemName, "item at index " + index + " in items"));
        messages = messages.concat(assertOptionalCoupon(value.coupon, "item at index " + index + " in items"));
        messages = messages.concat(assertOptionalDiscount(value.discount, "item at index " + index + " in items"));
        messages = messages.concat(assertOptionalIndex(value.index, "item at index " + index + " in items"));
        messages = messages.concat(assertQuantity(value.quantity, "item at index " + index + " in items"));
        messages = messages.concat(assertPrice(value.price, "item at index " + index + " in items"));
        messages = messages.concat(assertOptionalItemBrand(value.itemBrand, "item at index " + index + " in items"));
        messages = messages.concat(assertOptionalItemVariant(value.itemVariant, "item at index " + index + " in items"));
        messages = messages.concat(assertOptionalItemCategory(value.itemCategory, "item at index " + index + " in items"));
        messages = messages.concat(assertOptionalTravelDate(value.travelDate, "item at index " + index + " in items"));
        messages = messages.concat(assertOptionalAffiliation(value.affiliation, "item at index " + index + " in items"));
        messages = messages.concat(assertOptionalItemCategory2(value.itemCategory2, "item at index " + index + " in items"));
        messages = messages.concat(assertOptionalDestinationStation(value.destinationStation, "item at index " + index + " in items"));
        messages = messages.concat(assertOptionalOriginStation(value.originStation, "item at index " + index + " in items"));
        messages = messages.concat(assertOptionalTravelClass(value.travelClass, "item at index " + index + " in items"));
        messages = messages.concat(assertOptionalTravelRoute(value.travelRoute, "item at index " + index + " in items"));
        messages = messages.concat(assertOptionalIntercityDirect(value.intercityDirect, "item at index " + index + " in items"));
        messages = messages.concat(assertOptionalDeurTotDeur(value.deurTotDeur, "item at index " + index + " in items"));
        messages = messages.concat(assertItemRevenue(value.itemRevenue, "item at index " + index + " in items"));
      });
    }
    return messages;
  }
  
  function assertError(error, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("Oi6yaZll3yFM", label_ ? "error" + ": " + label_ : "error", error));
    return messages;
  }
  
  function assertIndex(index, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertInt("PKlIwCNeHb", label_ ? "index" + ": " + label_ : "index", index));
    return messages;
  }
  
  function assertOptionalIndex(index, label_) {
    var messages = [];
    if (index !== undefined && index !== null) {
      messages = messages.concat(AvoAssert.assertInt("PKlIwCNeHb", label_ ? "index" + ": " + label_ : "index", index));
    }
    return messages;
  }
  
  function assertPagePath(pagePath, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("PgQL3oYhqcEj", label_ ? "page_path" + ": " + label_ : "page_path", pagePath));
    return messages;
  }
  
  function assertOptionalPreview(preview, label_) {
    var messages = [];
    if (preview !== undefined && preview !== null) {
      messages = messages.concat(AvoAssert.assertBool("Po4mUsQEyB", label_ ? "preview" + ": " + label_ : "preview", preview));
    }
    return messages;
  }
  
  function assertTravelRoute(travelRoute, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("PpX-d_0VW", label_ ? "travel_route" + ": " + label_ : "travel_route", travelRoute));
    return messages;
  }
  
  function assertOptionalTravelRoute(travelRoute, label_) {
    var messages = [];
    if (travelRoute !== undefined && travelRoute !== null) {
      messages = messages.concat(AvoAssert.assertString("PpX-d_0VW", label_ ? "travel_route" + ": " + label_ : "travel_route", travelRoute));
    }
    return messages;
  }
  
  function assertFileName(fileName, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("PqLRY8g1AK7Q", label_ ? "file_name" + ": " + label_ : "file_name", fileName));
    return messages;
  }
  
  function assertPlanDate(planDate, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("QrQ2jdtpI42P", label_ ? "plan_date" + ": " + label_ : "plan_date", planDate));
    return messages;
  }
  
  function assertTransactionId(transactionId, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("SCki6fM2wea", label_ ? "transaction_id" + ": " + label_ : "transaction_id", transactionId));
    return messages;
  }
  
  function assertOptionalUcName(ucName, label_) {
    var messages = [];
    if (ucName !== undefined && ucName !== null) {
      messages = messages.concat(AvoAssert.assertString("SnbzGw91vYEjK_-uAfxau", label_ ? "uc_name" + ": " + label_ : "uc_name", ucName));
    }
    return messages;
  }
  
  function assertTestLocation(testLocation, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("TDtygjQ3jTuJ", label_ ? "test_location" + ": " + label_ : "test_location", testLocation));
    return messages;
  }
  
  function assertOptionalTestLocation(testLocation, label_) {
    var messages = [];
    if (testLocation !== undefined && testLocation !== null) {
      messages = messages.concat(AvoAssert.assertString("TDtygjQ3jTuJ", label_ ? "test_location" + ": " + label_ : "test_location", testLocation));
    }
    return messages;
  }
  
  function assertOptionalClickText(clickText, label_) {
    var messages = [];
    if (clickText !== undefined && clickText !== null) {
      messages = messages.concat(AvoAssert.assertString("TFD27fnuBpN-", label_ ? "click_text" + ": " + label_ : "click_text", clickText));
    }
    return messages;
  }
  
  function assertClickText(clickText, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("TFD27fnuBpN-", label_ ? "click_text" + ": " + label_ : "click_text", clickText));
    return messages;
  }
  
  function assertItemCategory2(itemCategory2, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("TIV1Wo8BM", label_ ? "item_category2" + ": " + label_ : "item_category2", itemCategory2));
    return messages;
  }
  
  function assertOptionalItemCategory2(itemCategory2, label_) {
    var messages = [];
    if (itemCategory2 !== undefined && itemCategory2 !== null) {
      messages = messages.concat(AvoAssert.assertString("TIV1Wo8BM", label_ ? "item_category2" + ": " + label_ : "item_category2", itemCategory2));
    }
    return messages;
  }
  
  function assertOptionalCustomerEntity(customerEntity, label_) {
    var messages = [];
    if (customerEntity !== undefined && customerEntity !== null) {
      messages = messages.concat(AvoAssert.assertString("TQleINBSI93G", label_ ? "customer_entity" + ": " + label_ : "customer_entity", customerEntity));
      if ("kaarthouder" !== customerEntity &&
          "contactpersoon" !== customerEntity) {
        var message = (label_ ? "customer_entity" + ": " + label_ : "customer_entity") + " should match one of the following values [ kaarthouder | contactpersoon ] but you provided the value " + customerEntity
        messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "TQleINBSI93G", message: message}]);
      }
    }
    return messages;
  }
  
  function assertOptionalUtmTerm(utmTerm, label_) {
    var messages = [];
    if (utmTerm !== undefined && utmTerm !== null) {
      messages = messages.concat(AvoAssert.assertString("TigsIVrjd8Ws", label_ ? "utm_term" + ": " + label_ : "utm_term", utmTerm));
    }
    return messages;
  }
  
  function assertFileExtension(fileExtension, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("TizyQU9Eo2GE", label_ ? "file_extension" + ": " + label_ : "file_extension", fileExtension));
    return messages;
  }
  
  function assertOptionalDestinationStation(destinationStation, label_) {
    var messages = [];
    if (destinationStation !== undefined && destinationStation !== null) {
      messages = messages.concat(AvoAssert.assertString("UpRgfCPRK", label_ ? "destination_station" + ": " + label_ : "destination_station", destinationStation));
    }
    return messages;
  }
  
  function assertOptionalUtmMedium(utmMedium, label_) {
    var messages = [];
    if (utmMedium !== undefined && utmMedium !== null) {
      messages = messages.concat(AvoAssert.assertString("WCgPbfCy_8b3", label_ ? "utm_medium" + ": " + label_ : "utm_medium", utmMedium));
    }
    return messages;
  }
  
  function assertOptionNoReservation(optionNoReservation, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertBool("WDi4lr0fPar_", label_ ? "option_no_reservation" + ": " + label_ : "option_no_reservation", optionNoReservation));
    return messages;
  }
  
  function assertTravelDate(travelDate, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("WGDHyEYby", label_ ? "travel_date" + ": " + label_ : "travel_date", travelDate));
    return messages;
  }
  
  function assertOptionalTravelDate(travelDate, label_) {
    var messages = [];
    if (travelDate !== undefined && travelDate !== null) {
      messages = messages.concat(AvoAssert.assertString("WGDHyEYby", label_ ? "travel_date" + ": " + label_ : "travel_date", travelDate));
    }
    return messages;
  }
  
  function assertOptionalElementType(elementType, label_) {
    var messages = [];
    if (elementType !== undefined && elementType !== null) {
      messages = messages.concat(AvoAssert.assertString("XP-wQ8Diq01EP_5L1OoxC", label_ ? "element_type" + ": " + label_ : "element_type", elementType));
    }
    return messages;
  }
  
  function assertOptionalFeedbackName(feedbackName, label_) {
    var messages = [];
    if (feedbackName !== undefined && feedbackName !== null) {
      messages = messages.concat(AvoAssert.assertString("Xhkk5MHMs", label_ ? "feedback_name" + ": " + label_ : "feedback_name", feedbackName));
    }
    return messages;
  }
  
  function assertOptionalTestAudienceId(testAudienceId, label_) {
    var messages = [];
    if (testAudienceId !== undefined && testAudienceId !== null) {
      messages = messages.concat(AvoAssert.assertString("Xiuci0NEjDkz", label_ ? "test_audience_id" + ": " + label_ : "test_audience_id", testAudienceId));
    }
    return messages;
  }
  
  function assertTeamName(teamName, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("XoZ_JHMfu", label_ ? "team_name" + ": " + label_ : "team_name", teamName));
    return messages;
  }
  
  function assertOptionalClickDestination(clickDestination, label_) {
    var messages = [];
    if (clickDestination !== undefined && clickDestination !== null) {
      messages = messages.concat(AvoAssert.assertString("ZRYtNJDfVeyb", label_ ? "click_destination" + ": " + label_ : "click_destination", clickDestination));
    }
    return messages;
  }
  
  function assertClickDestination(clickDestination, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("ZRYtNJDfVeyb", label_ ? "click_destination" + ": " + label_ : "click_destination", clickDestination));
    return messages;
  }
  
  function assertOptionalItemId(itemId, label_) {
    var messages = [];
    if (itemId !== undefined && itemId !== null) {
      messages = messages.concat(AvoAssert.assertString("ZVGAZOlEBhGj", label_ ? "item_id" + ": " + label_ : "item_id", itemId));
    }
    return messages;
  }
  
  function assertItemId(itemId, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("ZVGAZOlEBhGj", label_ ? "item_id" + ": " + label_ : "item_id", itemId));
    return messages;
  }
  
  function assertQuantity(quantity, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertInt("ZZlWcbau6V", label_ ? "quantity" + ": " + label_ : "quantity", quantity));
    return messages;
  }
  
  function assertOptionalVirtual(virtual, label_) {
    var messages = [];
    if (virtual !== undefined && virtual !== null) {
      messages = messages.concat(AvoAssert.assertBool("_3Sy5DLQHqRD", label_ ? "virtual" + ": " + label_ : "virtual", virtual));
    }
    return messages;
  }
  
  function assertOptionalBankSelected(bankSelected, label_) {
    var messages = [];
    if (bankSelected !== undefined && bankSelected !== null) {
      messages = messages.concat(AvoAssert.assertString("_8eP6aJ0U", label_ ? "bank_selected" + ": " + label_ : "bank_selected", bankSelected));
    }
    return messages;
  }
  
  function assertPrice(price, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertFloat("_T-mygJA7w", label_ ? "price" + ": " + label_ : "price", price));
    return messages;
  }
  
  function assertErrorMessage(errorMessage, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertList("_UC5Zg5bYPN", "error_message", errorMessage));
    if (errorMessage !== null && errorMessage !== undefined && errorMessage.forEach) {
      errorMessage.forEach(function (value, index) {
      });
    }
    return messages;
  }
  
  function assertTravelClass(travelClass, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("_WmY6XGTY", label_ ? "travel_class" + ": " + label_ : "travel_class", travelClass));
    return messages;
  }
  
  function assertOptionalTravelClass(travelClass, label_) {
    var messages = [];
    if (travelClass !== undefined && travelClass !== null) {
      messages = messages.concat(AvoAssert.assertString("_WmY6XGTY", label_ ? "travel_class" + ": " + label_ : "travel_class", travelClass));
    }
    return messages;
  }
  
  function assertPercent(percent, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertInt("_iIBN-4DdOc1", label_ ? "percent" + ": " + label_ : "percent", percent));
    return messages;
  }
  
  function assertCluster(cluster, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("aF92rWblhlD9", label_ ? "cluster" + ": " + label_ : "cluster", cluster));
    if ("abo" !== cluster &&
        "lvb" !== cluster &&
        "nsi" !== cluster &&
        "ovk" !== cluster &&
        "rcr" !== cluster) {
      var message = (label_ ? "cluster" + ": " + label_ : "cluster") + " should match one of the following values [ abo | lvb | nsi | ovk | rcr ] but you provided the value " + cluster
      messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "aF92rWblhlD9", message: message}]);
    }
    return messages;
  }
  
  function assertMinutesToPlanTime(minutesToPlanTime, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertInt("aI7_g6oQRfSk", label_ ? "minutes_to_plan_time" + ": " + label_ : "minutes_to_plan_time", minutesToPlanTime));
    return messages;
  }
  
  function assertUserId_(userId_, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("avo-enriched-type-user-id", label_ ? "User Id" + ": " + label_ : "User Id", userId_));
    return messages;
  }
  
  function assertOptionalPermissions(permissions, label_) {
    var messages = [];
    if (permissions !== undefined && permissions !== null) {
      messages = messages.concat(AvoAssert.assertList("b6ebejYlEx2Y", "permissions", permissions));
      permissions.forEach(function (value, index) {
      });
    }
    return messages;
  }
  
  function assertPermissions(permissions, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertList("b6ebejYlEx2Y", "permissions", permissions));
    if (permissions !== null && permissions !== undefined && permissions.forEach) {
      permissions.forEach(function (value, index) {
      });
    }
    return messages;
  }
  
  function assertUniqueName(uniqueName, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("bF4w0NCf7D4", label_ ? "unique_name" + ": " + label_ : "unique_name", uniqueName));
    return messages;
  }
  
  function assertOptionalOriginStation(originStation, label_) {
    var messages = [];
    if (originStation !== undefined && originStation !== null) {
      messages = messages.concat(AvoAssert.assertString("bMK3liq6t", label_ ? "origin_station" + ": " + label_ : "origin_station", originStation));
    }
    return messages;
  }
  
  function assertSelectedDate(selectedDate, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("cT6ai5_Dk", label_ ? "selected_date" + ": " + label_ : "selected_date", selectedDate));
    return messages;
  }
  
  function assertOptionalDiscount(discount, label_) {
    var messages = [];
    if (discount !== undefined && discount !== null) {
      messages = messages.concat(AvoAssert.assertFloat("ePZR23byGW", label_ ? "discount" + ": " + label_ : "discount", discount));
    }
    return messages;
  }
  
  function assertOptionalCampaignStatus(campaignStatus, label_) {
    var messages = [];
    if (campaignStatus !== undefined && campaignStatus !== null) {
      messages = messages.concat(AvoAssert.assertString("fW6NdHL5V", label_ ? "campaign_status" + ": " + label_ : "campaign_status", campaignStatus));
      if ("active" !== campaignStatus &&
          "inactive" !== campaignStatus) {
        var message = (label_ ? "campaign_status" + ": " + label_ : "campaign_status") + " should match one of the following values [ active | inactive ] but you provided the value " + campaignStatus
        messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "fW6NdHL5V", message: message}]);
      }
    }
    return messages;
  }
  
  function assertArrivalOrDepartureDate(arrivalOrDepartureDate, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("fei9WfaoV0KU", label_ ? "arrival_or_departure_date" + ": " + label_ : "arrival_or_departure_date", arrivalOrDepartureDate));
    return messages;
  }
  
  function assertFormName(formName, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("gL1cdb__7Q9c", label_ ? "form_name" + ": " + label_ : "form_name", formName));
    return messages;
  }
  
  function assertUcId(ucId, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("gbSQirnPl", label_ ? "uc_id" + ": " + label_ : "uc_id", ucId));
    return messages;
  }
  
  function assertExperimentsSummary(experimentsSummary, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertList("gmOAaJXmFQiI0auzUw4Df", "experiments_summary", experimentsSummary));
    if (experimentsSummary !== null && experimentsSummary !== undefined && experimentsSummary.forEach) {
      experimentsSummary.forEach(function (value, index) {
      });
    }
    return messages;
  }
  
  function assertOptionalOptionAmount(optionAmount, label_) {
    var messages = [];
    if (optionAmount !== undefined && optionAmount !== null) {
      messages = messages.concat(AvoAssert.assertInt("gyvKCwS5E", label_ ? "option_amount" + ": " + label_ : "option_amount", optionAmount));
    }
    return messages;
  }
  
  function assertItemName(itemName, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("hg4puJyLhb", label_ ? "item_name" + ": " + label_ : "item_name", itemName));
    return messages;
  }
  
  function assertPlanTime(planTime, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("hi8osDXdCJVA", label_ ? "plan_time" + ": " + label_ : "plan_time", planTime));
    return messages;
  }
  
  function assertTestTeam(testTeam, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("ij0L0WRQXuPq", label_ ? "test_team" + ": " + label_ : "test_team", testTeam));
    return messages;
  }
  
  function assertOptionalTestTeam(testTeam, label_) {
    var messages = [];
    if (testTeam !== undefined && testTeam !== null) {
      messages = messages.concat(AvoAssert.assertString("ij0L0WRQXuPq", label_ ? "test_team" + ": " + label_ : "test_team", testTeam));
    }
    return messages;
  }
  
  function assertOptionalChatClickSource(chatClickSource, label_) {
    var messages = [];
    if (chatClickSource !== undefined && chatClickSource !== null) {
      messages = messages.concat(AvoAssert.assertString("j8qPJcH-G", label_ ? "chat_click_source" + ": " + label_ : "chat_click_source", chatClickSource));
      if ("button" !== chatClickSource &&
          "cancellation_link" !== chatClickSource &&
          "chat_link" !== chatClickSource &&
          "live_chat" !== chatClickSource) {
        var message = (label_ ? "chat_click_source" + ": " + label_ : "chat_click_source") + " should match one of the following values [ button | cancellation_link | chat_link | live_chat ] but you provided the value " + chatClickSource
        messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "j8qPJcH-G", message: message}]);
      }
    }
    return messages;
  }
  
  function assertContentType(contentType, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("jbSdZ_YNpuuA", label_ ? "content_type" + ": " + label_ : "content_type", contentType));
    return messages;
  }
  
  function assertOptionalUtmContent(utmContent, label_) {
    var messages = [];
    if (utmContent !== undefined && utmContent !== null) {
      messages = messages.concat(AvoAssert.assertString("jksVIoRXIWk2", label_ ? "utm_content" + ": " + label_ : "utm_content", utmContent));
    }
    return messages;
  }
  
  function assertPageType(pageType, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("juLwL7wdryz", label_ ? "page_type" + ": " + label_ : "page_type", pageType));
    if ("service_page" !== pageType &&
        "home_page" !== pageType &&
        "check_out_page" !== pageType &&
        "thank_you_page" !== pageType &&
        "product_overview_page" !== pageType &&
        "product_category_page" !== pageType &&
        "product_detail_page" !== pageType &&
        "product_configuration_page" !== pageType &&
        "campaign_page" !== pageType &&
        "not_set" !== pageType &&
        "content_overview_page" !== pageType &&
        "content_article_page" !== pageType) {
      var message = (label_ ? "page_type" + ": " + label_ : "page_type") + " should match one of the following values [ service_page | home_page | check_out_page | thank_you_page | product_overview_page | product_category_page | product_detail_page | product_configuration_page | campaign_page | not_set | content_overview_page | content_article_page ] but you provided the value " + pageType
      messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "juLwL7wdryz", message: message}]);
    }
    return messages;
  }
  
  function assertItemRevenue(itemRevenue, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertFloat("k7CLuUXjt3HSeA3jMU2c7", label_ ? "item_revenue" + ": " + label_ : "item_revenue", itemRevenue));
    return messages;
  }
  
  function assertWebsiteVersion(websiteVersion, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("l4YWQepFGqt9", label_ ? "website_version" + ": " + label_ : "website_version", websiteVersion));
    if ("consument" !== websiteVersion &&
        "zakelijk" !== websiteVersion) {
      var message = (label_ ? "website_version" + ": " + label_ : "website_version") + " should match one of the following values [ consument | zakelijk ] but you provided the value " + websiteVersion
      messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "l4YWQepFGqt9", message: message}]);
    }
    return messages;
  }
  
  function assertMijnnsVersion(mijnnsVersion, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("lbXiVJSEQrn6", label_ ? "mijnns_version" + ": " + label_ : "mijnns_version", mijnnsVersion));
    if ("mijnns" !== mijnnsVersion &&
        "mijnns_zakelijk" !== mijnnsVersion) {
      var message = (label_ ? "mijnns_version" + ": " + label_ : "mijnns_version") + " should match one of the following values [ mijnns | mijnns_zakelijk ] but you provided the value " + mijnnsVersion
      messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "lbXiVJSEQrn6", message: message}]);
    }
    return messages;
  }
  
  function assertTicketPrice(ticketPrice, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertFloat("lztkT6sWa2HW", label_ ? "ticket_price" + ": " + label_ : "ticket_price", ticketPrice));
    return messages;
  }
  
  function assertPushConsentStatus(pushConsentStatus, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertList("mE3yslcjncEm", "push_consent_status", pushConsentStatus));
    if (pushConsentStatus !== null && pushConsentStatus !== undefined && pushConsentStatus.forEach) {
      pushConsentStatus.forEach(function (value, index) {
      });
    }
    return messages;
  }
  
  function assertOptionalOptionViaStation(optionViaStation, label_) {
    var messages = [];
    if (optionViaStation !== undefined && optionViaStation !== null) {
      messages = messages.concat(AvoAssert.assertString("nXtf5xu83rju", label_ ? "option_via_station" + ": " + label_ : "option_via_station", optionViaStation));
    }
    return messages;
  }
  
  function assertNewTab(newTab, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertBool("nw5UW2_uvVj", label_ ? "new_tab" + ": " + label_ : "new_tab", newTab));
    return messages;
  }
  
  function assertOptionalButtonType(buttonType, label_) {
    var messages = [];
    if (buttonType !== undefined && buttonType !== null) {
      messages = messages.concat(AvoAssert.assertString("oZ6ysVC6Ugt", label_ ? "button_type" + ": " + label_ : "button_type", buttonType));
    }
    return messages;
  }
  
  function assertOptionalOrigin(origin, label_) {
    var messages = [];
    if (origin !== undefined && origin !== null) {
      messages = messages.concat(AvoAssert.assertString("oyE5fJGQ8YEf", label_ ? "origin" + ": " + label_ : "origin", origin));
    }
    return messages;
  }
  
  function assertOptionalTestDescription(testDescription, label_) {
    var messages = [];
    if (testDescription !== undefined && testDescription !== null) {
      messages = messages.concat(AvoAssert.assertString("pnPG0qR_-", label_ ? "test_description" + ": " + label_ : "test_description", testDescription));
    }
    return messages;
  }
  
  function assertDestinationType(destinationType, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("pzgV0n5Ze47t", label_ ? "destination_type" + ": " + label_ : "destination_type", destinationType));
    if ("station" !== destinationType &&
        "address" !== destinationType &&
        "stop" !== destinationType &&
        "poi" !== destinationType &&
        "unknown" !== destinationType) {
      var message = (label_ ? "destination_type" + ": " + label_ : "destination_type") + " should match one of the following values [ station | address | stop | poi | unknown ] but you provided the value " + destinationType
      messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "pzgV0n5Ze47t", message: message}]);
    }
    return messages;
  }
  
  function assertItemVariant(itemVariant, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("qAitKhHMy0", label_ ? "item_variant" + ": " + label_ : "item_variant", itemVariant));
    return messages;
  }
  
  function assertOptionalItemVariant(itemVariant, label_) {
    var messages = [];
    if (itemVariant !== undefined && itemVariant !== null) {
      messages = messages.concat(AvoAssert.assertString("qAitKhHMy0", label_ ? "item_variant" + ": " + label_ : "item_variant", itemVariant));
    }
    return messages;
  }
  
  function assertOptionalItemListId(itemListId, label_) {
    var messages = [];
    if (itemListId !== undefined && itemListId !== null) {
      messages = messages.concat(AvoAssert.assertString("qAs6FFElba8q", label_ ? "item_list_id" + ": " + label_ : "item_list_id", itemListId));
    }
    return messages;
  }
  
  function assertOptionalSalesChannel(salesChannel, label_) {
    var messages = [];
    if (salesChannel !== undefined && salesChannel !== null) {
      messages = messages.concat(AvoAssert.assertString("qJKae_S4y_", label_ ? "sales_channel" + ": " + label_ : "sales_channel", salesChannel));
    }
    return messages;
  }
  
  function assertChecked(checked, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertBool("rzoBfRsaz89", label_ ? "checked" + ": " + label_ : "checked", checked));
    return messages;
  }
  
  function assertFormId1(formId1, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("s4UF8TMcgsg9", label_ ? "form_id" + ": " + label_ : "form_id", formId1));
    return messages;
  }
  
  function assertOptionalFeedbackRating(feedbackRating, label_) {
    var messages = [];
    if (feedbackRating !== undefined && feedbackRating !== null) {
      messages = messages.concat(AvoAssert.assertString("sctfOrm9GDA0", label_ ? "feedback_rating" + ": " + label_ : "feedback_rating", feedbackRating));
    }
    return messages;
  }
  
  function assertErrorStatus(errorStatus, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("shuP1-uKm", label_ ? "error_status" + ": " + label_ : "error_status", errorStatus));
    return messages;
  }
  
  function assertVideoDuration(videoDuration, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertFloat("tFHwzcV_y9J4", label_ ? "video_duration" + ": " + label_ : "video_duration", videoDuration));
    return messages;
  }
  
  function assertOptionalDestinationPath(destinationPath, label_) {
    var messages = [];
    if (destinationPath !== undefined && destinationPath !== null) {
      messages = messages.concat(AvoAssert.assertString("twaKzqqM-SP3", label_ ? "destination_path" + ": " + label_ : "destination_path", destinationPath));
    }
    return messages;
  }
  
  function assertNsEnvironment(nsEnvironment, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("ux8kucXh9-", label_ ? "ns_environment" + ": " + label_ : "ns_environment", nsEnvironment));
    if ("acc" !== nsEnvironment &&
        "test" !== nsEnvironment &&
        "prod" !== nsEnvironment &&
        "test2" !== nsEnvironment &&
        "test3" !== nsEnvironment &&
        "testaut" !== nsEnvironment &&
        "testaut2" !== nsEnvironment &&
        "testaut3" !== nsEnvironment &&
        "dev-localhost" !== nsEnvironment &&
        "unittest" !== nsEnvironment) {
      var message = (label_ ? "ns_environment" + ": " + label_ : "ns_environment") + " should match one of the following values [ acc | test | prod | test2 | test3 | testaut | testaut2 | testaut3 | dev-localhost | unittest ] but you provided the value " + nsEnvironment
      messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "ux8kucXh9-", message: message}]);
    }
    return messages;
  }
  
  function assertOptionalBcInteractionId(bcInteractionId, label_) {
    var messages = [];
    if (bcInteractionId !== undefined && bcInteractionId !== null) {
      messages = messages.concat(AvoAssert.assertString("wLBBYJ4_yksXyt0QEPGl3", label_ ? "bc_interaction_id" + ": " + label_ : "bc_interaction_id", bcInteractionId));
    }
    return messages;
  }
  
  function assertOptionalWebsiteSection(websiteSection, label_) {
    var messages = [];
    if (websiteSection !== undefined && websiteSection !== null) {
      messages = messages.concat(AvoAssert.assertString("wskyjid5yxT0", label_ ? "website_section" + ": " + label_ : "website_section", websiteSection));
    }
    return messages;
  }
  
  function assertOptionHasTravelassistance(optionHasTravelassistance, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertBool("xp4K_4mDFr_k", label_ ? "option_has_travelassistance" + ": " + label_ : "option_has_travelassistance", optionHasTravelassistance));
    return messages;
  }
  
  function assertMethod(method, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("zL_iONcMP8KH", label_ ? "method" + ": " + label_ : "method", method));
    if ("facebook" !== method &&
        "twitter" !== method &&
        "instagram" !== method &&
        "youtube" !== method &&
        "linkedin" !== method) {
      var message = (label_ ? "method" + ": " + label_ : "method") + " should match one of the following values [ facebook | twitter | instagram | youtube | linkedin ] but you provided the value " + method
      messages = messages.concat([{tag: 'expectedStringMatch', propertyId: "zL_iONcMP8KH", message: message}]);
    }
    return messages;
  }
  
  function assertPageStructure(pageStructure, label_) {
    var messages = [];
    messages = messages.concat(AvoAssert.assertString("z__awEy565g", label_ ? "page_structure" + ": " + label_ : "page_structure", pageStructure));
    return messages;
  }
  
  function setAvoLogger(avoLogger) {
    __AVO_LOGGER__ = avoLogger;
  }
  
  var sysPlatform;
  var sysLanguage;
  var sysNsEnvironment;
  var sysDatalayerSource;
  var sysPreview;
  
  function setSystemProperties(properties) {
    if (properties.platform !== null && properties.platform !== undefined) {
      sysPlatform = properties.platform;
      assertPlatform(sysPlatform);
    }
    if (properties.language !== null && properties.language !== undefined) {
      sysLanguage = properties.language;
      assertLanguage(sysLanguage);
    }
    if (properties.nsEnvironment !== null && properties.nsEnvironment !== undefined) {
      sysNsEnvironment = properties.nsEnvironment;
      assertNsEnvironment(sysNsEnvironment);
    }
    if (properties.datalayerSource !== null && properties.datalayerSource !== undefined) {
      sysDatalayerSource = properties.datalayerSource;
      assertDatalayerSource(sysDatalayerSource);
    }
    if (properties.preview !== null && properties.preview !== undefined) {
      sysPreview = properties.preview;
      assertOptionalPreview(sysPreview);
    }
  }
  
  function setSystemProperties_(properties) {
    if (properties.platform !== null && properties.platform !== undefined) {
      sysPlatform = properties.platform;
      assertPlatform(sysPlatform);
    }
    if (properties.language !== null && properties.language !== undefined) {
      sysLanguage = properties.language;
      assertLanguage(sysLanguage);
    }
    if (properties.nsEnvironment !== null && properties.nsEnvironment !== undefined) {
      sysNsEnvironment = properties.nsEnvironment;
      assertNsEnvironment(sysNsEnvironment);
    }
    if (properties.datalayerSource !== null && properties.datalayerSource !== undefined) {
      sysDatalayerSource = properties.datalayerSource;
      assertDatalayerSource(sysDatalayerSource);
    }
    if (properties.preview !== null && properties.preview !== undefined) {
      sysPreview = properties.preview;
      assertOptionalPreview(sysPreview);
    }
  }
  
  
  var NsDataQueue;
  function setup_(options, systemProperties, NsDataQueueDestination, destinationOptions) {
    __WEB_DEBUGGER__ = false;
    if (options.validateProperties === true) {
      __AVO_DEV__ = true;
    }
    
    setSystemProperties_(systemProperties);
    
    destinationOptions = destinationOptions || {};
    
    if (!__AVO_NOOP__) {
      if (options.useProductionKey) {
      } else {
      }
      
      NsDataQueue = NsDataQueueDestination;
      NsDataQueue.make(options.useProductionKey);
      if (__AVO_DEV__) {
        // debug console in Avo
        _avo_invoke_meta(__AVO_ENV__, 'setup', [], 'setup');
      }
    }
  }
  
  function initAvo(options, systemProperties, destinationOptions, NsDataQueueDestination) {
    if (__AVO_ENV__ !== null) {
      return;
    }
    __AVO_ENV__ = options.env.toLowerCase();
    if (options.avoLogger !== undefined) {
      __AVO_LOGGER__ = options.avoLogger;
    }
    if (options.noop === true) {
      __AVO_NOOP__ = true;
    }
    if (__AVO_NOOP__ && __AVO_ENV__ == 'prod') {
      InternalAvoLogger.warn("****************************************************");
      InternalAvoLogger.warn("WARNING Avo cannot be initialized in noop mode in production:");
      InternalAvoLogger.warn("- Overwriting configuration with noop=false.");
      InternalAvoLogger.warn("- Please reach out if you want to be able to run Avo in production mode with noop=true");
      InternalAvoLogger.warn("****************************************************");
      __AVO_NOOP__ = false;
    }
    if (__AVO_NOOP__) {
      InternalAvoLogger.log("****************************************************");
      InternalAvoLogger.log("Avo is now initialized in noop mode. This means:");
      InternalAvoLogger.log("- No events will be sent");
      InternalAvoLogger.log("- No network requests are made");
      InternalAvoLogger.log("****************************************************");
    }
    if (options.strict !== undefined) {
      __STRICT__ = options.strict !== false;
    }
    if (options.reportFailureAs !== undefined) {
      __REPORT_FAILURE_AS__ = options.reportFailureAs;
    }
    __WEB_DEBUGGER__ = !__AVO_NOOP__ && ((typeof window !== 'undefined' && window.location.search.indexOf("avo_debug=1") > -1) || (options.webDebugger !== false && __AVO_ENV__ !== 'prod'));
    if (!__AVO_NOOP__ && options.inspector !== undefined) {
      __INSPECTOR__ = options.inspector;
    } else if (__AVO_ENV__ !== 'prod') {
      InternalAvoLogger.warn("Avo Inspector not provided in initAvo() call");
    }
    if (__AVO_ENV__ !== 'prod') {
      __AVO_DEV__ = true;
    }
    
    setSystemProperties(systemProperties);
    
    destinationOptions = destinationOptions || {};
    
    if (__WEB_DEBUGGER__ && !__AVO_NOOP__) {
    if (options.webDebuggerOptions && options.webDebuggerOptions.position) {
      const {
        BOTTOM_RIGHT,
        BOTTOM_LEFT,
        TOP_RIGHT,
        TOP_LEFT,
        } =
        WebDebuggerPosition.position;

      try {
        WebDebuggerAssertions.assertKey(
          options.webDebuggerOptions.position,
          "position",
          position => {
            return position === BOTTOM_RIGHT ||
            position === BOTTOM_LEFT ||
            position === TOP_RIGHT ||
            position === TOP_LEFT;
          }
        )
      } catch (e) {
        throw new Error('WebDebugger: Position object incorrect. Use methods from WebDebuggerPosition.');
      }

      const top = options.webDebuggerOptions.position.top || 0;
      const right = options.webDebuggerOptions.position.right || 0;
      const bottom = options.webDebuggerOptions.position.bottom || 0;
      const left = options.webDebuggerOptions.position.left || 0;

      let positionParams;

      switch (options.webDebuggerOptions.position.position) {
        case BOTTOM_RIGHT:
          positionParams = {
            position: BOTTOM_RIGHT,
            bottom,
            right,
          };
          break;
        case BOTTOM_LEFT:
          positionParams = {
            position: BOTTOM_LEFT,
            bottom,
            left,
          };
          break;
        case TOP_RIGHT:
          positionParams = {
            position: TOP_RIGHT,
            top,
            right,
          };
          break;
        case TOP_LEFT:
          positionParams = {
            position: TOP_LEFT,
            top,
            left,
          };
          break;
        default: throw new Error('WebDebugger: Position object incorrect. Use methods from WebDebuggerPosition.');
      }

      _avo_debugger_send_position(positionParams);
    }

(function() {
  if (typeof window === 'undefined') { return; }
  var init = function() {
    if (document.getElementById("avo-debugger") === null) {
      var iframe = document.createElement("iframe");
      document.body.appendChild(iframe);
      iframe.id = "avo-debugger";
      iframe.src = "https://www.avo.app/_debugger";
      iframe.style = "display: none;";
    }
  };

  if (document.body) {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();
      
    }
    if (!__AVO_NOOP__) {
      if (__AVO_ENV__ === 'prod') {
      }
      if (__AVO_ENV__ === 'dev') {
      }
      
      NsDataQueue = NsDataQueueDestination;
      if (__AVO_ENV__ === 'prod') {
        NsDataQueue.make && NsDataQueue.make(__AVO_ENV__, null);
      } else if (__AVO_ENV__ === 'dev') {
        NsDataQueue.make && NsDataQueue.make(__AVO_ENV__, null);
      } else {
        console[__REPORT_FAILURE_AS__ || 'error']("[avo] No staging key is set for nsDataQueue. Head to destination settings in Avo to set a staging key.");
        NsDataQueue.make && NsDataQueue.make(__AVO_ENV__, null);
      }
      if (__AVO_DEV__) {
        // debug console in Avo
        _avo_invoke_meta(__AVO_ENV__, 'init', [], 'init');
      }
    }
  }
  
  /**
   * button_click: Fires when a button is clicked
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/FOzIm6uwh0q/trigger/NHJsKlxZV
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.buttonType] - Type of button that is clicked (reset, submit or button)
   * @param {string} properties.uniqueName - Unique name / translations string for the element or event
   * @param {string} [properties.description] - Description of the element or event
   * @param {string} [properties.clickDestination] - Provide URL or screen_name if the button navigates
   * @param {string} [properties.clickText] - visible text which is clicked on / or label or element clicked (in case of nes-select for example)
   * @param {string} [properties.websiteSection] - Part of the website (header/footer/homepage/cookiebar/reisplanner etc.)
   * @param {string} [properties.data] - Extra information in string format
   * 
   * @see {@link https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/FOzIm6uwh0q}
   */
  function buttonClick(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalButtonType(properties.buttonType));
      messages = messages.concat(assertUniqueName(properties.uniqueName));
      messages = messages.concat(assertOptionalDescription(properties.description));
      messages = messages.concat(assertOptionalClickDestination(properties.clickDestination));
      messages = messages.concat(assertOptionalClickText(properties.clickText));
      messages = messages.concat(assertOptionalWebsiteSection(properties.websiteSection));
      messages = messages.concat(assertOptionalData(properties.data));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertLanguage(sysLanguage));
      messages = messages.concat(assertNsEnvironment(sysNsEnvironment));
      messages = messages.concat(assertDatalayerSource(sysDatalayerSource));
      messages = messages.concat(assertOptionalPreview(sysPreview));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("button_click", Object.keys(properties), [
        "buttonType",
        "uniqueName",
        "description",
        "clickDestination",
        "clickText",
        "websiteSection",
        "data"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "FOzIm6uwh0q", "3c6505cf99a19fa111cd02346e1054d8e5ccdc0a7c2f661e605c582e4d801491", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("button_click", {
        "schema": "iglu:nl.ns/button_click/jsonschema/2-0-6",
        "button_type": properties.buttonType,
        "unique_name": properties.uniqueName,
        "description": properties.description,
        "click_destination": properties.clickDestination,
        "click_text": properties.clickText,
        "website_section": properties.websiteSection,
        "data": properties.data,
        "platform": sysPlatform,
        "language": sysLanguage,
        "ns_environment": sysNsEnvironment,
        "datalayer_source": sysDatalayerSource,
        "preview": sysPreview,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("FOzIm6uwh0q", "button_click", messages, [
        {id: "4-eTlbcITN", name: "schema", value: "iglu:nl.ns/button_click/jsonschema/2-0-6"},
        {id: "7HGUvDZb-Fax", name: "data", value: properties.data},
        {id: "OCfm56R0fQu", name: "description", value: properties.description},
        {id: "TFD27fnuBpN-", name: "click_text", value: properties.clickText},
        {id: "ZRYtNJDfVeyb", name: "click_destination", value: properties.clickDestination},
        {id: "bF4w0NCf7D4", name: "unique_name", value: properties.uniqueName},
        {id: "oZ6ysVC6Ugt", name: "button_type", value: properties.buttonType},
        {id: "wskyjid5yxT0", name: "website_section", value: properties.websiteSection},
        {id: "-PddLxwT_", name: "platform", value: sysPlatform},
        {id: "Af3-RL1nz2", name: "language", value: sysLanguage},
        {id: "L-rHlXDQJd", name: "datalayer_source", value: sysDatalayerSource},
        {id: "Po4mUsQEyB", name: "preview", value: sysPreview},
        {id: "ux8kucXh9-", name: "ns_environment", value: sysNsEnvironment},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'button_click': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("button_click", {
          "schema": "iglu:nl.ns/button_click/jsonschema/2-0-6",
          "button_type": properties.buttonType,
          "unique_name": properties.uniqueName,
          "description": properties.description,
          "click_destination": properties.clickDestination,
          "click_text": properties.clickText,
          "website_section": properties.websiteSection,
          "data": properties.data,
          "platform": sysPlatform,
          "language": sysLanguage,
          "ns_environment": sysNsEnvironment,
          "datalayer_source": sysDatalayerSource,
          "preview": sysPreview,
          }, "FOzIm6uwh0q", "3c6505cf99a19fa111cd02346e1054d8e5ccdc0a7c2f661e605c582e4d801491");
      }
      // destination NsDataQueue
      NsDataQueue.logEvent("button_click", {
      "schema": "iglu:nl.ns/button_click/jsonschema/2-0-6",
      "button_type": properties.buttonType,
      "unique_name": properties.uniqueName,
      "description": properties.description,
      "click_destination": properties.clickDestination,
      "click_text": properties.clickText,
      "website_section": properties.websiteSection,
      "data": properties.data,
      "platform": sysPlatform,
      "language": sysLanguage,
      "ns_environment": sysNsEnvironment,
      "datalayer_source": sysDatalayerSource,
      "preview": sysPreview,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * element_view: When the user views a subsection of a page, for example a modal
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/_PZQtvO5afy/trigger/fS6ny3Svx
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.uniqueName - Unique name / translations string for the element or event
   * @param {string} [properties.description] - Description of the element or event
   * @param {string} properties.elementStructure - The page structure with a unique structure for the element that is viewed. For example: compare-modal|step-1. If used in combination with a interaction, provide the structure of the location on which the interaction takes place.
   * 
   * @see {@link https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/_PZQtvO5afy}
   */
  function elementView(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertUniqueName(properties.uniqueName));
      messages = messages.concat(assertOptionalDescription(properties.description));
      messages = messages.concat(assertElementStructure(properties.elementStructure));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertLanguage(sysLanguage));
      messages = messages.concat(assertNsEnvironment(sysNsEnvironment));
      messages = messages.concat(assertDatalayerSource(sysDatalayerSource));
      messages = messages.concat(assertOptionalPreview(sysPreview));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("element_view", Object.keys(properties), [
        "uniqueName",
        "description",
        "elementStructure"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "_PZQtvO5afy", "c959529e701821fb9d6d083c6b8d77436b1c35e8b62ef65a38002f75b72c2c76", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("element_view", {
        "schema": "iglu:nl.ns/element_view/jsonschema/4-0-3",
        "unique_name": properties.uniqueName,
        "description": properties.description,
        "element_structure": properties.elementStructure,
        "platform": sysPlatform,
        "language": sysLanguage,
        "ns_environment": sysNsEnvironment,
        "datalayer_source": sysDatalayerSource,
        "preview": sysPreview,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("_PZQtvO5afy", "element_view", messages, [
        {id: "4-eTlbcITN", name: "schema", value: "iglu:nl.ns/element_view/jsonschema/4-0-3"},
        {id: "FPhLne42GAA", name: "element_structure", value: properties.elementStructure},
        {id: "OCfm56R0fQu", name: "description", value: properties.description},
        {id: "bF4w0NCf7D4", name: "unique_name", value: properties.uniqueName},
        {id: "-PddLxwT_", name: "platform", value: sysPlatform},
        {id: "Af3-RL1nz2", name: "language", value: sysLanguage},
        {id: "L-rHlXDQJd", name: "datalayer_source", value: sysDatalayerSource},
        {id: "Po4mUsQEyB", name: "preview", value: sysPreview},
        {id: "ux8kucXh9-", name: "ns_environment", value: sysNsEnvironment},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'element_view': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("element_view", {
          "schema": "iglu:nl.ns/element_view/jsonschema/4-0-3",
          "unique_name": properties.uniqueName,
          "description": properties.description,
          "element_structure": properties.elementStructure,
          "platform": sysPlatform,
          "language": sysLanguage,
          "ns_environment": sysNsEnvironment,
          "datalayer_source": sysDatalayerSource,
          "preview": sysPreview,
          }, "_PZQtvO5afy", "c959529e701821fb9d6d083c6b8d77436b1c35e8b62ef65a38002f75b72c2c76");
      }
      // destination NsDataQueue
      NsDataQueue.logEvent("element_view", {
      "schema": "iglu:nl.ns/element_view/jsonschema/4-0-3",
      "unique_name": properties.uniqueName,
      "description": properties.description,
      "element_structure": properties.elementStructure,
      "platform": sysPlatform,
      "language": sysLanguage,
      "ns_environment": sysNsEnvironment,
      "datalayer_source": sysDatalayerSource,
      "preview": sysPreview,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * element_view: When the user views a subsection of a page, for example a modal, variant description: When a user sees an element, for example a button or modal
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.uniqueName - Unique name / translations string for the element or event
   * @param {string} [properties.description] - Description of the element or event
   * @param {string} [properties.nsShop] - Which shop/cluster: lvb_app, lvb_kaartjes, ns-flex, etc
   * 
   * @see {@link https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/_PZQtvO5afy.CMElxWlGhGjmFh8NJEaBI}
   */
  function elementViewElementViewApp(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertUniqueName(properties.uniqueName));
      messages = messages.concat(assertOptionalDescription(properties.description));
      messages = messages.concat(assertOptionalNsShop(properties.nsShop));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertLanguage(sysLanguage));
      messages = messages.concat(assertNsEnvironment(sysNsEnvironment));
      messages = messages.concat(assertDatalayerSource(sysDatalayerSource));
      messages = messages.concat(assertOptionalPreview(sysPreview));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("element_view", Object.keys(properties), [
        "uniqueName",
        "description",
        "nsShop"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "_PZQtvO5afy.CMElxWlGhGjmFh8NJEaBI", "fa8704cc88fd53946262d925da805bd6bf9ee6bcb0173d7148d0f5745cfaad30", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("element_view", {
        "schema": "iglu:nl.ns/element_view/jsonschema/4-0-3",
        "unique_name": properties.uniqueName,
        "description": properties.description,
        "ns_shop": properties.nsShop,
        "platform": sysPlatform,
        "language": sysLanguage,
        "ns_environment": sysNsEnvironment,
        "datalayer_source": sysDatalayerSource,
        "preview": sysPreview,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("_PZQtvO5afy.CMElxWlGhGjmFh8NJEaBI", "element_view", messages, [
        {id: "4-eTlbcITN", name: "schema", value: "iglu:nl.ns/element_view/jsonschema/4-0-3"},
        {id: "BImlhIesBPhx", name: "ns_shop", value: properties.nsShop},
        {id: "OCfm56R0fQu", name: "description", value: properties.description},
        {id: "bF4w0NCf7D4", name: "unique_name", value: properties.uniqueName},
        {id: "-PddLxwT_", name: "platform", value: sysPlatform},
        {id: "Af3-RL1nz2", name: "language", value: sysLanguage},
        {id: "L-rHlXDQJd", name: "datalayer_source", value: sysDatalayerSource},
        {id: "Po4mUsQEyB", name: "preview", value: sysPreview},
        {id: "ux8kucXh9-", name: "ns_environment", value: sysNsEnvironment},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'element_view': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("element_view", {
          "schema": "iglu:nl.ns/element_view/jsonschema/4-0-3",
          "unique_name": properties.uniqueName,
          "description": properties.description,
          "ns_shop": properties.nsShop,
          "platform": sysPlatform,
          "language": sysLanguage,
          "ns_environment": sysNsEnvironment,
          "datalayer_source": sysDatalayerSource,
          "preview": sysPreview,
          }, "_PZQtvO5afy.CMElxWlGhGjmFh8NJEaBI", "fa8704cc88fd53946262d925da805bd6bf9ee6bcb0173d7148d0f5745cfaad30");
      }
      // destination NsDataQueue
      NsDataQueue.logEvent("element_view", {
      "schema": "iglu:nl.ns/element_view/jsonschema/4-0-3",
      "unique_name": properties.uniqueName,
      "description": properties.description,
      "ns_shop": properties.nsShop,
      "platform": sysPlatform,
      "language": sysLanguage,
      "ns_environment": sysNsEnvironment,
      "datalayer_source": sysDatalayerSource,
      "preview": sysPreview,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * link_click: When a link is clicked
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/cbU-q4KjR86/trigger/0NaEFhD0K
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {bool} properties.newTab - Link opens in new tab
   * @param {bool} properties.externalLink - Link links to an external domain.
   * @param {string} properties.uniqueName - Unique name / translations string for the element or event
   * @param {string} properties.description - Description of the element or event
   * @param {string} properties.clickDestination - Provide URL or screen_name if the button navigates
   * @param {string} properties.clickText - visible text which is clicked on / or label or element clicked (in case of nes-select for example)
   * @param {string} [properties.websiteSection] - Part of the website (header/footer/homepage/cookiebar/reisplanner etc.)
   * 
   * @see {@link https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/cbU-q4KjR86}
   */
  function linkClick(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertNewTab(properties.newTab));
      messages = messages.concat(assertExternalLink(properties.externalLink));
      messages = messages.concat(assertUniqueName(properties.uniqueName));
      messages = messages.concat(assertDescription(properties.description));
      messages = messages.concat(assertClickDestination(properties.clickDestination));
      messages = messages.concat(assertClickText(properties.clickText));
      messages = messages.concat(assertOptionalWebsiteSection(properties.websiteSection));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertLanguage(sysLanguage));
      messages = messages.concat(assertNsEnvironment(sysNsEnvironment));
      messages = messages.concat(assertDatalayerSource(sysDatalayerSource));
      messages = messages.concat(assertOptionalPreview(sysPreview));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("link_click", Object.keys(properties), [
        "newTab",
        "externalLink",
        "uniqueName",
        "description",
        "clickDestination",
        "clickText",
        "websiteSection"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "cbU-q4KjR86", "2b4484c936868ab7760cb8dcbc227393afc8b071bfd109f9dcb7401fbabf27a3", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("link_click", {
        "schema": "iglu:nl.ns/link_click/jsonschema/1-0-2",
        "new_tab": properties.newTab,
        "external_link": properties.externalLink,
        "unique_name": properties.uniqueName,
        "description": properties.description,
        "click_destination": properties.clickDestination,
        "click_text": properties.clickText,
        "website_section": properties.websiteSection,
        "platform": sysPlatform,
        "language": sysLanguage,
        "ns_environment": sysNsEnvironment,
        "datalayer_source": sysDatalayerSource,
        "preview": sysPreview,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("cbU-q4KjR86", "link_click", messages, [
        {id: "4-eTlbcITN", name: "schema", value: "iglu:nl.ns/link_click/jsonschema/1-0-2"},
        {id: "DzZMn4cZBxR", name: "external_link", value: properties.externalLink},
        {id: "OCfm56R0fQu", name: "description", value: properties.description},
        {id: "TFD27fnuBpN-", name: "click_text", value: properties.clickText},
        {id: "ZRYtNJDfVeyb", name: "click_destination", value: properties.clickDestination},
        {id: "bF4w0NCf7D4", name: "unique_name", value: properties.uniqueName},
        {id: "nw5UW2_uvVj", name: "new_tab", value: properties.newTab},
        {id: "wskyjid5yxT0", name: "website_section", value: properties.websiteSection},
        {id: "-PddLxwT_", name: "platform", value: sysPlatform},
        {id: "Af3-RL1nz2", name: "language", value: sysLanguage},
        {id: "L-rHlXDQJd", name: "datalayer_source", value: sysDatalayerSource},
        {id: "Po4mUsQEyB", name: "preview", value: sysPreview},
        {id: "ux8kucXh9-", name: "ns_environment", value: sysNsEnvironment},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'link_click': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("link_click", {
          "schema": "iglu:nl.ns/link_click/jsonschema/1-0-2",
          "new_tab": properties.newTab,
          "external_link": properties.externalLink,
          "unique_name": properties.uniqueName,
          "description": properties.description,
          "click_destination": properties.clickDestination,
          "click_text": properties.clickText,
          "website_section": properties.websiteSection,
          "platform": sysPlatform,
          "language": sysLanguage,
          "ns_environment": sysNsEnvironment,
          "datalayer_source": sysDatalayerSource,
          "preview": sysPreview,
          }, "cbU-q4KjR86", "2b4484c936868ab7760cb8dcbc227393afc8b071bfd109f9dcb7401fbabf27a3");
      }
      // destination NsDataQueue
      NsDataQueue.logEvent("link_click", {
      "schema": "iglu:nl.ns/link_click/jsonschema/1-0-2",
      "new_tab": properties.newTab,
      "external_link": properties.externalLink,
      "unique_name": properties.uniqueName,
      "description": properties.description,
      "click_destination": properties.clickDestination,
      "click_text": properties.clickText,
      "website_section": properties.websiteSection,
      "platform": sysPlatform,
      "language": sysLanguage,
      "ns_environment": sysNsEnvironment,
      "datalayer_source": sysDatalayerSource,
      "preview": sysPreview,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * checkbox_click: When a user interacts with a checkbox
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/u1opA49f2lE/trigger/qbN-Od0ou
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.uniqueName - Unique name / translations string for the element or event
   * @param {string} properties.description - Description of the element or event
   * @param {bool} properties.checked - Is the element selected of not?
   * @param {string} properties.clickText - visible text which is clicked on / or label or element clicked (in case of nes-select for example)
   * @param {string} [properties.websiteSection] - Part of the website (header/footer/homepage/cookiebar/reisplanner etc.)
   * 
   * @see {@link https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/u1opA49f2lE}
   */
  function checkboxClick(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertUniqueName(properties.uniqueName));
      messages = messages.concat(assertDescription(properties.description));
      messages = messages.concat(assertChecked(properties.checked));
      messages = messages.concat(assertClickText(properties.clickText));
      messages = messages.concat(assertOptionalWebsiteSection(properties.websiteSection));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertLanguage(sysLanguage));
      messages = messages.concat(assertNsEnvironment(sysNsEnvironment));
      messages = messages.concat(assertDatalayerSource(sysDatalayerSource));
      messages = messages.concat(assertOptionalPreview(sysPreview));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("checkbox_click", Object.keys(properties), [
        "uniqueName",
        "description",
        "checked",
        "clickText",
        "websiteSection"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "u1opA49f2lE", "5b1ea04a082a748bb81effaf2cd45dc69b56bb702e141fde9c6687eb44500d9f", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("checkbox_click", {
        "schema": "iglu:nl.ns/checkbox_click/jsonschema/1-0-3",
        "unique_name": properties.uniqueName,
        "description": properties.description,
        "checked": properties.checked,
        "click_text": properties.clickText,
        "website_section": properties.websiteSection,
        "platform": sysPlatform,
        "language": sysLanguage,
        "ns_environment": sysNsEnvironment,
        "datalayer_source": sysDatalayerSource,
        "preview": sysPreview,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("u1opA49f2lE", "checkbox_click", messages, [
        {id: "4-eTlbcITN", name: "schema", value: "iglu:nl.ns/checkbox_click/jsonschema/1-0-3"},
        {id: "OCfm56R0fQu", name: "description", value: properties.description},
        {id: "TFD27fnuBpN-", name: "click_text", value: properties.clickText},
        {id: "bF4w0NCf7D4", name: "unique_name", value: properties.uniqueName},
        {id: "rzoBfRsaz89", name: "checked", value: properties.checked},
        {id: "wskyjid5yxT0", name: "website_section", value: properties.websiteSection},
        {id: "-PddLxwT_", name: "platform", value: sysPlatform},
        {id: "Af3-RL1nz2", name: "language", value: sysLanguage},
        {id: "L-rHlXDQJd", name: "datalayer_source", value: sysDatalayerSource},
        {id: "Po4mUsQEyB", name: "preview", value: sysPreview},
        {id: "ux8kucXh9-", name: "ns_environment", value: sysNsEnvironment},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'checkbox_click': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("checkbox_click", {
          "schema": "iglu:nl.ns/checkbox_click/jsonschema/1-0-3",
          "unique_name": properties.uniqueName,
          "description": properties.description,
          "checked": properties.checked,
          "click_text": properties.clickText,
          "website_section": properties.websiteSection,
          "platform": sysPlatform,
          "language": sysLanguage,
          "ns_environment": sysNsEnvironment,
          "datalayer_source": sysDatalayerSource,
          "preview": sysPreview,
          }, "u1opA49f2lE", "5b1ea04a082a748bb81effaf2cd45dc69b56bb702e141fde9c6687eb44500d9f");
      }
      // destination NsDataQueue
      NsDataQueue.logEvent("checkbox_click", {
      "schema": "iglu:nl.ns/checkbox_click/jsonschema/1-0-3",
      "unique_name": properties.uniqueName,
      "description": properties.description,
      "checked": properties.checked,
      "click_text": properties.clickText,
      "website_section": properties.websiteSection,
      "platform": sysPlatform,
      "language": sysLanguage,
      "ns_environment": sysNsEnvironment,
      "datalayer_source": sysDatalayerSource,
      "preview": sysPreview,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * registration_start: Event sent when a user clicks the signup button and that way starts the signup process.
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.mijnnsVersion - Name of the mijnNS-omgeving (consument of zakelijk)
   * 
   * @see {@link https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/CpCZNX24H8}
   */
  function registrationStart(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertMijnnsVersion(properties.mijnnsVersion));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertLanguage(sysLanguage));
      messages = messages.concat(assertNsEnvironment(sysNsEnvironment));
      messages = messages.concat(assertDatalayerSource(sysDatalayerSource));
      messages = messages.concat(assertOptionalPreview(sysPreview));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("registration_start", Object.keys(properties), [
        "mijnnsVersion"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "CpCZNX24H8", "a92059164e199c19d3ad456e0ea78c4a76b484361841d24063808b906b110466", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("registration_start", {
        "schema": "iglu:nl.ns/registration_start/jsonschema/1-0-0",
        "mijnns_version": properties.mijnnsVersion,
        "platform": sysPlatform,
        "language": sysLanguage,
        "ns_environment": sysNsEnvironment,
        "datalayer_source": sysDatalayerSource,
        "preview": sysPreview,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("CpCZNX24H8", "registration_start", messages, [
        {id: "4-eTlbcITN", name: "schema", value: "iglu:nl.ns/registration_start/jsonschema/1-0-0"},
        {id: "lbXiVJSEQrn6", name: "mijnns_version", value: properties.mijnnsVersion},
        {id: "-PddLxwT_", name: "platform", value: sysPlatform},
        {id: "Af3-RL1nz2", name: "language", value: sysLanguage},
        {id: "L-rHlXDQJd", name: "datalayer_source", value: sysDatalayerSource},
        {id: "Po4mUsQEyB", name: "preview", value: sysPreview},
        {id: "ux8kucXh9-", name: "ns_environment", value: sysNsEnvironment},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'registration_start': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("registration_start", {
          "schema": "iglu:nl.ns/registration_start/jsonschema/1-0-0",
          "mijnns_version": properties.mijnnsVersion,
          "platform": sysPlatform,
          "language": sysLanguage,
          "ns_environment": sysNsEnvironment,
          "datalayer_source": sysDatalayerSource,
          "preview": sysPreview,
          }, "CpCZNX24H8", "a92059164e199c19d3ad456e0ea78c4a76b484361841d24063808b906b110466");
      }
      // destination NsDataQueue
      NsDataQueue.logEvent("registration_start", {
      "schema": "iglu:nl.ns/registration_start/jsonschema/1-0-0",
      "mijnns_version": properties.mijnnsVersion,
      "platform": sysPlatform,
      "language": sysLanguage,
      "ns_environment": sysNsEnvironment,
      "datalayer_source": sysDatalayerSource,
      "preview": sysPreview,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * registration_success: Event sent when a user clicks the submit button and ends the signup process.
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.userId_ - The value used to identify the user. Make sure it's a unique sequence of characters used to identify the user.
   * @param {string} properties.mijnnsVersion - Name of the mijnNS-omgeving (consument of zakelijk)
   * @param {string} [properties.customerEntity] - Type entiteit van het record
   * @param {string} properties.hashedEmail - SHA256 hash of email address
   * 
   * @see {@link https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/aan9iGJR9q}
   */
  function registrationSuccess(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertUserId_(properties.userId_));
      messages = messages.concat(assertMijnnsVersion(properties.mijnnsVersion));
      messages = messages.concat(assertOptionalCustomerEntity(properties.customerEntity));
      messages = messages.concat(assertHashedEmail(properties.hashedEmail));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertLanguage(sysLanguage));
      messages = messages.concat(assertNsEnvironment(sysNsEnvironment));
      messages = messages.concat(assertDatalayerSource(sysDatalayerSource));
      messages = messages.concat(assertOptionalPreview(sysPreview));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("registration_success", Object.keys(properties), [
        "userId_",
        "mijnnsVersion",
        "customerEntity",
        "hashedEmail"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "aan9iGJR9q", "66f827cb4ea06d65be1c53448ee85e7a60c97844395542ac85cddaab83801174", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("registration_success", {
        "schema": "iglu:nl.ns/registration_success/jsonschema/1-0-0",
        "mijnns_version": properties.mijnnsVersion,
        "customer_entity": properties.customerEntity,
        "platform": sysPlatform,
        "language": sysLanguage,
        "ns_environment": sysNsEnvironment,
        "datalayer_source": sysDatalayerSource,
        "preview": sysPreview,
        }, {
        "hashed_email": properties.hashedEmail,
        }, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("aan9iGJR9q", "registration_success", messages, [
        {id: "4-eTlbcITN", name: "schema", value: "iglu:nl.ns/registration_success/jsonschema/1-0-0"},
        {id: "TQleINBSI93G", name: "customer_entity", value: properties.customerEntity},
        {id: "lbXiVJSEQrn6", name: "mijnns_version", value: properties.mijnnsVersion},
        {id: "-PddLxwT_", name: "platform", value: sysPlatform},
        {id: "Af3-RL1nz2", name: "language", value: sysLanguage},
        {id: "L-rHlXDQJd", name: "datalayer_source", value: sysDatalayerSource},
        {id: "Po4mUsQEyB", name: "preview", value: sysPreview},
        {id: "ux8kucXh9-", name: "ns_environment", value: sysNsEnvironment},
        ], [
        {id:"ALoQI7FpkV", name: "hashed_email", value: properties.hashedEmail},
        ], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'registration_success': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("registration_success", {
          "schema": "iglu:nl.ns/registration_success/jsonschema/1-0-0",
          "mijnns_version": properties.mijnnsVersion,
          "customer_entity": properties.customerEntity,
          "platform": sysPlatform,
          "language": sysLanguage,
          "ns_environment": sysNsEnvironment,
          "datalayer_source": sysDatalayerSource,
          "preview": sysPreview,
          }, "aan9iGJR9q", "66f827cb4ea06d65be1c53448ee85e7a60c97844395542ac85cddaab83801174");
      }
      // destination NsDataQueue
      NsDataQueue.setUserProperties(properties.userId_, {
      "hashed_email": properties.hashedEmail,
      });
      NsDataQueue.logEvent("registration_success", {
      "schema": "iglu:nl.ns/registration_success/jsonschema/1-0-0",
      "mijnns_version": properties.mijnnsVersion,
      "customer_entity": properties.customerEntity,
      "platform": sysPlatform,
      "language": sysLanguage,
      "ns_environment": sysNsEnvironment,
      "datalayer_source": sysDatalayerSource,
      "preview": sysPreview,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * login_start: Event sent a when a user clicks the log in button and begins the login process.
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.mijnnsVersion - Name of the mijnNS-omgeving (consument of zakelijk)
   * 
   * @see {@link https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/9IX1dJEetN}
   */
  function loginStart(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertMijnnsVersion(properties.mijnnsVersion));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertLanguage(sysLanguage));
      messages = messages.concat(assertNsEnvironment(sysNsEnvironment));
      messages = messages.concat(assertDatalayerSource(sysDatalayerSource));
      messages = messages.concat(assertOptionalPreview(sysPreview));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("login_start", Object.keys(properties), [
        "mijnnsVersion"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "9IX1dJEetN", "e807df59b0dbb75d2291ac4ccf689c6f9b8121601f84e5b78e00d5368074721a", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("login_start", {
        "schema": "iglu:nl.ns/login_start/jsonschema/1-0-0",
        "mijnns_version": properties.mijnnsVersion,
        "platform": sysPlatform,
        "language": sysLanguage,
        "ns_environment": sysNsEnvironment,
        "datalayer_source": sysDatalayerSource,
        "preview": sysPreview,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("9IX1dJEetN", "login_start", messages, [
        {id: "4-eTlbcITN", name: "schema", value: "iglu:nl.ns/login_start/jsonschema/1-0-0"},
        {id: "lbXiVJSEQrn6", name: "mijnns_version", value: properties.mijnnsVersion},
        {id: "-PddLxwT_", name: "platform", value: sysPlatform},
        {id: "Af3-RL1nz2", name: "language", value: sysLanguage},
        {id: "L-rHlXDQJd", name: "datalayer_source", value: sysDatalayerSource},
        {id: "Po4mUsQEyB", name: "preview", value: sysPreview},
        {id: "ux8kucXh9-", name: "ns_environment", value: sysNsEnvironment},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'login_start': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("login_start", {
          "schema": "iglu:nl.ns/login_start/jsonschema/1-0-0",
          "mijnns_version": properties.mijnnsVersion,
          "platform": sysPlatform,
          "language": sysLanguage,
          "ns_environment": sysNsEnvironment,
          "datalayer_source": sysDatalayerSource,
          "preview": sysPreview,
          }, "9IX1dJEetN", "e807df59b0dbb75d2291ac4ccf689c6f9b8121601f84e5b78e00d5368074721a");
      }
      // destination NsDataQueue
      NsDataQueue.logEvent("login_start", {
      "schema": "iglu:nl.ns/login_start/jsonschema/1-0-0",
      "mijnns_version": properties.mijnnsVersion,
      "platform": sysPlatform,
      "language": sysLanguage,
      "ns_environment": sysNsEnvironment,
      "datalayer_source": sysDatalayerSource,
      "preview": sysPreview,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * login_error: Event sent when a user's account information is not successfully authenticated.
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.mijnnsVersion - Name of the mijnNS-omgeving (consument of zakelijk)
   * @param {string} properties.error - Error message that was displayed
   * 
   * @see {@link https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/eGcvTR899Z}
   */
  function loginError(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertMijnnsVersion(properties.mijnnsVersion));
      messages = messages.concat(assertError(properties.error));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertLanguage(sysLanguage));
      messages = messages.concat(assertNsEnvironment(sysNsEnvironment));
      messages = messages.concat(assertDatalayerSource(sysDatalayerSource));
      messages = messages.concat(assertOptionalPreview(sysPreview));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("login_error", Object.keys(properties), [
        "mijnnsVersion",
        "error"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "eGcvTR899Z", "1f4a27d8dc31d220345a3b0f0e37164b5584c34da42f19512486d236c89ee59c", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("login_error", {
        "schema": "iglu:nl.ns/login_error/jsonschema/1-0-0",
        "mijnns_version": properties.mijnnsVersion,
        "error": properties.error,
        "platform": sysPlatform,
        "language": sysLanguage,
        "ns_environment": sysNsEnvironment,
        "datalayer_source": sysDatalayerSource,
        "preview": sysPreview,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("eGcvTR899Z", "login_error", messages, [
        {id: "4-eTlbcITN", name: "schema", value: "iglu:nl.ns/login_error/jsonschema/1-0-0"},
        {id: "Oi6yaZll3yFM", name: "error", value: properties.error},
        {id: "lbXiVJSEQrn6", name: "mijnns_version", value: properties.mijnnsVersion},
        {id: "-PddLxwT_", name: "platform", value: sysPlatform},
        {id: "Af3-RL1nz2", name: "language", value: sysLanguage},
        {id: "L-rHlXDQJd", name: "datalayer_source", value: sysDatalayerSource},
        {id: "Po4mUsQEyB", name: "preview", value: sysPreview},
        {id: "ux8kucXh9-", name: "ns_environment", value: sysNsEnvironment},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'login_error': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("login_error", {
          "schema": "iglu:nl.ns/login_error/jsonschema/1-0-0",
          "mijnns_version": properties.mijnnsVersion,
          "error": properties.error,
          "platform": sysPlatform,
          "language": sysLanguage,
          "ns_environment": sysNsEnvironment,
          "datalayer_source": sysDatalayerSource,
          "preview": sysPreview,
          }, "eGcvTR899Z", "1f4a27d8dc31d220345a3b0f0e37164b5584c34da42f19512486d236c89ee59c");
      }
      // destination NsDataQueue
      NsDataQueue.logEvent("login_error", {
      "schema": "iglu:nl.ns/login_error/jsonschema/1-0-0",
      "mijnns_version": properties.mijnnsVersion,
      "error": properties.error,
      "platform": sysPlatform,
      "language": sysLanguage,
      "ns_environment": sysNsEnvironment,
      "datalayer_source": sysDatalayerSource,
      "preview": sysPreview,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * session_start: Event fires at the first page view in a user session [definitie gebruikerssessie].
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.utmSource] - Source of the campaign
   * @param {string} [properties.utmMedium] - Medium of marketing campaign (CPC etc)
   * @param {string} [properties.utmCampaign] - name of the marketing campaign responsible for this visit
   * @param {string} [properties.utmTerm] - term used in search or custom utm param
   * @param {string} [properties.utmContent] - description of campaign content
   * @param {string} [properties.utmId] - utm id
   * 
   * @see {@link https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/Fa-EbJyylC8}
   */
  function sessionStart(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalUtmSource(properties.utmSource));
      messages = messages.concat(assertOptionalUtmMedium(properties.utmMedium));
      messages = messages.concat(assertOptionalUtmCampaign(properties.utmCampaign));
      messages = messages.concat(assertOptionalUtmTerm(properties.utmTerm));
      messages = messages.concat(assertOptionalUtmContent(properties.utmContent));
      messages = messages.concat(assertOptionalUtmId(properties.utmId));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertLanguage(sysLanguage));
      messages = messages.concat(assertNsEnvironment(sysNsEnvironment));
      messages = messages.concat(assertDatalayerSource(sysDatalayerSource));
      messages = messages.concat(assertOptionalPreview(sysPreview));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("session_start", Object.keys(properties), [
        "utmSource",
        "utmMedium",
        "utmCampaign",
        "utmTerm",
        "utmContent",
        "utmId"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "Fa-EbJyylC8", "1b4e8f76a64a99ac74886d5f87a229284a42ee4d4afc84f84f28efbb0137ace4", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("session_start", {
        "schema": "iglu:nl.ns/session_start/jsonschema/1-0-0",
        "utm_source": properties.utmSource,
        "utm_medium": properties.utmMedium,
        "utm_campaign": properties.utmCampaign,
        "utm_term": properties.utmTerm,
        "utm_content": properties.utmContent,
        "utm_id": properties.utmId,
        "platform": sysPlatform,
        "language": sysLanguage,
        "ns_environment": sysNsEnvironment,
        "datalayer_source": sysDatalayerSource,
        "preview": sysPreview,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("Fa-EbJyylC8", "session_start", messages, [
        {id: "4-eTlbcITN", name: "schema", value: "iglu:nl.ns/session_start/jsonschema/1-0-0"},
        {id: "3k9em70_j0Ac", name: "utm_campaign", value: properties.utmCampaign},
        {id: "4X73rTMNgTkZ", name: "utm_source", value: properties.utmSource},
        {id: "BXSsSA9Tphqq", name: "utm_id", value: properties.utmId},
        {id: "TigsIVrjd8Ws", name: "utm_term", value: properties.utmTerm},
        {id: "WCgPbfCy_8b3", name: "utm_medium", value: properties.utmMedium},
        {id: "jksVIoRXIWk2", name: "utm_content", value: properties.utmContent},
        {id: "-PddLxwT_", name: "platform", value: sysPlatform},
        {id: "Af3-RL1nz2", name: "language", value: sysLanguage},
        {id: "L-rHlXDQJd", name: "datalayer_source", value: sysDatalayerSource},
        {id: "Po4mUsQEyB", name: "preview", value: sysPreview},
        {id: "ux8kucXh9-", name: "ns_environment", value: sysNsEnvironment},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'session_start': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("session_start", {
          "schema": "iglu:nl.ns/session_start/jsonschema/1-0-0",
          "utm_source": properties.utmSource,
          "utm_medium": properties.utmMedium,
          "utm_campaign": properties.utmCampaign,
          "utm_term": properties.utmTerm,
          "utm_content": properties.utmContent,
          "utm_id": properties.utmId,
          "platform": sysPlatform,
          "language": sysLanguage,
          "ns_environment": sysNsEnvironment,
          "datalayer_source": sysDatalayerSource,
          "preview": sysPreview,
          }, "Fa-EbJyylC8", "1b4e8f76a64a99ac74886d5f87a229284a42ee4d4afc84f84f28efbb0137ace4");
      }
      // destination NsDataQueue
      NsDataQueue.logEvent("session_start", {
      "schema": "iglu:nl.ns/session_start/jsonschema/1-0-0",
      "utm_source": properties.utmSource,
      "utm_medium": properties.utmMedium,
      "utm_campaign": properties.utmCampaign,
      "utm_term": properties.utmTerm,
      "utm_content": properties.utmContent,
      "utm_id": properties.utmId,
      "platform": sysPlatform,
      "language": sysLanguage,
      "ns_environment": sysNsEnvironment,
      "datalayer_source": sysDatalayerSource,
      "preview": sysPreview,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * scroll: Triggers when a certain % of the page depth has been reached
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {int} properties.percent - Scroll depth on the page that has been reached.
   * 
   * @see {@link https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/jY9kOhOVXBX}
   */
  function scroll(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPercent(properties.percent));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertLanguage(sysLanguage));
      messages = messages.concat(assertNsEnvironment(sysNsEnvironment));
      messages = messages.concat(assertDatalayerSource(sysDatalayerSource));
      messages = messages.concat(assertOptionalPreview(sysPreview));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("scroll", Object.keys(properties), [
        "percent"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "jY9kOhOVXBX", "ba6be03bbfecca784497e65f266ef5dbb4d334063d9f61694b90615418fed910", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("scroll", {
        "schema": "iglu:nl.ns/scroll/jsonschema/1-0-0",
        "percent": properties.percent,
        "platform": sysPlatform,
        "language": sysLanguage,
        "ns_environment": sysNsEnvironment,
        "datalayer_source": sysDatalayerSource,
        "preview": sysPreview,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("jY9kOhOVXBX", "scroll", messages, [
        {id: "4-eTlbcITN", name: "schema", value: "iglu:nl.ns/scroll/jsonschema/1-0-0"},
        {id: "_iIBN-4DdOc1", name: "percent", value: properties.percent},
        {id: "-PddLxwT_", name: "platform", value: sysPlatform},
        {id: "Af3-RL1nz2", name: "language", value: sysLanguage},
        {id: "L-rHlXDQJd", name: "datalayer_source", value: sysDatalayerSource},
        {id: "Po4mUsQEyB", name: "preview", value: sysPreview},
        {id: "ux8kucXh9-", name: "ns_environment", value: sysNsEnvironment},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'scroll': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("scroll", {
          "schema": "iglu:nl.ns/scroll/jsonschema/1-0-0",
          "percent": properties.percent,
          "platform": sysPlatform,
          "language": sysLanguage,
          "ns_environment": sysNsEnvironment,
          "datalayer_source": sysDatalayerSource,
          "preview": sysPreview,
          }, "jY9kOhOVXBX", "ba6be03bbfecca784497e65f266ef5dbb4d334063d9f61694b90615418fed910");
      }
      // destination NsDataQueue
      NsDataQueue.logEvent("scroll", {
      "schema": "iglu:nl.ns/scroll/jsonschema/1-0-0",
      "percent": properties.percent,
      "platform": sysPlatform,
      "language": sysLanguage,
      "ns_environment": sysNsEnvironment,
      "datalayer_source": sysDatalayerSource,
      "preview": sysPreview,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * visit_qualified: 30s on page or clickthrough
   * 
   * @see {@link https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/mo12laQ7-DZ}
   */
  function visitQualified(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertLanguage(sysLanguage));
      messages = messages.concat(assertNsEnvironment(sysNsEnvironment));
      messages = messages.concat(assertDatalayerSource(sysDatalayerSource));
      messages = messages.concat(assertOptionalPreview(sysPreview));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("visit_qualified", Object.keys(properties), [
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "mo12laQ7-DZ", "5c40c4d22c43c0e7f692b7962efa5396cf1da460737c3a6ebd1f42770b5f3b41", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("visit_qualified", {
        "schema": "iglu:nl.ns/visit_qualified/jsonschema/1-0-0",
        "platform": sysPlatform,
        "language": sysLanguage,
        "ns_environment": sysNsEnvironment,
        "datalayer_source": sysDatalayerSource,
        "preview": sysPreview,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("mo12laQ7-DZ", "visit_qualified", messages, [
        {id: "4-eTlbcITN", name: "schema", value: "iglu:nl.ns/visit_qualified/jsonschema/1-0-0"},
        {id: "-PddLxwT_", name: "platform", value: sysPlatform},
        {id: "Af3-RL1nz2", name: "language", value: sysLanguage},
        {id: "L-rHlXDQJd", name: "datalayer_source", value: sysDatalayerSource},
        {id: "Po4mUsQEyB", name: "preview", value: sysPreview},
        {id: "ux8kucXh9-", name: "ns_environment", value: sysNsEnvironment},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'visit_qualified': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("visit_qualified", {
          "schema": "iglu:nl.ns/visit_qualified/jsonschema/1-0-0",
          "platform": sysPlatform,
          "language": sysLanguage,
          "ns_environment": sysNsEnvironment,
          "datalayer_source": sysDatalayerSource,
          "preview": sysPreview,
          }, "mo12laQ7-DZ", "5c40c4d22c43c0e7f692b7962efa5396cf1da460737c3a6ebd1f42770b5f3b41");
      }
      // destination NsDataQueue
      NsDataQueue.logEvent("visit_qualified", {
      "schema": "iglu:nl.ns/visit_qualified/jsonschema/1-0-0",
      "platform": sysPlatform,
      "language": sysLanguage,
      "ns_environment": sysNsEnvironment,
      "datalayer_source": sysDatalayerSource,
      "preview": sysPreview,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * begin_checkout: Web: When you hit add to cart/go to cart button i.e. next step after product detail page
App: The step after the add_to_cart, when you configure the ticket
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.currency - The currency of the purchase
   * @param {string} properties.coupon - ONLY WEB | coupon-code or campaign id
   * @param {float} properties.value - value of purhcased/added/removed item(s)
   * @param {Array<object>} properties.items - item array of objects:
[{
          item_id: 'FLEX|7,
          item_name: 'Traject Vrij',
          coupon: 'Zomercampagne',
          discount: 5.00,
          index: 0,
          item_brand: 'NS.nl',
          item_category: 'Abonnementen',
          origin_station: 'Ede-Wageningen',
          destination_station: 'Woerden'
          item_variant: 'NS-Flex',  
          price: 291.90,
          quantity: 1
          item_revenue: 291.90
          intercity_direct: true,
          deur_tot_deur: {}
        }]
   * @param {string} properties.nsShop - Which shop/cluster: lvb_app, lvb_kaartjes, ns-flex, etc
   * @param {string} [properties.salesChannel] - Wat is het verkoopkanaal van de aankoop? Spoordeelwinkel / Losse kaatjes / Externe verkoper
   * 
   * @see {@link https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/YSfuMbF3uzA}
   */
  function beginCheckout(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertCurrency(properties.currency));
      messages = messages.concat(assertCoupon(properties.coupon));
      messages = messages.concat(assertValue(properties.value));
      messages = messages.concat(assertItems(properties.items));
      messages = messages.concat(assertNsShop(properties.nsShop));
      messages = messages.concat(assertOptionalSalesChannel(properties.salesChannel));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertLanguage(sysLanguage));
      messages = messages.concat(assertNsEnvironment(sysNsEnvironment));
      messages = messages.concat(assertDatalayerSource(sysDatalayerSource));
      messages = messages.concat(assertOptionalPreview(sysPreview));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("begin_checkout", Object.keys(properties), [
        "currency",
        "coupon",
        "value",
        "items",
        "nsShop",
        "salesChannel"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "YSfuMbF3uzA", "24e45f5c32b4f8684d6b1b7f0dbd88f1bf32c4b559981627e1e30c30e4dae403", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("begin_checkout", {
        "schema": "iglu:nl.ns/begin_checkout/jsonschema/1-0-6",
        "currency": properties.currency,
        "coupon": properties.coupon,
        "value": properties.value,
        "items": properties.items.map(function(value) {
          return {
            "item_id": value.itemId,
            "item_name": value.itemName,
            "coupon": value.coupon,
            "discount": value.discount,
            "index": value.index,
            "quantity": value.quantity,
            "price": value.price,
            "item_brand": value.itemBrand,
            "item_variant": value.itemVariant,
            "item_category": value.itemCategory,
            "travel_date": value.travelDate,
            "affiliation": value.affiliation,
            "item_category2": value.itemCategory2,
            "destination_station": value.destinationStation,
            "origin_station": value.originStation,
            "travel_class": value.travelClass,
            "travel_route": value.travelRoute,
            "intercity_direct": value.intercityDirect,
            "deur_tot_deur": value.deurTotDeur,
            "item_revenue": value.itemRevenue,
          };
          }),
        "ns_shop": properties.nsShop,
        "sales_channel": properties.salesChannel,
        "platform": sysPlatform,
        "language": sysLanguage,
        "ns_environment": sysNsEnvironment,
        "datalayer_source": sysDatalayerSource,
        "preview": sysPreview,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("YSfuMbF3uzA", "begin_checkout", messages, [
        {id: "4-eTlbcITN", name: "schema", value: "iglu:nl.ns/begin_checkout/jsonschema/1-0-6"},
        {id: "17s21jQ4G", name: "intercity_direct", value: properties.intercityDirect},
        {id: "1WkP-6sA8x_5", name: "value", value: properties.value},
        {id: "6-GUnFHLFL", name: "item_brand", value: properties.itemBrand},
        {id: "7h-TV9MOq2", name: "item_category", value: properties.itemCategory},
        {id: "9Tv-BxH6jSI", name: "coupon", value: properties.coupon},
        {id: "BImlhIesBPhx", name: "ns_shop", value: properties.nsShop},
        {id: "D-6RH3lvH", name: "affiliation", value: properties.affiliation},
        {id: "GuYrcDncVS5", name: "currency", value: properties.currency},
        {id: "JzW147FWP", name: "deur_tot_deur", value: properties.deurTotDeur},
        {id: "Oavl4KfPHF3", name: "items", value: properties.items},
        {id: "PKlIwCNeHb", name: "index", value: properties.index},
        {id: "PpX-d_0VW", name: "travel_route", value: properties.travelRoute},
        {id: "TIV1Wo8BM", name: "item_category2", value: properties.itemCategory2},
        {id: "UpRgfCPRK", name: "destination_station", value: properties.destinationStation},
        {id: "WGDHyEYby", name: "travel_date", value: properties.travelDate},
        {id: "ZVGAZOlEBhGj", name: "item_id", value: properties.itemId},
        {id: "ZZlWcbau6V", name: "quantity", value: properties.quantity},
        {id: "_T-mygJA7w", name: "price", value: properties.price},
        {id: "_WmY6XGTY", name: "travel_class", value: properties.travelClass},
        {id: "bMK3liq6t", name: "origin_station", value: properties.originStation},
        {id: "ePZR23byGW", name: "discount", value: properties.discount},
        {id: "hg4puJyLhb", name: "item_name", value: properties.itemName},
        {id: "k7CLuUXjt3HSeA3jMU2c7", name: "item_revenue", value: properties.itemRevenue},
        {id: "qAitKhHMy0", name: "item_variant", value: properties.itemVariant},
        {id: "qJKae_S4y_", name: "sales_channel", value: properties.salesChannel},
        {id: "-PddLxwT_", name: "platform", value: sysPlatform},
        {id: "Af3-RL1nz2", name: "language", value: sysLanguage},
        {id: "L-rHlXDQJd", name: "datalayer_source", value: sysDatalayerSource},
        {id: "Po4mUsQEyB", name: "preview", value: sysPreview},
        {id: "ux8kucXh9-", name: "ns_environment", value: sysNsEnvironment},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'begin_checkout': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("begin_checkout", {
          "schema": "iglu:nl.ns/begin_checkout/jsonschema/1-0-6",
          "currency": properties.currency,
          "coupon": properties.coupon,
          "value": properties.value,
          "items": properties.items.map(function(value) {
            return {
              "item_id": value.itemId,
              "item_name": value.itemName,
              "coupon": value.coupon,
              "discount": value.discount,
              "index": value.index,
              "quantity": value.quantity,
              "price": value.price,
              "item_brand": value.itemBrand,
              "item_variant": value.itemVariant,
              "item_category": value.itemCategory,
              "travel_date": value.travelDate,
              "affiliation": value.affiliation,
              "item_category2": value.itemCategory2,
              "destination_station": value.destinationStation,
              "origin_station": value.originStation,
              "travel_class": value.travelClass,
              "travel_route": value.travelRoute,
              "intercity_direct": value.intercityDirect,
              "deur_tot_deur": value.deurTotDeur,
              "item_revenue": value.itemRevenue,
            };
            }),
          "ns_shop": properties.nsShop,
          "sales_channel": properties.salesChannel,
          "platform": sysPlatform,
          "language": sysLanguage,
          "ns_environment": sysNsEnvironment,
          "datalayer_source": sysDatalayerSource,
          "preview": sysPreview,
          }, "YSfuMbF3uzA", "24e45f5c32b4f8684d6b1b7f0dbd88f1bf32c4b559981627e1e30c30e4dae403");
      }
      // destination NsDataQueue
      NsDataQueue.logEvent("begin_checkout", {
      "schema": "iglu:nl.ns/begin_checkout/jsonschema/1-0-6",
      "currency": properties.currency,
      "coupon": properties.coupon,
      "value": properties.value,
      "items": properties.items.map(function(value) {
        return {
          "item_id": value.itemId,
          "item_name": value.itemName,
          "coupon": value.coupon,
          "discount": value.discount,
          "index": value.index,
          "quantity": value.quantity,
          "price": value.price,
          "item_brand": value.itemBrand,
          "item_variant": value.itemVariant,
          "item_category": value.itemCategory,
          "travel_date": value.travelDate,
          "affiliation": value.affiliation,
          "item_category2": value.itemCategory2,
          "destination_station": value.destinationStation,
          "origin_station": value.originStation,
          "travel_class": value.travelClass,
          "travel_route": value.travelRoute,
          "intercity_direct": value.intercityDirect,
          "deur_tot_deur": value.deurTotDeur,
          "item_revenue": value.itemRevenue,
        };
        }),
      "ns_shop": properties.nsShop,
      "sales_channel": properties.salesChannel,
      "platform": sysPlatform,
      "language": sysLanguage,
      "ns_environment": sysNsEnvironment,
      "datalayer_source": sysDatalayerSource,
      "preview": sysPreview,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * purchase: triggered when a purchase is verified (payed etc.) pref. server side, not dependend on a 'succes page' view.
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.currency - The currency of the purchase
   * @param {string} properties.transactionId - Transaction or Order ID of the order
   * @param {string} [properties.coupon] - ONLY WEB | coupon-code or campaign id
   * @param {float} [properties.tax] - € value of tax
   * @param {float} properties.value - value of purhcased/added/removed item(s)
   * @param {Array<object>} properties.items - item array of objects:
[{
          item_id: 'FLEX|7,
          item_name: 'Traject Vrij',
          coupon: 'Zomercampagne',
          discount: 5.00,
          index: 0,
          item_brand: 'NS.nl',
          item_category: 'Abonnementen',
          origin_station: 'Ede-Wageningen',
          destination_station: 'Woerden'
          item_variant: 'NS-Flex',  
          price: 291.90,
          quantity: 1
          item_revenue: 291.90
          intercity_direct: true,
          deur_tot_deur: {}
        }]
   * @param {string} properties.nsShop - Which shop/cluster: lvb_app, lvb_kaartjes, ns-flex, etc
   * @param {string} [properties.paymentType] - payment type like iDeal, Creditcard etc
   * @param {string} [properties.ticketClass] - class: first or second
   * @param {string} [properties.salesChannel] - Wat is het verkoopkanaal van de aankoop? Spoordeelwinkel / Losse kaatjes / Externe verkoper
   * @param {Array<object>} [properties.existingProduct] - current product you up or downgrade (one):
[{
          item_id: 'FLEX|7,
          item_name: 'Traject Vrij',
          item_brand: 'NS.nl',
          item_category: 'Abonnementen',
          item_category2: 'Abonnementen',
          item_variant: 'NS-Flex',
          price: 291.90,
          quantity: 1
        }]
   * 
   * @see {@link https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/AVPCdJ0ONj2}
   */
  function purchase(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertCurrency(properties.currency));
      messages = messages.concat(assertTransactionId(properties.transactionId));
      messages = messages.concat(assertOptionalCoupon(properties.coupon));
      messages = messages.concat(assertOptionalTax(properties.tax));
      messages = messages.concat(assertValue(properties.value));
      messages = messages.concat(assertItems(properties.items));
      messages = messages.concat(assertNsShop(properties.nsShop));
      messages = messages.concat(assertOptionalPaymentType(properties.paymentType));
      messages = messages.concat(assertOptionalTicketClass(properties.ticketClass));
      messages = messages.concat(assertOptionalSalesChannel(properties.salesChannel));
      messages = messages.concat(assertOptionalExistingProduct(properties.existingProduct));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertLanguage(sysLanguage));
      messages = messages.concat(assertNsEnvironment(sysNsEnvironment));
      messages = messages.concat(assertDatalayerSource(sysDatalayerSource));
      messages = messages.concat(assertOptionalPreview(sysPreview));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("purchase", Object.keys(properties), [
        "currency",
        "transactionId",
        "coupon",
        "tax",
        "value",
        "items",
        "nsShop",
        "paymentType",
        "ticketClass",
        "salesChannel",
        "existingProduct"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "AVPCdJ0ONj2", "29c92b041313b04ef83753d8f27815c7fca7066f5629aeffce51b531ffbd09fd", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("purchase", {
        "schema": "iglu:nl.ns/purchase/jsonschema/2-0-13",
        "currency": properties.currency,
        "transaction_id": properties.transactionId,
        "coupon": properties.coupon,
        "tax": properties.tax,
        "value": properties.value,
        "items": properties.items.map(function(value) {
          return {
            "item_id": value.itemId,
            "item_name": value.itemName,
            "coupon": value.coupon,
            "discount": value.discount,
            "index": value.index,
            "quantity": value.quantity,
            "price": value.price,
            "item_brand": value.itemBrand,
            "item_variant": value.itemVariant,
            "item_category": value.itemCategory,
            "travel_date": value.travelDate,
            "affiliation": value.affiliation,
            "item_category2": value.itemCategory2,
            "destination_station": value.destinationStation,
            "origin_station": value.originStation,
            "travel_class": value.travelClass,
            "travel_route": value.travelRoute,
            "intercity_direct": value.intercityDirect,
            "deur_tot_deur": value.deurTotDeur,
            "item_revenue": value.itemRevenue,
          };
          }),
        "ns_shop": properties.nsShop,
        "payment_type": properties.paymentType,
        "ticket_class": properties.ticketClass,
        "sales_channel": properties.salesChannel,
        "existing_product": properties.existingProduct !== undefined && properties.existingProduct !== null ? 
          properties.existingProduct.map(function(value) {
          return {
            "item_id": value.itemId,
            "item_name": value.itemName,
            "quantity": value.quantity,
            "item_category": value.itemCategory,
            "item_category2": value.itemCategory2,
            "price": value.price,
            "item_brand": value.itemBrand,
            "item_variant": value.itemVariant,
          };
          }) : properties.existingProduct,
        "platform": sysPlatform,
        "language": sysLanguage,
        "ns_environment": sysNsEnvironment,
        "datalayer_source": sysDatalayerSource,
        "preview": sysPreview,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("AVPCdJ0ONj2", "purchase", messages, [
        {id: "4-eTlbcITN", name: "schema", value: "iglu:nl.ns/purchase/jsonschema/2-0-13"},
        {id: "06ak1UmwgYlK", name: "payment_type", value: properties.paymentType},
        {id: "17s21jQ4G", name: "intercity_direct", value: properties.intercityDirect},
        {id: "1WkP-6sA8x_5", name: "value", value: properties.value},
        {id: "6-GUnFHLFL", name: "item_brand", value: properties.itemBrand},
        {id: "7h-TV9MOq2", name: "item_category", value: properties.itemCategory},
        {id: "9Tv-BxH6jSI", name: "coupon", value: properties.coupon},
        {id: "BImlhIesBPhx", name: "ns_shop", value: properties.nsShop},
        {id: "D-6RH3lvH", name: "affiliation", value: properties.affiliation},
        {id: "GsMr_TucEDqV", name: "existing_product", value: properties.existingProduct},
        {id: "GuYrcDncVS5", name: "currency", value: properties.currency},
        {id: "IBS3IO629xIC", name: "tax", value: properties.tax},
        {id: "JzW147FWP", name: "deur_tot_deur", value: properties.deurTotDeur},
        {id: "OPP6AeYDy", name: "ticket_class", value: properties.ticketClass},
        {id: "Oavl4KfPHF3", name: "items", value: properties.items},
        {id: "PKlIwCNeHb", name: "index", value: properties.index},
        {id: "PpX-d_0VW", name: "travel_route", value: properties.travelRoute},
        {id: "SCki6fM2wea", name: "transaction_id", value: properties.transactionId},
        {id: "TIV1Wo8BM", name: "item_category2", value: properties.itemCategory2},
        {id: "UpRgfCPRK", name: "destination_station", value: properties.destinationStation},
        {id: "WGDHyEYby", name: "travel_date", value: properties.travelDate},
        {id: "ZVGAZOlEBhGj", name: "item_id", value: properties.itemId},
        {id: "ZZlWcbau6V", name: "quantity", value: properties.quantity},
        {id: "_T-mygJA7w", name: "price", value: properties.price},
        {id: "_WmY6XGTY", name: "travel_class", value: properties.travelClass},
        {id: "bMK3liq6t", name: "origin_station", value: properties.originStation},
        {id: "ePZR23byGW", name: "discount", value: properties.discount},
        {id: "hg4puJyLhb", name: "item_name", value: properties.itemName},
        {id: "k7CLuUXjt3HSeA3jMU2c7", name: "item_revenue", value: properties.itemRevenue},
        {id: "qAitKhHMy0", name: "item_variant", value: properties.itemVariant},
        {id: "qJKae_S4y_", name: "sales_channel", value: properties.salesChannel},
        {id: "-PddLxwT_", name: "platform", value: sysPlatform},
        {id: "Af3-RL1nz2", name: "language", value: sysLanguage},
        {id: "L-rHlXDQJd", name: "datalayer_source", value: sysDatalayerSource},
        {id: "Po4mUsQEyB", name: "preview", value: sysPreview},
        {id: "ux8kucXh9-", name: "ns_environment", value: sysNsEnvironment},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'purchase': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("purchase", {
          "schema": "iglu:nl.ns/purchase/jsonschema/2-0-13",
          "currency": properties.currency,
          "transaction_id": properties.transactionId,
          "coupon": properties.coupon,
          "tax": properties.tax,
          "value": properties.value,
          "items": properties.items.map(function(value) {
            return {
              "item_id": value.itemId,
              "item_name": value.itemName,
              "coupon": value.coupon,
              "discount": value.discount,
              "index": value.index,
              "quantity": value.quantity,
              "price": value.price,
              "item_brand": value.itemBrand,
              "item_variant": value.itemVariant,
              "item_category": value.itemCategory,
              "travel_date": value.travelDate,
              "affiliation": value.affiliation,
              "item_category2": value.itemCategory2,
              "destination_station": value.destinationStation,
              "origin_station": value.originStation,
              "travel_class": value.travelClass,
              "travel_route": value.travelRoute,
              "intercity_direct": value.intercityDirect,
              "deur_tot_deur": value.deurTotDeur,
              "item_revenue": value.itemRevenue,
            };
            }),
          "ns_shop": properties.nsShop,
          "payment_type": properties.paymentType,
          "ticket_class": properties.ticketClass,
          "sales_channel": properties.salesChannel,
          "existing_product": properties.existingProduct !== undefined && properties.existingProduct !== null ? 
            properties.existingProduct.map(function(value) {
            return {
              "item_id": value.itemId,
              "item_name": value.itemName,
              "quantity": value.quantity,
              "item_category": value.itemCategory,
              "item_category2": value.itemCategory2,
              "price": value.price,
              "item_brand": value.itemBrand,
              "item_variant": value.itemVariant,
            };
            }) : properties.existingProduct,
          "platform": sysPlatform,
          "language": sysLanguage,
          "ns_environment": sysNsEnvironment,
          "datalayer_source": sysDatalayerSource,
          "preview": sysPreview,
          }, "AVPCdJ0ONj2", "29c92b041313b04ef83753d8f27815c7fca7066f5629aeffce51b531ffbd09fd");
      }
      // destination NsDataQueue
      NsDataQueue.logEvent("purchase", {
      "schema": "iglu:nl.ns/purchase/jsonschema/2-0-13",
      "currency": properties.currency,
      "transaction_id": properties.transactionId,
      "coupon": properties.coupon,
      "tax": properties.tax,
      "value": properties.value,
      "items": properties.items.map(function(value) {
        return {
          "item_id": value.itemId,
          "item_name": value.itemName,
          "coupon": value.coupon,
          "discount": value.discount,
          "index": value.index,
          "quantity": value.quantity,
          "price": value.price,
          "item_brand": value.itemBrand,
          "item_variant": value.itemVariant,
          "item_category": value.itemCategory,
          "travel_date": value.travelDate,
          "affiliation": value.affiliation,
          "item_category2": value.itemCategory2,
          "destination_station": value.destinationStation,
          "origin_station": value.originStation,
          "travel_class": value.travelClass,
          "travel_route": value.travelRoute,
          "intercity_direct": value.intercityDirect,
          "deur_tot_deur": value.deurTotDeur,
          "item_revenue": value.itemRevenue,
        };
        }),
      "ns_shop": properties.nsShop,
      "payment_type": properties.paymentType,
      "ticket_class": properties.ticketClass,
      "sales_channel": properties.salesChannel,
      "existing_product": properties.existingProduct !== undefined && properties.existingProduct !== null ? 
        properties.existingProduct.map(function(value) {
        return {
          "item_id": value.itemId,
          "item_name": value.itemName,
          "quantity": value.quantity,
          "item_category": value.itemCategory,
          "item_category2": value.itemCategory2,
          "price": value.price,
          "item_brand": value.itemBrand,
          "item_variant": value.itemVariant,
        };
        }) : properties.existingProduct,
      "platform": sysPlatform,
      "language": sysLanguage,
      "ns_environment": sysNsEnvironment,
      "datalayer_source": sysDatalayerSource,
      "preview": sysPreview,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * click: click on links buttons etc
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.clickClasses - no description
   * @param {string} properties.clickType - e.g. 'button', 'checkbox', 'text_link'
   * @param {string} properties.clickDestination - Provide URL or screen_name if the button navigates
   * @param {string} properties.clickText - visible text which is clicked on / or label or element clicked (in case of nes-select for example)
   * @param {string} [properties.data] - Extra information in string format
   * @param {string} [properties.websiteSection] - Part of the website (header/footer/homepage/cookiebar/reisplanner etc.)
   * @param {string} [properties.clickId1] - The HTML id attribute for an outbound link or file download
   * 
   * @see {@link https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/1s4XEWLbFQ9}
   */
  function click(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertClickClasses(properties.clickClasses));
      messages = messages.concat(assertClickType(properties.clickType));
      messages = messages.concat(assertClickDestination(properties.clickDestination));
      messages = messages.concat(assertClickText(properties.clickText));
      messages = messages.concat(assertOptionalData(properties.data));
      messages = messages.concat(assertOptionalWebsiteSection(properties.websiteSection));
      messages = messages.concat(assertOptionalClickId1(properties.clickId1));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertLanguage(sysLanguage));
      messages = messages.concat(assertNsEnvironment(sysNsEnvironment));
      messages = messages.concat(assertDatalayerSource(sysDatalayerSource));
      messages = messages.concat(assertOptionalPreview(sysPreview));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("click", Object.keys(properties), [
        "clickClasses",
        "clickType",
        "clickDestination",
        "clickText",
        "data",
        "websiteSection",
        "clickId1"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "1s4XEWLbFQ9", "b92bdb886bb95cb21fada6d6f5f8bafd95d5da8aa9f6a785bdca0687c9b7eece", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("click", {
        "schema": "iglu:nl.ns/click/jsonschema/1-0-2",
        "click_classes": properties.clickClasses,
        "click_type": properties.clickType,
        "click_destination": properties.clickDestination,
        "click_text": properties.clickText,
        "data": properties.data,
        "website_section": properties.websiteSection,
        "click_id": properties.clickId1,
        "platform": sysPlatform,
        "language": sysLanguage,
        "ns_environment": sysNsEnvironment,
        "datalayer_source": sysDatalayerSource,
        "preview": sysPreview,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("1s4XEWLbFQ9", "click", messages, [
        {id: "4-eTlbcITN", name: "schema", value: "iglu:nl.ns/click/jsonschema/1-0-2"},
        {id: "7HGUvDZb-Fax", name: "data", value: properties.data},
        {id: "BxxFgWL7KfAD", name: "click_type", value: properties.clickType},
        {id: "HolZTTkkioUB", name: "click_id", value: properties.clickId1},
        {id: "K5J4L8efdGgl", name: "click_classes", value: properties.clickClasses},
        {id: "TFD27fnuBpN-", name: "click_text", value: properties.clickText},
        {id: "ZRYtNJDfVeyb", name: "click_destination", value: properties.clickDestination},
        {id: "wskyjid5yxT0", name: "website_section", value: properties.websiteSection},
        {id: "-PddLxwT_", name: "platform", value: sysPlatform},
        {id: "Af3-RL1nz2", name: "language", value: sysLanguage},
        {id: "L-rHlXDQJd", name: "datalayer_source", value: sysDatalayerSource},
        {id: "Po4mUsQEyB", name: "preview", value: sysPreview},
        {id: "ux8kucXh9-", name: "ns_environment", value: sysNsEnvironment},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'click': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("click", {
          "schema": "iglu:nl.ns/click/jsonschema/1-0-2",
          "click_classes": properties.clickClasses,
          "click_type": properties.clickType,
          "click_destination": properties.clickDestination,
          "click_text": properties.clickText,
          "data": properties.data,
          "website_section": properties.websiteSection,
          "click_id": properties.clickId1,
          "platform": sysPlatform,
          "language": sysLanguage,
          "ns_environment": sysNsEnvironment,
          "datalayer_source": sysDatalayerSource,
          "preview": sysPreview,
          }, "1s4XEWLbFQ9", "b92bdb886bb95cb21fada6d6f5f8bafd95d5da8aa9f6a785bdca0687c9b7eece");
      }
      // destination NsDataQueue
      NsDataQueue.logEvent("click", {
      "schema": "iglu:nl.ns/click/jsonschema/1-0-2",
      "click_classes": properties.clickClasses,
      "click_type": properties.clickType,
      "click_destination": properties.clickDestination,
      "click_text": properties.clickText,
      "data": properties.data,
      "website_section": properties.websiteSection,
      "click_id": properties.clickId1,
      "platform": sysPlatform,
      "language": sysLanguage,
      "ns_environment": sysNsEnvironment,
      "datalayer_source": sysDatalayerSource,
      "preview": sysPreview,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * feedback_give: triggers on submition of feedback
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.feedbackPlatform - Platform that is used to gather feedback
   * @param {string} [properties.feedbackRating] - Rating that was given
   * @param {string} [properties.feedbackType] - Type of feedback. i.e. 'responsive-dialog' or 'feedback-button'
   * @param {string} [properties.feedbackName] - Name of the survey or feedback button
   * @param {string} properties.teamName - Name of the team (feedback/qualtrics)
   * 
   * @see {@link https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/QFK9qm6fM6V}
   */
  function feedbackGive(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertFeedbackPlatform(properties.feedbackPlatform));
      messages = messages.concat(assertOptionalFeedbackRating(properties.feedbackRating));
      messages = messages.concat(assertOptionalFeedbackType(properties.feedbackType));
      messages = messages.concat(assertOptionalFeedbackName(properties.feedbackName));
      messages = messages.concat(assertTeamName(properties.teamName));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertLanguage(sysLanguage));
      messages = messages.concat(assertNsEnvironment(sysNsEnvironment));
      messages = messages.concat(assertDatalayerSource(sysDatalayerSource));
      messages = messages.concat(assertOptionalPreview(sysPreview));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("feedback_give", Object.keys(properties), [
        "feedbackPlatform",
        "feedbackRating",
        "feedbackType",
        "feedbackName",
        "teamName"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "QFK9qm6fM6V", "520f61ffbb1d47d02f368dc344d57e658c8674e3bc5a28ada5f959c0df868973", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("feedback_give", {
        "schema": "iglu:nl.ns/feedback_give/jsonschema/1-0-2",
        "feedback_platform": properties.feedbackPlatform,
        "feedback_rating": properties.feedbackRating,
        "feedback_type": properties.feedbackType,
        "feedback_name": properties.feedbackName,
        "team_name": properties.teamName,
        "platform": sysPlatform,
        "language": sysLanguage,
        "ns_environment": sysNsEnvironment,
        "datalayer_source": sysDatalayerSource,
        "preview": sysPreview,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("QFK9qm6fM6V", "feedback_give", messages, [
        {id: "4-eTlbcITN", name: "schema", value: "iglu:nl.ns/feedback_give/jsonschema/1-0-2"},
        {id: "5EE-BUb_w", name: "feedback_type", value: properties.feedbackType},
        {id: "BRMFCaolHInZ", name: "feedback_platform", value: properties.feedbackPlatform},
        {id: "Xhkk5MHMs", name: "feedback_name", value: properties.feedbackName},
        {id: "XoZ_JHMfu", name: "team_name", value: properties.teamName},
        {id: "sctfOrm9GDA0", name: "feedback_rating", value: properties.feedbackRating},
        {id: "-PddLxwT_", name: "platform", value: sysPlatform},
        {id: "Af3-RL1nz2", name: "language", value: sysLanguage},
        {id: "L-rHlXDQJd", name: "datalayer_source", value: sysDatalayerSource},
        {id: "Po4mUsQEyB", name: "preview", value: sysPreview},
        {id: "ux8kucXh9-", name: "ns_environment", value: sysNsEnvironment},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'feedback_give': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("feedback_give", {
          "schema": "iglu:nl.ns/feedback_give/jsonschema/1-0-2",
          "feedback_platform": properties.feedbackPlatform,
          "feedback_rating": properties.feedbackRating,
          "feedback_type": properties.feedbackType,
          "feedback_name": properties.feedbackName,
          "team_name": properties.teamName,
          "platform": sysPlatform,
          "language": sysLanguage,
          "ns_environment": sysNsEnvironment,
          "datalayer_source": sysDatalayerSource,
          "preview": sysPreview,
          }, "QFK9qm6fM6V", "520f61ffbb1d47d02f368dc344d57e658c8674e3bc5a28ada5f959c0df868973");
      }
      // destination NsDataQueue
      NsDataQueue.logEvent("feedback_give", {
      "schema": "iglu:nl.ns/feedback_give/jsonschema/1-0-2",
      "feedback_platform": properties.feedbackPlatform,
      "feedback_rating": properties.feedbackRating,
      "feedback_type": properties.feedbackType,
      "feedback_name": properties.feedbackName,
      "team_name": properties.teamName,
      "platform": sysPlatform,
      "language": sysLanguage,
      "ns_environment": sysNsEnvironment,
      "datalayer_source": sysDatalayerSource,
      "preview": sysPreview,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * content_share: triggers on last onsite/in app action of sharing
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.method - The method in which the content is shared.
   * @param {string} properties.contentType - The type of shared content.
   * @param {string} [properties.itemId] - APP & WEB | ID of the product  / unique SKU for product
   * 
   * @see {@link https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/D_FIMLMedlm}
   */
  function contentShare(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertMethod(properties.method));
      messages = messages.concat(assertContentType(properties.contentType));
      messages = messages.concat(assertOptionalItemId(properties.itemId));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertLanguage(sysLanguage));
      messages = messages.concat(assertNsEnvironment(sysNsEnvironment));
      messages = messages.concat(assertDatalayerSource(sysDatalayerSource));
      messages = messages.concat(assertOptionalPreview(sysPreview));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("content_share", Object.keys(properties), [
        "method",
        "contentType",
        "itemId"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "D_FIMLMedlm", "67f8fca10e1e2f4cf5fd4ec24a146f9dafcd2f58ae962ef2cf7068592959c4f0", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("content_share", {
        "schema": "iglu:nl.ns/content_share/jsonschema/1-0-0",
        "method": properties.method,
        "content_type": properties.contentType,
        "item_id": properties.itemId,
        "platform": sysPlatform,
        "language": sysLanguage,
        "ns_environment": sysNsEnvironment,
        "datalayer_source": sysDatalayerSource,
        "preview": sysPreview,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("D_FIMLMedlm", "content_share", messages, [
        {id: "4-eTlbcITN", name: "schema", value: "iglu:nl.ns/content_share/jsonschema/1-0-0"},
        {id: "ZVGAZOlEBhGj", name: "item_id", value: properties.itemId},
        {id: "jbSdZ_YNpuuA", name: "content_type", value: properties.contentType},
        {id: "zL_iONcMP8KH", name: "method", value: properties.method},
        {id: "-PddLxwT_", name: "platform", value: sysPlatform},
        {id: "Af3-RL1nz2", name: "language", value: sysLanguage},
        {id: "L-rHlXDQJd", name: "datalayer_source", value: sysDatalayerSource},
        {id: "Po4mUsQEyB", name: "preview", value: sysPreview},
        {id: "ux8kucXh9-", name: "ns_environment", value: sysNsEnvironment},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'content_share': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("content_share", {
          "schema": "iglu:nl.ns/content_share/jsonschema/1-0-0",
          "method": properties.method,
          "content_type": properties.contentType,
          "item_id": properties.itemId,
          "platform": sysPlatform,
          "language": sysLanguage,
          "ns_environment": sysNsEnvironment,
          "datalayer_source": sysDatalayerSource,
          "preview": sysPreview,
          }, "D_FIMLMedlm", "67f8fca10e1e2f4cf5fd4ec24a146f9dafcd2f58ae962ef2cf7068592959c4f0");
      }
      // destination NsDataQueue
      NsDataQueue.logEvent("content_share", {
      "schema": "iglu:nl.ns/content_share/jsonschema/1-0-0",
      "method": properties.method,
      "content_type": properties.contentType,
      "item_id": properties.itemId,
      "platform": sysPlatform,
      "language": sysLanguage,
      "ns_environment": sysNsEnvironment,
      "datalayer_source": sysDatalayerSource,
      "preview": sysPreview,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * form_start: triggers on first click in the form
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.formName - Name parameter from the <form> tag
   * @param {string} properties.formId1 - ID parameter of the form tag
   * 
   * @see {@link https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/mBzV6jmUM7H}
   */
  function formStart(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertFormName(properties.formName));
      messages = messages.concat(assertFormId1(properties.formId1));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertLanguage(sysLanguage));
      messages = messages.concat(assertNsEnvironment(sysNsEnvironment));
      messages = messages.concat(assertDatalayerSource(sysDatalayerSource));
      messages = messages.concat(assertOptionalPreview(sysPreview));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("form_start", Object.keys(properties), [
        "formName",
        "formId1"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "mBzV6jmUM7H", "f508850bdf7803ac9b79f0dc074cc57d05c79363c4905873bcca7873d9da230e", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("form_start", {
        "schema": "iglu:nl.ns/form_start/jsonschema/1-0-1",
        "form_name": properties.formName,
        "form_id": properties.formId1,
        "platform": sysPlatform,
        "language": sysLanguage,
        "ns_environment": sysNsEnvironment,
        "datalayer_source": sysDatalayerSource,
        "preview": sysPreview,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("mBzV6jmUM7H", "form_start", messages, [
        {id: "4-eTlbcITN", name: "schema", value: "iglu:nl.ns/form_start/jsonschema/1-0-1"},
        {id: "gL1cdb__7Q9c", name: "form_name", value: properties.formName},
        {id: "s4UF8TMcgsg9", name: "form_id", value: properties.formId1},
        {id: "-PddLxwT_", name: "platform", value: sysPlatform},
        {id: "Af3-RL1nz2", name: "language", value: sysLanguage},
        {id: "L-rHlXDQJd", name: "datalayer_source", value: sysDatalayerSource},
        {id: "Po4mUsQEyB", name: "preview", value: sysPreview},
        {id: "ux8kucXh9-", name: "ns_environment", value: sysNsEnvironment},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'form_start': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("form_start", {
          "schema": "iglu:nl.ns/form_start/jsonschema/1-0-1",
          "form_name": properties.formName,
          "form_id": properties.formId1,
          "platform": sysPlatform,
          "language": sysLanguage,
          "ns_environment": sysNsEnvironment,
          "datalayer_source": sysDatalayerSource,
          "preview": sysPreview,
          }, "mBzV6jmUM7H", "f508850bdf7803ac9b79f0dc074cc57d05c79363c4905873bcca7873d9da230e");
      }
      // destination NsDataQueue
      NsDataQueue.logEvent("form_start", {
      "schema": "iglu:nl.ns/form_start/jsonschema/1-0-1",
      "form_name": properties.formName,
      "form_id": properties.formId1,
      "platform": sysPlatform,
      "language": sysLanguage,
      "ns_environment": sysNsEnvironment,
      "datalayer_source": sysDatalayerSource,
      "preview": sysPreview,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * form_submit: triggers after submitting the form (after field validation)
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.formId1 - ID parameter of the form tag
   * @param {string} properties.formDestination - Full URL of the redirect after the form submit
   * @param {Array<string>} [properties.permissions] - Array with modified permissions and status
[
  {
    'type':'Commercieel',
    'status':'true',
  },
  {
    'type':'Reisgegevens delen',
    'status':'false',
  },
]
   * @param {string} properties.clickText - visible text which is clicked on / or label or element clicked (in case of nes-select for example)
   * @param {string} properties.formName - Name parameter from the <form> tag
   * 
   * @see {@link https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/DBkD3D8Uq_u}
   */
  function formSubmit(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertFormId1(properties.formId1));
      messages = messages.concat(assertFormDestination(properties.formDestination));
      messages = messages.concat(assertOptionalPermissions(properties.permissions));
      messages = messages.concat(assertClickText(properties.clickText));
      messages = messages.concat(assertFormName(properties.formName));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertLanguage(sysLanguage));
      messages = messages.concat(assertNsEnvironment(sysNsEnvironment));
      messages = messages.concat(assertDatalayerSource(sysDatalayerSource));
      messages = messages.concat(assertOptionalPreview(sysPreview));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("form_submit", Object.keys(properties), [
        "formId1",
        "formDestination",
        "permissions",
        "clickText",
        "formName"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "DBkD3D8Uq_u", "e8431ac2f8b12a69e52a61ff446d81d603b99448c94260f11336d196bb65dc1b", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("form_submit", {
        "schema": "iglu:nl.ns/form_submit/jsonschema/1-0-1",
        "form_id": properties.formId1,
        "form_destination": properties.formDestination,
        "permissions": properties.permissions,
        "click_text": properties.clickText,
        "form_name": properties.formName,
        "platform": sysPlatform,
        "language": sysLanguage,
        "ns_environment": sysNsEnvironment,
        "datalayer_source": sysDatalayerSource,
        "preview": sysPreview,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("DBkD3D8Uq_u", "form_submit", messages, [
        {id: "4-eTlbcITN", name: "schema", value: "iglu:nl.ns/form_submit/jsonschema/1-0-1"},
        {id: "83KZlBXgHnFi", name: "form_destination", value: properties.formDestination},
        {id: "TFD27fnuBpN-", name: "click_text", value: properties.clickText},
        {id: "b6ebejYlEx2Y", name: "permissions", value: properties.permissions},
        {id: "gL1cdb__7Q9c", name: "form_name", value: properties.formName},
        {id: "s4UF8TMcgsg9", name: "form_id", value: properties.formId1},
        {id: "-PddLxwT_", name: "platform", value: sysPlatform},
        {id: "Af3-RL1nz2", name: "language", value: sysLanguage},
        {id: "L-rHlXDQJd", name: "datalayer_source", value: sysDatalayerSource},
        {id: "Po4mUsQEyB", name: "preview", value: sysPreview},
        {id: "ux8kucXh9-", name: "ns_environment", value: sysNsEnvironment},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'form_submit': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("form_submit", {
          "schema": "iglu:nl.ns/form_submit/jsonschema/1-0-1",
          "form_id": properties.formId1,
          "form_destination": properties.formDestination,
          "permissions": properties.permissions,
          "click_text": properties.clickText,
          "form_name": properties.formName,
          "platform": sysPlatform,
          "language": sysLanguage,
          "ns_environment": sysNsEnvironment,
          "datalayer_source": sysDatalayerSource,
          "preview": sysPreview,
          }, "DBkD3D8Uq_u", "e8431ac2f8b12a69e52a61ff446d81d603b99448c94260f11336d196bb65dc1b");
      }
      // destination NsDataQueue
      NsDataQueue.logEvent("form_submit", {
      "schema": "iglu:nl.ns/form_submit/jsonschema/1-0-1",
      "form_id": properties.formId1,
      "form_destination": properties.formDestination,
      "permissions": properties.permissions,
      "click_text": properties.clickText,
      "form_name": properties.formName,
      "platform": sysPlatform,
      "language": sysLanguage,
      "ns_environment": sysNsEnvironment,
      "datalayer_source": sysDatalayerSource,
      "preview": sysPreview,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * form_error: triggers after field validation
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.formName - Name parameter from the <form> tag
   * @param {string} properties.formId1 - ID parameter of the form tag
   * @param {Array<string>} properties.errorMessage - What error message(s) does the user see? List of translation keys or strings.
   * 
   * @see {@link https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/xduE82bRW-m}
   */
  function formError(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertFormName(properties.formName));
      messages = messages.concat(assertFormId1(properties.formId1));
      messages = messages.concat(assertErrorMessage(properties.errorMessage));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertLanguage(sysLanguage));
      messages = messages.concat(assertNsEnvironment(sysNsEnvironment));
      messages = messages.concat(assertDatalayerSource(sysDatalayerSource));
      messages = messages.concat(assertOptionalPreview(sysPreview));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("form_error", Object.keys(properties), [
        "formName",
        "formId1",
        "errorMessage"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "xduE82bRW-m", "9def032f656cb79e6a33b0654ab79c8381f17df40881dfcf35fabbe2ca9a5f5b", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("form_error", {
        "schema": "iglu:nl.ns/form_error/jsonschema/1-0-1",
        "form_name": properties.formName,
        "form_id": properties.formId1,
        "error_message": properties.errorMessage,
        "platform": sysPlatform,
        "language": sysLanguage,
        "ns_environment": sysNsEnvironment,
        "datalayer_source": sysDatalayerSource,
        "preview": sysPreview,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("xduE82bRW-m", "form_error", messages, [
        {id: "4-eTlbcITN", name: "schema", value: "iglu:nl.ns/form_error/jsonschema/1-0-1"},
        {id: "_UC5Zg5bYPN", name: "error_message", value: properties.errorMessage},
        {id: "gL1cdb__7Q9c", name: "form_name", value: properties.formName},
        {id: "s4UF8TMcgsg9", name: "form_id", value: properties.formId1},
        {id: "-PddLxwT_", name: "platform", value: sysPlatform},
        {id: "Af3-RL1nz2", name: "language", value: sysLanguage},
        {id: "L-rHlXDQJd", name: "datalayer_source", value: sysDatalayerSource},
        {id: "Po4mUsQEyB", name: "preview", value: sysPreview},
        {id: "ux8kucXh9-", name: "ns_environment", value: sysNsEnvironment},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'form_error': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("form_error", {
          "schema": "iglu:nl.ns/form_error/jsonschema/1-0-1",
          "form_name": properties.formName,
          "form_id": properties.formId1,
          "error_message": properties.errorMessage,
          "platform": sysPlatform,
          "language": sysLanguage,
          "ns_environment": sysNsEnvironment,
          "datalayer_source": sysDatalayerSource,
          "preview": sysPreview,
          }, "xduE82bRW-m", "9def032f656cb79e6a33b0654ab79c8381f17df40881dfcf35fabbe2ca9a5f5b");
      }
      // destination NsDataQueue
      NsDataQueue.logEvent("form_error", {
      "schema": "iglu:nl.ns/form_error/jsonschema/1-0-1",
      "form_name": properties.formName,
      "form_id": properties.formId1,
      "error_message": properties.errorMessage,
      "platform": sysPlatform,
      "language": sysLanguage,
      "ns_environment": sysNsEnvironment,
      "datalayer_source": sysDatalayerSource,
      "preview": sysPreview,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * view_item: Triggers when the product detail page is viewed
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {float} properties.value - value of purhcased/added/removed item(s)
   * @param {Array<object>} properties.items - item array of objects:
[{
          item_id: 'FLEX|7,
          item_name: 'Traject Vrij',
          coupon: 'Zomercampagne',
          discount: 5.00,
          index: 0,
          item_brand: 'NS.nl',
          item_category: 'Abonnementen',
          origin_station: 'Ede-Wageningen',
          destination_station: 'Woerden'
          item_variant: 'NS-Flex',  
          price: 291.90,
          quantity: 1
          item_revenue: 291.90
          intercity_direct: true,
          deur_tot_deur: {}
        }]
   * @param {string} properties.nsShop - Which shop/cluster: lvb_app, lvb_kaartjes, ns-flex, etc
   * @param {string} [properties.salesChannel] - Wat is het verkoopkanaal van de aankoop? Spoordeelwinkel / Losse kaatjes / Externe verkoper
   * 
   * @see {@link https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/jwnzAKOyDYr}
   */
  function viewItem(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertValue(properties.value));
      messages = messages.concat(assertItems(properties.items));
      messages = messages.concat(assertNsShop(properties.nsShop));
      messages = messages.concat(assertOptionalSalesChannel(properties.salesChannel));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertLanguage(sysLanguage));
      messages = messages.concat(assertNsEnvironment(sysNsEnvironment));
      messages = messages.concat(assertDatalayerSource(sysDatalayerSource));
      messages = messages.concat(assertOptionalPreview(sysPreview));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("view_item", Object.keys(properties), [
        "value",
        "items",
        "nsShop",
        "salesChannel"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "jwnzAKOyDYr", "67ab86980f1a666b149028a0930a6ecd9d0f572794a754d721a48bdf76fe4703", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("view_item", {
        "currency": "EUR",
        "schema": "iglu:nl.ns/view_item/jsonschema/1-0-5",
        "value": properties.value,
        "items": properties.items.map(function(value) {
          return {
            "item_id": value.itemId,
            "item_name": value.itemName,
            "coupon": value.coupon,
            "discount": value.discount,
            "index": value.index,
            "quantity": value.quantity,
            "price": value.price,
            "item_brand": value.itemBrand,
            "item_variant": value.itemVariant,
            "item_category": value.itemCategory,
            "travel_date": value.travelDate,
            "affiliation": value.affiliation,
            "item_category2": value.itemCategory2,
            "destination_station": value.destinationStation,
            "origin_station": value.originStation,
            "travel_class": value.travelClass,
            "travel_route": value.travelRoute,
            "intercity_direct": value.intercityDirect,
            "deur_tot_deur": value.deurTotDeur,
            "item_revenue": value.itemRevenue,
          };
          }),
        "ns_shop": properties.nsShop,
        "sales_channel": properties.salesChannel,
        "platform": sysPlatform,
        "language": sysLanguage,
        "ns_environment": sysNsEnvironment,
        "datalayer_source": sysDatalayerSource,
        "preview": sysPreview,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("jwnzAKOyDYr", "view_item", messages, [
        {id: "GuYrcDncVS5", name: "currency", value: "EUR"},
        {id: "4-eTlbcITN", name: "schema", value: "iglu:nl.ns/view_item/jsonschema/1-0-5"},
        {id: "17s21jQ4G", name: "intercity_direct", value: properties.intercityDirect},
        {id: "1WkP-6sA8x_5", name: "value", value: properties.value},
        {id: "6-GUnFHLFL", name: "item_brand", value: properties.itemBrand},
        {id: "7h-TV9MOq2", name: "item_category", value: properties.itemCategory},
        {id: "9Tv-BxH6jSI", name: "coupon", value: properties.coupon},
        {id: "BImlhIesBPhx", name: "ns_shop", value: properties.nsShop},
        {id: "D-6RH3lvH", name: "affiliation", value: properties.affiliation},
        {id: "JzW147FWP", name: "deur_tot_deur", value: properties.deurTotDeur},
        {id: "Oavl4KfPHF3", name: "items", value: properties.items},
        {id: "PKlIwCNeHb", name: "index", value: properties.index},
        {id: "PpX-d_0VW", name: "travel_route", value: properties.travelRoute},
        {id: "TIV1Wo8BM", name: "item_category2", value: properties.itemCategory2},
        {id: "UpRgfCPRK", name: "destination_station", value: properties.destinationStation},
        {id: "WGDHyEYby", name: "travel_date", value: properties.travelDate},
        {id: "ZVGAZOlEBhGj", name: "item_id", value: properties.itemId},
        {id: "ZZlWcbau6V", name: "quantity", value: properties.quantity},
        {id: "_T-mygJA7w", name: "price", value: properties.price},
        {id: "_WmY6XGTY", name: "travel_class", value: properties.travelClass},
        {id: "bMK3liq6t", name: "origin_station", value: properties.originStation},
        {id: "ePZR23byGW", name: "discount", value: properties.discount},
        {id: "hg4puJyLhb", name: "item_name", value: properties.itemName},
        {id: "k7CLuUXjt3HSeA3jMU2c7", name: "item_revenue", value: properties.itemRevenue},
        {id: "qAitKhHMy0", name: "item_variant", value: properties.itemVariant},
        {id: "qJKae_S4y_", name: "sales_channel", value: properties.salesChannel},
        {id: "-PddLxwT_", name: "platform", value: sysPlatform},
        {id: "Af3-RL1nz2", name: "language", value: sysLanguage},
        {id: "L-rHlXDQJd", name: "datalayer_source", value: sysDatalayerSource},
        {id: "Po4mUsQEyB", name: "preview", value: sysPreview},
        {id: "ux8kucXh9-", name: "ns_environment", value: sysNsEnvironment},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'view_item': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("view_item", {
          "currency": "EUR",
          "schema": "iglu:nl.ns/view_item/jsonschema/1-0-5",
          "value": properties.value,
          "items": properties.items.map(function(value) {
            return {
              "item_id": value.itemId,
              "item_name": value.itemName,
              "coupon": value.coupon,
              "discount": value.discount,
              "index": value.index,
              "quantity": value.quantity,
              "price": value.price,
              "item_brand": value.itemBrand,
              "item_variant": value.itemVariant,
              "item_category": value.itemCategory,
              "travel_date": value.travelDate,
              "affiliation": value.affiliation,
              "item_category2": value.itemCategory2,
              "destination_station": value.destinationStation,
              "origin_station": value.originStation,
              "travel_class": value.travelClass,
              "travel_route": value.travelRoute,
              "intercity_direct": value.intercityDirect,
              "deur_tot_deur": value.deurTotDeur,
              "item_revenue": value.itemRevenue,
            };
            }),
          "ns_shop": properties.nsShop,
          "sales_channel": properties.salesChannel,
          "platform": sysPlatform,
          "language": sysLanguage,
          "ns_environment": sysNsEnvironment,
          "datalayer_source": sysDatalayerSource,
          "preview": sysPreview,
          }, "jwnzAKOyDYr", "67ab86980f1a666b149028a0930a6ecd9d0f572794a754d721a48bdf76fe4703");
      }
      // destination NsDataQueue
      NsDataQueue.logEvent("view_item", {
      "currency": "EUR",
      "schema": "iglu:nl.ns/view_item/jsonschema/1-0-5",
      "value": properties.value,
      "items": properties.items.map(function(value) {
        return {
          "item_id": value.itemId,
          "item_name": value.itemName,
          "coupon": value.coupon,
          "discount": value.discount,
          "index": value.index,
          "quantity": value.quantity,
          "price": value.price,
          "item_brand": value.itemBrand,
          "item_variant": value.itemVariant,
          "item_category": value.itemCategory,
          "travel_date": value.travelDate,
          "affiliation": value.affiliation,
          "item_category2": value.itemCategory2,
          "destination_station": value.destinationStation,
          "origin_station": value.originStation,
          "travel_class": value.travelClass,
          "travel_route": value.travelRoute,
          "intercity_direct": value.intercityDirect,
          "deur_tot_deur": value.deurTotDeur,
          "item_revenue": value.itemRevenue,
        };
        }),
      "ns_shop": properties.nsShop,
      "sales_channel": properties.salesChannel,
      "platform": sysPlatform,
      "language": sysLanguage,
      "ns_environment": sysNsEnvironment,
      "datalayer_source": sysDatalayerSource,
      "preview": sysPreview,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * keuzehulp_click: Triggers when a user clicks on a given choice in the keuzehulp
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.question - question
   * @param {string} properties.answer - answer
   * @param {string} properties.websiteVersion - Consument of zakelijk
   * 
   * @see {@link https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/zxrhsEtLq6G}
   */
  function keuzehulpClick(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertQuestion(properties.question));
      messages = messages.concat(assertAnswer(properties.answer));
      messages = messages.concat(assertWebsiteVersion(properties.websiteVersion));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertLanguage(sysLanguage));
      messages = messages.concat(assertNsEnvironment(sysNsEnvironment));
      messages = messages.concat(assertDatalayerSource(sysDatalayerSource));
      messages = messages.concat(assertOptionalPreview(sysPreview));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("keuzehulp_click", Object.keys(properties), [
        "question",
        "answer",
        "websiteVersion"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "zxrhsEtLq6G", "d6eb8e999d403252605dffa27bfcefc62cfddbeda8646d42d9a3c2af05ca52b6", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("keuzehulp_click", {
        "schema": "iglu:nl.ns/keuzehulp_click/jsonschema/1-0-0",
        "question": properties.question,
        "answer": properties.answer,
        "website_version": properties.websiteVersion,
        "platform": sysPlatform,
        "language": sysLanguage,
        "ns_environment": sysNsEnvironment,
        "datalayer_source": sysDatalayerSource,
        "preview": sysPreview,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("zxrhsEtLq6G", "keuzehulp_click", messages, [
        {id: "4-eTlbcITN", name: "schema", value: "iglu:nl.ns/keuzehulp_click/jsonschema/1-0-0"},
        {id: "7f5ty_nULaWo", name: "question", value: properties.question},
        {id: "F4RDcFwudL0_", name: "answer", value: properties.answer},
        {id: "l4YWQepFGqt9", name: "website_version", value: properties.websiteVersion},
        {id: "-PddLxwT_", name: "platform", value: sysPlatform},
        {id: "Af3-RL1nz2", name: "language", value: sysLanguage},
        {id: "L-rHlXDQJd", name: "datalayer_source", value: sysDatalayerSource},
        {id: "Po4mUsQEyB", name: "preview", value: sysPreview},
        {id: "ux8kucXh9-", name: "ns_environment", value: sysNsEnvironment},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'keuzehulp_click': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("keuzehulp_click", {
          "schema": "iglu:nl.ns/keuzehulp_click/jsonschema/1-0-0",
          "question": properties.question,
          "answer": properties.answer,
          "website_version": properties.websiteVersion,
          "platform": sysPlatform,
          "language": sysLanguage,
          "ns_environment": sysNsEnvironment,
          "datalayer_source": sysDatalayerSource,
          "preview": sysPreview,
          }, "zxrhsEtLq6G", "d6eb8e999d403252605dffa27bfcefc62cfddbeda8646d42d9a3c2af05ca52b6");
      }
      // destination NsDataQueue
      NsDataQueue.logEvent("keuzehulp_click", {
      "schema": "iglu:nl.ns/keuzehulp_click/jsonschema/1-0-0",
      "question": properties.question,
      "answer": properties.answer,
      "website_version": properties.websiteVersion,
      "platform": sysPlatform,
      "language": sysLanguage,
      "ns_environment": sysNsEnvironment,
      "datalayer_source": sysDatalayerSource,
      "preview": sysPreview,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * keuzehulp_success: Triggers on show page advice keuzehulp
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {Array<object>} properties.items - item array of objects:
[{
          item_id: 'FLEX|7,
          item_name: 'Traject Vrij',
          coupon: 'Zomercampagne',
          discount: 5.00,
          index: 0,
          item_brand: 'NS.nl',
          item_category: 'Abonnementen',
          origin_station: 'Ede-Wageningen',
          destination_station: 'Woerden'
          item_variant: 'NS-Flex',  
          price: 291.90,
          quantity: 1
          item_revenue: 291.90
          intercity_direct: true,
          deur_tot_deur: {}
        }]
   * @param {string} properties.websiteVersion - Consument of zakelijk
   * 
   * @see {@link https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/oxnl9fXxacs}
   */
  function keuzehulpSuccess(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertItems(properties.items));
      messages = messages.concat(assertWebsiteVersion(properties.websiteVersion));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertLanguage(sysLanguage));
      messages = messages.concat(assertNsEnvironment(sysNsEnvironment));
      messages = messages.concat(assertDatalayerSource(sysDatalayerSource));
      messages = messages.concat(assertOptionalPreview(sysPreview));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("keuzehulp_success", Object.keys(properties), [
        "items",
        "websiteVersion"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "oxnl9fXxacs", "1aa2e30e514650c447534ec0cbbeac4475417c414df48aa1fd55fea3859acb89", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("keuzehulp_success", {
        "schema": "iglu:nl.ns/keuzehulp_success/jsonschema/1-0-1",
        "items": properties.items.map(function(value) {
          return {
            "item_id": value.itemId,
            "item_name": value.itemName,
            "coupon": value.coupon,
            "discount": value.discount,
            "index": value.index,
            "quantity": value.quantity,
            "price": value.price,
            "item_brand": value.itemBrand,
            "item_variant": value.itemVariant,
            "item_category": value.itemCategory,
            "travel_date": value.travelDate,
            "affiliation": value.affiliation,
            "item_category2": value.itemCategory2,
            "destination_station": value.destinationStation,
            "origin_station": value.originStation,
            "travel_class": value.travelClass,
            "travel_route": value.travelRoute,
            "intercity_direct": value.intercityDirect,
            "deur_tot_deur": value.deurTotDeur,
            "item_revenue": value.itemRevenue,
          };
          }),
        "website_version": properties.websiteVersion,
        "platform": sysPlatform,
        "language": sysLanguage,
        "ns_environment": sysNsEnvironment,
        "datalayer_source": sysDatalayerSource,
        "preview": sysPreview,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("oxnl9fXxacs", "keuzehulp_success", messages, [
        {id: "4-eTlbcITN", name: "schema", value: "iglu:nl.ns/keuzehulp_success/jsonschema/1-0-1"},
        {id: "17s21jQ4G", name: "intercity_direct", value: properties.intercityDirect},
        {id: "6-GUnFHLFL", name: "item_brand", value: properties.itemBrand},
        {id: "7h-TV9MOq2", name: "item_category", value: properties.itemCategory},
        {id: "9Tv-BxH6jSI", name: "coupon", value: properties.coupon},
        {id: "D-6RH3lvH", name: "affiliation", value: properties.affiliation},
        {id: "JzW147FWP", name: "deur_tot_deur", value: properties.deurTotDeur},
        {id: "Oavl4KfPHF3", name: "items", value: properties.items},
        {id: "PKlIwCNeHb", name: "index", value: properties.index},
        {id: "PpX-d_0VW", name: "travel_route", value: properties.travelRoute},
        {id: "TIV1Wo8BM", name: "item_category2", value: properties.itemCategory2},
        {id: "UpRgfCPRK", name: "destination_station", value: properties.destinationStation},
        {id: "WGDHyEYby", name: "travel_date", value: properties.travelDate},
        {id: "ZVGAZOlEBhGj", name: "item_id", value: properties.itemId},
        {id: "ZZlWcbau6V", name: "quantity", value: properties.quantity},
        {id: "_T-mygJA7w", name: "price", value: properties.price},
        {id: "_WmY6XGTY", name: "travel_class", value: properties.travelClass},
        {id: "bMK3liq6t", name: "origin_station", value: properties.originStation},
        {id: "ePZR23byGW", name: "discount", value: properties.discount},
        {id: "hg4puJyLhb", name: "item_name", value: properties.itemName},
        {id: "k7CLuUXjt3HSeA3jMU2c7", name: "item_revenue", value: properties.itemRevenue},
        {id: "l4YWQepFGqt9", name: "website_version", value: properties.websiteVersion},
        {id: "qAitKhHMy0", name: "item_variant", value: properties.itemVariant},
        {id: "-PddLxwT_", name: "platform", value: sysPlatform},
        {id: "Af3-RL1nz2", name: "language", value: sysLanguage},
        {id: "L-rHlXDQJd", name: "datalayer_source", value: sysDatalayerSource},
        {id: "Po4mUsQEyB", name: "preview", value: sysPreview},
        {id: "ux8kucXh9-", name: "ns_environment", value: sysNsEnvironment},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'keuzehulp_success': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("keuzehulp_success", {
          "schema": "iglu:nl.ns/keuzehulp_success/jsonschema/1-0-1",
          "items": properties.items.map(function(value) {
            return {
              "item_id": value.itemId,
              "item_name": value.itemName,
              "coupon": value.coupon,
              "discount": value.discount,
              "index": value.index,
              "quantity": value.quantity,
              "price": value.price,
              "item_brand": value.itemBrand,
              "item_variant": value.itemVariant,
              "item_category": value.itemCategory,
              "travel_date": value.travelDate,
              "affiliation": value.affiliation,
              "item_category2": value.itemCategory2,
              "destination_station": value.destinationStation,
              "origin_station": value.originStation,
              "travel_class": value.travelClass,
              "travel_route": value.travelRoute,
              "intercity_direct": value.intercityDirect,
              "deur_tot_deur": value.deurTotDeur,
              "item_revenue": value.itemRevenue,
            };
            }),
          "website_version": properties.websiteVersion,
          "platform": sysPlatform,
          "language": sysLanguage,
          "ns_environment": sysNsEnvironment,
          "datalayer_source": sysDatalayerSource,
          "preview": sysPreview,
          }, "oxnl9fXxacs", "1aa2e30e514650c447534ec0cbbeac4475417c414df48aa1fd55fea3859acb89");
      }
      // destination NsDataQueue
      NsDataQueue.logEvent("keuzehulp_success", {
      "schema": "iglu:nl.ns/keuzehulp_success/jsonschema/1-0-1",
      "items": properties.items.map(function(value) {
        return {
          "item_id": value.itemId,
          "item_name": value.itemName,
          "coupon": value.coupon,
          "discount": value.discount,
          "index": value.index,
          "quantity": value.quantity,
          "price": value.price,
          "item_brand": value.itemBrand,
          "item_variant": value.itemVariant,
          "item_category": value.itemCategory,
          "travel_date": value.travelDate,
          "affiliation": value.affiliation,
          "item_category2": value.itemCategory2,
          "destination_station": value.destinationStation,
          "origin_station": value.originStation,
          "travel_class": value.travelClass,
          "travel_route": value.travelRoute,
          "intercity_direct": value.intercityDirect,
          "deur_tot_deur": value.deurTotDeur,
          "item_revenue": value.itemRevenue,
        };
        }),
      "website_version": properties.websiteVersion,
      "platform": sysPlatform,
      "language": sysLanguage,
      "ns_environment": sysNsEnvironment,
      "datalayer_source": sysDatalayerSource,
      "preview": sysPreview,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * chat_start: Triggers on opening the chat widget
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.chatTool - Name of the Chat Module/Chat Agent i.e. 'Cognigy'; 'EnterpriseBot', 'Parley'
   * @param {string} properties.chatInitiator - How was the chat started? Opened by click, hover, time-based, 
   * @param {string} [properties.chatClickSource] - What was the source of the chat_initiator, liveChat, 
   * 
   * @see {@link https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/whazzFBzCgx}
   */
  function chatStart(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertChatTool(properties.chatTool));
      messages = messages.concat(assertChatInitiator(properties.chatInitiator));
      messages = messages.concat(assertOptionalChatClickSource(properties.chatClickSource));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertLanguage(sysLanguage));
      messages = messages.concat(assertNsEnvironment(sysNsEnvironment));
      messages = messages.concat(assertDatalayerSource(sysDatalayerSource));
      messages = messages.concat(assertOptionalPreview(sysPreview));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("chat_start", Object.keys(properties), [
        "chatTool",
        "chatInitiator",
        "chatClickSource"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "whazzFBzCgx", "8efa88250f37b3dfb34986354613ce402fcafe2fac8f9b632ed5abc1cf60b569", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("chat_start", {
        "schema": "iglu:nl.ns/chat_start/jsonschema/1-0-1",
        "chat_tool": properties.chatTool,
        "chat_initiator": properties.chatInitiator,
        "chat_click_source": properties.chatClickSource,
        "platform": sysPlatform,
        "language": sysLanguage,
        "ns_environment": sysNsEnvironment,
        "datalayer_source": sysDatalayerSource,
        "preview": sysPreview,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("whazzFBzCgx", "chat_start", messages, [
        {id: "4-eTlbcITN", name: "schema", value: "iglu:nl.ns/chat_start/jsonschema/1-0-1"},
        {id: "5pRtByAXn", name: "chat_initiator", value: properties.chatInitiator},
        {id: "B7jES2_im", name: "chat_tool", value: properties.chatTool},
        {id: "j8qPJcH-G", name: "chat_click_source", value: properties.chatClickSource},
        {id: "-PddLxwT_", name: "platform", value: sysPlatform},
        {id: "Af3-RL1nz2", name: "language", value: sysLanguage},
        {id: "L-rHlXDQJd", name: "datalayer_source", value: sysDatalayerSource},
        {id: "Po4mUsQEyB", name: "preview", value: sysPreview},
        {id: "ux8kucXh9-", name: "ns_environment", value: sysNsEnvironment},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'chat_start': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("chat_start", {
          "schema": "iglu:nl.ns/chat_start/jsonschema/1-0-1",
          "chat_tool": properties.chatTool,
          "chat_initiator": properties.chatInitiator,
          "chat_click_source": properties.chatClickSource,
          "platform": sysPlatform,
          "language": sysLanguage,
          "ns_environment": sysNsEnvironment,
          "datalayer_source": sysDatalayerSource,
          "preview": sysPreview,
          }, "whazzFBzCgx", "8efa88250f37b3dfb34986354613ce402fcafe2fac8f9b632ed5abc1cf60b569");
      }
      // destination NsDataQueue
      NsDataQueue.logEvent("chat_start", {
      "schema": "iglu:nl.ns/chat_start/jsonschema/1-0-1",
      "chat_tool": properties.chatTool,
      "chat_initiator": properties.chatInitiator,
      "chat_click_source": properties.chatClickSource,
      "platform": sysPlatform,
      "language": sysLanguage,
      "ns_environment": sysNsEnvironment,
      "datalayer_source": sysDatalayerSource,
      "preview": sysPreview,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * video_start: when the video starts playing
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.videoTitle - title of the video
   * @param {string} properties.videoUrl - link of the video
   * @param {bool} properties.visible - true if the video is in the viewport
   * @param {string} properties.videoProvider1 - youtube, vimeo, brightcove, etc
   * 
   * @see {@link https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/-UuwVQnJInf}
   */
  function videoStart(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertVideoTitle(properties.videoTitle));
      messages = messages.concat(assertVideoUrl(properties.videoUrl));
      messages = messages.concat(assertVisible(properties.visible));
      messages = messages.concat(assertVideoProvider1(properties.videoProvider1));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertLanguage(sysLanguage));
      messages = messages.concat(assertNsEnvironment(sysNsEnvironment));
      messages = messages.concat(assertDatalayerSource(sysDatalayerSource));
      messages = messages.concat(assertOptionalPreview(sysPreview));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("video_start", Object.keys(properties), [
        "videoTitle",
        "videoUrl",
        "visible",
        "videoProvider1"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "-UuwVQnJInf", "6bbe84250221fcbddcf31ea28bafe3b171312d10e2f2e0b92cd8999ef699123f", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("video_start", {
        "schema": "iglu:nl.ns/video_start/jsonschema/1-0-0",
        "video_title": properties.videoTitle,
        "video_url": properties.videoUrl,
        "visible": properties.visible,
        "video_provider": properties.videoProvider1,
        "platform": sysPlatform,
        "language": sysLanguage,
        "ns_environment": sysNsEnvironment,
        "datalayer_source": sysDatalayerSource,
        "preview": sysPreview,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("-UuwVQnJInf", "video_start", messages, [
        {id: "4-eTlbcITN", name: "schema", value: "iglu:nl.ns/video_start/jsonschema/1-0-0"},
        {id: "2b5JV7Hc-MhF", name: "visible", value: properties.visible},
        {id: "5W6xoSKVWDn2", name: "video_url", value: properties.videoUrl},
        {id: "E29-6P-mJPC9", name: "video_title", value: properties.videoTitle},
        {id: "Hx_El_YtO-Wk", name: "video_provider", value: properties.videoProvider1},
        {id: "-PddLxwT_", name: "platform", value: sysPlatform},
        {id: "Af3-RL1nz2", name: "language", value: sysLanguage},
        {id: "L-rHlXDQJd", name: "datalayer_source", value: sysDatalayerSource},
        {id: "Po4mUsQEyB", name: "preview", value: sysPreview},
        {id: "ux8kucXh9-", name: "ns_environment", value: sysNsEnvironment},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'video_start': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("video_start", {
          "schema": "iglu:nl.ns/video_start/jsonschema/1-0-0",
          "video_title": properties.videoTitle,
          "video_url": properties.videoUrl,
          "visible": properties.visible,
          "video_provider": properties.videoProvider1,
          "platform": sysPlatform,
          "language": sysLanguage,
          "ns_environment": sysNsEnvironment,
          "datalayer_source": sysDatalayerSource,
          "preview": sysPreview,
          }, "-UuwVQnJInf", "6bbe84250221fcbddcf31ea28bafe3b171312d10e2f2e0b92cd8999ef699123f");
      }
      // destination NsDataQueue
      NsDataQueue.logEvent("video_start", {
      "schema": "iglu:nl.ns/video_start/jsonschema/1-0-0",
      "video_title": properties.videoTitle,
      "video_url": properties.videoUrl,
      "visible": properties.visible,
      "video_provider": properties.videoProvider1,
      "platform": sysPlatform,
      "language": sysLanguage,
      "ns_environment": sysNsEnvironment,
      "datalayer_source": sysDatalayerSource,
      "preview": sysPreview,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * video_progress: when the video progresses past 10%, 25%, 50%, and 75% duration time
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.videoTitle - title of the video
   * @param {string} properties.videoUrl - link of the video
   * @param {float} properties.videoCurrentTime - video current time
   * @param {float} properties.videoDuration - Duration of the video
   * @param {int} properties.videoPercent - % watch of total video length
   * @param {bool} properties.visible - true if the video is in the viewport
   * @param {string} properties.videoProvider1 - youtube, vimeo, brightcove, etc
   * 
   * @see {@link https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/frCti8DVUp5}
   */
  function videoProgress(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertVideoTitle(properties.videoTitle));
      messages = messages.concat(assertVideoUrl(properties.videoUrl));
      messages = messages.concat(assertVideoCurrentTime(properties.videoCurrentTime));
      messages = messages.concat(assertVideoDuration(properties.videoDuration));
      messages = messages.concat(assertVideoPercent(properties.videoPercent));
      messages = messages.concat(assertVisible(properties.visible));
      messages = messages.concat(assertVideoProvider1(properties.videoProvider1));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertLanguage(sysLanguage));
      messages = messages.concat(assertNsEnvironment(sysNsEnvironment));
      messages = messages.concat(assertDatalayerSource(sysDatalayerSource));
      messages = messages.concat(assertOptionalPreview(sysPreview));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("video_progress", Object.keys(properties), [
        "videoTitle",
        "videoUrl",
        "videoCurrentTime",
        "videoDuration",
        "videoPercent",
        "visible",
        "videoProvider1"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "frCti8DVUp5", "3f337d072a5829bd7d833fddf802207b3ecd12bfc3362ae0f077a573dec088b3", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("video_progress", {
        "schema": "iglu:nl.ns/video_progress/jsonschema/1-0-0",
        "video_title": properties.videoTitle,
        "video_url": properties.videoUrl,
        "video_current_time": properties.videoCurrentTime,
        "video_duration": properties.videoDuration,
        "video_percent": properties.videoPercent,
        "visible": properties.visible,
        "video_provider": properties.videoProvider1,
        "platform": sysPlatform,
        "language": sysLanguage,
        "ns_environment": sysNsEnvironment,
        "datalayer_source": sysDatalayerSource,
        "preview": sysPreview,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("frCti8DVUp5", "video_progress", messages, [
        {id: "4-eTlbcITN", name: "schema", value: "iglu:nl.ns/video_progress/jsonschema/1-0-0"},
        {id: "2b5JV7Hc-MhF", name: "visible", value: properties.visible},
        {id: "5W6xoSKVWDn2", name: "video_url", value: properties.videoUrl},
        {id: "C3vfalxpU8Ib", name: "video_current_time", value: properties.videoCurrentTime},
        {id: "E29-6P-mJPC9", name: "video_title", value: properties.videoTitle},
        {id: "Hx_El_YtO-Wk", name: "video_provider", value: properties.videoProvider1},
        {id: "KtXvxPrGGhXA", name: "video_percent", value: properties.videoPercent},
        {id: "tFHwzcV_y9J4", name: "video_duration", value: properties.videoDuration},
        {id: "-PddLxwT_", name: "platform", value: sysPlatform},
        {id: "Af3-RL1nz2", name: "language", value: sysLanguage},
        {id: "L-rHlXDQJd", name: "datalayer_source", value: sysDatalayerSource},
        {id: "Po4mUsQEyB", name: "preview", value: sysPreview},
        {id: "ux8kucXh9-", name: "ns_environment", value: sysNsEnvironment},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'video_progress': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("video_progress", {
          "schema": "iglu:nl.ns/video_progress/jsonschema/1-0-0",
          "video_title": properties.videoTitle,
          "video_url": properties.videoUrl,
          "video_current_time": properties.videoCurrentTime,
          "video_duration": properties.videoDuration,
          "video_percent": properties.videoPercent,
          "visible": properties.visible,
          "video_provider": properties.videoProvider1,
          "platform": sysPlatform,
          "language": sysLanguage,
          "ns_environment": sysNsEnvironment,
          "datalayer_source": sysDatalayerSource,
          "preview": sysPreview,
          }, "frCti8DVUp5", "3f337d072a5829bd7d833fddf802207b3ecd12bfc3362ae0f077a573dec088b3");
      }
      // destination NsDataQueue
      NsDataQueue.logEvent("video_progress", {
      "schema": "iglu:nl.ns/video_progress/jsonschema/1-0-0",
      "video_title": properties.videoTitle,
      "video_url": properties.videoUrl,
      "video_current_time": properties.videoCurrentTime,
      "video_duration": properties.videoDuration,
      "video_percent": properties.videoPercent,
      "visible": properties.visible,
      "video_provider": properties.videoProvider1,
      "platform": sysPlatform,
      "language": sysLanguage,
      "ns_environment": sysNsEnvironment,
      "datalayer_source": sysDatalayerSource,
      "preview": sysPreview,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * video_complete: when the video ends (100% viewed)
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.videoTitle - title of the video
   * @param {string} properties.videoUrl - link of the video
   * @param {float} properties.videoCurrentTime - video current time
   * @param {string} properties.videoProvider1 - youtube, vimeo, brightcove, etc
   * @param {bool} properties.visible - true if the video is in the viewport
   * 
   * @see {@link https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/A9DN33XJgfq}
   */
  function videoComplete(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertVideoTitle(properties.videoTitle));
      messages = messages.concat(assertVideoUrl(properties.videoUrl));
      messages = messages.concat(assertVideoCurrentTime(properties.videoCurrentTime));
      messages = messages.concat(assertVideoProvider1(properties.videoProvider1));
      messages = messages.concat(assertVisible(properties.visible));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertLanguage(sysLanguage));
      messages = messages.concat(assertNsEnvironment(sysNsEnvironment));
      messages = messages.concat(assertDatalayerSource(sysDatalayerSource));
      messages = messages.concat(assertOptionalPreview(sysPreview));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("video_complete", Object.keys(properties), [
        "videoTitle",
        "videoUrl",
        "videoCurrentTime",
        "videoProvider1",
        "visible"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "A9DN33XJgfq", "61c5eba977b28c06ff9eccc7d57a96dddaf4ed263495cfd15fcc0bc47f141d80", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("video_complete", {
        "schema": "iglu:nl.ns/video_complete/jsonschema/1-0-0",
        "video_title": properties.videoTitle,
        "video_url": properties.videoUrl,
        "video_current_time": properties.videoCurrentTime,
        "video_provider": properties.videoProvider1,
        "visible": properties.visible,
        "platform": sysPlatform,
        "language": sysLanguage,
        "ns_environment": sysNsEnvironment,
        "datalayer_source": sysDatalayerSource,
        "preview": sysPreview,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("A9DN33XJgfq", "video_complete", messages, [
        {id: "4-eTlbcITN", name: "schema", value: "iglu:nl.ns/video_complete/jsonschema/1-0-0"},
        {id: "2b5JV7Hc-MhF", name: "visible", value: properties.visible},
        {id: "5W6xoSKVWDn2", name: "video_url", value: properties.videoUrl},
        {id: "C3vfalxpU8Ib", name: "video_current_time", value: properties.videoCurrentTime},
        {id: "E29-6P-mJPC9", name: "video_title", value: properties.videoTitle},
        {id: "Hx_El_YtO-Wk", name: "video_provider", value: properties.videoProvider1},
        {id: "-PddLxwT_", name: "platform", value: sysPlatform},
        {id: "Af3-RL1nz2", name: "language", value: sysLanguage},
        {id: "L-rHlXDQJd", name: "datalayer_source", value: sysDatalayerSource},
        {id: "Po4mUsQEyB", name: "preview", value: sysPreview},
        {id: "ux8kucXh9-", name: "ns_environment", value: sysNsEnvironment},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'video_complete': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("video_complete", {
          "schema": "iglu:nl.ns/video_complete/jsonschema/1-0-0",
          "video_title": properties.videoTitle,
          "video_url": properties.videoUrl,
          "video_current_time": properties.videoCurrentTime,
          "video_provider": properties.videoProvider1,
          "visible": properties.visible,
          "platform": sysPlatform,
          "language": sysLanguage,
          "ns_environment": sysNsEnvironment,
          "datalayer_source": sysDatalayerSource,
          "preview": sysPreview,
          }, "A9DN33XJgfq", "61c5eba977b28c06ff9eccc7d57a96dddaf4ed263495cfd15fcc0bc47f141d80");
      }
      // destination NsDataQueue
      NsDataQueue.logEvent("video_complete", {
      "schema": "iglu:nl.ns/video_complete/jsonschema/1-0-0",
      "video_title": properties.videoTitle,
      "video_url": properties.videoUrl,
      "video_current_time": properties.videoCurrentTime,
      "video_provider": properties.videoProvider1,
      "visible": properties.visible,
      "platform": sysPlatform,
      "language": sysLanguage,
      "ns_environment": sysNsEnvironment,
      "datalayer_source": sysDatalayerSource,
      "preview": sysPreview,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * lead_generate: when succesfull leadform send by user
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.formId1 - ID parameter of the form tag
   * @param {string} properties.formName - Name parameter from the <form> tag
   * 
   * @see {@link https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/ubmAH73Pvjx}
   */
  function leadGenerate(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertFormId1(properties.formId1));
      messages = messages.concat(assertFormName(properties.formName));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertLanguage(sysLanguage));
      messages = messages.concat(assertNsEnvironment(sysNsEnvironment));
      messages = messages.concat(assertDatalayerSource(sysDatalayerSource));
      messages = messages.concat(assertOptionalPreview(sysPreview));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("lead_generate", Object.keys(properties), [
        "formId1",
        "formName"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "ubmAH73Pvjx", "334e15bddfb07ecda4263de2c87a98531767e404b396cad5a87f33ef190fb2d4", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("lead_generate", {
        "schema": "iglu:nl.ns/lead_generate/jsonschema/1-0-0",
        "form_id": properties.formId1,
        "form_name": properties.formName,
        "platform": sysPlatform,
        "language": sysLanguage,
        "ns_environment": sysNsEnvironment,
        "datalayer_source": sysDatalayerSource,
        "preview": sysPreview,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("ubmAH73Pvjx", "lead_generate", messages, [
        {id: "4-eTlbcITN", name: "schema", value: "iglu:nl.ns/lead_generate/jsonschema/1-0-0"},
        {id: "gL1cdb__7Q9c", name: "form_name", value: properties.formName},
        {id: "s4UF8TMcgsg9", name: "form_id", value: properties.formId1},
        {id: "-PddLxwT_", name: "platform", value: sysPlatform},
        {id: "Af3-RL1nz2", name: "language", value: sysLanguage},
        {id: "L-rHlXDQJd", name: "datalayer_source", value: sysDatalayerSource},
        {id: "Po4mUsQEyB", name: "preview", value: sysPreview},
        {id: "ux8kucXh9-", name: "ns_environment", value: sysNsEnvironment},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'lead_generate': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("lead_generate", {
          "schema": "iglu:nl.ns/lead_generate/jsonschema/1-0-0",
          "form_id": properties.formId1,
          "form_name": properties.formName,
          "platform": sysPlatform,
          "language": sysLanguage,
          "ns_environment": sysNsEnvironment,
          "datalayer_source": sysDatalayerSource,
          "preview": sysPreview,
          }, "ubmAH73Pvjx", "334e15bddfb07ecda4263de2c87a98531767e404b396cad5a87f33ef190fb2d4");
      }
      // destination NsDataQueue
      NsDataQueue.logEvent("lead_generate", {
      "schema": "iglu:nl.ns/lead_generate/jsonschema/1-0-0",
      "form_id": properties.formId1,
      "form_name": properties.formName,
      "platform": sysPlatform,
      "language": sysLanguage,
      "ns_environment": sysNsEnvironment,
      "datalayer_source": sysDatalayerSource,
      "preview": sysPreview,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * file_download: when a user clicks a link leading to a file
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.fileExtension - The extension of a file download (for example, 'pdf' or 'txt').
   * @param {string} properties.fileName - The page path of a file download (for example, '/menus/dinner-menu.pdf').
   * @param {string} [properties.clickId1] - The HTML id attribute for an outbound link or file download
   * @param {string} properties.clickText - visible text which is clicked on / or label or element clicked (in case of nes-select for example)
   * @param {string} properties.clickClasses - no description
   * @param {string} properties.clickDestination - Provide URL or screen_name if the button navigates
   * 
   * @see {@link https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/96x5Eusp665}
   */
  function fileDownload(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertFileExtension(properties.fileExtension));
      messages = messages.concat(assertFileName(properties.fileName));
      messages = messages.concat(assertOptionalClickId1(properties.clickId1));
      messages = messages.concat(assertClickText(properties.clickText));
      messages = messages.concat(assertClickClasses(properties.clickClasses));
      messages = messages.concat(assertClickDestination(properties.clickDestination));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertLanguage(sysLanguage));
      messages = messages.concat(assertNsEnvironment(sysNsEnvironment));
      messages = messages.concat(assertDatalayerSource(sysDatalayerSource));
      messages = messages.concat(assertOptionalPreview(sysPreview));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("file_download", Object.keys(properties), [
        "fileExtension",
        "fileName",
        "clickId1",
        "clickText",
        "clickClasses",
        "clickDestination"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "96x5Eusp665", "613e264f2a7b65e41ffbbf0dd894b2a45cfb33ddca4c8fbfa7c69c73a364a105", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("file_download", {
        "schema": "iglu:nl.ns/file_download/jsonschema/1-0-1",
        "file_extension": properties.fileExtension,
        "file_name": properties.fileName,
        "click_id": properties.clickId1,
        "click_text": properties.clickText,
        "click_classes": properties.clickClasses,
        "click_destination": properties.clickDestination,
        "platform": sysPlatform,
        "language": sysLanguage,
        "ns_environment": sysNsEnvironment,
        "datalayer_source": sysDatalayerSource,
        "preview": sysPreview,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("96x5Eusp665", "file_download", messages, [
        {id: "4-eTlbcITN", name: "schema", value: "iglu:nl.ns/file_download/jsonschema/1-0-1"},
        {id: "HolZTTkkioUB", name: "click_id", value: properties.clickId1},
        {id: "K5J4L8efdGgl", name: "click_classes", value: properties.clickClasses},
        {id: "PqLRY8g1AK7Q", name: "file_name", value: properties.fileName},
        {id: "TFD27fnuBpN-", name: "click_text", value: properties.clickText},
        {id: "TizyQU9Eo2GE", name: "file_extension", value: properties.fileExtension},
        {id: "ZRYtNJDfVeyb", name: "click_destination", value: properties.clickDestination},
        {id: "-PddLxwT_", name: "platform", value: sysPlatform},
        {id: "Af3-RL1nz2", name: "language", value: sysLanguage},
        {id: "L-rHlXDQJd", name: "datalayer_source", value: sysDatalayerSource},
        {id: "Po4mUsQEyB", name: "preview", value: sysPreview},
        {id: "ux8kucXh9-", name: "ns_environment", value: sysNsEnvironment},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'file_download': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("file_download", {
          "schema": "iglu:nl.ns/file_download/jsonschema/1-0-1",
          "file_extension": properties.fileExtension,
          "file_name": properties.fileName,
          "click_id": properties.clickId1,
          "click_text": properties.clickText,
          "click_classes": properties.clickClasses,
          "click_destination": properties.clickDestination,
          "platform": sysPlatform,
          "language": sysLanguage,
          "ns_environment": sysNsEnvironment,
          "datalayer_source": sysDatalayerSource,
          "preview": sysPreview,
          }, "96x5Eusp665", "613e264f2a7b65e41ffbbf0dd894b2a45cfb33ddca4c8fbfa7c69c73a364a105");
      }
      // destination NsDataQueue
      NsDataQueue.logEvent("file_download", {
      "schema": "iglu:nl.ns/file_download/jsonschema/1-0-1",
      "file_extension": properties.fileExtension,
      "file_name": properties.fileName,
      "click_id": properties.clickId1,
      "click_text": properties.clickText,
      "click_classes": properties.clickClasses,
      "click_destination": properties.clickDestination,
      "platform": sysPlatform,
      "language": sysLanguage,
      "ns_environment": sysNsEnvironment,
      "datalayer_source": sysDatalayerSource,
      "preview": sysPreview,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * reisvergelijker_start: First click during a session on the reisvergelijker
   * 
   * @see {@link https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/d5RrIQuwY3f}
   */
  function reisvergelijkerStart(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertLanguage(sysLanguage));
      messages = messages.concat(assertNsEnvironment(sysNsEnvironment));
      messages = messages.concat(assertDatalayerSource(sysDatalayerSource));
      messages = messages.concat(assertOptionalPreview(sysPreview));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("reisvergelijker_start", Object.keys(properties), [
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "d5RrIQuwY3f", "ab8ce165367f4a44e485e73b3ea2bbb796c9f3ab81510863e328cb41f99eafa9", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("reisvergelijker_start", {
        "schema": "iglu:nl.ns/reisvergelijker_start/jsonschema/1-0-0",
        "platform": sysPlatform,
        "language": sysLanguage,
        "ns_environment": sysNsEnvironment,
        "datalayer_source": sysDatalayerSource,
        "preview": sysPreview,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("d5RrIQuwY3f", "reisvergelijker_start", messages, [
        {id: "4-eTlbcITN", name: "schema", value: "iglu:nl.ns/reisvergelijker_start/jsonschema/1-0-0"},
        {id: "-PddLxwT_", name: "platform", value: sysPlatform},
        {id: "Af3-RL1nz2", name: "language", value: sysLanguage},
        {id: "L-rHlXDQJd", name: "datalayer_source", value: sysDatalayerSource},
        {id: "Po4mUsQEyB", name: "preview", value: sysPreview},
        {id: "ux8kucXh9-", name: "ns_environment", value: sysNsEnvironment},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'reisvergelijker_start': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("reisvergelijker_start", {
          "schema": "iglu:nl.ns/reisvergelijker_start/jsonschema/1-0-0",
          "platform": sysPlatform,
          "language": sysLanguage,
          "ns_environment": sysNsEnvironment,
          "datalayer_source": sysDatalayerSource,
          "preview": sysPreview,
          }, "d5RrIQuwY3f", "ab8ce165367f4a44e485e73b3ea2bbb796c9f3ab81510863e328cb41f99eafa9");
      }
      // destination NsDataQueue
      NsDataQueue.logEvent("reisvergelijker_start", {
      "schema": "iglu:nl.ns/reisvergelijker_start/jsonschema/1-0-0",
      "platform": sysPlatform,
      "language": sysLanguage,
      "ns_environment": sysNsEnvironment,
      "datalayer_source": sysDatalayerSource,
      "preview": sysPreview,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * reisvergelijker_success: Advise shown to the customer
   * 
   * @see {@link https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/tVvvyMSeNgy}
   */
  function reisvergelijkerSuccess(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertLanguage(sysLanguage));
      messages = messages.concat(assertNsEnvironment(sysNsEnvironment));
      messages = messages.concat(assertDatalayerSource(sysDatalayerSource));
      messages = messages.concat(assertOptionalPreview(sysPreview));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("reisvergelijker_success", Object.keys(properties), [
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "tVvvyMSeNgy", "17513e2fb3be5e30b410222d5ac7fbbd01ad731f68ed466bdb0351bb2a2b0f31", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("reisvergelijker_success", {
        "schema": "iglu:nl.ns/reisvergelijker_success/jsonschema/1-0-0",
        "platform": sysPlatform,
        "language": sysLanguage,
        "ns_environment": sysNsEnvironment,
        "datalayer_source": sysDatalayerSource,
        "preview": sysPreview,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("tVvvyMSeNgy", "reisvergelijker_success", messages, [
        {id: "4-eTlbcITN", name: "schema", value: "iglu:nl.ns/reisvergelijker_success/jsonschema/1-0-0"},
        {id: "-PddLxwT_", name: "platform", value: sysPlatform},
        {id: "Af3-RL1nz2", name: "language", value: sysLanguage},
        {id: "L-rHlXDQJd", name: "datalayer_source", value: sysDatalayerSource},
        {id: "Po4mUsQEyB", name: "preview", value: sysPreview},
        {id: "ux8kucXh9-", name: "ns_environment", value: sysNsEnvironment},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'reisvergelijker_success': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("reisvergelijker_success", {
          "schema": "iglu:nl.ns/reisvergelijker_success/jsonschema/1-0-0",
          "platform": sysPlatform,
          "language": sysLanguage,
          "ns_environment": sysNsEnvironment,
          "datalayer_source": sysDatalayerSource,
          "preview": sysPreview,
          }, "tVvvyMSeNgy", "17513e2fb3be5e30b410222d5ac7fbbd01ad731f68ed466bdb0351bb2a2b0f31");
      }
      // destination NsDataQueue
      NsDataQueue.logEvent("reisvergelijker_success", {
      "schema": "iglu:nl.ns/reisvergelijker_success/jsonschema/1-0-0",
      "platform": sysPlatform,
      "language": sysLanguage,
      "ns_environment": sysNsEnvironment,
      "datalayer_source": sysDatalayerSource,
      "preview": sysPreview,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * reisplanner_success: A new advice is calculated and displayed
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.originType - Type of the origin location like station or address
   * @param {string} [properties.originModalities] - which modalities are checked by user
   * @param {string} properties.destinationType - Type of the destination location like station or address
   * @param {string} properties.arrivalOrDepartureDate - arrival or departure date chosen?
   * @param {string} properties.planDate - What is the date of the journey
   * @param {string} properties.planTime - What is the time of the journey
   * @param {int} properties.minutesToPlanTime - Amount of minutes before the planned journey.
   * @param {string} [properties.optionViaStation] - Make the travel planner plan a journey via an extra station that is selected.
   * @param {string} [properties.optionTransportOptions] - Included options (trein, bus, metro, tram, veerboot)
   * @param {bool} properties.optionNoReservation - option
   * @param {bool} properties.optionHasTravelassistance - The user that plans a journey has (or doesn't have) travel assistance enabled
   * @param {bool} properties.optionOnlyLocalTrains - The option to only show local trains (Sprinters)
   * @param {int} [properties.optionExtraTransferTime] - How much extra transfer time is selected
   * @param {float} properties.ticketPrice - price of the ticket
   * @param {string} [properties.origin] - from station of planned trip
   * @param {string} properties.destination - to station
   * 
   * @see {@link https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/6JB9Vvg02a1}
   */
  function reisplannerSuccess(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOriginType(properties.originType));
      messages = messages.concat(assertOptionalOriginModalities(properties.originModalities));
      messages = messages.concat(assertDestinationType(properties.destinationType));
      messages = messages.concat(assertArrivalOrDepartureDate(properties.arrivalOrDepartureDate));
      messages = messages.concat(assertPlanDate(properties.planDate));
      messages = messages.concat(assertPlanTime(properties.planTime));
      messages = messages.concat(assertMinutesToPlanTime(properties.minutesToPlanTime));
      messages = messages.concat(assertOptionalOptionViaStation(properties.optionViaStation));
      messages = messages.concat(assertOptionalOptionTransportOptions(properties.optionTransportOptions));
      messages = messages.concat(assertOptionNoReservation(properties.optionNoReservation));
      messages = messages.concat(assertOptionHasTravelassistance(properties.optionHasTravelassistance));
      messages = messages.concat(assertOptionOnlyLocalTrains(properties.optionOnlyLocalTrains));
      messages = messages.concat(assertOptionalOptionExtraTransferTime(properties.optionExtraTransferTime));
      messages = messages.concat(assertTicketPrice(properties.ticketPrice));
      messages = messages.concat(assertOptionalOrigin(properties.origin));
      messages = messages.concat(assertDestination(properties.destination));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertLanguage(sysLanguage));
      messages = messages.concat(assertNsEnvironment(sysNsEnvironment));
      messages = messages.concat(assertDatalayerSource(sysDatalayerSource));
      messages = messages.concat(assertOptionalPreview(sysPreview));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("reisplanner_success", Object.keys(properties), [
        "originType",
        "originModalities",
        "destinationType",
        "arrivalOrDepartureDate",
        "planDate",
        "planTime",
        "minutesToPlanTime",
        "optionViaStation",
        "optionTransportOptions",
        "optionNoReservation",
        "optionHasTravelassistance",
        "optionOnlyLocalTrains",
        "optionExtraTransferTime",
        "ticketPrice",
        "origin",
        "destination"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "6JB9Vvg02a1", "84abdf11a259a81483d0514e2253926b20f34797b723a6fb83501c987e893cb2", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("reisplanner_success", {
        "schema": "iglu:nl.ns/reisplanner_success/jsonschema/1-0-0",
        "origin_type": properties.originType,
        "origin_modalities": properties.originModalities,
        "destination_type": properties.destinationType,
        "arrival_or_departure_date": properties.arrivalOrDepartureDate,
        "plan_date": properties.planDate,
        "plan_time": properties.planTime,
        "minutes_to_plan_time": properties.minutesToPlanTime,
        "option_via_station": properties.optionViaStation,
        "option_transport_options": properties.optionTransportOptions,
        "option_no_reservation": properties.optionNoReservation,
        "option_has_travelassistance": properties.optionHasTravelassistance,
        "option_only_local_trains": properties.optionOnlyLocalTrains,
        "option_extra_transfer_time": properties.optionExtraTransferTime,
        "ticket_price": properties.ticketPrice,
        "origin": properties.origin,
        "destination": properties.destination,
        "platform": sysPlatform,
        "language": sysLanguage,
        "ns_environment": sysNsEnvironment,
        "datalayer_source": sysDatalayerSource,
        "preview": sysPreview,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("6JB9Vvg02a1", "reisplanner_success", messages, [
        {id: "4-eTlbcITN", name: "schema", value: "iglu:nl.ns/reisplanner_success/jsonschema/1-0-0"},
        {id: "8jofQf9ETeBe", name: "option_only_local_trains", value: properties.optionOnlyLocalTrains},
        {id: "CaMQ0XJCJbKL", name: "option_transport_options", value: properties.optionTransportOptions},
        {id: "EhTR7EnR_4-n", name: "option_extra_transfer_time", value: properties.optionExtraTransferTime},
        {id: "JhQcIHY4C9pI", name: "origin_type", value: properties.originType},
        {id: "K5UKR3Wbe9xC", name: "destination", value: properties.destination},
        {id: "MgmcZ65PSEiQ", name: "origin_modalities", value: properties.originModalities},
        {id: "QrQ2jdtpI42P", name: "plan_date", value: properties.planDate},
        {id: "WDi4lr0fPar_", name: "option_no_reservation", value: properties.optionNoReservation},
        {id: "aI7_g6oQRfSk", name: "minutes_to_plan_time", value: properties.minutesToPlanTime},
        {id: "fei9WfaoV0KU", name: "arrival_or_departure_date", value: properties.arrivalOrDepartureDate},
        {id: "hi8osDXdCJVA", name: "plan_time", value: properties.planTime},
        {id: "lztkT6sWa2HW", name: "ticket_price", value: properties.ticketPrice},
        {id: "nXtf5xu83rju", name: "option_via_station", value: properties.optionViaStation},
        {id: "oyE5fJGQ8YEf", name: "origin", value: properties.origin},
        {id: "pzgV0n5Ze47t", name: "destination_type", value: properties.destinationType},
        {id: "xp4K_4mDFr_k", name: "option_has_travelassistance", value: properties.optionHasTravelassistance},
        {id: "-PddLxwT_", name: "platform", value: sysPlatform},
        {id: "Af3-RL1nz2", name: "language", value: sysLanguage},
        {id: "L-rHlXDQJd", name: "datalayer_source", value: sysDatalayerSource},
        {id: "Po4mUsQEyB", name: "preview", value: sysPreview},
        {id: "ux8kucXh9-", name: "ns_environment", value: sysNsEnvironment},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'reisplanner_success': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("reisplanner_success", {
          "schema": "iglu:nl.ns/reisplanner_success/jsonschema/1-0-0",
          "origin_type": properties.originType,
          "origin_modalities": properties.originModalities,
          "destination_type": properties.destinationType,
          "arrival_or_departure_date": properties.arrivalOrDepartureDate,
          "plan_date": properties.planDate,
          "plan_time": properties.planTime,
          "minutes_to_plan_time": properties.minutesToPlanTime,
          "option_via_station": properties.optionViaStation,
          "option_transport_options": properties.optionTransportOptions,
          "option_no_reservation": properties.optionNoReservation,
          "option_has_travelassistance": properties.optionHasTravelassistance,
          "option_only_local_trains": properties.optionOnlyLocalTrains,
          "option_extra_transfer_time": properties.optionExtraTransferTime,
          "ticket_price": properties.ticketPrice,
          "origin": properties.origin,
          "destination": properties.destination,
          "platform": sysPlatform,
          "language": sysLanguage,
          "ns_environment": sysNsEnvironment,
          "datalayer_source": sysDatalayerSource,
          "preview": sysPreview,
          }, "6JB9Vvg02a1", "84abdf11a259a81483d0514e2253926b20f34797b723a6fb83501c987e893cb2");
      }
      // destination NsDataQueue
      NsDataQueue.logEvent("reisplanner_success", {
      "schema": "iglu:nl.ns/reisplanner_success/jsonschema/1-0-0",
      "origin_type": properties.originType,
      "origin_modalities": properties.originModalities,
      "destination_type": properties.destinationType,
      "arrival_or_departure_date": properties.arrivalOrDepartureDate,
      "plan_date": properties.planDate,
      "plan_time": properties.planTime,
      "minutes_to_plan_time": properties.minutesToPlanTime,
      "option_via_station": properties.optionViaStation,
      "option_transport_options": properties.optionTransportOptions,
      "option_no_reservation": properties.optionNoReservation,
      "option_has_travelassistance": properties.optionHasTravelassistance,
      "option_only_local_trains": properties.optionOnlyLocalTrains,
      "option_extra_transfer_time": properties.optionExtraTransferTime,
      "ticket_price": properties.ticketPrice,
      "origin": properties.origin,
      "destination": properties.destination,
      "platform": sysPlatform,
      "language": sysLanguage,
      "ns_environment": sysNsEnvironment,
      "datalayer_source": sysDatalayerSource,
      "preview": sysPreview,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * reisplanner_error: Pop-up shown when journey cannot be planned
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {Array<string>} properties.errorMessage - What error message(s) does the user see? List of translation keys or strings.
   * @param {string} properties.errorStatus - error status
   * @param {string} properties.errorCategory - error category
   * 
   * @see {@link https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/le4Df-rdG3z}
   */
  function reisplannerError(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertErrorMessage(properties.errorMessage));
      messages = messages.concat(assertErrorStatus(properties.errorStatus));
      messages = messages.concat(assertErrorCategory(properties.errorCategory));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertLanguage(sysLanguage));
      messages = messages.concat(assertNsEnvironment(sysNsEnvironment));
      messages = messages.concat(assertDatalayerSource(sysDatalayerSource));
      messages = messages.concat(assertOptionalPreview(sysPreview));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("reisplanner_error", Object.keys(properties), [
        "errorMessage",
        "errorStatus",
        "errorCategory"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "le4Df-rdG3z", "3e8b767b5801c09df66039e6bde844fd3bba8cf4b221e17532a583306c58e0f3", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("reisplanner_error", {
        "schema": "iglu:nl.ns/reisplanner_error/jsonschema/1-0-1",
        "error_message": properties.errorMessage,
        "error_status": properties.errorStatus,
        "error_category": properties.errorCategory,
        "platform": sysPlatform,
        "language": sysLanguage,
        "ns_environment": sysNsEnvironment,
        "datalayer_source": sysDatalayerSource,
        "preview": sysPreview,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("le4Df-rdG3z", "reisplanner_error", messages, [
        {id: "4-eTlbcITN", name: "schema", value: "iglu:nl.ns/reisplanner_error/jsonschema/1-0-1"},
        {id: "7Nf2EeEBl", name: "error_category", value: properties.errorCategory},
        {id: "_UC5Zg5bYPN", name: "error_message", value: properties.errorMessage},
        {id: "shuP1-uKm", name: "error_status", value: properties.errorStatus},
        {id: "-PddLxwT_", name: "platform", value: sysPlatform},
        {id: "Af3-RL1nz2", name: "language", value: sysLanguage},
        {id: "L-rHlXDQJd", name: "datalayer_source", value: sysDatalayerSource},
        {id: "Po4mUsQEyB", name: "preview", value: sysPreview},
        {id: "ux8kucXh9-", name: "ns_environment", value: sysNsEnvironment},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'reisplanner_error': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("reisplanner_error", {
          "schema": "iglu:nl.ns/reisplanner_error/jsonschema/1-0-1",
          "error_message": properties.errorMessage,
          "error_status": properties.errorStatus,
          "error_category": properties.errorCategory,
          "platform": sysPlatform,
          "language": sysLanguage,
          "ns_environment": sysNsEnvironment,
          "datalayer_source": sysDatalayerSource,
          "preview": sysPreview,
          }, "le4Df-rdG3z", "3e8b767b5801c09df66039e6bde844fd3bba8cf4b221e17532a583306c58e0f3");
      }
      // destination NsDataQueue
      NsDataQueue.logEvent("reisplanner_error", {
      "schema": "iglu:nl.ns/reisplanner_error/jsonschema/1-0-1",
      "error_message": properties.errorMessage,
      "error_status": properties.errorStatus,
      "error_category": properties.errorCategory,
      "platform": sysPlatform,
      "language": sysLanguage,
      "ns_environment": sysNsEnvironment,
      "datalayer_source": sysDatalayerSource,
      "preview": sysPreview,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * cookie_consent_submit: Status after closing the cookiebar
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.cookieConsentStatus] - Value of the cookieConsentStatus cookie
   * 
   * @see {@link https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/KPs9gjyZhq1}
   */
  function cookieConsentSubmit(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalCookieConsentStatus(properties.cookieConsentStatus));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertLanguage(sysLanguage));
      messages = messages.concat(assertNsEnvironment(sysNsEnvironment));
      messages = messages.concat(assertDatalayerSource(sysDatalayerSource));
      messages = messages.concat(assertOptionalPreview(sysPreview));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("cookie_consent_submit", Object.keys(properties), [
        "cookieConsentStatus"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "KPs9gjyZhq1", "92733f7101eb9c8878b085a3dec99cc14ae250c1249040a1c429317bb3b8910d", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("cookie_consent_submit", {
        "schema": "iglu:nl.ns/cookie_consent_submit/jsonschema/2-0-2",
        "cookie_consent_status": properties.cookieConsentStatus,
        "platform": sysPlatform,
        "language": sysLanguage,
        "ns_environment": sysNsEnvironment,
        "datalayer_source": sysDatalayerSource,
        "preview": sysPreview,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("KPs9gjyZhq1", "cookie_consent_submit", messages, [
        {id: "4-eTlbcITN", name: "schema", value: "iglu:nl.ns/cookie_consent_submit/jsonschema/2-0-2"},
        {id: "-DxiaheG2mil", name: "cookie_consent_status", value: properties.cookieConsentStatus},
        {id: "-PddLxwT_", name: "platform", value: sysPlatform},
        {id: "Af3-RL1nz2", name: "language", value: sysLanguage},
        {id: "L-rHlXDQJd", name: "datalayer_source", value: sysDatalayerSource},
        {id: "Po4mUsQEyB", name: "preview", value: sysPreview},
        {id: "ux8kucXh9-", name: "ns_environment", value: sysNsEnvironment},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'cookie_consent_submit': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("cookie_consent_submit", {
          "schema": "iglu:nl.ns/cookie_consent_submit/jsonschema/2-0-2",
          "cookie_consent_status": properties.cookieConsentStatus,
          "platform": sysPlatform,
          "language": sysLanguage,
          "ns_environment": sysNsEnvironment,
          "datalayer_source": sysDatalayerSource,
          "preview": sysPreview,
          }, "KPs9gjyZhq1", "92733f7101eb9c8878b085a3dec99cc14ae250c1249040a1c429317bb3b8910d");
      }
      // destination NsDataQueue
      NsDataQueue.logEvent("cookie_consent_submit", {
      "schema": "iglu:nl.ns/cookie_consent_submit/jsonschema/2-0-2",
      "cookie_consent_status": properties.cookieConsentStatus,
      "platform": sysPlatform,
      "language": sysLanguage,
      "ns_environment": sysNsEnvironment,
      "datalayer_source": sysDatalayerSource,
      "preview": sysPreview,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * push_consent: When toggle is changed for push consent
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {Array<string>} properties.pushConsentStatus - Array with modified permissions and status
[
  {
    'type':'En? Hoe is je reis?',
    'status':'true',
  }
]
   * 
   * @see {@link https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/wubhhpkiKqv}
   */
  function pushConsent(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPushConsentStatus(properties.pushConsentStatus));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertLanguage(sysLanguage));
      messages = messages.concat(assertNsEnvironment(sysNsEnvironment));
      messages = messages.concat(assertDatalayerSource(sysDatalayerSource));
      messages = messages.concat(assertOptionalPreview(sysPreview));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("push_consent", Object.keys(properties), [
        "pushConsentStatus"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "wubhhpkiKqv", "e043861c2e39cf0b7f82157f8bbc9ae78652c1ae223eaee2dcdf93850904a666", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("push_consent", {
        "schema": "iglu:nl.ns/push_consent/jsonschema/1-0-0",
        "push_consent_status": properties.pushConsentStatus,
        "platform": sysPlatform,
        "language": sysLanguage,
        "ns_environment": sysNsEnvironment,
        "datalayer_source": sysDatalayerSource,
        "preview": sysPreview,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("wubhhpkiKqv", "push_consent", messages, [
        {id: "4-eTlbcITN", name: "schema", value: "iglu:nl.ns/push_consent/jsonschema/1-0-0"},
        {id: "mE3yslcjncEm", name: "push_consent_status", value: properties.pushConsentStatus},
        {id: "-PddLxwT_", name: "platform", value: sysPlatform},
        {id: "Af3-RL1nz2", name: "language", value: sysLanguage},
        {id: "L-rHlXDQJd", name: "datalayer_source", value: sysDatalayerSource},
        {id: "Po4mUsQEyB", name: "preview", value: sysPreview},
        {id: "ux8kucXh9-", name: "ns_environment", value: sysNsEnvironment},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'push_consent': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("push_consent", {
          "schema": "iglu:nl.ns/push_consent/jsonschema/1-0-0",
          "push_consent_status": properties.pushConsentStatus,
          "platform": sysPlatform,
          "language": sysLanguage,
          "ns_environment": sysNsEnvironment,
          "datalayer_source": sysDatalayerSource,
          "preview": sysPreview,
          }, "wubhhpkiKqv", "e043861c2e39cf0b7f82157f8bbc9ae78652c1ae223eaee2dcdf93850904a666");
      }
      // destination NsDataQueue
      NsDataQueue.logEvent("push_consent", {
      "schema": "iglu:nl.ns/push_consent/jsonschema/1-0-0",
      "push_consent_status": properties.pushConsentStatus,
      "platform": sysPlatform,
      "language": sysLanguage,
      "ns_environment": sysNsEnvironment,
      "datalayer_source": sysDatalayerSource,
      "preview": sysPreview,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * reisregisseur_change_permission: Triggers when permission is toggled
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {Array<string>} properties.permissions - Array with modified permissions and status
[
  {
    'type':'Commercieel',
    'status':'true',
  },
  {
    'type':'Reisgegevens delen',
    'status':'false',
  },
]
   * 
   * @see {@link https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/TjGfck4PwVP}
   */
  function reisregisseurChangePermission(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPermissions(properties.permissions));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertLanguage(sysLanguage));
      messages = messages.concat(assertNsEnvironment(sysNsEnvironment));
      messages = messages.concat(assertDatalayerSource(sysDatalayerSource));
      messages = messages.concat(assertOptionalPreview(sysPreview));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("reisregisseur_change_permission", Object.keys(properties), [
        "permissions"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "TjGfck4PwVP", "9372b0b143627dfba583f175ed3addf80fc7270afc56889e3f9e7b9c17852e4b", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("reisregisseur_change_permission", {
        "schema": "iglu:nl.ns/reisregisseur_change_permission/jsonschema/1-0-0",
        "permissions": properties.permissions,
        "platform": sysPlatform,
        "language": sysLanguage,
        "ns_environment": sysNsEnvironment,
        "datalayer_source": sysDatalayerSource,
        "preview": sysPreview,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("TjGfck4PwVP", "reisregisseur_change_permission", messages, [
        {id: "4-eTlbcITN", name: "schema", value: "iglu:nl.ns/reisregisseur_change_permission/jsonschema/1-0-0"},
        {id: "b6ebejYlEx2Y", name: "permissions", value: properties.permissions},
        {id: "-PddLxwT_", name: "platform", value: sysPlatform},
        {id: "Af3-RL1nz2", name: "language", value: sysLanguage},
        {id: "L-rHlXDQJd", name: "datalayer_source", value: sysDatalayerSource},
        {id: "Po4mUsQEyB", name: "preview", value: sysPreview},
        {id: "ux8kucXh9-", name: "ns_environment", value: sysNsEnvironment},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'reisregisseur_change_permission': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("reisregisseur_change_permission", {
          "schema": "iglu:nl.ns/reisregisseur_change_permission/jsonschema/1-0-0",
          "permissions": properties.permissions,
          "platform": sysPlatform,
          "language": sysLanguage,
          "ns_environment": sysNsEnvironment,
          "datalayer_source": sysDatalayerSource,
          "preview": sysPreview,
          }, "TjGfck4PwVP", "9372b0b143627dfba583f175ed3addf80fc7270afc56889e3f9e7b9c17852e4b");
      }
      // destination NsDataQueue
      NsDataQueue.logEvent("reisregisseur_change_permission", {
      "schema": "iglu:nl.ns/reisregisseur_change_permission/jsonschema/1-0-0",
      "permissions": properties.permissions,
      "platform": sysPlatform,
      "language": sysLanguage,
      "ns_environment": sysNsEnvironment,
      "datalayer_source": sysDatalayerSource,
      "preview": sysPreview,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * nba_view: incl. UTMS from email
when users triggers an NBA
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.ucId - id of the NBA fe uc0150. Stated in the CDP.
   * @param {string} properties.ucVariant - variant of the uc. fe you always have a 'control', but also a variant 'versieA', 'versieB' etc. depending on the number of variants the marketeer made. A customer can only see one variant.
   * @param {string} [properties.ucName] - Name of the BC nba
   * @param {string} [properties.bcInteractionId] - Blueconic Interaction ID; 
The ID of the interaction. For example the ID of a dialogue variant.
   * 
   * @see {@link https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/QJN-6_MntPF}
   */
  function nbaView(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertUcId(properties.ucId));
      messages = messages.concat(assertUcVariant(properties.ucVariant));
      messages = messages.concat(assertOptionalUcName(properties.ucName));
      messages = messages.concat(assertOptionalBcInteractionId(properties.bcInteractionId));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertLanguage(sysLanguage));
      messages = messages.concat(assertNsEnvironment(sysNsEnvironment));
      messages = messages.concat(assertDatalayerSource(sysDatalayerSource));
      messages = messages.concat(assertOptionalPreview(sysPreview));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("nba_view", Object.keys(properties), [
        "ucId",
        "ucVariant",
        "ucName",
        "bcInteractionId"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "QJN-6_MntPF", "ae88acc3b1b00942725e2f2cea0d7f39ced0e7deb349dbc8bf885303f83e9e7a", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("nba_view", {
        "schema": "iglu:nl.ns/nba_view/jsonschema/1-0-5",
        "uc_id": properties.ucId,
        "uc_variant": properties.ucVariant,
        "uc_name": properties.ucName,
        "bc_interaction_id": properties.bcInteractionId,
        "platform": sysPlatform,
        "language": sysLanguage,
        "ns_environment": sysNsEnvironment,
        "datalayer_source": sysDatalayerSource,
        "preview": sysPreview,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("QJN-6_MntPF", "nba_view", messages, [
        {id: "4-eTlbcITN", name: "schema", value: "iglu:nl.ns/nba_view/jsonschema/1-0-5"},
        {id: "7OXAcO_7A", name: "uc_variant", value: properties.ucVariant},
        {id: "SnbzGw91vYEjK_-uAfxau", name: "uc_name", value: properties.ucName},
        {id: "gbSQirnPl", name: "uc_id", value: properties.ucId},
        {id: "wLBBYJ4_yksXyt0QEPGl3", name: "bc_interaction_id", value: properties.bcInteractionId},
        {id: "-PddLxwT_", name: "platform", value: sysPlatform},
        {id: "Af3-RL1nz2", name: "language", value: sysLanguage},
        {id: "L-rHlXDQJd", name: "datalayer_source", value: sysDatalayerSource},
        {id: "Po4mUsQEyB", name: "preview", value: sysPreview},
        {id: "ux8kucXh9-", name: "ns_environment", value: sysNsEnvironment},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'nba_view': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("nba_view", {
          "schema": "iglu:nl.ns/nba_view/jsonschema/1-0-5",
          "uc_id": properties.ucId,
          "uc_variant": properties.ucVariant,
          "uc_name": properties.ucName,
          "bc_interaction_id": properties.bcInteractionId,
          "platform": sysPlatform,
          "language": sysLanguage,
          "ns_environment": sysNsEnvironment,
          "datalayer_source": sysDatalayerSource,
          "preview": sysPreview,
          }, "QJN-6_MntPF", "ae88acc3b1b00942725e2f2cea0d7f39ced0e7deb349dbc8bf885303f83e9e7a");
      }
      // destination NsDataQueue
      NsDataQueue.logEvent("nba_view", {
      "schema": "iglu:nl.ns/nba_view/jsonschema/1-0-5",
      "uc_id": properties.ucId,
      "uc_variant": properties.ucVariant,
      "uc_name": properties.ucName,
      "bc_interaction_id": properties.bcInteractionId,
      "platform": sysPlatform,
      "language": sysLanguage,
      "ns_environment": sysNsEnvironment,
      "datalayer_source": sysDatalayerSource,
      "preview": sysPreview,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * nba_success: target for NBA is matched
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.ucId - id of the NBA fe uc0150. Stated in the CDP.
   * @param {string} properties.ucVariant - variant of the uc. fe you always have a 'control', but also a variant 'versieA', 'versieB' etc. depending on the number of variants the marketeer made. A customer can only see one variant.
   * @param {string} properties.ucLocation - location the uc is shown. fe. web: ns.nl/spoordeelwinkel of app: travelplanner
   * 
   * @see {@link https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/OcvSS16e-Le}
   */
  function nbaSuccess(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertUcId(properties.ucId));
      messages = messages.concat(assertUcVariant(properties.ucVariant));
      messages = messages.concat(assertUcLocation(properties.ucLocation));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertLanguage(sysLanguage));
      messages = messages.concat(assertNsEnvironment(sysNsEnvironment));
      messages = messages.concat(assertDatalayerSource(sysDatalayerSource));
      messages = messages.concat(assertOptionalPreview(sysPreview));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("nba_success", Object.keys(properties), [
        "ucId",
        "ucVariant",
        "ucLocation"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "OcvSS16e-Le", "fcb5bc3e417d4f0be9a626fd51c625b12ba2adcf5912fb6e32b6d07e2cc0b944", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("nba_success", {
        "schema": "iglu:nl.ns/nba_success/jsonschema/1-0-0",
        "uc_id": properties.ucId,
        "uc_variant": properties.ucVariant,
        "uc_location": properties.ucLocation,
        "platform": sysPlatform,
        "language": sysLanguage,
        "ns_environment": sysNsEnvironment,
        "datalayer_source": sysDatalayerSource,
        "preview": sysPreview,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("OcvSS16e-Le", "nba_success", messages, [
        {id: "4-eTlbcITN", name: "schema", value: "iglu:nl.ns/nba_success/jsonschema/1-0-0"},
        {id: "7OXAcO_7A", name: "uc_variant", value: properties.ucVariant},
        {id: "Am6PkQ_Uo", name: "uc_location", value: properties.ucLocation},
        {id: "gbSQirnPl", name: "uc_id", value: properties.ucId},
        {id: "-PddLxwT_", name: "platform", value: sysPlatform},
        {id: "Af3-RL1nz2", name: "language", value: sysLanguage},
        {id: "L-rHlXDQJd", name: "datalayer_source", value: sysDatalayerSource},
        {id: "Po4mUsQEyB", name: "preview", value: sysPreview},
        {id: "ux8kucXh9-", name: "ns_environment", value: sysNsEnvironment},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'nba_success': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("nba_success", {
          "schema": "iglu:nl.ns/nba_success/jsonschema/1-0-0",
          "uc_id": properties.ucId,
          "uc_variant": properties.ucVariant,
          "uc_location": properties.ucLocation,
          "platform": sysPlatform,
          "language": sysLanguage,
          "ns_environment": sysNsEnvironment,
          "datalayer_source": sysDatalayerSource,
          "preview": sysPreview,
          }, "OcvSS16e-Le", "fcb5bc3e417d4f0be9a626fd51c625b12ba2adcf5912fb6e32b6d07e2cc0b944");
      }
      // destination NsDataQueue
      NsDataQueue.logEvent("nba_success", {
      "schema": "iglu:nl.ns/nba_success/jsonschema/1-0-0",
      "uc_id": properties.ucId,
      "uc_variant": properties.ucVariant,
      "uc_location": properties.ucLocation,
      "platform": sysPlatform,
      "language": sysLanguage,
      "ns_environment": sysNsEnvironment,
      "datalayer_source": sysDatalayerSource,
      "preview": sysPreview,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * nba_audience_add: Add audience of an NBA
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.testTool - Source of the experiment (optimizely, optimizely_sv, gtm, blueconic)
   * @param {string} properties.testLocation - e.g. homepage_banner, sdw, email, Facebook
   * @param {string} properties.testId - for NBAs, ucxxxx
for Experiments, specific experiment ID
   * @param {string} properties.testVariant - Test group
Control Group: ctrl
Variant: number_description i.e. v01_change_buttons_bottom
   * @param {string} [properties.testAudienceId] - Tool-specific ID of the test group
   * @param {string} properties.cluster - Cluster owner for test
   * 
   * @see {@link https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/XmNclzkwEt8}
   */
  function nbaAudienceAdd(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertTestTool(properties.testTool));
      messages = messages.concat(assertTestLocation(properties.testLocation));
      messages = messages.concat(assertTestId(properties.testId));
      messages = messages.concat(assertTestVariant(properties.testVariant));
      messages = messages.concat(assertOptionalTestAudienceId(properties.testAudienceId));
      messages = messages.concat(assertCluster(properties.cluster));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertLanguage(sysLanguage));
      messages = messages.concat(assertNsEnvironment(sysNsEnvironment));
      messages = messages.concat(assertDatalayerSource(sysDatalayerSource));
      messages = messages.concat(assertOptionalPreview(sysPreview));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("nba_audience_add", Object.keys(properties), [
        "testTool",
        "testLocation",
        "testId",
        "testVariant",
        "testAudienceId",
        "cluster"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "XmNclzkwEt8", "6f50e83f8896582fd3c469d52d0a251a608e7a1a01285a74bdc3fc6c8114a5de", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("nba_audience_add", {
        "schema": "iglu:nl.ns/nba_audience_add/jsonschema/1-0-1",
        "test_tool": properties.testTool,
        "test_location": properties.testLocation,
        "test_id": properties.testId,
        "test_variant": properties.testVariant,
        "test_audience_id": properties.testAudienceId,
        "cluster": properties.cluster,
        "platform": sysPlatform,
        "language": sysLanguage,
        "ns_environment": sysNsEnvironment,
        "datalayer_source": sysDatalayerSource,
        "preview": sysPreview,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("XmNclzkwEt8", "nba_audience_add", messages, [
        {id: "4-eTlbcITN", name: "schema", value: "iglu:nl.ns/nba_audience_add/jsonschema/1-0-1"},
        {id: "GL_TSnWYyKgW", name: "test_tool", value: properties.testTool},
        {id: "HpghA4STUpM1", name: "test_id", value: properties.testId},
        {id: "I44jVDyqBZic", name: "test_variant", value: properties.testVariant},
        {id: "TDtygjQ3jTuJ", name: "test_location", value: properties.testLocation},
        {id: "Xiuci0NEjDkz", name: "test_audience_id", value: properties.testAudienceId},
        {id: "aF92rWblhlD9", name: "cluster", value: properties.cluster},
        {id: "-PddLxwT_", name: "platform", value: sysPlatform},
        {id: "Af3-RL1nz2", name: "language", value: sysLanguage},
        {id: "L-rHlXDQJd", name: "datalayer_source", value: sysDatalayerSource},
        {id: "Po4mUsQEyB", name: "preview", value: sysPreview},
        {id: "ux8kucXh9-", name: "ns_environment", value: sysNsEnvironment},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'nba_audience_add': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("nba_audience_add", {
          "schema": "iglu:nl.ns/nba_audience_add/jsonschema/1-0-1",
          "test_tool": properties.testTool,
          "test_location": properties.testLocation,
          "test_id": properties.testId,
          "test_variant": properties.testVariant,
          "test_audience_id": properties.testAudienceId,
          "cluster": properties.cluster,
          "platform": sysPlatform,
          "language": sysLanguage,
          "ns_environment": sysNsEnvironment,
          "datalayer_source": sysDatalayerSource,
          "preview": sysPreview,
          }, "XmNclzkwEt8", "6f50e83f8896582fd3c469d52d0a251a608e7a1a01285a74bdc3fc6c8114a5de");
      }
      // destination NsDataQueue
      NsDataQueue.logEvent("nba_audience_add", {
      "schema": "iglu:nl.ns/nba_audience_add/jsonschema/1-0-1",
      "test_tool": properties.testTool,
      "test_location": properties.testLocation,
      "test_id": properties.testId,
      "test_variant": properties.testVariant,
      "test_audience_id": properties.testAudienceId,
      "cluster": properties.cluster,
      "platform": sysPlatform,
      "language": sysLanguage,
      "ns_environment": sysNsEnvironment,
      "datalayer_source": sysDatalayerSource,
      "preview": sysPreview,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * experiment_view: view a variant or the control version of an experiment
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.testTool - Source of the experiment (optimizely, optimizely_sv, gtm, blueconic)
   * @param {string} properties.testTeam - Team that initiates the test
   * @param {string} [properties.testLocation] - e.g. homepage_banner, sdw, email, Facebook
   * @param {string} properties.testId - for NBAs, ucxxxx
for Experiments, specific experiment ID
   * @param {string} properties.testVariant - Test group
Control Group: ctrl
Variant: number_description i.e. v01_change_buttons_bottom
   * @param {string} [properties.testAudienceId] - Tool-specific ID of the test group
   * @param {string} [properties.testDescription] - Short Hypotheses or purpose of this test
   * 
   * @see {@link https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/B_v6cdwUvaM}
   */
  function experimentView(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertTestTool(properties.testTool));
      messages = messages.concat(assertTestTeam(properties.testTeam));
      messages = messages.concat(assertOptionalTestLocation(properties.testLocation));
      messages = messages.concat(assertTestId(properties.testId));
      messages = messages.concat(assertTestVariant(properties.testVariant));
      messages = messages.concat(assertOptionalTestAudienceId(properties.testAudienceId));
      messages = messages.concat(assertOptionalTestDescription(properties.testDescription));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertLanguage(sysLanguage));
      messages = messages.concat(assertNsEnvironment(sysNsEnvironment));
      messages = messages.concat(assertDatalayerSource(sysDatalayerSource));
      messages = messages.concat(assertOptionalPreview(sysPreview));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("experiment_view", Object.keys(properties), [
        "testTool",
        "testTeam",
        "testLocation",
        "testId",
        "testVariant",
        "testAudienceId",
        "testDescription"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "B_v6cdwUvaM", "7ff41e3d1066ddfd87f56cdc8f28f883c7929da8abb4a6280ea844c8dce996db", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("experiment_view", {
        "schema": "iglu:nl.ns/experiment_view/jsonschema/1-0-5",
        "test_tool": properties.testTool,
        "test_team": properties.testTeam,
        "test_location": properties.testLocation,
        "test_id": properties.testId,
        "test_variant": properties.testVariant,
        "test_audience_id": properties.testAudienceId,
        "test_description": properties.testDescription,
        "platform": sysPlatform,
        "language": sysLanguage,
        "ns_environment": sysNsEnvironment,
        "datalayer_source": sysDatalayerSource,
        "preview": sysPreview,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("B_v6cdwUvaM", "experiment_view", messages, [
        {id: "4-eTlbcITN", name: "schema", value: "iglu:nl.ns/experiment_view/jsonschema/1-0-5"},
        {id: "GL_TSnWYyKgW", name: "test_tool", value: properties.testTool},
        {id: "HpghA4STUpM1", name: "test_id", value: properties.testId},
        {id: "I44jVDyqBZic", name: "test_variant", value: properties.testVariant},
        {id: "TDtygjQ3jTuJ", name: "test_location", value: properties.testLocation},
        {id: "Xiuci0NEjDkz", name: "test_audience_id", value: properties.testAudienceId},
        {id: "ij0L0WRQXuPq", name: "test_team", value: properties.testTeam},
        {id: "pnPG0qR_-", name: "test_description", value: properties.testDescription},
        {id: "-PddLxwT_", name: "platform", value: sysPlatform},
        {id: "Af3-RL1nz2", name: "language", value: sysLanguage},
        {id: "L-rHlXDQJd", name: "datalayer_source", value: sysDatalayerSource},
        {id: "Po4mUsQEyB", name: "preview", value: sysPreview},
        {id: "ux8kucXh9-", name: "ns_environment", value: sysNsEnvironment},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'experiment_view': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("experiment_view", {
          "schema": "iglu:nl.ns/experiment_view/jsonschema/1-0-5",
          "test_tool": properties.testTool,
          "test_team": properties.testTeam,
          "test_location": properties.testLocation,
          "test_id": properties.testId,
          "test_variant": properties.testVariant,
          "test_audience_id": properties.testAudienceId,
          "test_description": properties.testDescription,
          "platform": sysPlatform,
          "language": sysLanguage,
          "ns_environment": sysNsEnvironment,
          "datalayer_source": sysDatalayerSource,
          "preview": sysPreview,
          }, "B_v6cdwUvaM", "7ff41e3d1066ddfd87f56cdc8f28f883c7929da8abb4a6280ea844c8dce996db");
      }
      // destination NsDataQueue
      NsDataQueue.logEvent("experiment_view", {
      "schema": "iglu:nl.ns/experiment_view/jsonschema/1-0-5",
      "test_tool": properties.testTool,
      "test_team": properties.testTeam,
      "test_location": properties.testLocation,
      "test_id": properties.testId,
      "test_variant": properties.testVariant,
      "test_audience_id": properties.testAudienceId,
      "test_description": properties.testDescription,
      "platform": sysPlatform,
      "language": sysLanguage,
      "ns_environment": sysNsEnvironment,
      "datalayer_source": sysDatalayerSource,
      "preview": sysPreview,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * experiment_success: succes of an experiment
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.testTool - Source of the experiment (optimizely, optimizely_sv, gtm, blueconic)
   * @param {string} properties.testTeam - Team that initiates the test
   * @param {string} properties.testLocation - e.g. homepage_banner, sdw, email, Facebook
   * @param {string} properties.testId - for NBAs, ucxxxx
for Experiments, specific experiment ID
   * @param {string} properties.testVariant - Test group
Control Group: ctrl
Variant: number_description i.e. v01_change_buttons_bottom
   * @param {string} [properties.testAudienceId] - Tool-specific ID of the test group
   * @param {string} [properties.destinationPath] - In case of a click, show the full page URL of the destination
   * @param {string} properties.clickText - visible text which is clicked on / or label or element clicked (in case of nes-select for example)
   * 
   * @see {@link https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/xtxv7EspiUx}
   */
  function experimentSuccess(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertTestTool(properties.testTool));
      messages = messages.concat(assertTestTeam(properties.testTeam));
      messages = messages.concat(assertTestLocation(properties.testLocation));
      messages = messages.concat(assertTestId(properties.testId));
      messages = messages.concat(assertTestVariant(properties.testVariant));
      messages = messages.concat(assertOptionalTestAudienceId(properties.testAudienceId));
      messages = messages.concat(assertOptionalDestinationPath(properties.destinationPath));
      messages = messages.concat(assertClickText(properties.clickText));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertLanguage(sysLanguage));
      messages = messages.concat(assertNsEnvironment(sysNsEnvironment));
      messages = messages.concat(assertDatalayerSource(sysDatalayerSource));
      messages = messages.concat(assertOptionalPreview(sysPreview));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("experiment_success", Object.keys(properties), [
        "testTool",
        "testTeam",
        "testLocation",
        "testId",
        "testVariant",
        "testAudienceId",
        "destinationPath",
        "clickText"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "xtxv7EspiUx", "2efa6eef73e4caf21961d2ec63ddfc27275e64f783cbb748e9a8ba2f5e960e63", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("experiment_success", {
        "schema": "iglu:nl.ns/experiment_success/jsonschema/1-0-0",
        "test_tool": properties.testTool,
        "test_team": properties.testTeam,
        "test_location": properties.testLocation,
        "test_id": properties.testId,
        "test_variant": properties.testVariant,
        "test_audience_id": properties.testAudienceId,
        "destination_path": properties.destinationPath,
        "click_text": properties.clickText,
        "platform": sysPlatform,
        "language": sysLanguage,
        "ns_environment": sysNsEnvironment,
        "datalayer_source": sysDatalayerSource,
        "preview": sysPreview,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("xtxv7EspiUx", "experiment_success", messages, [
        {id: "4-eTlbcITN", name: "schema", value: "iglu:nl.ns/experiment_success/jsonschema/1-0-0"},
        {id: "GL_TSnWYyKgW", name: "test_tool", value: properties.testTool},
        {id: "HpghA4STUpM1", name: "test_id", value: properties.testId},
        {id: "I44jVDyqBZic", name: "test_variant", value: properties.testVariant},
        {id: "TDtygjQ3jTuJ", name: "test_location", value: properties.testLocation},
        {id: "TFD27fnuBpN-", name: "click_text", value: properties.clickText},
        {id: "Xiuci0NEjDkz", name: "test_audience_id", value: properties.testAudienceId},
        {id: "ij0L0WRQXuPq", name: "test_team", value: properties.testTeam},
        {id: "twaKzqqM-SP3", name: "destination_path", value: properties.destinationPath},
        {id: "-PddLxwT_", name: "platform", value: sysPlatform},
        {id: "Af3-RL1nz2", name: "language", value: sysLanguage},
        {id: "L-rHlXDQJd", name: "datalayer_source", value: sysDatalayerSource},
        {id: "Po4mUsQEyB", name: "preview", value: sysPreview},
        {id: "ux8kucXh9-", name: "ns_environment", value: sysNsEnvironment},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'experiment_success': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("experiment_success", {
          "schema": "iglu:nl.ns/experiment_success/jsonschema/1-0-0",
          "test_tool": properties.testTool,
          "test_team": properties.testTeam,
          "test_location": properties.testLocation,
          "test_id": properties.testId,
          "test_variant": properties.testVariant,
          "test_audience_id": properties.testAudienceId,
          "destination_path": properties.destinationPath,
          "click_text": properties.clickText,
          "platform": sysPlatform,
          "language": sysLanguage,
          "ns_environment": sysNsEnvironment,
          "datalayer_source": sysDatalayerSource,
          "preview": sysPreview,
          }, "xtxv7EspiUx", "2efa6eef73e4caf21961d2ec63ddfc27275e64f783cbb748e9a8ba2f5e960e63");
      }
      // destination NsDataQueue
      NsDataQueue.logEvent("experiment_success", {
      "schema": "iglu:nl.ns/experiment_success/jsonschema/1-0-0",
      "test_tool": properties.testTool,
      "test_team": properties.testTeam,
      "test_location": properties.testLocation,
      "test_id": properties.testId,
      "test_variant": properties.testVariant,
      "test_audience_id": properties.testAudienceId,
      "destination_path": properties.destinationPath,
      "click_text": properties.clickText,
      "platform": sysPlatform,
      "language": sysLanguage,
      "ns_environment": sysNsEnvironment,
      "datalayer_source": sysDatalayerSource,
      "preview": sysPreview,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * page_view: page views including Angular dynamic page views & WAHS 'pages'
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.pagePath - web only
   * @param {string} properties.pageStructure - Unique page structure with a unique structure for the page that is viewed. For example: ns.nl|ns-flex|abonnementen. If used in combination with a interaction, provide the structure of the location on which the interaction takes place.
   * @param {string} properties.pageType - category type of the page: service_page, thank_you_page,check_out_page
   * @param {string} properties.pageTitle - title of the webpage
   * @param {bool} [properties.virtual] - virtual page
   * @param {string} [properties.campaignStatus] - The status of the campaign if page_type is 
   * 
   * @see {@link https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/U6jhs_8eU}
   */
  function pageView(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertPagePath(properties.pagePath));
      messages = messages.concat(assertPageStructure(properties.pageStructure));
      messages = messages.concat(assertPageType(properties.pageType));
      messages = messages.concat(assertPageTitle(properties.pageTitle));
      messages = messages.concat(assertOptionalVirtual(properties.virtual));
      messages = messages.concat(assertOptionalCampaignStatus(properties.campaignStatus));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertLanguage(sysLanguage));
      messages = messages.concat(assertNsEnvironment(sysNsEnvironment));
      messages = messages.concat(assertDatalayerSource(sysDatalayerSource));
      messages = messages.concat(assertOptionalPreview(sysPreview));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("page_view", Object.keys(properties), [
        "pagePath",
        "pageStructure",
        "pageType",
        "pageTitle",
        "virtual",
        "campaignStatus"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "U6jhs_8eU", "a6beee2f2c8da701e9e84acc3d113504b0daa4afdfb9c5ac832797a29407d91e", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("page_view", {
        "schema": "iglu:nl.ns/page_view/jsonschema/4-0-4",
        "page_path": properties.pagePath,
        "page_structure": properties.pageStructure,
        "page_type": properties.pageType,
        "page_title": properties.pageTitle,
        "virtual": properties.virtual,
        "campaign_status": properties.campaignStatus,
        "platform": sysPlatform,
        "language": sysLanguage,
        "ns_environment": sysNsEnvironment,
        "datalayer_source": sysDatalayerSource,
        "preview": sysPreview,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("U6jhs_8eU", "page_view", messages, [
        {id: "4-eTlbcITN", name: "schema", value: "iglu:nl.ns/page_view/jsonschema/4-0-4"},
        {id: "HrAYDiO719kk", name: "page_title", value: properties.pageTitle},
        {id: "PgQL3oYhqcEj", name: "page_path", value: properties.pagePath},
        {id: "_3Sy5DLQHqRD", name: "virtual", value: properties.virtual},
        {id: "fW6NdHL5V", name: "campaign_status", value: properties.campaignStatus},
        {id: "juLwL7wdryz", name: "page_type", value: properties.pageType},
        {id: "z__awEy565g", name: "page_structure", value: properties.pageStructure},
        {id: "-PddLxwT_", name: "platform", value: sysPlatform},
        {id: "Af3-RL1nz2", name: "language", value: sysLanguage},
        {id: "L-rHlXDQJd", name: "datalayer_source", value: sysDatalayerSource},
        {id: "Po4mUsQEyB", name: "preview", value: sysPreview},
        {id: "ux8kucXh9-", name: "ns_environment", value: sysNsEnvironment},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'page_view': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("page_view", {
          "schema": "iglu:nl.ns/page_view/jsonschema/4-0-4",
          "page_path": properties.pagePath,
          "page_structure": properties.pageStructure,
          "page_type": properties.pageType,
          "page_title": properties.pageTitle,
          "virtual": properties.virtual,
          "campaign_status": properties.campaignStatus,
          "platform": sysPlatform,
          "language": sysLanguage,
          "ns_environment": sysNsEnvironment,
          "datalayer_source": sysDatalayerSource,
          "preview": sysPreview,
          }, "U6jhs_8eU", "a6beee2f2c8da701e9e84acc3d113504b0daa4afdfb9c5ac832797a29407d91e");
      }
      // destination NsDataQueue
      NsDataQueue.logEvent("page_view", {
      "schema": "iglu:nl.ns/page_view/jsonschema/4-0-4",
      "page_path": properties.pagePath,
      "page_structure": properties.pageStructure,
      "page_type": properties.pageType,
      "page_title": properties.pageTitle,
      "virtual": properties.virtual,
      "campaign_status": properties.campaignStatus,
      "platform": sysPlatform,
      "language": sysLanguage,
      "ns_environment": sysNsEnvironment,
      "datalayer_source": sysDatalayerSource,
      "preview": sysPreview,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * add_to_cart: App: When you hit add to cart button in multiple buying flows
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.currency - The currency of the purchase
   * @param {float} properties.value - value of purhcased/added/removed item(s)
   * @param {Array<object>} properties.items - item array of objects:
[{
          item_id: 'FLEX|7,
          item_name: 'Traject Vrij',
          coupon: 'Zomercampagne',
          discount: 5.00,
          index: 0,
          item_brand: 'NS.nl',
          item_category: 'Abonnementen',
          origin_station: 'Ede-Wageningen',
          destination_station: 'Woerden'
          item_variant: 'NS-Flex',  
          price: 291.90,
          quantity: 1
          item_revenue: 291.90
          intercity_direct: true,
          deur_tot_deur: {}
        }]
   * @param {string} properties.nsShop - Which shop/cluster: lvb_app, lvb_kaartjes, ns-flex, etc
   * 
   * @see {@link https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/XIShibtSw}
   */
  function addToCart(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertCurrency(properties.currency));
      messages = messages.concat(assertValue(properties.value));
      messages = messages.concat(assertItems(properties.items));
      messages = messages.concat(assertNsShop(properties.nsShop));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertLanguage(sysLanguage));
      messages = messages.concat(assertNsEnvironment(sysNsEnvironment));
      messages = messages.concat(assertDatalayerSource(sysDatalayerSource));
      messages = messages.concat(assertOptionalPreview(sysPreview));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("add_to_cart", Object.keys(properties), [
        "currency",
        "value",
        "items",
        "nsShop"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "XIShibtSw", "2ce452fc30d3636d247c21107910b5d0cd8a0897f301a9aa66e5a21700dcf0c8", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("add_to_cart", {
        "schema": "iglu:nl.ns/add_to_cart/jsonschema/2-0-1",
        "currency": properties.currency,
        "value": properties.value,
        "items": properties.items.map(function(value) {
          return {
            "item_id": value.itemId,
            "item_name": value.itemName,
            "coupon": value.coupon,
            "discount": value.discount,
            "index": value.index,
            "quantity": value.quantity,
            "price": value.price,
            "item_brand": value.itemBrand,
            "item_variant": value.itemVariant,
            "item_category": value.itemCategory,
            "travel_date": value.travelDate,
            "affiliation": value.affiliation,
            "item_category2": value.itemCategory2,
            "destination_station": value.destinationStation,
            "origin_station": value.originStation,
            "travel_class": value.travelClass,
            "travel_route": value.travelRoute,
            "intercity_direct": value.intercityDirect,
            "deur_tot_deur": value.deurTotDeur,
            "item_revenue": value.itemRevenue,
          };
          }),
        "ns_shop": properties.nsShop,
        "platform": sysPlatform,
        "language": sysLanguage,
        "ns_environment": sysNsEnvironment,
        "datalayer_source": sysDatalayerSource,
        "preview": sysPreview,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("XIShibtSw", "add_to_cart", messages, [
        {id: "4-eTlbcITN", name: "schema", value: "iglu:nl.ns/add_to_cart/jsonschema/2-0-1"},
        {id: "17s21jQ4G", name: "intercity_direct", value: properties.intercityDirect},
        {id: "1WkP-6sA8x_5", name: "value", value: properties.value},
        {id: "6-GUnFHLFL", name: "item_brand", value: properties.itemBrand},
        {id: "7h-TV9MOq2", name: "item_category", value: properties.itemCategory},
        {id: "9Tv-BxH6jSI", name: "coupon", value: properties.coupon},
        {id: "BImlhIesBPhx", name: "ns_shop", value: properties.nsShop},
        {id: "D-6RH3lvH", name: "affiliation", value: properties.affiliation},
        {id: "GuYrcDncVS5", name: "currency", value: properties.currency},
        {id: "JzW147FWP", name: "deur_tot_deur", value: properties.deurTotDeur},
        {id: "Oavl4KfPHF3", name: "items", value: properties.items},
        {id: "PKlIwCNeHb", name: "index", value: properties.index},
        {id: "PpX-d_0VW", name: "travel_route", value: properties.travelRoute},
        {id: "TIV1Wo8BM", name: "item_category2", value: properties.itemCategory2},
        {id: "UpRgfCPRK", name: "destination_station", value: properties.destinationStation},
        {id: "WGDHyEYby", name: "travel_date", value: properties.travelDate},
        {id: "ZVGAZOlEBhGj", name: "item_id", value: properties.itemId},
        {id: "ZZlWcbau6V", name: "quantity", value: properties.quantity},
        {id: "_T-mygJA7w", name: "price", value: properties.price},
        {id: "_WmY6XGTY", name: "travel_class", value: properties.travelClass},
        {id: "bMK3liq6t", name: "origin_station", value: properties.originStation},
        {id: "ePZR23byGW", name: "discount", value: properties.discount},
        {id: "hg4puJyLhb", name: "item_name", value: properties.itemName},
        {id: "k7CLuUXjt3HSeA3jMU2c7", name: "item_revenue", value: properties.itemRevenue},
        {id: "qAitKhHMy0", name: "item_variant", value: properties.itemVariant},
        {id: "-PddLxwT_", name: "platform", value: sysPlatform},
        {id: "Af3-RL1nz2", name: "language", value: sysLanguage},
        {id: "L-rHlXDQJd", name: "datalayer_source", value: sysDatalayerSource},
        {id: "Po4mUsQEyB", name: "preview", value: sysPreview},
        {id: "ux8kucXh9-", name: "ns_environment", value: sysNsEnvironment},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'add_to_cart': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("add_to_cart", {
          "schema": "iglu:nl.ns/add_to_cart/jsonschema/2-0-1",
          "currency": properties.currency,
          "value": properties.value,
          "items": properties.items.map(function(value) {
            return {
              "item_id": value.itemId,
              "item_name": value.itemName,
              "coupon": value.coupon,
              "discount": value.discount,
              "index": value.index,
              "quantity": value.quantity,
              "price": value.price,
              "item_brand": value.itemBrand,
              "item_variant": value.itemVariant,
              "item_category": value.itemCategory,
              "travel_date": value.travelDate,
              "affiliation": value.affiliation,
              "item_category2": value.itemCategory2,
              "destination_station": value.destinationStation,
              "origin_station": value.originStation,
              "travel_class": value.travelClass,
              "travel_route": value.travelRoute,
              "intercity_direct": value.intercityDirect,
              "deur_tot_deur": value.deurTotDeur,
              "item_revenue": value.itemRevenue,
            };
            }),
          "ns_shop": properties.nsShop,
          "platform": sysPlatform,
          "language": sysLanguage,
          "ns_environment": sysNsEnvironment,
          "datalayer_source": sysDatalayerSource,
          "preview": sysPreview,
          }, "XIShibtSw", "2ce452fc30d3636d247c21107910b5d0cd8a0897f301a9aa66e5a21700dcf0c8");
      }
      // destination NsDataQueue
      NsDataQueue.logEvent("add_to_cart", {
      "schema": "iglu:nl.ns/add_to_cart/jsonschema/2-0-1",
      "currency": properties.currency,
      "value": properties.value,
      "items": properties.items.map(function(value) {
        return {
          "item_id": value.itemId,
          "item_name": value.itemName,
          "coupon": value.coupon,
          "discount": value.discount,
          "index": value.index,
          "quantity": value.quantity,
          "price": value.price,
          "item_brand": value.itemBrand,
          "item_variant": value.itemVariant,
          "item_category": value.itemCategory,
          "travel_date": value.travelDate,
          "affiliation": value.affiliation,
          "item_category2": value.itemCategory2,
          "destination_station": value.destinationStation,
          "origin_station": value.originStation,
          "travel_class": value.travelClass,
          "travel_route": value.travelRoute,
          "intercity_direct": value.intercityDirect,
          "deur_tot_deur": value.deurTotDeur,
          "item_revenue": value.itemRevenue,
        };
        }),
      "ns_shop": properties.nsShop,
      "platform": sysPlatform,
      "language": sysLanguage,
      "ns_environment": sysNsEnvironment,
      "datalayer_source": sysDatalayerSource,
      "preview": sysPreview,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * remove_from_cart: When a product is removed from the cart
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.currency - The currency of the purchase
   * @param {float} properties.value - value of purhcased/added/removed item(s)
   * @param {Array<object>} properties.items - item array of objects:
[{
          item_id: 'FLEX|7,
          item_name: 'Traject Vrij',
          coupon: 'Zomercampagne',
          discount: 5.00,
          index: 0,
          item_brand: 'NS.nl',
          item_category: 'Abonnementen',
          origin_station: 'Ede-Wageningen',
          destination_station: 'Woerden'
          item_variant: 'NS-Flex',  
          price: 291.90,
          quantity: 1
          item_revenue: 291.90
          intercity_direct: true,
          deur_tot_deur: {}
        }]
   * @param {string} properties.nsShop - Which shop/cluster: lvb_app, lvb_kaartjes, ns-flex, etc
   * @param {string} [properties.websiteSection] - Part of the website (header/footer/homepage/cookiebar/reisplanner etc.)
   * @param {Array<object>} [properties.existingProduct] - current product you up or downgrade (one):
[{
          item_id: 'FLEX|7,
          item_name: 'Traject Vrij',
          item_brand: 'NS.nl',
          item_category: 'Abonnementen',
          item_category2: 'Abonnementen',
          item_variant: 'NS-Flex',
          price: 291.90,
          quantity: 1
        }]
   * 
   * @see {@link https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/FnwydILgs}
   */
  function removeFromCart(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertCurrency(properties.currency));
      messages = messages.concat(assertValue(properties.value));
      messages = messages.concat(assertItems(properties.items));
      messages = messages.concat(assertNsShop(properties.nsShop));
      messages = messages.concat(assertOptionalWebsiteSection(properties.websiteSection));
      messages = messages.concat(assertOptionalExistingProduct(properties.existingProduct));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertLanguage(sysLanguage));
      messages = messages.concat(assertNsEnvironment(sysNsEnvironment));
      messages = messages.concat(assertDatalayerSource(sysDatalayerSource));
      messages = messages.concat(assertOptionalPreview(sysPreview));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("remove_from_cart", Object.keys(properties), [
        "currency",
        "value",
        "items",
        "nsShop",
        "websiteSection",
        "existingProduct"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "FnwydILgs", "bc7714d16d061b00862883715e0cb37fb0e4857bc284e8605366e31301bd3e3d", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("remove_from_cart", {
        "schema": "iglu:nl.ns/remove_from_cart/jsonschema/1-0-4",
        "currency": properties.currency,
        "value": properties.value,
        "items": properties.items.map(function(value) {
          return {
            "item_id": value.itemId,
            "item_name": value.itemName,
            "coupon": value.coupon,
            "discount": value.discount,
            "index": value.index,
            "quantity": value.quantity,
            "price": value.price,
            "item_brand": value.itemBrand,
            "item_variant": value.itemVariant,
            "item_category": value.itemCategory,
            "travel_date": value.travelDate,
            "affiliation": value.affiliation,
            "item_category2": value.itemCategory2,
            "destination_station": value.destinationStation,
            "origin_station": value.originStation,
            "travel_class": value.travelClass,
            "travel_route": value.travelRoute,
            "intercity_direct": value.intercityDirect,
            "deur_tot_deur": value.deurTotDeur,
            "item_revenue": value.itemRevenue,
          };
          }),
        "ns_shop": properties.nsShop,
        "website_section": properties.websiteSection,
        "existing_product": properties.existingProduct !== undefined && properties.existingProduct !== null ? 
          properties.existingProduct.map(function(value) {
          return {
            "item_id": value.itemId,
            "item_name": value.itemName,
            "quantity": value.quantity,
            "item_category": value.itemCategory,
            "item_category2": value.itemCategory2,
            "price": value.price,
            "item_brand": value.itemBrand,
            "item_variant": value.itemVariant,
          };
          }) : properties.existingProduct,
        "platform": sysPlatform,
        "language": sysLanguage,
        "ns_environment": sysNsEnvironment,
        "datalayer_source": sysDatalayerSource,
        "preview": sysPreview,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("FnwydILgs", "remove_from_cart", messages, [
        {id: "4-eTlbcITN", name: "schema", value: "iglu:nl.ns/remove_from_cart/jsonschema/1-0-4"},
        {id: "17s21jQ4G", name: "intercity_direct", value: properties.intercityDirect},
        {id: "1WkP-6sA8x_5", name: "value", value: properties.value},
        {id: "6-GUnFHLFL", name: "item_brand", value: properties.itemBrand},
        {id: "7h-TV9MOq2", name: "item_category", value: properties.itemCategory},
        {id: "9Tv-BxH6jSI", name: "coupon", value: properties.coupon},
        {id: "BImlhIesBPhx", name: "ns_shop", value: properties.nsShop},
        {id: "D-6RH3lvH", name: "affiliation", value: properties.affiliation},
        {id: "GsMr_TucEDqV", name: "existing_product", value: properties.existingProduct},
        {id: "GuYrcDncVS5", name: "currency", value: properties.currency},
        {id: "JzW147FWP", name: "deur_tot_deur", value: properties.deurTotDeur},
        {id: "Oavl4KfPHF3", name: "items", value: properties.items},
        {id: "PKlIwCNeHb", name: "index", value: properties.index},
        {id: "PpX-d_0VW", name: "travel_route", value: properties.travelRoute},
        {id: "TIV1Wo8BM", name: "item_category2", value: properties.itemCategory2},
        {id: "UpRgfCPRK", name: "destination_station", value: properties.destinationStation},
        {id: "WGDHyEYby", name: "travel_date", value: properties.travelDate},
        {id: "ZVGAZOlEBhGj", name: "item_id", value: properties.itemId},
        {id: "ZZlWcbau6V", name: "quantity", value: properties.quantity},
        {id: "_T-mygJA7w", name: "price", value: properties.price},
        {id: "_WmY6XGTY", name: "travel_class", value: properties.travelClass},
        {id: "bMK3liq6t", name: "origin_station", value: properties.originStation},
        {id: "ePZR23byGW", name: "discount", value: properties.discount},
        {id: "hg4puJyLhb", name: "item_name", value: properties.itemName},
        {id: "k7CLuUXjt3HSeA3jMU2c7", name: "item_revenue", value: properties.itemRevenue},
        {id: "qAitKhHMy0", name: "item_variant", value: properties.itemVariant},
        {id: "wskyjid5yxT0", name: "website_section", value: properties.websiteSection},
        {id: "-PddLxwT_", name: "platform", value: sysPlatform},
        {id: "Af3-RL1nz2", name: "language", value: sysLanguage},
        {id: "L-rHlXDQJd", name: "datalayer_source", value: sysDatalayerSource},
        {id: "Po4mUsQEyB", name: "preview", value: sysPreview},
        {id: "ux8kucXh9-", name: "ns_environment", value: sysNsEnvironment},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'remove_from_cart': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("remove_from_cart", {
          "schema": "iglu:nl.ns/remove_from_cart/jsonschema/1-0-4",
          "currency": properties.currency,
          "value": properties.value,
          "items": properties.items.map(function(value) {
            return {
              "item_id": value.itemId,
              "item_name": value.itemName,
              "coupon": value.coupon,
              "discount": value.discount,
              "index": value.index,
              "quantity": value.quantity,
              "price": value.price,
              "item_brand": value.itemBrand,
              "item_variant": value.itemVariant,
              "item_category": value.itemCategory,
              "travel_date": value.travelDate,
              "affiliation": value.affiliation,
              "item_category2": value.itemCategory2,
              "destination_station": value.destinationStation,
              "origin_station": value.originStation,
              "travel_class": value.travelClass,
              "travel_route": value.travelRoute,
              "intercity_direct": value.intercityDirect,
              "deur_tot_deur": value.deurTotDeur,
              "item_revenue": value.itemRevenue,
            };
            }),
          "ns_shop": properties.nsShop,
          "website_section": properties.websiteSection,
          "existing_product": properties.existingProduct !== undefined && properties.existingProduct !== null ? 
            properties.existingProduct.map(function(value) {
            return {
              "item_id": value.itemId,
              "item_name": value.itemName,
              "quantity": value.quantity,
              "item_category": value.itemCategory,
              "item_category2": value.itemCategory2,
              "price": value.price,
              "item_brand": value.itemBrand,
              "item_variant": value.itemVariant,
            };
            }) : properties.existingProduct,
          "platform": sysPlatform,
          "language": sysLanguage,
          "ns_environment": sysNsEnvironment,
          "datalayer_source": sysDatalayerSource,
          "preview": sysPreview,
          }, "FnwydILgs", "bc7714d16d061b00862883715e0cb37fb0e4857bc284e8605366e31301bd3e3d");
      }
      // destination NsDataQueue
      NsDataQueue.logEvent("remove_from_cart", {
      "schema": "iglu:nl.ns/remove_from_cart/jsonschema/1-0-4",
      "currency": properties.currency,
      "value": properties.value,
      "items": properties.items.map(function(value) {
        return {
          "item_id": value.itemId,
          "item_name": value.itemName,
          "coupon": value.coupon,
          "discount": value.discount,
          "index": value.index,
          "quantity": value.quantity,
          "price": value.price,
          "item_brand": value.itemBrand,
          "item_variant": value.itemVariant,
          "item_category": value.itemCategory,
          "travel_date": value.travelDate,
          "affiliation": value.affiliation,
          "item_category2": value.itemCategory2,
          "destination_station": value.destinationStation,
          "origin_station": value.originStation,
          "travel_class": value.travelClass,
          "travel_route": value.travelRoute,
          "intercity_direct": value.intercityDirect,
          "deur_tot_deur": value.deurTotDeur,
          "item_revenue": value.itemRevenue,
        };
        }),
      "ns_shop": properties.nsShop,
      "website_section": properties.websiteSection,
      "existing_product": properties.existingProduct !== undefined && properties.existingProduct !== null ? 
        properties.existingProduct.map(function(value) {
        return {
          "item_id": value.itemId,
          "item_name": value.itemName,
          "quantity": value.quantity,
          "item_category": value.itemCategory,
          "item_category2": value.itemCategory2,
          "price": value.price,
          "item_brand": value.itemBrand,
          "item_variant": value.itemVariant,
        };
        }) : properties.existingProduct,
      "platform": sysPlatform,
      "language": sysLanguage,
      "ns_environment": sysNsEnvironment,
      "datalayer_source": sysDatalayerSource,
      "preview": sysPreview,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * datepicker_click: Click in de (nes) datapicker (selecting date)
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/msKAEF5r8m/trigger/jTSXtyBva
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.selectedDate - Date as string in 'DD-MM-YYYY' format
   * @param {string} [properties.websiteSection] - Part of the website (header/footer/homepage/cookiebar/reisplanner etc.)
   * @param {string} properties.uniqueName - Unique name / translations string for the element or event
   * @param {string} properties.description - Description of the element or event
   * 
   * @see {@link https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/msKAEF5r8m}
   */
  function datepickerClick(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertSelectedDate(properties.selectedDate));
      messages = messages.concat(assertOptionalWebsiteSection(properties.websiteSection));
      messages = messages.concat(assertUniqueName(properties.uniqueName));
      messages = messages.concat(assertDescription(properties.description));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertLanguage(sysLanguage));
      messages = messages.concat(assertNsEnvironment(sysNsEnvironment));
      messages = messages.concat(assertDatalayerSource(sysDatalayerSource));
      messages = messages.concat(assertOptionalPreview(sysPreview));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("datepicker_click", Object.keys(properties), [
        "selectedDate",
        "websiteSection",
        "uniqueName",
        "description"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "msKAEF5r8m", "da0631c3262229d8ff602f9f490c3d06804233a922e57235ab7c9c4516f05f06", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("datepicker_click", {
        "schema": "iglu:nl.ns/datepicker_click/jsonschema/1-0-3",
        "selected_date": properties.selectedDate,
        "website_section": properties.websiteSection,
        "unique_name": properties.uniqueName,
        "description": properties.description,
        "platform": sysPlatform,
        "language": sysLanguage,
        "ns_environment": sysNsEnvironment,
        "datalayer_source": sysDatalayerSource,
        "preview": sysPreview,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("msKAEF5r8m", "datepicker_click", messages, [
        {id: "4-eTlbcITN", name: "schema", value: "iglu:nl.ns/datepicker_click/jsonschema/1-0-3"},
        {id: "OCfm56R0fQu", name: "description", value: properties.description},
        {id: "bF4w0NCf7D4", name: "unique_name", value: properties.uniqueName},
        {id: "cT6ai5_Dk", name: "selected_date", value: properties.selectedDate},
        {id: "wskyjid5yxT0", name: "website_section", value: properties.websiteSection},
        {id: "-PddLxwT_", name: "platform", value: sysPlatform},
        {id: "Af3-RL1nz2", name: "language", value: sysLanguage},
        {id: "L-rHlXDQJd", name: "datalayer_source", value: sysDatalayerSource},
        {id: "Po4mUsQEyB", name: "preview", value: sysPreview},
        {id: "ux8kucXh9-", name: "ns_environment", value: sysNsEnvironment},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'datepicker_click': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("datepicker_click", {
          "schema": "iglu:nl.ns/datepicker_click/jsonschema/1-0-3",
          "selected_date": properties.selectedDate,
          "website_section": properties.websiteSection,
          "unique_name": properties.uniqueName,
          "description": properties.description,
          "platform": sysPlatform,
          "language": sysLanguage,
          "ns_environment": sysNsEnvironment,
          "datalayer_source": sysDatalayerSource,
          "preview": sysPreview,
          }, "msKAEF5r8m", "da0631c3262229d8ff602f9f490c3d06804233a922e57235ab7c9c4516f05f06");
      }
      // destination NsDataQueue
      NsDataQueue.logEvent("datepicker_click", {
      "schema": "iglu:nl.ns/datepicker_click/jsonschema/1-0-3",
      "selected_date": properties.selectedDate,
      "website_section": properties.websiteSection,
      "unique_name": properties.uniqueName,
      "description": properties.description,
      "platform": sysPlatform,
      "language": sysLanguage,
      "ns_environment": sysNsEnvironment,
      "datalayer_source": sysDatalayerSource,
      "preview": sysPreview,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * select_click: Click event when user selects an option in a select element
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/GnxZUuAXuv/trigger/9RpwarP4T
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} [properties.websiteSection] - Part of the website (header/footer/homepage/cookiebar/reisplanner etc.)
   * @param {string} properties.description - Description of the element or event
   * @param {string} properties.uniqueName - Unique name / translations string for the element or event
   * @param {string} properties.clickText - visible text which is clicked on / or label or element clicked (in case of nes-select for example)
   * @param {int} [properties.optionAmount] - Amount of options that user can select from. 
   * @param {string} properties.selectedOption - Label or value of option that is selected
   * @param {Array<string>} properties.optionList - Optional list of items that the user see as select options
   * 
   * @see {@link https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/GnxZUuAXuv}
   */
  function selectClick(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertOptionalWebsiteSection(properties.websiteSection));
      messages = messages.concat(assertDescription(properties.description));
      messages = messages.concat(assertUniqueName(properties.uniqueName));
      messages = messages.concat(assertClickText(properties.clickText));
      messages = messages.concat(assertOptionalOptionAmount(properties.optionAmount));
      messages = messages.concat(assertSelectedOption(properties.selectedOption));
      messages = messages.concat(assertOptionList(properties.optionList));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertLanguage(sysLanguage));
      messages = messages.concat(assertNsEnvironment(sysNsEnvironment));
      messages = messages.concat(assertDatalayerSource(sysDatalayerSource));
      messages = messages.concat(assertOptionalPreview(sysPreview));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("select_click", Object.keys(properties), [
        "websiteSection",
        "description",
        "uniqueName",
        "clickText",
        "optionAmount",
        "selectedOption",
        "optionList"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "GnxZUuAXuv", "6686858108e95622fa819290a8dc42981d708c48c204a27573fabf599a18d060", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("select_click", {
        "schema": "iglu:nl.ns/select_click/jsonschema/1-0-2",
        "website_section": properties.websiteSection,
        "description": properties.description,
        "unique_name": properties.uniqueName,
        "click_text": properties.clickText,
        "option_amount": properties.optionAmount,
        "selected_option": properties.selectedOption,
        "option_list": properties.optionList,
        "platform": sysPlatform,
        "language": sysLanguage,
        "ns_environment": sysNsEnvironment,
        "datalayer_source": sysDatalayerSource,
        "preview": sysPreview,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("GnxZUuAXuv", "select_click", messages, [
        {id: "4-eTlbcITN", name: "schema", value: "iglu:nl.ns/select_click/jsonschema/1-0-2"},
        {id: "2_Kyx49Pj", name: "selected_option", value: properties.selectedOption},
        {id: "MJqw4kh96", name: "option_list", value: properties.optionList},
        {id: "OCfm56R0fQu", name: "description", value: properties.description},
        {id: "TFD27fnuBpN-", name: "click_text", value: properties.clickText},
        {id: "bF4w0NCf7D4", name: "unique_name", value: properties.uniqueName},
        {id: "gyvKCwS5E", name: "option_amount", value: properties.optionAmount},
        {id: "wskyjid5yxT0", name: "website_section", value: properties.websiteSection},
        {id: "-PddLxwT_", name: "platform", value: sysPlatform},
        {id: "Af3-RL1nz2", name: "language", value: sysLanguage},
        {id: "L-rHlXDQJd", name: "datalayer_source", value: sysDatalayerSource},
        {id: "Po4mUsQEyB", name: "preview", value: sysPreview},
        {id: "ux8kucXh9-", name: "ns_environment", value: sysNsEnvironment},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'select_click': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("select_click", {
          "schema": "iglu:nl.ns/select_click/jsonschema/1-0-2",
          "website_section": properties.websiteSection,
          "description": properties.description,
          "unique_name": properties.uniqueName,
          "click_text": properties.clickText,
          "option_amount": properties.optionAmount,
          "selected_option": properties.selectedOption,
          "option_list": properties.optionList,
          "platform": sysPlatform,
          "language": sysLanguage,
          "ns_environment": sysNsEnvironment,
          "datalayer_source": sysDatalayerSource,
          "preview": sysPreview,
          }, "GnxZUuAXuv", "6686858108e95622fa819290a8dc42981d708c48c204a27573fabf599a18d060");
      }
      // destination NsDataQueue
      NsDataQueue.logEvent("select_click", {
      "schema": "iglu:nl.ns/select_click/jsonschema/1-0-2",
      "website_section": properties.websiteSection,
      "description": properties.description,
      "unique_name": properties.uniqueName,
      "click_text": properties.clickText,
      "option_amount": properties.optionAmount,
      "selected_option": properties.selectedOption,
      "option_list": properties.optionList,
      "platform": sysPlatform,
      "language": sysLanguage,
      "ns_environment": sysNsEnvironment,
      "datalayer_source": sysDatalayerSource,
      "preview": sysPreview,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * selectable_click: Click on (nes) selectable element
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/MLjZq2fxPU/trigger/fCE1oL9DS
   * 2. 
   * View in Avo: https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/MLjZq2fxPU/trigger/_PJvkmUUu
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.uniqueName - Unique name / translations string for the element or event
   * @param {string} properties.description - Description of the element or event
   * @param {string} [properties.websiteSection] - Part of the website (header/footer/homepage/cookiebar/reisplanner etc.)
   * @param {string} properties.clickText - visible text which is clicked on / or label or element clicked (in case of nes-select for example)
   * @param {Array<string>} [properties.optionList] - Optional list of items that the user see as select options
   * @param {string} properties.selectedOption - Label or value of option that is selected
   * @param {int} [properties.optionAmount] - Amount of options that user can select from. 
   * 
   * @see {@link https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/MLjZq2fxPU}
   */
  function selectableClick(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertUniqueName(properties.uniqueName));
      messages = messages.concat(assertDescription(properties.description));
      messages = messages.concat(assertOptionalWebsiteSection(properties.websiteSection));
      messages = messages.concat(assertClickText(properties.clickText));
      messages = messages.concat(assertOptionalOptionList(properties.optionList));
      messages = messages.concat(assertSelectedOption(properties.selectedOption));
      messages = messages.concat(assertOptionalOptionAmount(properties.optionAmount));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertLanguage(sysLanguage));
      messages = messages.concat(assertNsEnvironment(sysNsEnvironment));
      messages = messages.concat(assertDatalayerSource(sysDatalayerSource));
      messages = messages.concat(assertOptionalPreview(sysPreview));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("selectable_click", Object.keys(properties), [
        "uniqueName",
        "description",
        "websiteSection",
        "clickText",
        "optionList",
        "selectedOption",
        "optionAmount"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "MLjZq2fxPU", "5fc9627f89d0ee0ef54ef300460a828ab22201fe4218b1073466cf2718d291c8", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("selectable_click", {
        "schema": "iglu:nl.ns/selectable_click/jsonschema/1-0-3",
        "unique_name": properties.uniqueName,
        "description": properties.description,
        "website_section": properties.websiteSection,
        "click_text": properties.clickText,
        "option_list": properties.optionList,
        "selected_option": properties.selectedOption,
        "option_amount": properties.optionAmount,
        "platform": sysPlatform,
        "language": sysLanguage,
        "ns_environment": sysNsEnvironment,
        "datalayer_source": sysDatalayerSource,
        "preview": sysPreview,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("MLjZq2fxPU", "selectable_click", messages, [
        {id: "4-eTlbcITN", name: "schema", value: "iglu:nl.ns/selectable_click/jsonschema/1-0-3"},
        {id: "2_Kyx49Pj", name: "selected_option", value: properties.selectedOption},
        {id: "MJqw4kh96", name: "option_list", value: properties.optionList},
        {id: "OCfm56R0fQu", name: "description", value: properties.description},
        {id: "TFD27fnuBpN-", name: "click_text", value: properties.clickText},
        {id: "bF4w0NCf7D4", name: "unique_name", value: properties.uniqueName},
        {id: "gyvKCwS5E", name: "option_amount", value: properties.optionAmount},
        {id: "wskyjid5yxT0", name: "website_section", value: properties.websiteSection},
        {id: "-PddLxwT_", name: "platform", value: sysPlatform},
        {id: "Af3-RL1nz2", name: "language", value: sysLanguage},
        {id: "L-rHlXDQJd", name: "datalayer_source", value: sysDatalayerSource},
        {id: "Po4mUsQEyB", name: "preview", value: sysPreview},
        {id: "ux8kucXh9-", name: "ns_environment", value: sysNsEnvironment},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'selectable_click': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("selectable_click", {
          "schema": "iglu:nl.ns/selectable_click/jsonschema/1-0-3",
          "unique_name": properties.uniqueName,
          "description": properties.description,
          "website_section": properties.websiteSection,
          "click_text": properties.clickText,
          "option_list": properties.optionList,
          "selected_option": properties.selectedOption,
          "option_amount": properties.optionAmount,
          "platform": sysPlatform,
          "language": sysLanguage,
          "ns_environment": sysNsEnvironment,
          "datalayer_source": sysDatalayerSource,
          "preview": sysPreview,
          }, "MLjZq2fxPU", "5fc9627f89d0ee0ef54ef300460a828ab22201fe4218b1073466cf2718d291c8");
      }
      // destination NsDataQueue
      NsDataQueue.logEvent("selectable_click", {
      "schema": "iglu:nl.ns/selectable_click/jsonschema/1-0-3",
      "unique_name": properties.uniqueName,
      "description": properties.description,
      "website_section": properties.websiteSection,
      "click_text": properties.clickText,
      "option_list": properties.optionList,
      "selected_option": properties.selectedOption,
      "option_amount": properties.optionAmount,
      "platform": sysPlatform,
      "language": sysLanguage,
      "ns_environment": sysNsEnvironment,
      "datalayer_source": sysDatalayerSource,
      "preview": sysPreview,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * expandable_click: Click on (nes) expandable element
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/VDgWpmWo1M/trigger/qednrkkmG
   * 2. 
   * View in Avo: https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/VDgWpmWo1M/trigger/V_TcP3S_J
   * 3. 
   * View in Avo: https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/VDgWpmWo1M/trigger/U9J7z8cjdNzc_It_0KRIg
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.clickText - visible text which is clicked on / or label or element clicked (in case of nes-select for example)
   * @param {string} [properties.websiteSection] - Part of the website (header/footer/homepage/cookiebar/reisplanner etc.)
   * @param {string} properties.uniqueName - Unique name / translations string for the element or event
   * @param {string} properties.description - Description of the element or event
   * @param {bool} properties.opened - Does the user opens the element?
   * 
   * @see {@link https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/VDgWpmWo1M}
   */
  function expandableClick(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertClickText(properties.clickText));
      messages = messages.concat(assertOptionalWebsiteSection(properties.websiteSection));
      messages = messages.concat(assertUniqueName(properties.uniqueName));
      messages = messages.concat(assertDescription(properties.description));
      messages = messages.concat(assertOpened(properties.opened));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertLanguage(sysLanguage));
      messages = messages.concat(assertNsEnvironment(sysNsEnvironment));
      messages = messages.concat(assertDatalayerSource(sysDatalayerSource));
      messages = messages.concat(assertOptionalPreview(sysPreview));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("expandable_click", Object.keys(properties), [
        "clickText",
        "websiteSection",
        "uniqueName",
        "description",
        "opened"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "VDgWpmWo1M", "68ea65db9db595d8c204b47f3389798929547188e43ec3e0ecb76bca3703b4a2", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("expandable_click", {
        "schema": "iglu:nl.ns/expandable_click/jsonschema/1-0-3",
        "click_text": properties.clickText,
        "website_section": properties.websiteSection,
        "unique_name": properties.uniqueName,
        "description": properties.description,
        "opened": properties.opened,
        "platform": sysPlatform,
        "language": sysLanguage,
        "ns_environment": sysNsEnvironment,
        "datalayer_source": sysDatalayerSource,
        "preview": sysPreview,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("VDgWpmWo1M", "expandable_click", messages, [
        {id: "4-eTlbcITN", name: "schema", value: "iglu:nl.ns/expandable_click/jsonschema/1-0-3"},
        {id: "5r8JteLxZ", name: "opened", value: properties.opened},
        {id: "OCfm56R0fQu", name: "description", value: properties.description},
        {id: "TFD27fnuBpN-", name: "click_text", value: properties.clickText},
        {id: "bF4w0NCf7D4", name: "unique_name", value: properties.uniqueName},
        {id: "wskyjid5yxT0", name: "website_section", value: properties.websiteSection},
        {id: "-PddLxwT_", name: "platform", value: sysPlatform},
        {id: "Af3-RL1nz2", name: "language", value: sysLanguage},
        {id: "L-rHlXDQJd", name: "datalayer_source", value: sysDatalayerSource},
        {id: "Po4mUsQEyB", name: "preview", value: sysPreview},
        {id: "ux8kucXh9-", name: "ns_environment", value: sysNsEnvironment},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'expandable_click': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("expandable_click", {
          "schema": "iglu:nl.ns/expandable_click/jsonschema/1-0-3",
          "click_text": properties.clickText,
          "website_section": properties.websiteSection,
          "unique_name": properties.uniqueName,
          "description": properties.description,
          "opened": properties.opened,
          "platform": sysPlatform,
          "language": sysLanguage,
          "ns_environment": sysNsEnvironment,
          "datalayer_source": sysDatalayerSource,
          "preview": sysPreview,
          }, "VDgWpmWo1M", "68ea65db9db595d8c204b47f3389798929547188e43ec3e0ecb76bca3703b4a2");
      }
      // destination NsDataQueue
      NsDataQueue.logEvent("expandable_click", {
      "schema": "iglu:nl.ns/expandable_click/jsonschema/1-0-3",
      "click_text": properties.clickText,
      "website_section": properties.websiteSection,
      "unique_name": properties.uniqueName,
      "description": properties.description,
      "opened": properties.opened,
      "platform": sysPlatform,
      "language": sysLanguage,
      "ns_environment": sysNsEnvironment,
      "datalayer_source": sysDatalayerSource,
      "preview": sysPreview,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * toggle_click: Click on (nes) toggle element
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/BUoGWMzQE/trigger/wL9AzUGxp
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.clickText - visible text which is clicked on / or label or element clicked (in case of nes-select for example)
   * @param {string} properties.uniqueName - Unique name / translations string for the element or event
   * @param {string} properties.description - Description of the element or event
   * @param {string} [properties.websiteSection] - Part of the website (header/footer/homepage/cookiebar/reisplanner etc.)
   * @param {bool} properties.checked - Is the element selected of not?
   * 
   * @see {@link https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/BUoGWMzQE}
   */
  function toggleClick(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertClickText(properties.clickText));
      messages = messages.concat(assertUniqueName(properties.uniqueName));
      messages = messages.concat(assertDescription(properties.description));
      messages = messages.concat(assertOptionalWebsiteSection(properties.websiteSection));
      messages = messages.concat(assertChecked(properties.checked));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertLanguage(sysLanguage));
      messages = messages.concat(assertNsEnvironment(sysNsEnvironment));
      messages = messages.concat(assertDatalayerSource(sysDatalayerSource));
      messages = messages.concat(assertOptionalPreview(sysPreview));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("toggle_click", Object.keys(properties), [
        "clickText",
        "uniqueName",
        "description",
        "websiteSection",
        "checked"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "BUoGWMzQE", "070b6cfa9cf4de76da8fe02cae87319fb8cc966a1b02eafae49920e0c000a013", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("toggle_click", {
        "schema": "iglu:nl.ns/toggle_click/jsonschema/1-0-3",
        "click_text": properties.clickText,
        "unique_name": properties.uniqueName,
        "description": properties.description,
        "website_section": properties.websiteSection,
        "checked": properties.checked,
        "platform": sysPlatform,
        "language": sysLanguage,
        "ns_environment": sysNsEnvironment,
        "datalayer_source": sysDatalayerSource,
        "preview": sysPreview,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("BUoGWMzQE", "toggle_click", messages, [
        {id: "4-eTlbcITN", name: "schema", value: "iglu:nl.ns/toggle_click/jsonschema/1-0-3"},
        {id: "OCfm56R0fQu", name: "description", value: properties.description},
        {id: "TFD27fnuBpN-", name: "click_text", value: properties.clickText},
        {id: "bF4w0NCf7D4", name: "unique_name", value: properties.uniqueName},
        {id: "rzoBfRsaz89", name: "checked", value: properties.checked},
        {id: "wskyjid5yxT0", name: "website_section", value: properties.websiteSection},
        {id: "-PddLxwT_", name: "platform", value: sysPlatform},
        {id: "Af3-RL1nz2", name: "language", value: sysLanguage},
        {id: "L-rHlXDQJd", name: "datalayer_source", value: sysDatalayerSource},
        {id: "Po4mUsQEyB", name: "preview", value: sysPreview},
        {id: "ux8kucXh9-", name: "ns_environment", value: sysNsEnvironment},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'toggle_click': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("toggle_click", {
          "schema": "iglu:nl.ns/toggle_click/jsonschema/1-0-3",
          "click_text": properties.clickText,
          "unique_name": properties.uniqueName,
          "description": properties.description,
          "website_section": properties.websiteSection,
          "checked": properties.checked,
          "platform": sysPlatform,
          "language": sysLanguage,
          "ns_environment": sysNsEnvironment,
          "datalayer_source": sysDatalayerSource,
          "preview": sysPreview,
          }, "BUoGWMzQE", "070b6cfa9cf4de76da8fe02cae87319fb8cc966a1b02eafae49920e0c000a013");
      }
      // destination NsDataQueue
      NsDataQueue.logEvent("toggle_click", {
      "schema": "iglu:nl.ns/toggle_click/jsonschema/1-0-3",
      "click_text": properties.clickText,
      "unique_name": properties.uniqueName,
      "description": properties.description,
      "website_section": properties.websiteSection,
      "checked": properties.checked,
      "platform": sysPlatform,
      "language": sysLanguage,
      "ns_environment": sysNsEnvironment,
      "datalayer_source": sysDatalayerSource,
      "preview": sysPreview,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * element_click: Click on an element (such as a list item)
   * 
   * When to trigger this event:
   * 1. 
   * View in Avo: https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/440O74wD4O/trigger/HAwmdUlvL
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.uniqueName - Unique name / translations string for the element or event
   * @param {string} [properties.elementType] - Type of element shown
   * 
   * @see {@link https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/440O74wD4O}
   */
  function elementClick(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertUniqueName(properties.uniqueName));
      messages = messages.concat(assertOptionalElementType(properties.elementType));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertLanguage(sysLanguage));
      messages = messages.concat(assertNsEnvironment(sysNsEnvironment));
      messages = messages.concat(assertDatalayerSource(sysDatalayerSource));
      messages = messages.concat(assertOptionalPreview(sysPreview));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("element_click", Object.keys(properties), [
        "uniqueName",
        "elementType"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "440O74wD4O", "ea44ee77dc83c44f30c428d8f996d5ea8a973b878036762c90c3615bfd820279", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("element_click", {
        "schema": "iglu:nl.ns/element_click/jsonschema/1-0-4",
        "unique_name": properties.uniqueName,
        "element_type": properties.elementType,
        "platform": sysPlatform,
        "language": sysLanguage,
        "ns_environment": sysNsEnvironment,
        "datalayer_source": sysDatalayerSource,
        "preview": sysPreview,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("440O74wD4O", "element_click", messages, [
        {id: "4-eTlbcITN", name: "schema", value: "iglu:nl.ns/element_click/jsonschema/1-0-4"},
        {id: "XP-wQ8Diq01EP_5L1OoxC", name: "element_type", value: properties.elementType},
        {id: "bF4w0NCf7D4", name: "unique_name", value: properties.uniqueName},
        {id: "-PddLxwT_", name: "platform", value: sysPlatform},
        {id: "Af3-RL1nz2", name: "language", value: sysLanguage},
        {id: "L-rHlXDQJd", name: "datalayer_source", value: sysDatalayerSource},
        {id: "Po4mUsQEyB", name: "preview", value: sysPreview},
        {id: "ux8kucXh9-", name: "ns_environment", value: sysNsEnvironment},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'element_click': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("element_click", {
          "schema": "iglu:nl.ns/element_click/jsonschema/1-0-4",
          "unique_name": properties.uniqueName,
          "element_type": properties.elementType,
          "platform": sysPlatform,
          "language": sysLanguage,
          "ns_environment": sysNsEnvironment,
          "datalayer_source": sysDatalayerSource,
          "preview": sysPreview,
          }, "440O74wD4O", "ea44ee77dc83c44f30c428d8f996d5ea8a973b878036762c90c3615bfd820279");
      }
      // destination NsDataQueue
      NsDataQueue.logEvent("element_click", {
      "schema": "iglu:nl.ns/element_click/jsonschema/1-0-4",
      "unique_name": properties.uniqueName,
      "element_type": properties.elementType,
      "platform": sysPlatform,
      "language": sysLanguage,
      "ns_environment": sysNsEnvironment,
      "datalayer_source": sysDatalayerSource,
      "preview": sysPreview,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * view_item_list: Triggers when the product detail page is viewed
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {float} properties.value - value of purhcased/added/removed item(s)
   * @param {Array<object>} properties.items - item array of objects:
[{
          item_id: 'FLEX|7,
          item_name: 'Traject Vrij',
          coupon: 'Zomercampagne',
          discount: 5.00,
          index: 0,
          item_brand: 'NS.nl',
          item_category: 'Abonnementen',
          origin_station: 'Ede-Wageningen',
          destination_station: 'Woerden'
          item_variant: 'NS-Flex',  
          price: 291.90,
          quantity: 1
          item_revenue: 291.90
          intercity_direct: true,
          deur_tot_deur: {}
        }]
   * @param {string} [properties.itemListId] - id of the list viewed
   * @param {string} [properties.itemListName] - The name of the list in which the item was presented to the user
   * @param {string} properties.nsShop - Which shop/cluster: lvb_app, lvb_kaartjes, ns-flex, etc
   * @param {string} [properties.salesChannel] - Wat is het verkoopkanaal van de aankoop? Spoordeelwinkel / Losse kaatjes / Externe verkoper
   * 
   * @see {@link https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/deRK33OE7}
   */
  function viewItemList(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertValue(properties.value));
      messages = messages.concat(assertItems(properties.items));
      messages = messages.concat(assertOptionalItemListId(properties.itemListId));
      messages = messages.concat(assertOptionalItemListName(properties.itemListName));
      messages = messages.concat(assertNsShop(properties.nsShop));
      messages = messages.concat(assertOptionalSalesChannel(properties.salesChannel));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertLanguage(sysLanguage));
      messages = messages.concat(assertNsEnvironment(sysNsEnvironment));
      messages = messages.concat(assertDatalayerSource(sysDatalayerSource));
      messages = messages.concat(assertOptionalPreview(sysPreview));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("view_item_list", Object.keys(properties), [
        "value",
        "items",
        "itemListId",
        "itemListName",
        "nsShop",
        "salesChannel"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "deRK33OE7", "5fe463cc8ffa0be03504722d5bea131fba1bb32104c095803d2f5183a8c85d9b", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("view_item_list", {
        "currency": "EUR",
        "schema": "iglu:nl.ns/view_item_list/jsonschema/1-0-6",
        "value": properties.value,
        "items": properties.items.map(function(value) {
          return {
            "item_id": value.itemId,
            "item_name": value.itemName,
            "coupon": value.coupon,
            "discount": value.discount,
            "index": value.index,
            "quantity": value.quantity,
            "price": value.price,
            "item_brand": value.itemBrand,
            "item_variant": value.itemVariant,
            "item_category": value.itemCategory,
            "travel_date": value.travelDate,
            "affiliation": value.affiliation,
            "item_category2": value.itemCategory2,
            "destination_station": value.destinationStation,
            "origin_station": value.originStation,
            "travel_class": value.travelClass,
            "travel_route": value.travelRoute,
            "intercity_direct": value.intercityDirect,
            "deur_tot_deur": value.deurTotDeur,
            "item_revenue": value.itemRevenue,
          };
          }),
        "item_list_id": properties.itemListId,
        "item_list_name": properties.itemListName,
        "ns_shop": properties.nsShop,
        "sales_channel": properties.salesChannel,
        "platform": sysPlatform,
        "language": sysLanguage,
        "ns_environment": sysNsEnvironment,
        "datalayer_source": sysDatalayerSource,
        "preview": sysPreview,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("deRK33OE7", "view_item_list", messages, [
        {id: "GuYrcDncVS5", name: "currency", value: "EUR"},
        {id: "4-eTlbcITN", name: "schema", value: "iglu:nl.ns/view_item_list/jsonschema/1-0-6"},
        {id: "17s21jQ4G", name: "intercity_direct", value: properties.intercityDirect},
        {id: "1WkP-6sA8x_5", name: "value", value: properties.value},
        {id: "6-GUnFHLFL", name: "item_brand", value: properties.itemBrand},
        {id: "7h-TV9MOq2", name: "item_category", value: properties.itemCategory},
        {id: "9Tv-BxH6jSI", name: "coupon", value: properties.coupon},
        {id: "BImlhIesBPhx", name: "ns_shop", value: properties.nsShop},
        {id: "D-6RH3lvH", name: "affiliation", value: properties.affiliation},
        {id: "JzW147FWP", name: "deur_tot_deur", value: properties.deurTotDeur},
        {id: "LydSjYynFBlR", name: "item_list_name", value: properties.itemListName},
        {id: "Oavl4KfPHF3", name: "items", value: properties.items},
        {id: "PKlIwCNeHb", name: "index", value: properties.index},
        {id: "PpX-d_0VW", name: "travel_route", value: properties.travelRoute},
        {id: "TIV1Wo8BM", name: "item_category2", value: properties.itemCategory2},
        {id: "UpRgfCPRK", name: "destination_station", value: properties.destinationStation},
        {id: "WGDHyEYby", name: "travel_date", value: properties.travelDate},
        {id: "ZVGAZOlEBhGj", name: "item_id", value: properties.itemId},
        {id: "ZZlWcbau6V", name: "quantity", value: properties.quantity},
        {id: "_T-mygJA7w", name: "price", value: properties.price},
        {id: "_WmY6XGTY", name: "travel_class", value: properties.travelClass},
        {id: "bMK3liq6t", name: "origin_station", value: properties.originStation},
        {id: "ePZR23byGW", name: "discount", value: properties.discount},
        {id: "hg4puJyLhb", name: "item_name", value: properties.itemName},
        {id: "k7CLuUXjt3HSeA3jMU2c7", name: "item_revenue", value: properties.itemRevenue},
        {id: "qAitKhHMy0", name: "item_variant", value: properties.itemVariant},
        {id: "qAs6FFElba8q", name: "item_list_id", value: properties.itemListId},
        {id: "qJKae_S4y_", name: "sales_channel", value: properties.salesChannel},
        {id: "-PddLxwT_", name: "platform", value: sysPlatform},
        {id: "Af3-RL1nz2", name: "language", value: sysLanguage},
        {id: "L-rHlXDQJd", name: "datalayer_source", value: sysDatalayerSource},
        {id: "Po4mUsQEyB", name: "preview", value: sysPreview},
        {id: "ux8kucXh9-", name: "ns_environment", value: sysNsEnvironment},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'view_item_list': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("view_item_list", {
          "currency": "EUR",
          "schema": "iglu:nl.ns/view_item_list/jsonschema/1-0-6",
          "value": properties.value,
          "items": properties.items.map(function(value) {
            return {
              "item_id": value.itemId,
              "item_name": value.itemName,
              "coupon": value.coupon,
              "discount": value.discount,
              "index": value.index,
              "quantity": value.quantity,
              "price": value.price,
              "item_brand": value.itemBrand,
              "item_variant": value.itemVariant,
              "item_category": value.itemCategory,
              "travel_date": value.travelDate,
              "affiliation": value.affiliation,
              "item_category2": value.itemCategory2,
              "destination_station": value.destinationStation,
              "origin_station": value.originStation,
              "travel_class": value.travelClass,
              "travel_route": value.travelRoute,
              "intercity_direct": value.intercityDirect,
              "deur_tot_deur": value.deurTotDeur,
              "item_revenue": value.itemRevenue,
            };
            }),
          "item_list_id": properties.itemListId,
          "item_list_name": properties.itemListName,
          "ns_shop": properties.nsShop,
          "sales_channel": properties.salesChannel,
          "platform": sysPlatform,
          "language": sysLanguage,
          "ns_environment": sysNsEnvironment,
          "datalayer_source": sysDatalayerSource,
          "preview": sysPreview,
          }, "deRK33OE7", "5fe463cc8ffa0be03504722d5bea131fba1bb32104c095803d2f5183a8c85d9b");
      }
      // destination NsDataQueue
      NsDataQueue.logEvent("view_item_list", {
      "currency": "EUR",
      "schema": "iglu:nl.ns/view_item_list/jsonschema/1-0-6",
      "value": properties.value,
      "items": properties.items.map(function(value) {
        return {
          "item_id": value.itemId,
          "item_name": value.itemName,
          "coupon": value.coupon,
          "discount": value.discount,
          "index": value.index,
          "quantity": value.quantity,
          "price": value.price,
          "item_brand": value.itemBrand,
          "item_variant": value.itemVariant,
          "item_category": value.itemCategory,
          "travel_date": value.travelDate,
          "affiliation": value.affiliation,
          "item_category2": value.itemCategory2,
          "destination_station": value.destinationStation,
          "origin_station": value.originStation,
          "travel_class": value.travelClass,
          "travel_route": value.travelRoute,
          "intercity_direct": value.intercityDirect,
          "deur_tot_deur": value.deurTotDeur,
          "item_revenue": value.itemRevenue,
        };
        }),
      "item_list_id": properties.itemListId,
      "item_list_name": properties.itemListName,
      "ns_shop": properties.nsShop,
      "sales_channel": properties.salesChannel,
      "platform": sysPlatform,
      "language": sysLanguage,
      "ns_environment": sysNsEnvironment,
      "datalayer_source": sysDatalayerSource,
      "preview": sysPreview,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * purchase_unconfirmed: Event on the last interaction before navigating to the payment provider
   * 
   * When to trigger this event:
   * 1. Bij klikken op betaal button
   * View in Avo: https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/sudJ_WFJW/trigger/moDfbyEZ4
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {float} properties.value - value of purhcased/added/removed item(s)
   * @param {Array<object>} properties.items - item array of objects:
[{
          item_id: 'FLEX|7,
          item_name: 'Traject Vrij',
          coupon: 'Zomercampagne',
          discount: 5.00,
          index: 0,
          item_brand: 'NS.nl',
          item_category: 'Abonnementen',
          origin_station: 'Ede-Wageningen',
          destination_station: 'Woerden'
          item_variant: 'NS-Flex',  
          price: 291.90,
          quantity: 1
          item_revenue: 291.90
          intercity_direct: true,
          deur_tot_deur: {}
        }]
   * @param {string} properties.nsShop - Which shop/cluster: lvb_app, lvb_kaartjes, ns-flex, etc
   * @param {string} properties.transactionId - Transaction or Order ID of the order
   * @param {string} [properties.paymentType] - payment type like iDeal, Creditcard etc
   * @param {string} [properties.bankSelected] - Selected bank
   * @param {string} [properties.salesChannel] - Wat is het verkoopkanaal van de aankoop? Spoordeelwinkel / Losse kaatjes / Externe verkoper
   * @param {Array<object>} [properties.existingProduct] - current product you up or downgrade (one):
[{
          item_id: 'FLEX|7,
          item_name: 'Traject Vrij',
          item_brand: 'NS.nl',
          item_category: 'Abonnementen',
          item_category2: 'Abonnementen',
          item_variant: 'NS-Flex',
          price: 291.90,
          quantity: 1
        }]
   * @param {string} [properties.coupon] - ONLY WEB | coupon-code or campaign id
   * @param {float} [properties.discount] - ONLY WEB | Item discount value
   * 
   * @see {@link https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/sudJ_WFJW}
   */
  function purchaseUnconfirmed(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertValue(properties.value));
      messages = messages.concat(assertItems(properties.items));
      messages = messages.concat(assertNsShop(properties.nsShop));
      messages = messages.concat(assertTransactionId(properties.transactionId));
      messages = messages.concat(assertOptionalPaymentType(properties.paymentType));
      messages = messages.concat(assertOptionalBankSelected(properties.bankSelected));
      messages = messages.concat(assertOptionalSalesChannel(properties.salesChannel));
      messages = messages.concat(assertOptionalExistingProduct(properties.existingProduct));
      messages = messages.concat(assertOptionalCoupon(properties.coupon));
      messages = messages.concat(assertOptionalDiscount(properties.discount));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertLanguage(sysLanguage));
      messages = messages.concat(assertNsEnvironment(sysNsEnvironment));
      messages = messages.concat(assertDatalayerSource(sysDatalayerSource));
      messages = messages.concat(assertOptionalPreview(sysPreview));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("purchase_unconfirmed", Object.keys(properties), [
        "value",
        "items",
        "nsShop",
        "transactionId",
        "paymentType",
        "bankSelected",
        "salesChannel",
        "existingProduct",
        "coupon",
        "discount"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "sudJ_WFJW", "f33fb75c800ff19056b1072b9ad208bf55038be4a5838593a800a60ade5c5116", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("purchase_unconfirmed", {
        "currency": "EUR",
        "schema": "iglu:nl.ns/purchase_unconfirmed/jsonschema/1-0-8",
        "value": properties.value,
        "items": properties.items.map(function(value) {
          return {
            "item_id": value.itemId,
            "item_name": value.itemName,
            "coupon": value.coupon,
            "discount": value.discount,
            "index": value.index,
            "quantity": value.quantity,
            "price": value.price,
            "item_brand": value.itemBrand,
            "item_variant": value.itemVariant,
            "item_category": value.itemCategory,
            "travel_date": value.travelDate,
            "affiliation": value.affiliation,
            "item_category2": value.itemCategory2,
            "destination_station": value.destinationStation,
            "origin_station": value.originStation,
            "travel_class": value.travelClass,
            "travel_route": value.travelRoute,
            "intercity_direct": value.intercityDirect,
            "deur_tot_deur": value.deurTotDeur,
            "item_revenue": value.itemRevenue,
          };
          }),
        "ns_shop": properties.nsShop,
        "transaction_id": properties.transactionId,
        "payment_type": properties.paymentType,
        "bank_selected": properties.bankSelected,
        "sales_channel": properties.salesChannel,
        "existing_product": properties.existingProduct !== undefined && properties.existingProduct !== null ? 
          properties.existingProduct.map(function(value) {
          return {
            "item_id": value.itemId,
            "item_name": value.itemName,
            "quantity": value.quantity,
            "item_category": value.itemCategory,
            "item_category2": value.itemCategory2,
            "price": value.price,
            "item_brand": value.itemBrand,
            "item_variant": value.itemVariant,
          };
          }) : properties.existingProduct,
        "coupon": properties.coupon,
        "discount": properties.discount,
        "platform": sysPlatform,
        "language": sysLanguage,
        "ns_environment": sysNsEnvironment,
        "datalayer_source": sysDatalayerSource,
        "preview": sysPreview,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("sudJ_WFJW", "purchase_unconfirmed", messages, [
        {id: "GuYrcDncVS5", name: "currency", value: "EUR"},
        {id: "4-eTlbcITN", name: "schema", value: "iglu:nl.ns/purchase_unconfirmed/jsonschema/1-0-8"},
        {id: "06ak1UmwgYlK", name: "payment_type", value: properties.paymentType},
        {id: "17s21jQ4G", name: "intercity_direct", value: properties.intercityDirect},
        {id: "1WkP-6sA8x_5", name: "value", value: properties.value},
        {id: "6-GUnFHLFL", name: "item_brand", value: properties.itemBrand},
        {id: "7h-TV9MOq2", name: "item_category", value: properties.itemCategory},
        {id: "9Tv-BxH6jSI", name: "coupon", value: properties.coupon},
        {id: "BImlhIesBPhx", name: "ns_shop", value: properties.nsShop},
        {id: "D-6RH3lvH", name: "affiliation", value: properties.affiliation},
        {id: "GsMr_TucEDqV", name: "existing_product", value: properties.existingProduct},
        {id: "JzW147FWP", name: "deur_tot_deur", value: properties.deurTotDeur},
        {id: "Oavl4KfPHF3", name: "items", value: properties.items},
        {id: "PKlIwCNeHb", name: "index", value: properties.index},
        {id: "PpX-d_0VW", name: "travel_route", value: properties.travelRoute},
        {id: "SCki6fM2wea", name: "transaction_id", value: properties.transactionId},
        {id: "TIV1Wo8BM", name: "item_category2", value: properties.itemCategory2},
        {id: "UpRgfCPRK", name: "destination_station", value: properties.destinationStation},
        {id: "WGDHyEYby", name: "travel_date", value: properties.travelDate},
        {id: "ZVGAZOlEBhGj", name: "item_id", value: properties.itemId},
        {id: "ZZlWcbau6V", name: "quantity", value: properties.quantity},
        {id: "_8eP6aJ0U", name: "bank_selected", value: properties.bankSelected},
        {id: "_T-mygJA7w", name: "price", value: properties.price},
        {id: "_WmY6XGTY", name: "travel_class", value: properties.travelClass},
        {id: "bMK3liq6t", name: "origin_station", value: properties.originStation},
        {id: "ePZR23byGW", name: "discount", value: properties.discount},
        {id: "hg4puJyLhb", name: "item_name", value: properties.itemName},
        {id: "k7CLuUXjt3HSeA3jMU2c7", name: "item_revenue", value: properties.itemRevenue},
        {id: "qAitKhHMy0", name: "item_variant", value: properties.itemVariant},
        {id: "qJKae_S4y_", name: "sales_channel", value: properties.salesChannel},
        {id: "-PddLxwT_", name: "platform", value: sysPlatform},
        {id: "Af3-RL1nz2", name: "language", value: sysLanguage},
        {id: "L-rHlXDQJd", name: "datalayer_source", value: sysDatalayerSource},
        {id: "Po4mUsQEyB", name: "preview", value: sysPreview},
        {id: "ux8kucXh9-", name: "ns_environment", value: sysNsEnvironment},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'purchase_unconfirmed': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("purchase_unconfirmed", {
          "currency": "EUR",
          "schema": "iglu:nl.ns/purchase_unconfirmed/jsonschema/1-0-8",
          "value": properties.value,
          "items": properties.items.map(function(value) {
            return {
              "item_id": value.itemId,
              "item_name": value.itemName,
              "coupon": value.coupon,
              "discount": value.discount,
              "index": value.index,
              "quantity": value.quantity,
              "price": value.price,
              "item_brand": value.itemBrand,
              "item_variant": value.itemVariant,
              "item_category": value.itemCategory,
              "travel_date": value.travelDate,
              "affiliation": value.affiliation,
              "item_category2": value.itemCategory2,
              "destination_station": value.destinationStation,
              "origin_station": value.originStation,
              "travel_class": value.travelClass,
              "travel_route": value.travelRoute,
              "intercity_direct": value.intercityDirect,
              "deur_tot_deur": value.deurTotDeur,
              "item_revenue": value.itemRevenue,
            };
            }),
          "ns_shop": properties.nsShop,
          "transaction_id": properties.transactionId,
          "payment_type": properties.paymentType,
          "bank_selected": properties.bankSelected,
          "sales_channel": properties.salesChannel,
          "existing_product": properties.existingProduct !== undefined && properties.existingProduct !== null ? 
            properties.existingProduct.map(function(value) {
            return {
              "item_id": value.itemId,
              "item_name": value.itemName,
              "quantity": value.quantity,
              "item_category": value.itemCategory,
              "item_category2": value.itemCategory2,
              "price": value.price,
              "item_brand": value.itemBrand,
              "item_variant": value.itemVariant,
            };
            }) : properties.existingProduct,
          "coupon": properties.coupon,
          "discount": properties.discount,
          "platform": sysPlatform,
          "language": sysLanguage,
          "ns_environment": sysNsEnvironment,
          "datalayer_source": sysDatalayerSource,
          "preview": sysPreview,
          }, "sudJ_WFJW", "f33fb75c800ff19056b1072b9ad208bf55038be4a5838593a800a60ade5c5116");
      }
      // destination NsDataQueue
      NsDataQueue.logEvent("purchase_unconfirmed", {
      "currency": "EUR",
      "schema": "iglu:nl.ns/purchase_unconfirmed/jsonschema/1-0-8",
      "value": properties.value,
      "items": properties.items.map(function(value) {
        return {
          "item_id": value.itemId,
          "item_name": value.itemName,
          "coupon": value.coupon,
          "discount": value.discount,
          "index": value.index,
          "quantity": value.quantity,
          "price": value.price,
          "item_brand": value.itemBrand,
          "item_variant": value.itemVariant,
          "item_category": value.itemCategory,
          "travel_date": value.travelDate,
          "affiliation": value.affiliation,
          "item_category2": value.itemCategory2,
          "destination_station": value.destinationStation,
          "origin_station": value.originStation,
          "travel_class": value.travelClass,
          "travel_route": value.travelRoute,
          "intercity_direct": value.intercityDirect,
          "deur_tot_deur": value.deurTotDeur,
          "item_revenue": value.itemRevenue,
        };
        }),
      "ns_shop": properties.nsShop,
      "transaction_id": properties.transactionId,
      "payment_type": properties.paymentType,
      "bank_selected": properties.bankSelected,
      "sales_channel": properties.salesChannel,
      "existing_product": properties.existingProduct !== undefined && properties.existingProduct !== null ? 
        properties.existingProduct.map(function(value) {
        return {
          "item_id": value.itemId,
          "item_name": value.itemName,
          "quantity": value.quantity,
          "item_category": value.itemCategory,
          "item_category2": value.itemCategory2,
          "price": value.price,
          "item_brand": value.itemBrand,
          "item_variant": value.itemVariant,
        };
        }) : properties.existingProduct,
      "coupon": properties.coupon,
      "discount": properties.discount,
      "platform": sysPlatform,
      "language": sysLanguage,
      "ns_environment": sysNsEnvironment,
      "datalayer_source": sysDatalayerSource,
      "preview": sysPreview,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * add_shipping_info: Web: The step before the last step
App: Confirms name and e-mail adress
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.currency - The currency of the purchase
   * @param {float} properties.value - value of purhcased/added/removed item(s)
   * @param {Array<object>} properties.items - item array of objects:
[{
          item_id: 'FLEX|7,
          item_name: 'Traject Vrij',
          coupon: 'Zomercampagne',
          discount: 5.00,
          index: 0,
          item_brand: 'NS.nl',
          item_category: 'Abonnementen',
          origin_station: 'Ede-Wageningen',
          destination_station: 'Woerden'
          item_variant: 'NS-Flex',  
          price: 291.90,
          quantity: 1
          item_revenue: 291.90
          intercity_direct: true,
          deur_tot_deur: {}
        }]
   * @param {string} properties.nsShop - Which shop/cluster: lvb_app, lvb_kaartjes, ns-flex, etc
   * @param {string} [properties.salesChannel] - Wat is het verkoopkanaal van de aankoop? Spoordeelwinkel / Losse kaatjes / Externe verkoper
   * 
   * @see {@link https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/mkKucON6P}
   */
  function addShippingInfo(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertCurrency(properties.currency));
      messages = messages.concat(assertValue(properties.value));
      messages = messages.concat(assertItems(properties.items));
      messages = messages.concat(assertNsShop(properties.nsShop));
      messages = messages.concat(assertOptionalSalesChannel(properties.salesChannel));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertLanguage(sysLanguage));
      messages = messages.concat(assertNsEnvironment(sysNsEnvironment));
      messages = messages.concat(assertDatalayerSource(sysDatalayerSource));
      messages = messages.concat(assertOptionalPreview(sysPreview));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("add_shipping_info", Object.keys(properties), [
        "currency",
        "value",
        "items",
        "nsShop",
        "salesChannel"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "mkKucON6P", "070456a556cccfb6d19c0f168abef0b97b9a572ea07aefab9bd52194a212ab9c", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("add_shipping_info", {
        "schema": "iglu:nl.ns/add_shipping_info/jsonschema/1-0-5",
        "currency": properties.currency,
        "value": properties.value,
        "items": properties.items.map(function(value) {
          return {
            "item_id": value.itemId,
            "item_name": value.itemName,
            "coupon": value.coupon,
            "discount": value.discount,
            "index": value.index,
            "quantity": value.quantity,
            "price": value.price,
            "item_brand": value.itemBrand,
            "item_variant": value.itemVariant,
            "item_category": value.itemCategory,
            "travel_date": value.travelDate,
            "affiliation": value.affiliation,
            "item_category2": value.itemCategory2,
            "destination_station": value.destinationStation,
            "origin_station": value.originStation,
            "travel_class": value.travelClass,
            "travel_route": value.travelRoute,
            "intercity_direct": value.intercityDirect,
            "deur_tot_deur": value.deurTotDeur,
            "item_revenue": value.itemRevenue,
          };
          }),
        "ns_shop": properties.nsShop,
        "sales_channel": properties.salesChannel,
        "platform": sysPlatform,
        "language": sysLanguage,
        "ns_environment": sysNsEnvironment,
        "datalayer_source": sysDatalayerSource,
        "preview": sysPreview,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("mkKucON6P", "add_shipping_info", messages, [
        {id: "4-eTlbcITN", name: "schema", value: "iglu:nl.ns/add_shipping_info/jsonschema/1-0-5"},
        {id: "17s21jQ4G", name: "intercity_direct", value: properties.intercityDirect},
        {id: "1WkP-6sA8x_5", name: "value", value: properties.value},
        {id: "6-GUnFHLFL", name: "item_brand", value: properties.itemBrand},
        {id: "7h-TV9MOq2", name: "item_category", value: properties.itemCategory},
        {id: "9Tv-BxH6jSI", name: "coupon", value: properties.coupon},
        {id: "BImlhIesBPhx", name: "ns_shop", value: properties.nsShop},
        {id: "D-6RH3lvH", name: "affiliation", value: properties.affiliation},
        {id: "GuYrcDncVS5", name: "currency", value: properties.currency},
        {id: "JzW147FWP", name: "deur_tot_deur", value: properties.deurTotDeur},
        {id: "Oavl4KfPHF3", name: "items", value: properties.items},
        {id: "PKlIwCNeHb", name: "index", value: properties.index},
        {id: "PpX-d_0VW", name: "travel_route", value: properties.travelRoute},
        {id: "TIV1Wo8BM", name: "item_category2", value: properties.itemCategory2},
        {id: "UpRgfCPRK", name: "destination_station", value: properties.destinationStation},
        {id: "WGDHyEYby", name: "travel_date", value: properties.travelDate},
        {id: "ZVGAZOlEBhGj", name: "item_id", value: properties.itemId},
        {id: "ZZlWcbau6V", name: "quantity", value: properties.quantity},
        {id: "_T-mygJA7w", name: "price", value: properties.price},
        {id: "_WmY6XGTY", name: "travel_class", value: properties.travelClass},
        {id: "bMK3liq6t", name: "origin_station", value: properties.originStation},
        {id: "ePZR23byGW", name: "discount", value: properties.discount},
        {id: "hg4puJyLhb", name: "item_name", value: properties.itemName},
        {id: "k7CLuUXjt3HSeA3jMU2c7", name: "item_revenue", value: properties.itemRevenue},
        {id: "qAitKhHMy0", name: "item_variant", value: properties.itemVariant},
        {id: "qJKae_S4y_", name: "sales_channel", value: properties.salesChannel},
        {id: "-PddLxwT_", name: "platform", value: sysPlatform},
        {id: "Af3-RL1nz2", name: "language", value: sysLanguage},
        {id: "L-rHlXDQJd", name: "datalayer_source", value: sysDatalayerSource},
        {id: "Po4mUsQEyB", name: "preview", value: sysPreview},
        {id: "ux8kucXh9-", name: "ns_environment", value: sysNsEnvironment},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'add_shipping_info': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("add_shipping_info", {
          "schema": "iglu:nl.ns/add_shipping_info/jsonschema/1-0-5",
          "currency": properties.currency,
          "value": properties.value,
          "items": properties.items.map(function(value) {
            return {
              "item_id": value.itemId,
              "item_name": value.itemName,
              "coupon": value.coupon,
              "discount": value.discount,
              "index": value.index,
              "quantity": value.quantity,
              "price": value.price,
              "item_brand": value.itemBrand,
              "item_variant": value.itemVariant,
              "item_category": value.itemCategory,
              "travel_date": value.travelDate,
              "affiliation": value.affiliation,
              "item_category2": value.itemCategory2,
              "destination_station": value.destinationStation,
              "origin_station": value.originStation,
              "travel_class": value.travelClass,
              "travel_route": value.travelRoute,
              "intercity_direct": value.intercityDirect,
              "deur_tot_deur": value.deurTotDeur,
              "item_revenue": value.itemRevenue,
            };
            }),
          "ns_shop": properties.nsShop,
          "sales_channel": properties.salesChannel,
          "platform": sysPlatform,
          "language": sysLanguage,
          "ns_environment": sysNsEnvironment,
          "datalayer_source": sysDatalayerSource,
          "preview": sysPreview,
          }, "mkKucON6P", "070456a556cccfb6d19c0f168abef0b97b9a572ea07aefab9bd52194a212ab9c");
      }
      // destination NsDataQueue
      NsDataQueue.logEvent("add_shipping_info", {
      "schema": "iglu:nl.ns/add_shipping_info/jsonschema/1-0-5",
      "currency": properties.currency,
      "value": properties.value,
      "items": properties.items.map(function(value) {
        return {
          "item_id": value.itemId,
          "item_name": value.itemName,
          "coupon": value.coupon,
          "discount": value.discount,
          "index": value.index,
          "quantity": value.quantity,
          "price": value.price,
          "item_brand": value.itemBrand,
          "item_variant": value.itemVariant,
          "item_category": value.itemCategory,
          "travel_date": value.travelDate,
          "affiliation": value.affiliation,
          "item_category2": value.itemCategory2,
          "destination_station": value.destinationStation,
          "origin_station": value.originStation,
          "travel_class": value.travelClass,
          "travel_route": value.travelRoute,
          "intercity_direct": value.intercityDirect,
          "deur_tot_deur": value.deurTotDeur,
          "item_revenue": value.itemRevenue,
        };
        }),
      "ns_shop": properties.nsShop,
      "sales_channel": properties.salesChannel,
      "platform": sysPlatform,
      "language": sysLanguage,
      "ns_environment": sysNsEnvironment,
      "datalayer_source": sysDatalayerSource,
      "preview": sysPreview,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * add_payment_info: Web: Final step of the purchase flow. App: Comfirms payment
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.currency - The currency of the purchase
   * @param {float} properties.value - value of purhcased/added/removed item(s)
   * @param {Array<object>} properties.items - item array of objects:
[{
          item_id: 'FLEX|7,
          item_name: 'Traject Vrij',
          coupon: 'Zomercampagne',
          discount: 5.00,
          index: 0,
          item_brand: 'NS.nl',
          item_category: 'Abonnementen',
          origin_station: 'Ede-Wageningen',
          destination_station: 'Woerden'
          item_variant: 'NS-Flex',  
          price: 291.90,
          quantity: 1
          item_revenue: 291.90
          intercity_direct: true,
          deur_tot_deur: {}
        }]
   * @param {string} properties.nsShop - Which shop/cluster: lvb_app, lvb_kaartjes, ns-flex, etc
   * @param {string} [properties.salesChannel] - Wat is het verkoopkanaal van de aankoop? Spoordeelwinkel / Losse kaatjes / Externe verkoper
   * 
   * @see {@link https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/X4CYs12Op}
   */
  function addPaymentInfo(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertCurrency(properties.currency));
      messages = messages.concat(assertValue(properties.value));
      messages = messages.concat(assertItems(properties.items));
      messages = messages.concat(assertNsShop(properties.nsShop));
      messages = messages.concat(assertOptionalSalesChannel(properties.salesChannel));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertLanguage(sysLanguage));
      messages = messages.concat(assertNsEnvironment(sysNsEnvironment));
      messages = messages.concat(assertDatalayerSource(sysDatalayerSource));
      messages = messages.concat(assertOptionalPreview(sysPreview));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("add_payment_info", Object.keys(properties), [
        "currency",
        "value",
        "items",
        "nsShop",
        "salesChannel"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "X4CYs12Op", "0e57300b5dd6aff974f9d8f9afccf190795631382b6e4158701c0bb5962c9505", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("add_payment_info", {
        "schema": "iglu:nl.ns/add_payment_info/jsonschema/1-0-5",
        "currency": properties.currency,
        "value": properties.value,
        "items": properties.items.map(function(value) {
          return {
            "item_id": value.itemId,
            "item_name": value.itemName,
            "coupon": value.coupon,
            "discount": value.discount,
            "index": value.index,
            "quantity": value.quantity,
            "price": value.price,
            "item_brand": value.itemBrand,
            "item_variant": value.itemVariant,
            "item_category": value.itemCategory,
            "travel_date": value.travelDate,
            "affiliation": value.affiliation,
            "item_category2": value.itemCategory2,
            "destination_station": value.destinationStation,
            "origin_station": value.originStation,
            "travel_class": value.travelClass,
            "travel_route": value.travelRoute,
            "intercity_direct": value.intercityDirect,
            "deur_tot_deur": value.deurTotDeur,
            "item_revenue": value.itemRevenue,
          };
          }),
        "ns_shop": properties.nsShop,
        "sales_channel": properties.salesChannel,
        "platform": sysPlatform,
        "language": sysLanguage,
        "ns_environment": sysNsEnvironment,
        "datalayer_source": sysDatalayerSource,
        "preview": sysPreview,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("X4CYs12Op", "add_payment_info", messages, [
        {id: "4-eTlbcITN", name: "schema", value: "iglu:nl.ns/add_payment_info/jsonschema/1-0-5"},
        {id: "17s21jQ4G", name: "intercity_direct", value: properties.intercityDirect},
        {id: "1WkP-6sA8x_5", name: "value", value: properties.value},
        {id: "6-GUnFHLFL", name: "item_brand", value: properties.itemBrand},
        {id: "7h-TV9MOq2", name: "item_category", value: properties.itemCategory},
        {id: "9Tv-BxH6jSI", name: "coupon", value: properties.coupon},
        {id: "BImlhIesBPhx", name: "ns_shop", value: properties.nsShop},
        {id: "D-6RH3lvH", name: "affiliation", value: properties.affiliation},
        {id: "GuYrcDncVS5", name: "currency", value: properties.currency},
        {id: "JzW147FWP", name: "deur_tot_deur", value: properties.deurTotDeur},
        {id: "Oavl4KfPHF3", name: "items", value: properties.items},
        {id: "PKlIwCNeHb", name: "index", value: properties.index},
        {id: "PpX-d_0VW", name: "travel_route", value: properties.travelRoute},
        {id: "TIV1Wo8BM", name: "item_category2", value: properties.itemCategory2},
        {id: "UpRgfCPRK", name: "destination_station", value: properties.destinationStation},
        {id: "WGDHyEYby", name: "travel_date", value: properties.travelDate},
        {id: "ZVGAZOlEBhGj", name: "item_id", value: properties.itemId},
        {id: "ZZlWcbau6V", name: "quantity", value: properties.quantity},
        {id: "_T-mygJA7w", name: "price", value: properties.price},
        {id: "_WmY6XGTY", name: "travel_class", value: properties.travelClass},
        {id: "bMK3liq6t", name: "origin_station", value: properties.originStation},
        {id: "ePZR23byGW", name: "discount", value: properties.discount},
        {id: "hg4puJyLhb", name: "item_name", value: properties.itemName},
        {id: "k7CLuUXjt3HSeA3jMU2c7", name: "item_revenue", value: properties.itemRevenue},
        {id: "qAitKhHMy0", name: "item_variant", value: properties.itemVariant},
        {id: "qJKae_S4y_", name: "sales_channel", value: properties.salesChannel},
        {id: "-PddLxwT_", name: "platform", value: sysPlatform},
        {id: "Af3-RL1nz2", name: "language", value: sysLanguage},
        {id: "L-rHlXDQJd", name: "datalayer_source", value: sysDatalayerSource},
        {id: "Po4mUsQEyB", name: "preview", value: sysPreview},
        {id: "ux8kucXh9-", name: "ns_environment", value: sysNsEnvironment},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'add_payment_info': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("add_payment_info", {
          "schema": "iglu:nl.ns/add_payment_info/jsonschema/1-0-5",
          "currency": properties.currency,
          "value": properties.value,
          "items": properties.items.map(function(value) {
            return {
              "item_id": value.itemId,
              "item_name": value.itemName,
              "coupon": value.coupon,
              "discount": value.discount,
              "index": value.index,
              "quantity": value.quantity,
              "price": value.price,
              "item_brand": value.itemBrand,
              "item_variant": value.itemVariant,
              "item_category": value.itemCategory,
              "travel_date": value.travelDate,
              "affiliation": value.affiliation,
              "item_category2": value.itemCategory2,
              "destination_station": value.destinationStation,
              "origin_station": value.originStation,
              "travel_class": value.travelClass,
              "travel_route": value.travelRoute,
              "intercity_direct": value.intercityDirect,
              "deur_tot_deur": value.deurTotDeur,
              "item_revenue": value.itemRevenue,
            };
            }),
          "ns_shop": properties.nsShop,
          "sales_channel": properties.salesChannel,
          "platform": sysPlatform,
          "language": sysLanguage,
          "ns_environment": sysNsEnvironment,
          "datalayer_source": sysDatalayerSource,
          "preview": sysPreview,
          }, "X4CYs12Op", "0e57300b5dd6aff974f9d8f9afccf190795631382b6e4158701c0bb5962c9505");
      }
      // destination NsDataQueue
      NsDataQueue.logEvent("add_payment_info", {
      "schema": "iglu:nl.ns/add_payment_info/jsonschema/1-0-5",
      "currency": properties.currency,
      "value": properties.value,
      "items": properties.items.map(function(value) {
        return {
          "item_id": value.itemId,
          "item_name": value.itemName,
          "coupon": value.coupon,
          "discount": value.discount,
          "index": value.index,
          "quantity": value.quantity,
          "price": value.price,
          "item_brand": value.itemBrand,
          "item_variant": value.itemVariant,
          "item_category": value.itemCategory,
          "travel_date": value.travelDate,
          "affiliation": value.affiliation,
          "item_category2": value.itemCategory2,
          "destination_station": value.destinationStation,
          "origin_station": value.originStation,
          "travel_class": value.travelClass,
          "travel_route": value.travelRoute,
          "intercity_direct": value.intercityDirect,
          "deur_tot_deur": value.deurTotDeur,
          "item_revenue": value.itemRevenue,
        };
        }),
      "ns_shop": properties.nsShop,
      "sales_channel": properties.salesChannel,
      "platform": sysPlatform,
      "language": sysLanguage,
      "ns_environment": sysNsEnvironment,
      "datalayer_source": sysDatalayerSource,
      "preview": sysPreview,
      });
    } else {
      // do nothing
    }
  }
  
  /**
   * logout_success: Event sent when a user logs out of the MijnNS application
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {string} properties.mijnnsVersion - Name of the mijnNS-omgeving (consument of zakelijk)
   * 
   * @see {@link https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/6KPbzWfr6}
   */
  function logoutSuccess(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertMijnnsVersion(properties.mijnnsVersion));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertLanguage(sysLanguage));
      messages = messages.concat(assertNsEnvironment(sysNsEnvironment));
      messages = messages.concat(assertDatalayerSource(sysDatalayerSource));
      messages = messages.concat(assertOptionalPreview(sysPreview));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("logout_success", Object.keys(properties), [
        "mijnnsVersion"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "6KPbzWfr6", "6d9a463d938c382351c8acdf7a224c4938b6c30fc93d62483988fd1be22b09da", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("logout_success", {
        "schema": "iglu:nl.ns/logout_success/jsonschema/1-0-1",
        "mijnns_version": properties.mijnnsVersion,
        "platform": sysPlatform,
        "language": sysLanguage,
        "ns_environment": sysNsEnvironment,
        "datalayer_source": sysDatalayerSource,
        "preview": sysPreview,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("6KPbzWfr6", "logout_success", messages, [
        {id: "4-eTlbcITN", name: "schema", value: "iglu:nl.ns/logout_success/jsonschema/1-0-1"},
        {id: "lbXiVJSEQrn6", name: "mijnns_version", value: properties.mijnnsVersion},
        {id: "-PddLxwT_", name: "platform", value: sysPlatform},
        {id: "Af3-RL1nz2", name: "language", value: sysLanguage},
        {id: "L-rHlXDQJd", name: "datalayer_source", value: sysDatalayerSource},
        {id: "Po4mUsQEyB", name: "preview", value: sysPreview},
        {id: "ux8kucXh9-", name: "ns_environment", value: sysNsEnvironment},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'logout_success': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("logout_success", {
          "schema": "iglu:nl.ns/logout_success/jsonschema/1-0-1",
          "mijnns_version": properties.mijnnsVersion,
          "platform": sysPlatform,
          "language": sysLanguage,
          "ns_environment": sysNsEnvironment,
          "datalayer_source": sysDatalayerSource,
          "preview": sysPreview,
          }, "6KPbzWfr6", "6d9a463d938c382351c8acdf7a224c4938b6c30fc93d62483988fd1be22b09da");
      }
      // destination NsDataQueue
      NsDataQueue.logEvent("logout_success", {
      "schema": "iglu:nl.ns/logout_success/jsonschema/1-0-1",
      "mijnns_version": properties.mijnnsVersion,
      "platform": sysPlatform,
      "language": sysLanguage,
      "ns_environment": sysNsEnvironment,
      "datalayer_source": sysDatalayerSource,
      "preview": sysPreview,
      });
      NsDataQueue.unidentify();
    } else {
      // do nothing
    }
  }
  
  /**
   * experiments_initialized: The experiments_initialized event is triggered once all experimental features on the web page have been successfully initialized and are ready for interaction. This can be used to send multiple experiments contexts to Snowplow
   * 
   * @param {object} properties - the properties associatied with this event
   * @param {object} properties.experiments - Contains information regarding experiment values on a page or event. 
   * @param {Array<string>} properties.experimentsSummary - Summary of the experiment; test_id and test_variant concatenated with '|'
   * 
   * @see {@link https://www.avo.app/schemas/YlokXVpIQVXO68TO4Rm5/events/8WFmJQzbFZ7WRiDrpiq52}
   */
  function experimentsInitialized(properties) {
    properties = properties || {};
    if (__AVO_DEV__ || __WEB_DEBUGGER__) {
      // assert properties
      var messages = [];
      messages = messages.concat(assertExperiments(properties.experiments));
      messages = messages.concat(assertExperimentsSummary(properties.experimentsSummary));
      messages = messages.concat(assertPlatform(sysPlatform));
      messages = messages.concat(assertLanguage(sysLanguage));
      messages = messages.concat(assertNsEnvironment(sysNsEnvironment));
      messages = messages.concat(assertDatalayerSource(sysDatalayerSource));
      messages = messages.concat(assertOptionalPreview(sysPreview));
      messages = messages.concat(AvoAssert.assertNoAdditionalProperties("experiments_initialized", Object.keys(properties), [
        "experiments",
        "experimentsSummary"
      ]));
      // debug console in Avo
      if (!__AVO_NOOP__) {
        _avo_invoke(__AVO_ENV__, "8WFmJQzbFZ7WRiDrpiq52", "d0bd37cd4648080d833907e4d3adc353d1955f8cde340aeac86ce052150738c6", messages.map(function(m) { return Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType}); }), 'event');
      }
      
      InternalAvoLogger.logEventSent("experiments_initialized", {
        "schema": "iglu:nl.ns/experiments_initialized/jsonschema/1-0-0",
        "experiments": {
          "test_id": properties.experiments.testId,
          "test_description": properties.experiments.testDescription,
          "test_variant": properties.experiments.testVariant,
          "test_location": properties.experiments.testLocation,
          "test_team": properties.experiments.testTeam,
          "test_audience_id": properties.experiments.testAudienceId,
          "test_tool": properties.experiments.testTool,
          "global_context": true,
          "schema": "iglu:nl.ns/experiments/jsonschema/1-0-3",
        },
        "experiments_summary": properties.experimentsSummary,
        "platform": sysPlatform,
        "language": sysLanguage,
        "ns_environment": sysNsEnvironment,
        "datalayer_source": sysDatalayerSource,
        "preview": sysPreview,
        }, {}, {});
      if (__WEB_DEBUGGER__) {
        // Avo web debugger
        _avo_debugger_log("8WFmJQzbFZ7WRiDrpiq52", "experiments_initialized", messages, [
        {id: "4-eTlbcITN", name: "schema", value: "iglu:nl.ns/experiments_initialized/jsonschema/1-0-0"},
        {id: "-aHNB2FOOK", name: "experiments", value: properties.experiments},
        {id: "4-eTlbcITN", name: "schema", value: properties.schema},
        {id: "GL_TSnWYyKgW", name: "test_tool", value: properties.testTool},
        {id: "HpghA4STUpM1", name: "test_id", value: properties.testId},
        {id: "I44jVDyqBZic", name: "test_variant", value: properties.testVariant},
        {id: "NL2dr-pMqXumklSBDwovA", name: "global_context", value: properties.globalContext},
        {id: "TDtygjQ3jTuJ", name: "test_location", value: properties.testLocation},
        {id: "Xiuci0NEjDkz", name: "test_audience_id", value: properties.testAudienceId},
        {id: "gmOAaJXmFQiI0auzUw4Df", name: "experiments_summary", value: properties.experimentsSummary},
        {id: "ij0L0WRQXuPq", name: "test_team", value: properties.testTeam},
        {id: "pnPG0qR_-", name: "test_description", value: properties.testDescription},
        {id: "-PddLxwT_", name: "platform", value: sysPlatform},
        {id: "Af3-RL1nz2", name: "language", value: sysLanguage},
        {id: "L-rHlXDQJd", name: "datalayer_source", value: sysDatalayerSource},
        {id: "Po4mUsQEyB", name: "preview", value: sysPreview},
        {id: "ux8kucXh9-", name: "ns_environment", value: sysNsEnvironment},
        ], [], []);
      }
      if (__AVO_DEV__ && (__STRICT__ === null || __STRICT__)) {
        // throw exception if messages is not empty
        if (messages.length !== 0) {
          throw new Error("Error sending event 'experiments_initialized': " + messages[0].message)
        }
      } else {
        messages.forEach(function(m) {
          console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
        });
      }
    }
    
    if (!__AVO_NOOP__) {
      if (__INSPECTOR__ != null) {
        __INSPECTOR__._avoFunctionTrackSchemaFromEvent("experiments_initialized", {
          "schema": "iglu:nl.ns/experiments_initialized/jsonschema/1-0-0",
          "experiments": {
            "test_id": properties.experiments.testId,
            "test_description": properties.experiments.testDescription,
            "test_variant": properties.experiments.testVariant,
            "test_location": properties.experiments.testLocation,
            "test_team": properties.experiments.testTeam,
            "test_audience_id": properties.experiments.testAudienceId,
            "test_tool": properties.experiments.testTool,
            "global_context": true,
            "schema": "iglu:nl.ns/experiments/jsonschema/1-0-3",
          },
          "experiments_summary": properties.experimentsSummary,
          "platform": sysPlatform,
          "language": sysLanguage,
          "ns_environment": sysNsEnvironment,
          "datalayer_source": sysDatalayerSource,
          "preview": sysPreview,
          }, "8WFmJQzbFZ7WRiDrpiq52", "d0bd37cd4648080d833907e4d3adc353d1955f8cde340aeac86ce052150738c6");
      }
      // destination NsDataQueue
      NsDataQueue.logEvent("experiments_initialized", {
      "schema": "iglu:nl.ns/experiments_initialized/jsonschema/1-0-0",
      "experiments": {
        "test_id": properties.experiments.testId,
        "test_description": properties.experiments.testDescription,
        "test_variant": properties.experiments.testVariant,
        "test_location": properties.experiments.testLocation,
        "test_team": properties.experiments.testTeam,
        "test_audience_id": properties.experiments.testAudienceId,
        "test_tool": properties.experiments.testTool,
        "global_context": true,
        "schema": "iglu:nl.ns/experiments/jsonschema/1-0-3",
      },
      "experiments_summary": properties.experimentsSummary,
      "platform": sysPlatform,
      "language": sysLanguage,
      "ns_environment": sysNsEnvironment,
      "datalayer_source": sysDatalayerSource,
      "preview": sysPreview,
      });
    } else {
      // do nothing
    }
  }
  
  exports.Platform = Platform;
  exports.PaymentType = PaymentType;
  exports.Schema = Schema;
  exports.ChatInitiator = ChatInitiator;
  exports.Language = Language;
  exports.NsShop = NsShop;
  exports.FeedbackPlatform = FeedbackPlatform;
  exports.Currency = Currency;
  exports.OriginType = OriginType;
  exports.CustomerEntity = CustomerEntity;
  exports.Cluster = Cluster;
  exports.CampaignStatus = CampaignStatus;
  exports.ChatClickSource = ChatClickSource;
  exports.PageType = PageType;
  exports.WebsiteVersion = WebsiteVersion;
  exports.MijnnsVersion = MijnnsVersion;
  exports.DestinationType = DestinationType;
  exports.NsEnvironment = NsEnvironment;
  exports.Method = Method;
  exports.setAvoLogger = setAvoLogger;
  exports.buttonClick = buttonClick;
  exports.elementView = elementView;
  exports.elementViewElementViewApp = elementViewElementViewApp;
  exports.linkClick = linkClick;
  exports.checkboxClick = checkboxClick;
  exports.registrationStart = registrationStart;
  exports.registrationSuccess = registrationSuccess;
  exports.loginStart = loginStart;
  exports.loginError = loginError;
  exports.sessionStart = sessionStart;
  exports.scroll = scroll;
  exports.visitQualified = visitQualified;
  exports.beginCheckout = beginCheckout;
  exports.purchase = purchase;
  exports.click = click;
  exports.feedbackGive = feedbackGive;
  exports.contentShare = contentShare;
  exports.formStart = formStart;
  exports.formSubmit = formSubmit;
  exports.formError = formError;
  exports.viewItem = viewItem;
  exports.keuzehulpClick = keuzehulpClick;
  exports.keuzehulpSuccess = keuzehulpSuccess;
  exports.chatStart = chatStart;
  exports.videoStart = videoStart;
  exports.videoProgress = videoProgress;
  exports.videoComplete = videoComplete;
  exports.leadGenerate = leadGenerate;
  exports.fileDownload = fileDownload;
  exports.reisvergelijkerStart = reisvergelijkerStart;
  exports.reisvergelijkerSuccess = reisvergelijkerSuccess;
  exports.reisplannerSuccess = reisplannerSuccess;
  exports.reisplannerError = reisplannerError;
  exports.cookieConsentSubmit = cookieConsentSubmit;
  exports.pushConsent = pushConsent;
  exports.reisregisseurChangePermission = reisregisseurChangePermission;
  exports.nbaView = nbaView;
  exports.nbaSuccess = nbaSuccess;
  exports.nbaAudienceAdd = nbaAudienceAdd;
  exports.experimentView = experimentView;
  exports.experimentSuccess = experimentSuccess;
  exports.pageView = pageView;
  exports.addToCart = addToCart;
  exports.removeFromCart = removeFromCart;
  exports.datepickerClick = datepickerClick;
  exports.selectClick = selectClick;
  exports.selectableClick = selectableClick;
  exports.expandableClick = expandableClick;
  exports.toggleClick = toggleClick;
  exports.elementClick = elementClick;
  exports.viewItemList = viewItemList;
  exports.purchaseUnconfirmed = purchaseUnconfirmed;
  exports.addShippingInfo = addShippingInfo;
  exports.addPaymentInfo = addPaymentInfo;
  exports.logoutSuccess = logoutSuccess;
  exports.experimentsInitialized = experimentsInitialized;
  exports.setSystemProperties_ = setSystemProperties_;
  exports.setSystemProperties = setSystemProperties;
  exports.setup_ = setup_;
  exports.initAvo = initAvo;
  exports.WebDebuggerPosition = WebDebuggerPosition;
  exports.avoInspectorApiKey = avoInspectorApiKey;
}(typeof exports === 'undefined' ? this.SourceJsGenericUtilsAvo = {} : exports));

// AVOMODULEMAP:"SourceJsGenericUtilsAvo"
// AVOEVENTMAP:["buttonClick","elementView","elementViewElementViewApp","linkClick","checkboxClick","registrationStart","registrationSuccess","loginStart","loginError","sessionStart","scroll","visitQualified","beginCheckout","purchase","click","feedbackGive","contentShare","formStart","formSubmit","formError","viewItem","keuzehulpClick","keuzehulpSuccess","chatStart","videoStart","videoProgress","videoComplete","leadGenerate","fileDownload","reisvergelijkerStart","reisvergelijkerSuccess","reisplannerSuccess","reisplannerError","cookieConsentSubmit","pushConsent","reisregisseurChangePermission","nbaView","nbaSuccess","nbaAudienceAdd","experimentView","experimentSuccess","pageView","addToCart","removeFromCart","datepickerClick","selectClick","selectableClick","expandableClick","toggleClick","elementClick","viewItemList","purchaseUnconfirmed","addShippingInfo","addPaymentInfo","logoutSuccess","experimentsInitialized"]
